function A(t, e) {
  if (!t)
    throw new Error(e);
}
const Tk = 34028234663852886e22, kk = -34028234663852886e22, yk = 4294967295, vk = 2147483647, hk = -2147483648;
function Cn(t) {
  if (typeof t != "number")
    throw new Error("invalid int 32: " + typeof t);
  if (!Number.isInteger(t) || t > vk || t < hk)
    throw new Error("invalid int 32: " + t);
}
function Mt(t) {
  if (typeof t != "number")
    throw new Error("invalid uint 32: " + typeof t);
  if (!Number.isInteger(t) || t > yk || t < 0)
    throw new Error("invalid uint 32: " + t);
}
function ai(t) {
  if (typeof t != "number")
    throw new Error("invalid float 32: " + typeof t);
  if (Number.isFinite(t) && (t > Tk || t < kk))
    throw new Error("invalid float 32: " + t);
}
const si = Symbol("@bufbuild/protobuf/enum-type");
function fk(t) {
  const e = t[si];
  return A(e, "missing enum type on enum object"), e;
}
function oi(t, e, n, a) {
  t[si] = ii(e, n.map((s) => ({
    no: s.no,
    name: s.name,
    localName: t[s.no]
  })));
}
function ii(t, e, n) {
  const a = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null), i = [];
  for (const r of e) {
    const c = ri(r);
    i.push(c), a[r.name] = c, s[r.no] = c;
  }
  return {
    typeName: t,
    values: i,
    // We do not surface options at this time
    // options: opt?.options ?? Object.create(null),
    findName(r) {
      return a[r];
    },
    findNumber(r) {
      return s[r];
    }
  };
}
function Rk(t, e, n) {
  const a = {};
  for (const s of e) {
    const i = ri(s);
    a[i.localName] = i.no, a[i.no] = i.localName;
  }
  return oi(a, t, e), a;
}
function ri(t) {
  return "localName" in t ? t : Object.assign(Object.assign({}, t), { localName: t.name });
}
class E {
  /**
   * Compare with a message of the same type.
   * Note that this function disregards extensions and unknown fields.
   */
  equals(e) {
    return this.getType().runtime.util.equals(this.getType(), this, e);
  }
  /**
   * Create a deep copy.
   */
  clone() {
    return this.getType().runtime.util.clone(this);
  }
  /**
   * Parse from binary data, merging fields.
   *
   * Repeated fields are appended. Map entries are added, overwriting
   * existing keys.
   *
   * If a message field is already present, it will be merged with the
   * new data.
   */
  fromBinary(e, n) {
    const a = this.getType(), s = a.runtime.bin, i = s.makeReadOptions(n);
    return s.readMessage(this, i.readerFactory(e), e.byteLength, i), this;
  }
  /**
   * Parse a message from a JSON value.
   */
  fromJson(e, n) {
    const a = this.getType(), s = a.runtime.json, i = s.makeReadOptions(n);
    return s.readMessage(a, e, i, this), this;
  }
  /**
   * Parse a message from a JSON string.
   */
  fromJsonString(e, n) {
    let a;
    try {
      a = JSON.parse(e);
    } catch (s) {
      throw new Error(`cannot decode ${this.getType().typeName} from JSON: ${s instanceof Error ? s.message : String(s)}`);
    }
    return this.fromJson(a, n);
  }
  /**
   * Serialize the message to binary data.
   */
  toBinary(e) {
    const n = this.getType(), a = n.runtime.bin, s = a.makeWriteOptions(e), i = s.writerFactory();
    return a.writeMessage(this, i, s), i.finish();
  }
  /**
   * Serialize the message to a JSON value, a JavaScript value that can be
   * passed to JSON.stringify().
   */
  toJson(e) {
    const n = this.getType(), a = n.runtime.json, s = a.makeWriteOptions(e);
    return a.writeMessage(this, s);
  }
  /**
   * Serialize the message to a JSON string.
   */
  toJsonString(e) {
    var n;
    const a = this.toJson(e);
    return JSON.stringify(a, null, (n = e?.prettySpaces) !== null && n !== void 0 ? n : 0);
  }
  /**
   * Override for serialization behavior. This will be invoked when calling
   * JSON.stringify on this message (i.e. JSON.stringify(msg)).
   *
   * Note that this will not serialize google.protobuf.Any with a packed
   * message because the protobuf JSON format specifies that it needs to be
   * unpacked, and this is only possible with a type registry to look up the
   * message type.  As a result, attempting to serialize a message with this
   * type will throw an Error.
   *
   * This method is protected because you should not need to invoke it
   * directly -- instead use JSON.stringify or toJsonString for
   * stringified JSON.  Alternatively, if actual JSON is desired, you should
   * use toJson.
   */
  toJSON() {
    return this.toJson({
      emitDefaultValues: !0
    });
  }
  /**
   * Retrieve the MessageType of this message - a singleton that represents
   * the protobuf message declaration and provides metadata for reflection-
   * based operations.
   */
  getType() {
    return Object.getPrototypeOf(this).constructor;
  }
}
function Ik(t, e, n, a) {
  var s;
  const i = (s = a?.localName) !== null && s !== void 0 ? s : e.substring(e.lastIndexOf(".") + 1), r = {
    [i]: function(c) {
      t.util.initFields(this), t.util.initPartial(c, this);
    }
  }[i];
  return Object.setPrototypeOf(r.prototype, new E()), Object.assign(r, {
    runtime: t,
    typeName: e,
    fields: t.util.newFieldList(n),
    fromBinary(c, d) {
      return new r().fromBinary(c, d);
    },
    fromJson(c, d) {
      return new r().fromJson(c, d);
    },
    fromJsonString(c, d) {
      return new r().fromJsonString(c, d);
    },
    equals(c, d) {
      return t.util.equals(r, c, d);
    }
  }), r;
}
function Sk() {
  let t = 0, e = 0;
  for (let a = 0; a < 28; a += 7) {
    let s = this.buf[this.pos++];
    if (t |= (s & 127) << a, !(s & 128))
      return this.assertBounds(), [t, e];
  }
  let n = this.buf[this.pos++];
  if (t |= (n & 15) << 28, e = (n & 112) >> 4, !(n & 128))
    return this.assertBounds(), [t, e];
  for (let a = 3; a <= 31; a += 7) {
    let s = this.buf[this.pos++];
    if (e |= (s & 127) << a, !(s & 128))
      return this.assertBounds(), [t, e];
  }
  throw new Error("invalid varint");
}
function It(t, e, n) {
  for (let i = 0; i < 28; i = i + 7) {
    const r = t >>> i, c = !(!(r >>> 7) && e == 0), d = (c ? r | 128 : r) & 255;
    if (n.push(d), !c)
      return;
  }
  const a = t >>> 28 & 15 | (e & 7) << 4, s = !!(e >> 3);
  if (n.push((s ? a | 128 : a) & 255), !!s) {
    for (let i = 3; i < 31; i = i + 7) {
      const r = e >>> i, c = !!(r >>> 7), d = (c ? r | 128 : r) & 255;
      if (n.push(d), !c)
        return;
    }
    n.push(e >>> 31 & 1);
  }
}
const Pn = 4294967296;
function bo(t) {
  const e = t[0] === "-";
  e && (t = t.slice(1));
  const n = 1e6;
  let a = 0, s = 0;
  function i(r, c) {
    const d = Number(t.slice(r, c));
    s *= n, a = a * n + d, a >= Pn && (s = s + (a / Pn | 0), a = a % Pn);
  }
  return i(-24, -18), i(-18, -12), i(-12, -6), i(-6), e ? ci(a, s) : $t(a, s);
}
function wk(t, e) {
  let n = $t(t, e);
  const a = n.hi & 2147483648;
  a && (n = ci(n.lo, n.hi));
  const s = mi(n.lo, n.hi);
  return a ? "-" + s : s;
}
function mi(t, e) {
  if ({ lo: t, hi: e } = bk(t, e), e <= 2097151)
    return String(Pn * e + t);
  const n = t & 16777215, a = (t >>> 24 | e << 8) & 16777215, s = e >> 16 & 65535;
  let i = n + a * 6777216 + s * 6710656, r = a + s * 8147497, c = s * 2;
  const d = 1e7;
  return i >= d && (r += Math.floor(i / d), i %= d), r >= d && (c += Math.floor(r / d), r %= d), c.toString() + _o(r) + _o(i);
}
function bk(t, e) {
  return { lo: t >>> 0, hi: e >>> 0 };
}
function $t(t, e) {
  return { lo: t | 0, hi: e | 0 };
}
function ci(t, e) {
  return e = ~e, t ? t = ~t + 1 : e += 1, $t(t, e);
}
const _o = (t) => {
  const e = String(t);
  return "0000000".slice(e.length) + e;
};
function Eo(t, e) {
  if (t >= 0) {
    for (; t > 127; )
      e.push(t & 127 | 128), t = t >>> 7;
    e.push(t);
  } else {
    for (let n = 0; n < 9; n++)
      e.push(t & 127 | 128), t = t >> 7;
    e.push(1);
  }
}
function _k() {
  let t = this.buf[this.pos++], e = t & 127;
  if (!(t & 128))
    return this.assertBounds(), e;
  if (t = this.buf[this.pos++], e |= (t & 127) << 7, !(t & 128))
    return this.assertBounds(), e;
  if (t = this.buf[this.pos++], e |= (t & 127) << 14, !(t & 128))
    return this.assertBounds(), e;
  if (t = this.buf[this.pos++], e |= (t & 127) << 21, !(t & 128))
    return this.assertBounds(), e;
  t = this.buf[this.pos++], e |= (t & 15) << 28;
  for (let n = 5; t & 128 && n < 10; n++)
    t = this.buf[this.pos++];
  if (t & 128)
    throw new Error("invalid varint");
  return this.assertBounds(), e >>> 0;
}
function Ek() {
  const t = new DataView(new ArrayBuffer(8));
  if (typeof BigInt == "function" && typeof t.getBigInt64 == "function" && typeof t.getBigUint64 == "function" && typeof t.setBigInt64 == "function" && typeof t.setBigUint64 == "function" && (typeof process != "object" || typeof process.env != "object" || process.env.BUF_BIGINT_DISABLE !== "1")) {
    const s = BigInt("-9223372036854775808"), i = BigInt("9223372036854775807"), r = BigInt("0"), c = BigInt("18446744073709551615");
    return {
      zero: BigInt(0),
      supported: !0,
      parse(d) {
        const l = typeof d == "bigint" ? d : BigInt(d);
        if (l > i || l < s)
          throw new Error(`int64 invalid: ${d}`);
        return l;
      },
      uParse(d) {
        const l = typeof d == "bigint" ? d : BigInt(d);
        if (l > c || l < r)
          throw new Error(`uint64 invalid: ${d}`);
        return l;
      },
      enc(d) {
        return t.setBigInt64(0, this.parse(d), !0), {
          lo: t.getInt32(0, !0),
          hi: t.getInt32(4, !0)
        };
      },
      uEnc(d) {
        return t.setBigInt64(0, this.uParse(d), !0), {
          lo: t.getInt32(0, !0),
          hi: t.getInt32(4, !0)
        };
      },
      dec(d, l) {
        return t.setInt32(0, d, !0), t.setInt32(4, l, !0), t.getBigInt64(0, !0);
      },
      uDec(d, l) {
        return t.setInt32(0, d, !0), t.setInt32(4, l, !0), t.getBigUint64(0, !0);
      }
    };
  }
  const n = (s) => A(/^-?[0-9]+$/.test(s), `int64 invalid: ${s}`), a = (s) => A(/^[0-9]+$/.test(s), `uint64 invalid: ${s}`);
  return {
    zero: "0",
    supported: !1,
    parse(s) {
      return typeof s != "string" && (s = s.toString()), n(s), s;
    },
    uParse(s) {
      return typeof s != "string" && (s = s.toString()), a(s), s;
    },
    enc(s) {
      return typeof s != "string" && (s = s.toString()), n(s), bo(s);
    },
    uEnc(s) {
      return typeof s != "string" && (s = s.toString()), a(s), bo(s);
    },
    dec(s, i) {
      return wk(s, i);
    },
    uDec(s, i) {
      return mi(s, i);
    }
  };
}
const $ = Ek();
var h;
(function(t) {
  t[t.DOUBLE = 1] = "DOUBLE", t[t.FLOAT = 2] = "FLOAT", t[t.INT64 = 3] = "INT64", t[t.UINT64 = 4] = "UINT64", t[t.INT32 = 5] = "INT32", t[t.FIXED64 = 6] = "FIXED64", t[t.FIXED32 = 7] = "FIXED32", t[t.BOOL = 8] = "BOOL", t[t.STRING = 9] = "STRING", t[t.BYTES = 12] = "BYTES", t[t.UINT32 = 13] = "UINT32", t[t.SFIXED32 = 15] = "SFIXED32", t[t.SFIXED64 = 16] = "SFIXED64", t[t.SINT32 = 17] = "SINT32", t[t.SINT64 = 18] = "SINT64";
})(h || (h = {}));
var Fe;
(function(t) {
  t[t.BIGINT = 0] = "BIGINT", t[t.STRING = 1] = "STRING";
})(Fe || (Fe = {}));
function Ge(t, e, n) {
  if (e === n)
    return !0;
  if (t == h.BYTES) {
    if (!(e instanceof Uint8Array) || !(n instanceof Uint8Array) || e.length !== n.length)
      return !1;
    for (let a = 0; a < e.length; a++)
      if (e[a] !== n[a])
        return !1;
    return !0;
  }
  switch (t) {
    case h.UINT64:
    case h.FIXED64:
    case h.INT64:
    case h.SFIXED64:
    case h.SINT64:
      return e == n;
  }
  return !1;
}
function He(t, e) {
  switch (t) {
    case h.BOOL:
      return !1;
    case h.UINT64:
    case h.FIXED64:
    case h.INT64:
    case h.SFIXED64:
    case h.SINT64:
      return e == 0 ? $.zero : "0";
    case h.DOUBLE:
    case h.FLOAT:
      return 0;
    case h.BYTES:
      return new Uint8Array(0);
    case h.STRING:
      return "";
    default:
      return 0;
  }
}
function li(t, e) {
  switch (t) {
    case h.BOOL:
      return e === !1;
    case h.STRING:
      return e === "";
    case h.BYTES:
      return e instanceof Uint8Array && !e.byteLength;
    default:
      return e == 0;
  }
}
var G;
(function(t) {
  t[t.Varint = 0] = "Varint", t[t.Bit64 = 1] = "Bit64", t[t.LengthDelimited = 2] = "LengthDelimited", t[t.StartGroup = 3] = "StartGroup", t[t.EndGroup = 4] = "EndGroup", t[t.Bit32 = 5] = "Bit32";
})(G || (G = {}));
class Mk {
  constructor(e) {
    this.stack = [], this.textEncoder = e ?? new TextEncoder(), this.chunks = [], this.buf = [];
  }
  /**
   * Return all bytes written and reset this writer.
   */
  finish() {
    this.chunks.push(new Uint8Array(this.buf));
    let e = 0;
    for (let s = 0; s < this.chunks.length; s++)
      e += this.chunks[s].length;
    let n = new Uint8Array(e), a = 0;
    for (let s = 0; s < this.chunks.length; s++)
      n.set(this.chunks[s], a), a += this.chunks[s].length;
    return this.chunks = [], n;
  }
  /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */
  fork() {
    return this.stack.push({ chunks: this.chunks, buf: this.buf }), this.chunks = [], this.buf = [], this;
  }
  /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */
  join() {
    let e = this.finish(), n = this.stack.pop();
    if (!n)
      throw new Error("invalid state, fork stack empty");
    return this.chunks = n.chunks, this.buf = n.buf, this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */
  tag(e, n) {
    return this.uint32((e << 3 | n) >>> 0);
  }
  /**
   * Write a chunk of raw bytes.
   */
  raw(e) {
    return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(e), this;
  }
  /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */
  uint32(e) {
    for (Mt(e); e > 127; )
      this.buf.push(e & 127 | 128), e = e >>> 7;
    return this.buf.push(e), this;
  }
  /**
   * Write a `int32` value, a signed 32 bit varint.
   */
  int32(e) {
    return Cn(e), Eo(e, this.buf), this;
  }
  /**
   * Write a `bool` value, a variant.
   */
  bool(e) {
    return this.buf.push(e ? 1 : 0), this;
  }
  /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */
  bytes(e) {
    return this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */
  string(e) {
    let n = this.textEncoder.encode(e);
    return this.uint32(n.byteLength), this.raw(n);
  }
  /**
   * Write a `float` value, 32-bit floating point number.
   */
  float(e) {
    ai(e);
    let n = new Uint8Array(4);
    return new DataView(n.buffer).setFloat32(0, e, !0), this.raw(n);
  }
  /**
   * Write a `double` value, a 64-bit floating point number.
   */
  double(e) {
    let n = new Uint8Array(8);
    return new DataView(n.buffer).setFloat64(0, e, !0), this.raw(n);
  }
  /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */
  fixed32(e) {
    Mt(e);
    let n = new Uint8Array(4);
    return new DataView(n.buffer).setUint32(0, e, !0), this.raw(n);
  }
  /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */
  sfixed32(e) {
    Cn(e);
    let n = new Uint8Array(4);
    return new DataView(n.buffer).setInt32(0, e, !0), this.raw(n);
  }
  /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */
  sint32(e) {
    return Cn(e), e = (e << 1 ^ e >> 31) >>> 0, Eo(e, this.buf), this;
  }
  /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */
  sfixed64(e) {
    let n = new Uint8Array(8), a = new DataView(n.buffer), s = $.enc(e);
    return a.setInt32(0, s.lo, !0), a.setInt32(4, s.hi, !0), this.raw(n);
  }
  /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */
  fixed64(e) {
    let n = new Uint8Array(8), a = new DataView(n.buffer), s = $.uEnc(e);
    return a.setInt32(0, s.lo, !0), a.setInt32(4, s.hi, !0), this.raw(n);
  }
  /**
   * Write a `int64` value, a signed 64-bit varint.
   */
  int64(e) {
    let n = $.enc(e);
    return It(n.lo, n.hi, this.buf), this;
  }
  /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64(e) {
    let n = $.enc(e), a = n.hi >> 31, s = n.lo << 1 ^ a, i = (n.hi << 1 | n.lo >>> 31) ^ a;
    return It(s, i, this.buf), this;
  }
  /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */
  uint64(e) {
    let n = $.uEnc(e);
    return It(n.lo, n.hi, this.buf), this;
  }
}
class Ok {
  constructor(e, n) {
    this.varint64 = Sk, this.uint32 = _k, this.buf = e, this.len = e.length, this.pos = 0, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength), this.textDecoder = n ?? new TextDecoder();
  }
  /**
   * Reads a tag - field number and wire type.
   */
  tag() {
    let e = this.uint32(), n = e >>> 3, a = e & 7;
    if (n <= 0 || a < 0 || a > 5)
      throw new Error("illegal tag: field no " + n + " wire type " + a);
    return [n, a];
  }
  /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */
  skip(e, n) {
    let a = this.pos;
    switch (e) {
      case G.Varint:
        for (; this.buf[this.pos++] & 128; )
          ;
        break;
      case G.Bit64:
        this.pos += 4;
      case G.Bit32:
        this.pos += 4;
        break;
      case G.LengthDelimited:
        let s = this.uint32();
        this.pos += s;
        break;
      case G.StartGroup:
        for (; ; ) {
          const [i, r] = this.tag();
          if (r === G.EndGroup) {
            if (n !== void 0 && i !== n)
              throw new Error("invalid end group tag");
            break;
          }
          this.skip(r, i);
        }
        break;
      default:
        throw new Error("cant skip wire type " + e);
    }
    return this.assertBounds(), this.buf.subarray(a, this.pos);
  }
  /**
   * Throws error if position in byte array is out of range.
   */
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  /**
   * Read a `int32` field, a signed 32 bit varint.
   */
  int32() {
    return this.uint32() | 0;
  }
  /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */
  sint32() {
    let e = this.uint32();
    return e >>> 1 ^ -(e & 1);
  }
  /**
   * Read a `int64` field, a signed 64-bit varint.
   */
  int64() {
    return $.dec(...this.varint64());
  }
  /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */
  uint64() {
    return $.uDec(...this.varint64());
  }
  /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64() {
    let [e, n] = this.varint64(), a = -(e & 1);
    return e = (e >>> 1 | (n & 1) << 31) ^ a, n = n >>> 1 ^ a, $.dec(e, n);
  }
  /**
   * Read a `bool` field, a variant.
   */
  bool() {
    let [e, n] = this.varint64();
    return e !== 0 || n !== 0;
  }
  /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */
  fixed32() {
    return this.view.getUint32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */
  sfixed32() {
    return this.view.getInt32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */
  fixed64() {
    return $.uDec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */
  sfixed64() {
    return $.dec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `float` field, 32-bit floating point number.
   */
  float() {
    return this.view.getFloat32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `double` field, a 64-bit floating point number.
   */
  double() {
    return this.view.getFloat64((this.pos += 8) - 8, !0);
  }
  /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */
  bytes() {
    let e = this.uint32(), n = this.pos;
    return this.pos += e, this.assertBounds(), this.buf.subarray(n, n + e);
  }
  /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */
  string() {
    return this.textDecoder.decode(this.bytes());
  }
}
function Nk(t, e, n, a) {
  let s;
  return {
    typeName: e,
    extendee: n,
    get field() {
      if (!s) {
        const i = typeof a == "function" ? a() : a;
        i.name = e.split(".").pop(), i.jsonName = `[${e}]`, s = t.util.newFieldList([i]).list()[0];
      }
      return s;
    },
    runtime: t
  };
}
function di(t) {
  const e = t.field.localName, n = /* @__PURE__ */ Object.create(null);
  return n[e] = Ck(t), [n, () => n[e]];
}
function Ck(t) {
  const e = t.field;
  if (e.repeated)
    return [];
  if (e.default !== void 0)
    return e.default;
  switch (e.kind) {
    case "enum":
      return e.T.values[0].no;
    case "scalar":
      return He(e.T, e.L);
    case "message":
      const n = e.T, a = new n();
      return n.fieldWrapper ? n.fieldWrapper.unwrapField(a) : a;
    case "map":
      throw "map fields are not allowed to be extensions";
  }
}
function Pk(t, e) {
  if (!e.repeated && (e.kind == "enum" || e.kind == "scalar")) {
    for (let n = t.length - 1; n >= 0; --n)
      if (t[n].no == e.no)
        return [t[n]];
    return [];
  }
  return t.filter((n) => n.no === e.no);
}
let le = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), at = [];
for (let t = 0; t < le.length; t++)
  at[le[t].charCodeAt(0)] = t;
at[45] = le.indexOf("+");
at[95] = le.indexOf("/");
const Yt = {
  /**
   * Decodes a base64 string to a byte array.
   *
   * - ignores white-space, including line breaks and tabs
   * - allows inner padding (can decode concatenated base64 strings)
   * - does not require padding
   * - understands base64url encoding:
   *   "-" instead of "+",
   *   "_" instead of "/",
   *   no padding
   */
  dec(t) {
    let e = t.length * 3 / 4;
    t[t.length - 2] == "=" ? e -= 2 : t[t.length - 1] == "=" && (e -= 1);
    let n = new Uint8Array(e), a = 0, s = 0, i, r = 0;
    for (let c = 0; c < t.length; c++) {
      if (i = at[t.charCodeAt(c)], i === void 0)
        switch (t[c]) {
          case "=":
            s = 0;
          case `
`:
          case "\r":
          case "	":
          case " ":
            continue;
          default:
            throw Error("invalid base64 string.");
        }
      switch (s) {
        case 0:
          r = i, s = 1;
          break;
        case 1:
          n[a++] = r << 2 | (i & 48) >> 4, r = i, s = 2;
          break;
        case 2:
          n[a++] = (r & 15) << 4 | (i & 60) >> 2, r = i, s = 3;
          break;
        case 3:
          n[a++] = (r & 3) << 6 | i, s = 0;
          break;
      }
    }
    if (s == 1)
      throw Error("invalid base64 string.");
    return n.subarray(0, a);
  },
  /**
   * Encode a byte array to a base64 string.
   */
  enc(t) {
    let e = "", n = 0, a, s = 0;
    for (let i = 0; i < t.length; i++)
      switch (a = t[i], n) {
        case 0:
          e += le[a >> 2], s = (a & 3) << 4, n = 1;
          break;
        case 1:
          e += le[s | a >> 4], s = (a & 15) << 2, n = 2;
          break;
        case 2:
          e += le[s | a >> 6], e += le[a & 63], n = 0;
          break;
      }
    return n && (e += le[s], e += "=", n == 1 && (e += "=")), e;
  }
};
function Dk(t, e, n) {
  pi(e, t);
  const a = e.runtime.bin.makeReadOptions(n), s = Pk(t.getType().runtime.bin.listUnknownFields(t), e.field), [i, r] = di(e);
  for (const c of s)
    e.runtime.bin.readField(i, a.readerFactory(c.data), e.field, c.wireType, a);
  return r();
}
function qk(t, e, n, a) {
  pi(e, t);
  const s = e.runtime.bin.makeReadOptions(a), i = e.runtime.bin.makeWriteOptions(a);
  if (ui(t, e)) {
    const l = t.getType().runtime.bin.listUnknownFields(t).filter((T) => T.no != e.field.no);
    t.getType().runtime.bin.discardUnknownFields(t);
    for (const T of l)
      t.getType().runtime.bin.onUnknownField(t, T.no, T.wireType, T.data);
  }
  const r = i.writerFactory();
  let c = e.field;
  !c.opt && !c.repeated && (c.kind == "enum" || c.kind == "scalar") && (c = Object.assign(Object.assign({}, e.field), { opt: !0 })), e.runtime.bin.writeField(c, n, r, i);
  const d = s.readerFactory(r.finish());
  for (; d.pos < d.len; ) {
    const [l, T] = d.tag(), R = d.skip(T, l);
    t.getType().runtime.bin.onUnknownField(t, l, T, R);
  }
}
function ui(t, e) {
  const n = t.getType();
  return e.extendee.typeName === n.typeName && !!n.runtime.bin.listUnknownFields(t).find((a) => a.no == e.field.no);
}
function pi(t, e) {
  A(t.extendee.typeName == e.getType().typeName, `extension ${t.typeName} can only be applied to message ${t.extendee.typeName}`);
}
function gi(t, e) {
  const n = t.localName;
  if (t.repeated)
    return e[n].length > 0;
  if (t.oneof)
    return e[t.oneof.localName].case === n;
  switch (t.kind) {
    case "enum":
    case "scalar":
      return t.opt || t.req ? e[n] !== void 0 : t.kind == "enum" ? e[n] !== t.T.values[0].no : !li(t.T, e[n]);
    case "message":
      return e[n] !== void 0;
    case "map":
      return Object.keys(e[n]).length > 0;
  }
}
function Mo(t, e) {
  const n = t.localName, a = !t.opt && !t.req;
  if (t.repeated)
    e[n] = [];
  else if (t.oneof)
    e[t.oneof.localName] = { case: void 0 };
  else
    switch (t.kind) {
      case "map":
        e[n] = {};
        break;
      case "enum":
        e[n] = a ? t.T.values[0].no : void 0;
        break;
      case "scalar":
        e[n] = a ? He(t.T, t.L) : void 0;
        break;
      case "message":
        e[n] = void 0;
        break;
    }
}
function Ye(t, e) {
  if (t === null || typeof t != "object" || !Object.getOwnPropertyNames(E.prototype).every((a) => a in t && typeof t[a] == "function"))
    return !1;
  const n = t.getType();
  return n === null || typeof n != "function" || !("typeName" in n) || typeof n.typeName != "string" ? !1 : e === void 0 ? !0 : n.typeName == e.typeName;
}
function Ti(t, e) {
  return Ye(e) || !t.fieldWrapper ? e : t.fieldWrapper.wrapField(e);
}
h.DOUBLE, h.FLOAT, h.INT64, h.UINT64, h.INT32, h.UINT32, h.BOOL, h.STRING, h.BYTES;
const Oo = {
  ignoreUnknownFields: !1
}, No = {
  emitDefaultValues: !1,
  enumAsInteger: !1,
  useProtoFieldName: !1,
  prettySpaces: 0
};
function Ak(t) {
  return t ? Object.assign(Object.assign({}, Oo), t) : Oo;
}
function Uk(t) {
  return t ? Object.assign(Object.assign({}, No), t) : No;
}
const Gn = Symbol(), Dn = Symbol();
function Gk() {
  return {
    makeReadOptions: Ak,
    makeWriteOptions: Uk,
    readMessage(t, e, n, a) {
      if (e == null || Array.isArray(e) || typeof e != "object")
        throw new Error(`cannot decode message ${t.typeName} from JSON: ${ae(e)}`);
      a = a ?? new t();
      const s = /* @__PURE__ */ new Map(), i = n.typeRegistry;
      for (const [r, c] of Object.entries(e)) {
        const d = t.fields.findJsonName(r);
        if (d) {
          if (d.oneof) {
            if (c === null && d.kind == "scalar")
              continue;
            const l = s.get(d.oneof);
            if (l !== void 0)
              throw new Error(`cannot decode message ${t.typeName} from JSON: multiple keys for oneof "${d.oneof.name}" present: "${l}", "${r}"`);
            s.set(d.oneof, r);
          }
          Co(a, c, d, n, t);
        } else {
          let l = !1;
          if (i?.findExtension && r.startsWith("[") && r.endsWith("]")) {
            const T = i.findExtension(r.substring(1, r.length - 1));
            if (T && T.extendee.typeName == t.typeName) {
              l = !0;
              const [R, S] = di(T);
              Co(R, c, T.field, n, T), qk(a, T, S(), n);
            }
          }
          if (!l && !n.ignoreUnknownFields)
            throw new Error(`cannot decode message ${t.typeName} from JSON: key "${r}" is unknown`);
        }
      }
      return a;
    },
    writeMessage(t, e) {
      const n = t.getType(), a = {};
      let s;
      try {
        for (s of n.fields.byNumber()) {
          if (!gi(s, t)) {
            if (s.req)
              throw "required field not set";
            if (!e.emitDefaultValues || !Bk(s))
              continue;
          }
          const r = s.oneof ? t[s.oneof.localName].value : t[s.localName], c = Po(s, r, e);
          c !== void 0 && (a[e.useProtoFieldName ? s.name : s.jsonName] = c);
        }
        const i = e.typeRegistry;
        if (i?.findExtensionFor)
          for (const r of n.runtime.bin.listUnknownFields(t)) {
            const c = i.findExtensionFor(n.typeName, r.no);
            if (c && ui(t, c)) {
              const d = Dk(t, c, e), l = Po(c.field, d, e);
              l !== void 0 && (a[c.field.jsonName] = l);
            }
          }
      } catch (i) {
        const r = s ? `cannot encode field ${n.typeName}.${s.name} to JSON` : `cannot encode message ${n.typeName} to JSON`, c = i instanceof Error ? i.message : String(i);
        throw new Error(r + (c.length > 0 ? `: ${c}` : ""));
      }
      return a;
    },
    readScalar(t, e, n) {
      return ln(t, e, n ?? Fe.BIGINT, !0);
    },
    writeScalar(t, e, n) {
      if (e !== void 0 && (n || li(t, e)))
        return qn(t, e);
    },
    debug: ae
  };
}
function ae(t) {
  if (t === null)
    return "null";
  switch (typeof t) {
    case "object":
      return Array.isArray(t) ? "array" : "object";
    case "string":
      return t.length > 100 ? "string" : `"${t.split('"').join('\\"')}"`;
    default:
      return String(t);
  }
}
function Co(t, e, n, a, s) {
  let i = n.localName;
  if (n.repeated) {
    if (A(n.kind != "map"), e === null)
      return;
    if (!Array.isArray(e))
      throw new Error(`cannot decode field ${s.typeName}.${n.name} from JSON: ${ae(e)}`);
    const r = t[i];
    for (const c of e) {
      if (c === null)
        throw new Error(`cannot decode field ${s.typeName}.${n.name} from JSON: ${ae(c)}`);
      switch (n.kind) {
        case "message":
          r.push(n.T.fromJson(c, a));
          break;
        case "enum":
          const d = St(n.T, c, a.ignoreUnknownFields, !0);
          d !== Dn && r.push(d);
          break;
        case "scalar":
          try {
            r.push(ln(n.T, c, n.L, !0));
          } catch (l) {
            let T = `cannot decode field ${s.typeName}.${n.name} from JSON: ${ae(c)}`;
            throw l instanceof Error && l.message.length > 0 && (T += `: ${l.message}`), new Error(T);
          }
          break;
      }
    }
  } else if (n.kind == "map") {
    if (e === null)
      return;
    if (typeof e != "object" || Array.isArray(e))
      throw new Error(`cannot decode field ${s.typeName}.${n.name} from JSON: ${ae(e)}`);
    const r = t[i];
    for (const [c, d] of Object.entries(e)) {
      if (d === null)
        throw new Error(`cannot decode field ${s.typeName}.${n.name} from JSON: map value null`);
      let l;
      try {
        l = Lk(n.K, c);
      } catch (T) {
        let R = `cannot decode map key for field ${s.typeName}.${n.name} from JSON: ${ae(e)}`;
        throw T instanceof Error && T.message.length > 0 && (R += `: ${T.message}`), new Error(R);
      }
      switch (n.V.kind) {
        case "message":
          r[l] = n.V.T.fromJson(d, a);
          break;
        case "enum":
          const T = St(n.V.T, d, a.ignoreUnknownFields, !0);
          T !== Dn && (r[l] = T);
          break;
        case "scalar":
          try {
            r[l] = ln(n.V.T, d, Fe.BIGINT, !0);
          } catch (R) {
            let S = `cannot decode map value for field ${s.typeName}.${n.name} from JSON: ${ae(e)}`;
            throw R instanceof Error && R.message.length > 0 && (S += `: ${R.message}`), new Error(S);
          }
          break;
      }
    }
  } else
    switch (n.oneof && (t = t[n.oneof.localName] = { case: i }, i = "value"), n.kind) {
      case "message":
        const r = n.T;
        if (e === null && r.typeName != "google.protobuf.Value")
          return;
        let c = t[i];
        Ye(c) ? c.fromJson(e, a) : (t[i] = c = r.fromJson(e, a), r.fieldWrapper && !n.oneof && (t[i] = r.fieldWrapper.unwrapField(c)));
        break;
      case "enum":
        const d = St(n.T, e, a.ignoreUnknownFields, !1);
        switch (d) {
          case Gn:
            Mo(n, t);
            break;
          case Dn:
            break;
          default:
            t[i] = d;
            break;
        }
        break;
      case "scalar":
        try {
          const l = ln(n.T, e, n.L, !1);
          switch (l) {
            case Gn:
              Mo(n, t);
              break;
            default:
              t[i] = l;
              break;
          }
        } catch (l) {
          let T = `cannot decode field ${s.typeName}.${n.name} from JSON: ${ae(e)}`;
          throw l instanceof Error && l.message.length > 0 && (T += `: ${l.message}`), new Error(T);
        }
        break;
    }
}
function Lk(t, e) {
  if (t === h.BOOL)
    switch (e) {
      case "true":
        e = !0;
        break;
      case "false":
        e = !1;
        break;
    }
  return ln(t, e, Fe.BIGINT, !0).toString();
}
function ln(t, e, n, a) {
  if (e === null)
    return a ? He(t, n) : Gn;
  switch (t) {
    case h.DOUBLE:
    case h.FLOAT:
      if (e === "NaN")
        return Number.NaN;
      if (e === "Infinity")
        return Number.POSITIVE_INFINITY;
      if (e === "-Infinity")
        return Number.NEGATIVE_INFINITY;
      if (e === "" || typeof e == "string" && e.trim().length !== e.length || typeof e != "string" && typeof e != "number")
        break;
      const s = Number(e);
      if (Number.isNaN(s) || !Number.isFinite(s))
        break;
      return t == h.FLOAT && ai(s), s;
    case h.INT32:
    case h.FIXED32:
    case h.SFIXED32:
    case h.SINT32:
    case h.UINT32:
      let i;
      if (typeof e == "number" ? i = e : typeof e == "string" && e.length > 0 && e.trim().length === e.length && (i = Number(e)), i === void 0)
        break;
      return t == h.UINT32 || t == h.FIXED32 ? Mt(i) : Cn(i), i;
    case h.INT64:
    case h.SFIXED64:
    case h.SINT64:
      if (typeof e != "number" && typeof e != "string")
        break;
      const r = $.parse(e);
      return n ? r.toString() : r;
    case h.FIXED64:
    case h.UINT64:
      if (typeof e != "number" && typeof e != "string")
        break;
      const c = $.uParse(e);
      return n ? c.toString() : c;
    case h.BOOL:
      if (typeof e != "boolean")
        break;
      return e;
    case h.STRING:
      if (typeof e != "string")
        break;
      try {
        encodeURIComponent(e);
      } catch {
        throw new Error("invalid UTF8");
      }
      return e;
    case h.BYTES:
      if (e === "")
        return new Uint8Array(0);
      if (typeof e != "string")
        break;
      return Yt.dec(e);
  }
  throw new Error();
}
function St(t, e, n, a) {
  if (e === null)
    return t.typeName == "google.protobuf.NullValue" ? 0 : a ? t.values[0].no : Gn;
  switch (typeof e) {
    case "number":
      if (Number.isInteger(e))
        return e;
      break;
    case "string":
      const s = t.findName(e);
      if (s !== void 0)
        return s.no;
      if (n)
        return Dn;
      break;
  }
  throw new Error(`cannot decode enum ${t.typeName} from JSON: ${ae(e)}`);
}
function Bk(t) {
  return t.repeated || t.kind == "map" ? !0 : !(t.oneof || t.kind == "message" || t.opt || t.req);
}
function Po(t, e, n) {
  if (t.kind == "map") {
    A(typeof e == "object" && e != null);
    const a = {}, s = Object.entries(e);
    switch (t.V.kind) {
      case "scalar":
        for (const [r, c] of s)
          a[r.toString()] = qn(t.V.T, c);
        break;
      case "message":
        for (const [r, c] of s)
          a[r.toString()] = c.toJson(n);
        break;
      case "enum":
        const i = t.V.T;
        for (const [r, c] of s)
          a[r.toString()] = wt(i, c, n.enumAsInteger);
        break;
    }
    return n.emitDefaultValues || s.length > 0 ? a : void 0;
  }
  if (t.repeated) {
    A(Array.isArray(e));
    const a = [];
    switch (t.kind) {
      case "scalar":
        for (let s = 0; s < e.length; s++)
          a.push(qn(t.T, e[s]));
        break;
      case "enum":
        for (let s = 0; s < e.length; s++)
          a.push(wt(t.T, e[s], n.enumAsInteger));
        break;
      case "message":
        for (let s = 0; s < e.length; s++)
          a.push(e[s].toJson(n));
        break;
    }
    return n.emitDefaultValues || a.length > 0 ? a : void 0;
  }
  switch (t.kind) {
    case "scalar":
      return qn(t.T, e);
    case "enum":
      return wt(t.T, e, n.enumAsInteger);
    case "message":
      return Ti(t.T, e).toJson(n);
  }
}
function wt(t, e, n) {
  var a;
  if (A(typeof e == "number"), t.typeName == "google.protobuf.NullValue")
    return null;
  if (n)
    return e;
  const s = t.findNumber(e);
  return (a = s?.name) !== null && a !== void 0 ? a : e;
}
function qn(t, e) {
  switch (t) {
    case h.INT32:
    case h.SFIXED32:
    case h.SINT32:
    case h.FIXED32:
    case h.UINT32:
      return A(typeof e == "number"), e;
    case h.FLOAT:
    case h.DOUBLE:
      return A(typeof e == "number"), Number.isNaN(e) ? "NaN" : e === Number.POSITIVE_INFINITY ? "Infinity" : e === Number.NEGATIVE_INFINITY ? "-Infinity" : e;
    case h.STRING:
      return A(typeof e == "string"), e;
    case h.BOOL:
      return A(typeof e == "boolean"), e;
    case h.UINT64:
    case h.FIXED64:
    case h.INT64:
    case h.SFIXED64:
    case h.SINT64:
      return A(typeof e == "bigint" || typeof e == "string" || typeof e == "number"), e.toString();
    case h.BYTES:
      return A(e instanceof Uint8Array), Yt.enc(e);
  }
}
const je = Symbol("@bufbuild/protobuf/unknown-fields"), Do = {
  readUnknownFields: !0,
  readerFactory: (t) => new Ok(t)
}, qo = {
  writeUnknownFields: !0,
  writerFactory: () => new Mk()
};
function xk(t) {
  return t ? Object.assign(Object.assign({}, Do), t) : Do;
}
function Fk(t) {
  return t ? Object.assign(Object.assign({}, qo), t) : qo;
}
function Jk() {
  return {
    makeReadOptions: xk,
    makeWriteOptions: Fk,
    listUnknownFields(t) {
      var e;
      return (e = t[je]) !== null && e !== void 0 ? e : [];
    },
    discardUnknownFields(t) {
      delete t[je];
    },
    writeUnknownFields(t, e) {
      const a = t[je];
      if (a)
        for (const s of a)
          e.tag(s.no, s.wireType).raw(s.data);
    },
    onUnknownField(t, e, n, a) {
      const s = t;
      Array.isArray(s[je]) || (s[je] = []), s[je].push({ no: e, wireType: n, data: a });
    },
    readMessage(t, e, n, a, s) {
      const i = t.getType(), r = s ? e.len : e.pos + n;
      let c, d;
      for (; e.pos < r && ([c, d] = e.tag(), !(s === !0 && d == G.EndGroup)); ) {
        const l = i.fields.find(c);
        if (!l) {
          const T = e.skip(d, c);
          a.readUnknownFields && this.onUnknownField(t, c, d, T);
          continue;
        }
        Ao(t, e, l, d, a);
      }
      if (s && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
      (d != G.EndGroup || c !== n))
        throw new Error("invalid end group tag");
    },
    readField: Ao,
    writeMessage(t, e, n) {
      const a = t.getType();
      for (const s of a.fields.byNumber()) {
        if (!gi(s, t)) {
          if (s.req)
            throw new Error(`cannot encode field ${a.typeName}.${s.name} to binary: required field not set`);
          continue;
        }
        const i = s.oneof ? t[s.oneof.localName].value : t[s.localName];
        Uo(s, i, e, n);
      }
      return n.writeUnknownFields && this.writeUnknownFields(t, e), e;
    },
    writeField(t, e, n, a) {
      e !== void 0 && Uo(t, e, n, a);
    }
  };
}
function Ao(t, e, n, a, s) {
  let { repeated: i, localName: r } = n;
  switch (n.oneof && (t = t[n.oneof.localName], t.case != r && delete t.value, t.case = r, r = "value"), n.kind) {
    case "scalar":
    case "enum":
      const c = n.kind == "enum" ? h.INT32 : n.T;
      let d = Ln;
      if (n.kind == "scalar" && n.L > 0 && (d = $k), i) {
        let S = t[r];
        if (a == G.LengthDelimited && c != h.STRING && c != h.BYTES) {
          let w = e.uint32() + e.pos;
          for (; e.pos < w; )
            S.push(d(e, c));
        } else
          S.push(d(e, c));
      } else
        t[r] = d(e, c);
      break;
    case "message":
      const l = n.T;
      i ? t[r].push(An(e, new l(), s, n)) : Ye(t[r]) ? An(e, t[r], s, n) : (t[r] = An(e, new l(), s, n), l.fieldWrapper && !n.oneof && !n.repeated && (t[r] = l.fieldWrapper.unwrapField(t[r])));
      break;
    case "map":
      let [T, R] = zk(n, e, s);
      t[r][T] = R;
      break;
  }
}
function An(t, e, n, a) {
  const s = e.getType().runtime.bin, i = a?.delimited;
  return s.readMessage(
    e,
    t,
    i ? a.no : t.uint32(),
    // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    n,
    i
  ), e;
}
function zk(t, e, n) {
  const a = e.uint32(), s = e.pos + a;
  let i, r;
  for (; e.pos < s; ) {
    const [c] = e.tag();
    switch (c) {
      case 1:
        i = Ln(e, t.K);
        break;
      case 2:
        switch (t.V.kind) {
          case "scalar":
            r = Ln(e, t.V.T);
            break;
          case "enum":
            r = e.int32();
            break;
          case "message":
            r = An(e, new t.V.T(), n, void 0);
            break;
        }
        break;
    }
  }
  if (i === void 0 && (i = He(t.K, Fe.BIGINT)), typeof i != "string" && typeof i != "number" && (i = i.toString()), r === void 0)
    switch (t.V.kind) {
      case "scalar":
        r = He(t.V.T, Fe.BIGINT);
        break;
      case "enum":
        r = t.V.T.values[0].no;
        break;
      case "message":
        r = new t.V.T();
        break;
    }
  return [i, r];
}
function $k(t, e) {
  const n = Ln(t, e);
  return typeof n == "bigint" ? n.toString() : n;
}
function Ln(t, e) {
  switch (e) {
    case h.STRING:
      return t.string();
    case h.BOOL:
      return t.bool();
    case h.DOUBLE:
      return t.double();
    case h.FLOAT:
      return t.float();
    case h.INT32:
      return t.int32();
    case h.INT64:
      return t.int64();
    case h.UINT64:
      return t.uint64();
    case h.FIXED64:
      return t.fixed64();
    case h.BYTES:
      return t.bytes();
    case h.FIXED32:
      return t.fixed32();
    case h.SFIXED32:
      return t.sfixed32();
    case h.SFIXED64:
      return t.sfixed64();
    case h.SINT64:
      return t.sint64();
    case h.UINT32:
      return t.uint32();
    case h.SINT32:
      return t.sint32();
  }
}
function Uo(t, e, n, a) {
  A(e !== void 0);
  const s = t.repeated;
  switch (t.kind) {
    case "scalar":
    case "enum":
      let i = t.kind == "enum" ? h.INT32 : t.T;
      if (s)
        if (A(Array.isArray(e)), t.packed)
          Wk(n, i, t.no, e);
        else
          for (const r of e)
            dn(n, i, t.no, r);
      else
        dn(n, i, t.no, e);
      break;
    case "message":
      if (s) {
        A(Array.isArray(e));
        for (const r of e)
          Go(n, a, t, r);
      } else
        Go(n, a, t, e);
      break;
    case "map":
      A(typeof e == "object" && e != null);
      for (const [r, c] of Object.entries(e))
        Yk(n, a, t, r, c);
      break;
  }
}
function Yk(t, e, n, a, s) {
  t.tag(n.no, G.LengthDelimited), t.fork();
  let i = a;
  switch (n.K) {
    case h.INT32:
    case h.FIXED32:
    case h.UINT32:
    case h.SFIXED32:
    case h.SINT32:
      i = Number.parseInt(a);
      break;
    case h.BOOL:
      A(a == "true" || a == "false"), i = a == "true";
      break;
  }
  switch (dn(t, n.K, 1, i), n.V.kind) {
    case "scalar":
      dn(t, n.V.T, 2, s);
      break;
    case "enum":
      dn(t, h.INT32, 2, s);
      break;
    case "message":
      A(s !== void 0), t.tag(2, G.LengthDelimited).bytes(s.toBinary(e));
      break;
  }
  t.join();
}
function Go(t, e, n, a) {
  const s = Ti(n.T, a);
  n.delimited ? t.tag(n.no, G.StartGroup).raw(s.toBinary(e)).tag(n.no, G.EndGroup) : t.tag(n.no, G.LengthDelimited).bytes(s.toBinary(e));
}
function dn(t, e, n, a) {
  A(a !== void 0);
  let [s, i] = ki(e);
  t.tag(n, s)[i](a);
}
function Wk(t, e, n, a) {
  if (!a.length)
    return;
  t.tag(n, G.LengthDelimited).fork();
  let [, s] = ki(e);
  for (let i = 0; i < a.length; i++)
    t[s](a[i]);
  t.join();
}
function ki(t) {
  let e = G.Varint;
  switch (t) {
    case h.BYTES:
    case h.STRING:
      e = G.LengthDelimited;
      break;
    case h.DOUBLE:
    case h.FIXED64:
    case h.SFIXED64:
      e = G.Bit64;
      break;
    case h.FIXED32:
    case h.SFIXED32:
    case h.FLOAT:
      e = G.Bit32;
      break;
  }
  const n = h[t].toLowerCase();
  return [e, n];
}
function Vk() {
  return {
    setEnumType: oi,
    initPartial(t, e) {
      if (t === void 0)
        return;
      const n = e.getType();
      for (const a of n.fields.byMember()) {
        const s = a.localName, i = e, r = t;
        if (r[s] != null)
          switch (a.kind) {
            case "oneof":
              const c = r[s].case;
              if (c === void 0)
                continue;
              const d = a.findField(c);
              let l = r[s].value;
              d && d.kind == "message" && !Ye(l, d.T) ? l = new d.T(l) : d && d.kind === "scalar" && d.T === h.BYTES && (l = rn(l)), i[s] = { case: c, value: l };
              break;
            case "scalar":
            case "enum":
              let T = r[s];
              a.T === h.BYTES && (T = a.repeated ? T.map(rn) : rn(T)), i[s] = T;
              break;
            case "map":
              switch (a.V.kind) {
                case "scalar":
                case "enum":
                  if (a.V.T === h.BYTES)
                    for (const [f, w] of Object.entries(r[s]))
                      i[s][f] = rn(w);
                  else
                    Object.assign(i[s], r[s]);
                  break;
                case "message":
                  const S = a.V.T;
                  for (const f of Object.keys(r[s])) {
                    let w = r[s][f];
                    S.fieldWrapper || (w = new S(w)), i[s][f] = w;
                  }
                  break;
              }
              break;
            case "message":
              const R = a.T;
              if (a.repeated)
                i[s] = r[s].map((S) => Ye(S, R) ? S : new R(S));
              else {
                const S = r[s];
                R.fieldWrapper ? /* We can't use BytesValue.typeName as that will create a circular import */ R.typeName === "google.protobuf.BytesValue" ? i[s] = rn(S) : i[s] = S : i[s] = Ye(S, R) ? S : new R(S);
              }
              break;
          }
      }
    },
    // TODO use isFieldSet() here to support future field presence
    equals(t, e, n) {
      return e === n ? !0 : !e || !n ? !1 : t.fields.byMember().every((a) => {
        const s = e[a.localName], i = n[a.localName];
        if (a.repeated) {
          if (s.length !== i.length)
            return !1;
          switch (a.kind) {
            case "message":
              return s.every((r, c) => a.T.equals(r, i[c]));
            case "scalar":
              return s.every((r, c) => Ge(a.T, r, i[c]));
            case "enum":
              return s.every((r, c) => Ge(h.INT32, r, i[c]));
          }
          throw new Error(`repeated cannot contain ${a.kind}`);
        }
        switch (a.kind) {
          case "message":
            return a.T.equals(s, i);
          case "enum":
            return Ge(h.INT32, s, i);
          case "scalar":
            return Ge(a.T, s, i);
          case "oneof":
            if (s.case !== i.case)
              return !1;
            const r = a.findField(s.case);
            if (r === void 0)
              return !0;
            switch (r.kind) {
              case "message":
                return r.T.equals(s.value, i.value);
              case "enum":
                return Ge(h.INT32, s.value, i.value);
              case "scalar":
                return Ge(r.T, s.value, i.value);
            }
            throw new Error(`oneof cannot contain ${r.kind}`);
          case "map":
            const c = Object.keys(s).concat(Object.keys(i));
            switch (a.V.kind) {
              case "message":
                const d = a.V.T;
                return c.every((T) => d.equals(s[T], i[T]));
              case "enum":
                return c.every((T) => Ge(h.INT32, s[T], i[T]));
              case "scalar":
                const l = a.V.T;
                return c.every((T) => Ge(l, s[T], i[T]));
            }
            break;
        }
      });
    },
    // TODO use isFieldSet() here to support future field presence
    clone(t) {
      const e = t.getType(), n = new e(), a = n;
      for (const s of e.fields.byMember()) {
        const i = t[s.localName];
        let r;
        if (s.repeated)
          r = i.map(Nn);
        else if (s.kind == "map") {
          r = a[s.localName];
          for (const [c, d] of Object.entries(i))
            r[c] = Nn(d);
        } else s.kind == "oneof" ? r = s.findField(i.case) ? { case: i.case, value: Nn(i.value) } : { case: void 0 } : r = Nn(i);
        a[s.localName] = r;
      }
      for (const s of e.runtime.bin.listUnknownFields(t))
        e.runtime.bin.onUnknownField(a, s.no, s.wireType, s.data);
      return n;
    }
  };
}
function Nn(t) {
  if (t === void 0)
    return t;
  if (Ye(t))
    return t.clone();
  if (t instanceof Uint8Array) {
    const e = new Uint8Array(t.byteLength);
    return e.set(t), e;
  }
  return t;
}
function rn(t) {
  return t instanceof Uint8Array ? t : new Uint8Array(t);
}
function yi(t, e, n) {
  return {
    syntax: t,
    json: Gk(),
    bin: Jk(),
    util: Object.assign(Object.assign({}, Vk()), {
      newFieldList: e,
      initFields: n
    }),
    makeMessageType(a, s, i) {
      return Ik(this, a, s, i);
    },
    makeEnum: Rk,
    makeEnumType: ii,
    getEnumType: fk,
    makeExtension(a, s, i) {
      return Nk(this, a, s, i);
    }
  };
}
class vi {
  constructor(e, n) {
    this._fields = e, this._normalizer = n;
  }
  findJsonName(e) {
    if (!this.jsonNames) {
      const n = {};
      for (const a of this.list())
        n[a.jsonName] = n[a.name] = a;
      this.jsonNames = n;
    }
    return this.jsonNames[e];
  }
  find(e) {
    if (!this.numbers) {
      const n = {};
      for (const a of this.list())
        n[a.no] = a;
      this.numbers = n;
    }
    return this.numbers[e];
  }
  list() {
    return this.all || (this.all = this._normalizer(this._fields)), this.all;
  }
  byNumber() {
    return this.numbersAsc || (this.numbersAsc = this.list().concat().sort((e, n) => e.no - n.no)), this.numbersAsc;
  }
  byMember() {
    if (!this.members) {
      this.members = [];
      const e = this.members;
      let n;
      for (const a of this.list())
        a.oneof ? a.oneof !== n && (n = a.oneof, e.push(n)) : e.push(a);
    }
    return this.members;
  }
}
function hi(t, e) {
  const n = fi(t);
  return e ? n : Zk(Qk(n));
}
function jk(t) {
  return hi(t, !1);
}
const Hk = fi;
function fi(t) {
  let e = !1;
  const n = [];
  for (let a = 0; a < t.length; a++) {
    let s = t.charAt(a);
    switch (s) {
      case "_":
        e = !0;
        break;
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        n.push(s), e = !1;
        break;
      default:
        e && (e = !1, s = s.toUpperCase()), n.push(s);
        break;
    }
  }
  return n.join("");
}
const Kk = /* @__PURE__ */ new Set([
  // names reserved by JavaScript
  "constructor",
  "toString",
  "toJSON",
  "valueOf"
]), Xk = /* @__PURE__ */ new Set([
  // names reserved by the runtime
  "getType",
  "clone",
  "equals",
  "fromBinary",
  "fromJson",
  "fromJsonString",
  "toBinary",
  "toJson",
  "toJsonString",
  // names reserved by the runtime for the future
  "toObject"
]), Ri = (t) => `${t}$`, Qk = (t) => Xk.has(t) ? Ri(t) : t, Zk = (t) => Kk.has(t) ? Ri(t) : t;
class ey {
  constructor(e) {
    this.kind = "oneof", this.repeated = !1, this.packed = !1, this.opt = !1, this.req = !1, this.default = void 0, this.fields = [], this.name = e, this.localName = jk(e);
  }
  addField(e) {
    A(e.oneof === this, `field ${e.name} not one of ${this.name}`), this.fields.push(e);
  }
  findField(e) {
    if (!this._lookup) {
      this._lookup = /* @__PURE__ */ Object.create(null);
      for (let n = 0; n < this.fields.length; n++)
        this._lookup[this.fields[n].localName] = this.fields[n];
    }
    return this._lookup[e];
  }
}
function Ii(t, e) {
  var n, a, s, i, r, c;
  const d = [];
  let l;
  for (const T of typeof t == "function" ? t() : t) {
    const R = T;
    if (R.localName = hi(T.name, T.oneof !== void 0), R.jsonName = (n = T.jsonName) !== null && n !== void 0 ? n : Hk(T.name), R.repeated = (a = T.repeated) !== null && a !== void 0 ? a : !1, T.kind == "scalar" && (R.L = (s = T.L) !== null && s !== void 0 ? s : Fe.BIGINT), R.delimited = (i = T.delimited) !== null && i !== void 0 ? i : !1, R.req = (r = T.req) !== null && r !== void 0 ? r : !1, R.opt = (c = T.opt) !== null && c !== void 0 ? c : !1, T.packed === void 0 && (e ? R.packed = T.kind == "enum" || T.kind == "scalar" && T.T != h.BYTES && T.T != h.STRING : R.packed = !1), T.oneof !== void 0) {
      const S = typeof T.oneof == "string" ? T.oneof : T.oneof.name;
      (!l || l.name != S) && (l = new ey(S)), R.oneof = l, l.addField(R);
    }
    d.push(R);
  }
  return d;
}
const o = yi(
  "proto3",
  (t) => new vi(t, (e) => Ii(e, !0)),
  // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
  (t) => {
    for (const e of t.getType().fields.byMember()) {
      if (e.opt)
        continue;
      const n = e.localName, a = t;
      if (e.repeated) {
        a[n] = [];
        continue;
      }
      switch (e.kind) {
        case "oneof":
          a[n] = { case: void 0 };
          break;
        case "enum":
          a[n] = 0;
          break;
        case "map":
          a[n] = {};
          break;
        case "scalar":
          a[n] = He(e.T, e.L);
          break;
      }
    }
  }
), p = yi(
  "proto2",
  (t) => new vi(t, (e) => Ii(e, !1)),
  // TODO merge with proto3 and initExtensionField, also see initPartial, equals, clone
  (t) => {
    for (const e of t.getType().fields.byMember()) {
      const n = e.localName, a = t;
      if (e.repeated) {
        a[n] = [];
        continue;
      }
      switch (e.kind) {
        case "oneof":
          a[n] = { case: void 0 };
          break;
        case "map":
          a[n] = {};
          break;
      }
    }
  }
);
var m;
(function(t) {
  t[t.Unary = 0] = "Unary", t[t.ServerStreaming = 1] = "ServerStreaming", t[t.ClientStreaming = 2] = "ClientStreaming", t[t.BiDiStreaming = 3] = "BiDiStreaming";
})(m || (m = {}));
var Lo;
(function(t) {
  t[t.NoSideEffects = 1] = "NoSideEffects", t[t.Idempotent = 2] = "Idempotent";
})(Lo || (Lo = {}));
var ne;
(function(t) {
  t[t.EDITION_UNKNOWN = 0] = "EDITION_UNKNOWN", t[t.EDITION_LEGACY = 900] = "EDITION_LEGACY", t[t.EDITION_PROTO2 = 998] = "EDITION_PROTO2", t[t.EDITION_PROTO3 = 999] = "EDITION_PROTO3", t[t.EDITION_2023 = 1e3] = "EDITION_2023", t[t.EDITION_2024 = 1001] = "EDITION_2024", t[t.EDITION_1_TEST_ONLY = 1] = "EDITION_1_TEST_ONLY", t[t.EDITION_2_TEST_ONLY = 2] = "EDITION_2_TEST_ONLY", t[t.EDITION_99997_TEST_ONLY = 99997] = "EDITION_99997_TEST_ONLY", t[t.EDITION_99998_TEST_ONLY = 99998] = "EDITION_99998_TEST_ONLY", t[t.EDITION_99999_TEST_ONLY = 99999] = "EDITION_99999_TEST_ONLY", t[t.EDITION_MAX = 2147483647] = "EDITION_MAX";
})(ne || (ne = {}));
p.util.setEnumType(ne, "google.protobuf.Edition", [
  { no: 0, name: "EDITION_UNKNOWN" },
  { no: 900, name: "EDITION_LEGACY" },
  { no: 998, name: "EDITION_PROTO2" },
  { no: 999, name: "EDITION_PROTO3" },
  { no: 1e3, name: "EDITION_2023" },
  { no: 1001, name: "EDITION_2024" },
  { no: 1, name: "EDITION_1_TEST_ONLY" },
  { no: 2, name: "EDITION_2_TEST_ONLY" },
  { no: 99997, name: "EDITION_99997_TEST_ONLY" },
  { no: 99998, name: "EDITION_99998_TEST_ONLY" },
  { no: 99999, name: "EDITION_99999_TEST_ONLY" },
  { no: 2147483647, name: "EDITION_MAX" }
]);
class Le extends E {
  constructor(e) {
    super(), this.file = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Le().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Le().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Le().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Le, e, n);
  }
}
Le.runtime = p;
Le.typeName = "google.protobuf.FileDescriptorSet";
Le.fields = p.util.newFieldList(() => [
  { no: 1, name: "file", kind: "message", T: de, repeated: !0 }
]);
class de extends E {
  constructor(e) {
    super(), this.dependency = [], this.publicDependency = [], this.weakDependency = [], this.messageType = [], this.enumType = [], this.service = [], this.extension = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new de().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new de().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new de().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(de, e, n);
  }
}
de.runtime = p;
de.typeName = "google.protobuf.FileDescriptorProto";
de.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "package", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "dependency", kind: "scalar", T: 9, repeated: !0 },
  { no: 10, name: "public_dependency", kind: "scalar", T: 5, repeated: !0 },
  { no: 11, name: "weak_dependency", kind: "scalar", T: 5, repeated: !0 },
  { no: 4, name: "message_type", kind: "message", T: se, repeated: !0 },
  { no: 5, name: "enum_type", kind: "message", T: oe, repeated: !0 },
  { no: 6, name: "service", kind: "message", T: he, repeated: !0 },
  { no: 7, name: "extension", kind: "message", T: ee, repeated: !0 },
  { no: 8, name: "options", kind: "message", T: Re, opt: !0 },
  { no: 9, name: "source_code_info", kind: "message", T: Ce, opt: !0 },
  { no: 12, name: "syntax", kind: "scalar", T: 9, opt: !0 },
  { no: 14, name: "edition", kind: "enum", T: p.getEnumType(ne), opt: !0 }
]);
class se extends E {
  constructor(e) {
    super(), this.field = [], this.extension = [], this.nestedType = [], this.enumType = [], this.extensionRange = [], this.oneofDecl = [], this.reservedRange = [], this.reservedName = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new se().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new se().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new se().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(se, e, n);
  }
}
se.runtime = p;
se.typeName = "google.protobuf.DescriptorProto";
se.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "field", kind: "message", T: ee, repeated: !0 },
  { no: 6, name: "extension", kind: "message", T: ee, repeated: !0 },
  { no: 3, name: "nested_type", kind: "message", T: se, repeated: !0 },
  { no: 4, name: "enum_type", kind: "message", T: oe, repeated: !0 },
  { no: 5, name: "extension_range", kind: "message", T: ue, repeated: !0 },
  { no: 8, name: "oneof_decl", kind: "message", T: ke, repeated: !0 },
  { no: 7, name: "options", kind: "message", T: Ie, opt: !0 },
  { no: 9, name: "reserved_range", kind: "message", T: pe, repeated: !0 },
  { no: 10, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
]);
class ue extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ue().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ue().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ue().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(ue, e, n);
  }
}
ue.runtime = p;
ue.typeName = "google.protobuf.DescriptorProto.ExtensionRange";
ue.fields = p.util.newFieldList(() => [
  { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 },
  { no: 3, name: "options", kind: "message", T: ge, opt: !0 }
]);
class pe extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new pe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new pe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new pe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(pe, e, n);
  }
}
pe.runtime = p;
pe.typeName = "google.protobuf.DescriptorProto.ReservedRange";
pe.fields = p.util.newFieldList(() => [
  { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
]);
class ge extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], this.declaration = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ge().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ge().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ge().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(ge, e, n);
  }
}
ge.runtime = p;
ge.typeName = "google.protobuf.ExtensionRangeOptions";
ge.fields = p.util.newFieldList(() => [
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 },
  { no: 2, name: "declaration", kind: "message", T: Te, repeated: !0 },
  { no: 50, name: "features", kind: "message", T: z, opt: !0 },
  { no: 3, name: "verification", kind: "enum", T: p.getEnumType(un), opt: !0, default: un.UNVERIFIED }
]);
var un;
(function(t) {
  t[t.DECLARATION = 0] = "DECLARATION", t[t.UNVERIFIED = 1] = "UNVERIFIED";
})(un || (un = {}));
p.util.setEnumType(un, "google.protobuf.ExtensionRangeOptions.VerificationState", [
  { no: 0, name: "DECLARATION" },
  { no: 1, name: "UNVERIFIED" }
]);
class Te extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Te().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Te().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Te().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Te, e, n);
  }
}
Te.runtime = p;
Te.typeName = "google.protobuf.ExtensionRangeOptions.Declaration";
Te.fields = p.util.newFieldList(() => [
  { no: 1, name: "number", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "full_name", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "type", kind: "scalar", T: 9, opt: !0 },
  { no: 5, name: "reserved", kind: "scalar", T: 8, opt: !0 },
  { no: 6, name: "repeated", kind: "scalar", T: 8, opt: !0 }
]);
class ee extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ee().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ee().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ee().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(ee, e, n);
  }
}
ee.runtime = p;
ee.typeName = "google.protobuf.FieldDescriptorProto";
ee.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "number", kind: "scalar", T: 5, opt: !0 },
  { no: 4, name: "label", kind: "enum", T: p.getEnumType(xn), opt: !0 },
  { no: 5, name: "type", kind: "enum", T: p.getEnumType(Bn), opt: !0 },
  { no: 6, name: "type_name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "extendee", kind: "scalar", T: 9, opt: !0 },
  { no: 7, name: "default_value", kind: "scalar", T: 9, opt: !0 },
  { no: 9, name: "oneof_index", kind: "scalar", T: 5, opt: !0 },
  { no: 10, name: "json_name", kind: "scalar", T: 9, opt: !0 },
  { no: 8, name: "options", kind: "message", T: Se, opt: !0 },
  { no: 17, name: "proto3_optional", kind: "scalar", T: 8, opt: !0 }
]);
var Bn;
(function(t) {
  t[t.DOUBLE = 1] = "DOUBLE", t[t.FLOAT = 2] = "FLOAT", t[t.INT64 = 3] = "INT64", t[t.UINT64 = 4] = "UINT64", t[t.INT32 = 5] = "INT32", t[t.FIXED64 = 6] = "FIXED64", t[t.FIXED32 = 7] = "FIXED32", t[t.BOOL = 8] = "BOOL", t[t.STRING = 9] = "STRING", t[t.GROUP = 10] = "GROUP", t[t.MESSAGE = 11] = "MESSAGE", t[t.BYTES = 12] = "BYTES", t[t.UINT32 = 13] = "UINT32", t[t.ENUM = 14] = "ENUM", t[t.SFIXED32 = 15] = "SFIXED32", t[t.SFIXED64 = 16] = "SFIXED64", t[t.SINT32 = 17] = "SINT32", t[t.SINT64 = 18] = "SINT64";
})(Bn || (Bn = {}));
p.util.setEnumType(Bn, "google.protobuf.FieldDescriptorProto.Type", [
  { no: 1, name: "TYPE_DOUBLE" },
  { no: 2, name: "TYPE_FLOAT" },
  { no: 3, name: "TYPE_INT64" },
  { no: 4, name: "TYPE_UINT64" },
  { no: 5, name: "TYPE_INT32" },
  { no: 6, name: "TYPE_FIXED64" },
  { no: 7, name: "TYPE_FIXED32" },
  { no: 8, name: "TYPE_BOOL" },
  { no: 9, name: "TYPE_STRING" },
  { no: 10, name: "TYPE_GROUP" },
  { no: 11, name: "TYPE_MESSAGE" },
  { no: 12, name: "TYPE_BYTES" },
  { no: 13, name: "TYPE_UINT32" },
  { no: 14, name: "TYPE_ENUM" },
  { no: 15, name: "TYPE_SFIXED32" },
  { no: 16, name: "TYPE_SFIXED64" },
  { no: 17, name: "TYPE_SINT32" },
  { no: 18, name: "TYPE_SINT64" }
]);
var xn;
(function(t) {
  t[t.OPTIONAL = 1] = "OPTIONAL", t[t.REPEATED = 3] = "REPEATED", t[t.REQUIRED = 2] = "REQUIRED";
})(xn || (xn = {}));
p.util.setEnumType(xn, "google.protobuf.FieldDescriptorProto.Label", [
  { no: 1, name: "LABEL_OPTIONAL" },
  { no: 3, name: "LABEL_REPEATED" },
  { no: 2, name: "LABEL_REQUIRED" }
]);
class ke extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ke().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ke().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ke().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(ke, e, n);
  }
}
ke.runtime = p;
ke.typeName = "google.protobuf.OneofDescriptorProto";
ke.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "options", kind: "message", T: be, opt: !0 }
]);
class oe extends E {
  constructor(e) {
    super(), this.value = [], this.reservedRange = [], this.reservedName = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new oe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new oe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new oe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(oe, e, n);
  }
}
oe.runtime = p;
oe.typeName = "google.protobuf.EnumDescriptorProto";
oe.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "value", kind: "message", T: ve, repeated: !0 },
  { no: 3, name: "options", kind: "message", T: _e, opt: !0 },
  { no: 4, name: "reserved_range", kind: "message", T: ye, repeated: !0 },
  { no: 5, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
]);
class ye extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ye().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ye().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ye().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(ye, e, n);
  }
}
ye.runtime = p;
ye.typeName = "google.protobuf.EnumDescriptorProto.EnumReservedRange";
ye.fields = p.util.newFieldList(() => [
  { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
  { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
]);
class ve extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ve().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ve().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ve().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(ve, e, n);
  }
}
ve.runtime = p;
ve.typeName = "google.protobuf.EnumValueDescriptorProto";
ve.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "number", kind: "scalar", T: 5, opt: !0 },
  { no: 3, name: "options", kind: "message", T: Ee, opt: !0 }
]);
class he extends E {
  constructor(e) {
    super(), this.method = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new he().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new he().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new he().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(he, e, n);
  }
}
he.runtime = p;
he.typeName = "google.protobuf.ServiceDescriptorProto";
he.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "method", kind: "message", T: fe, repeated: !0 },
  { no: 3, name: "options", kind: "message", T: Me, opt: !0 }
]);
class fe extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new fe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new fe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new fe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(fe, e, n);
  }
}
fe.runtime = p;
fe.typeName = "google.protobuf.MethodDescriptorProto";
fe.fields = p.util.newFieldList(() => [
  { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
  { no: 2, name: "input_type", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "output_type", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "options", kind: "message", T: re, opt: !0 },
  { no: 5, name: "client_streaming", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 6, name: "server_streaming", kind: "scalar", T: 8, opt: !0, default: !1 }
]);
class Re extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Re().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Re().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Re().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Re, e, n);
  }
}
Re.runtime = p;
Re.typeName = "google.protobuf.FileOptions";
Re.fields = p.util.newFieldList(() => [
  { no: 1, name: "java_package", kind: "scalar", T: 9, opt: !0 },
  { no: 8, name: "java_outer_classname", kind: "scalar", T: 9, opt: !0 },
  { no: 10, name: "java_multiple_files", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 20, name: "java_generate_equals_and_hash", kind: "scalar", T: 8, opt: !0 },
  { no: 27, name: "java_string_check_utf8", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 9, name: "optimize_for", kind: "enum", T: p.getEnumType(pn), opt: !0, default: pn.SPEED },
  { no: 11, name: "go_package", kind: "scalar", T: 9, opt: !0 },
  { no: 16, name: "cc_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 17, name: "java_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 18, name: "py_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 23, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 31, name: "cc_enable_arenas", kind: "scalar", T: 8, opt: !0, default: !0 },
  { no: 36, name: "objc_class_prefix", kind: "scalar", T: 9, opt: !0 },
  { no: 37, name: "csharp_namespace", kind: "scalar", T: 9, opt: !0 },
  { no: 39, name: "swift_prefix", kind: "scalar", T: 9, opt: !0 },
  { no: 40, name: "php_class_prefix", kind: "scalar", T: 9, opt: !0 },
  { no: 41, name: "php_namespace", kind: "scalar", T: 9, opt: !0 },
  { no: 44, name: "php_metadata_namespace", kind: "scalar", T: 9, opt: !0 },
  { no: 45, name: "ruby_package", kind: "scalar", T: 9, opt: !0 },
  { no: 50, name: "features", kind: "message", T: z, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
var pn;
(function(t) {
  t[t.SPEED = 1] = "SPEED", t[t.CODE_SIZE = 2] = "CODE_SIZE", t[t.LITE_RUNTIME = 3] = "LITE_RUNTIME";
})(pn || (pn = {}));
p.util.setEnumType(pn, "google.protobuf.FileOptions.OptimizeMode", [
  { no: 1, name: "SPEED" },
  { no: 2, name: "CODE_SIZE" },
  { no: 3, name: "LITE_RUNTIME" }
]);
class Ie extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ie().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ie().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ie().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Ie, e, n);
  }
}
Ie.runtime = p;
Ie.typeName = "google.protobuf.MessageOptions";
Ie.fields = p.util.newFieldList(() => [
  { no: 1, name: "message_set_wire_format", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 2, name: "no_standard_descriptor_accessor", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 7, name: "map_entry", kind: "scalar", T: 8, opt: !0 },
  { no: 11, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
  { no: 12, name: "features", kind: "message", T: z, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
class Se extends E {
  constructor(e) {
    super(), this.targets = [], this.editionDefaults = [], this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Se().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Se().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Se().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Se, e, n);
  }
}
Se.runtime = p;
Se.typeName = "google.protobuf.FieldOptions";
Se.fields = p.util.newFieldList(() => [
  { no: 1, name: "ctype", kind: "enum", T: p.getEnumType(gn), opt: !0, default: gn.STRING },
  { no: 2, name: "packed", kind: "scalar", T: 8, opt: !0 },
  { no: 6, name: "jstype", kind: "enum", T: p.getEnumType(Tn), opt: !0, default: Tn.JS_NORMAL },
  { no: 5, name: "lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 15, name: "unverified_lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 10, name: "weak", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 16, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 17, name: "retention", kind: "enum", T: p.getEnumType(Fn), opt: !0 },
  { no: 19, name: "targets", kind: "enum", T: p.getEnumType(Jn), repeated: !0 },
  { no: 20, name: "edition_defaults", kind: "message", T: we, repeated: !0 },
  { no: 21, name: "features", kind: "message", T: z, opt: !0 },
  { no: 22, name: "feature_support", kind: "message", T: ie, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
var gn;
(function(t) {
  t[t.STRING = 0] = "STRING", t[t.CORD = 1] = "CORD", t[t.STRING_PIECE = 2] = "STRING_PIECE";
})(gn || (gn = {}));
p.util.setEnumType(gn, "google.protobuf.FieldOptions.CType", [
  { no: 0, name: "STRING" },
  { no: 1, name: "CORD" },
  { no: 2, name: "STRING_PIECE" }
]);
var Tn;
(function(t) {
  t[t.JS_NORMAL = 0] = "JS_NORMAL", t[t.JS_STRING = 1] = "JS_STRING", t[t.JS_NUMBER = 2] = "JS_NUMBER";
})(Tn || (Tn = {}));
p.util.setEnumType(Tn, "google.protobuf.FieldOptions.JSType", [
  { no: 0, name: "JS_NORMAL" },
  { no: 1, name: "JS_STRING" },
  { no: 2, name: "JS_NUMBER" }
]);
var Fn;
(function(t) {
  t[t.RETENTION_UNKNOWN = 0] = "RETENTION_UNKNOWN", t[t.RETENTION_RUNTIME = 1] = "RETENTION_RUNTIME", t[t.RETENTION_SOURCE = 2] = "RETENTION_SOURCE";
})(Fn || (Fn = {}));
p.util.setEnumType(Fn, "google.protobuf.FieldOptions.OptionRetention", [
  { no: 0, name: "RETENTION_UNKNOWN" },
  { no: 1, name: "RETENTION_RUNTIME" },
  { no: 2, name: "RETENTION_SOURCE" }
]);
var Jn;
(function(t) {
  t[t.TARGET_TYPE_UNKNOWN = 0] = "TARGET_TYPE_UNKNOWN", t[t.TARGET_TYPE_FILE = 1] = "TARGET_TYPE_FILE", t[t.TARGET_TYPE_EXTENSION_RANGE = 2] = "TARGET_TYPE_EXTENSION_RANGE", t[t.TARGET_TYPE_MESSAGE = 3] = "TARGET_TYPE_MESSAGE", t[t.TARGET_TYPE_FIELD = 4] = "TARGET_TYPE_FIELD", t[t.TARGET_TYPE_ONEOF = 5] = "TARGET_TYPE_ONEOF", t[t.TARGET_TYPE_ENUM = 6] = "TARGET_TYPE_ENUM", t[t.TARGET_TYPE_ENUM_ENTRY = 7] = "TARGET_TYPE_ENUM_ENTRY", t[t.TARGET_TYPE_SERVICE = 8] = "TARGET_TYPE_SERVICE", t[t.TARGET_TYPE_METHOD = 9] = "TARGET_TYPE_METHOD";
})(Jn || (Jn = {}));
p.util.setEnumType(Jn, "google.protobuf.FieldOptions.OptionTargetType", [
  { no: 0, name: "TARGET_TYPE_UNKNOWN" },
  { no: 1, name: "TARGET_TYPE_FILE" },
  { no: 2, name: "TARGET_TYPE_EXTENSION_RANGE" },
  { no: 3, name: "TARGET_TYPE_MESSAGE" },
  { no: 4, name: "TARGET_TYPE_FIELD" },
  { no: 5, name: "TARGET_TYPE_ONEOF" },
  { no: 6, name: "TARGET_TYPE_ENUM" },
  { no: 7, name: "TARGET_TYPE_ENUM_ENTRY" },
  { no: 8, name: "TARGET_TYPE_SERVICE" },
  { no: 9, name: "TARGET_TYPE_METHOD" }
]);
class we extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new we().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new we().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new we().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(we, e, n);
  }
}
we.runtime = p;
we.typeName = "google.protobuf.FieldOptions.EditionDefault";
we.fields = p.util.newFieldList(() => [
  { no: 3, name: "edition", kind: "enum", T: p.getEnumType(ne), opt: !0 },
  { no: 2, name: "value", kind: "scalar", T: 9, opt: !0 }
]);
class ie extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ie().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ie().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ie().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(ie, e, n);
  }
}
ie.runtime = p;
ie.typeName = "google.protobuf.FieldOptions.FeatureSupport";
ie.fields = p.util.newFieldList(() => [
  { no: 1, name: "edition_introduced", kind: "enum", T: p.getEnumType(ne), opt: !0 },
  { no: 2, name: "edition_deprecated", kind: "enum", T: p.getEnumType(ne), opt: !0 },
  { no: 3, name: "deprecation_warning", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "edition_removed", kind: "enum", T: p.getEnumType(ne), opt: !0 }
]);
class be extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new be().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new be().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new be().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(be, e, n);
  }
}
be.runtime = p;
be.typeName = "google.protobuf.OneofOptions";
be.fields = p.util.newFieldList(() => [
  { no: 1, name: "features", kind: "message", T: z, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
class _e extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new _e().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new _e().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new _e().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(_e, e, n);
  }
}
_e.runtime = p;
_e.typeName = "google.protobuf.EnumOptions";
_e.fields = p.util.newFieldList(() => [
  { no: 2, name: "allow_alias", kind: "scalar", T: 8, opt: !0 },
  { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 6, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
  { no: 7, name: "features", kind: "message", T: z, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
class Ee extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ee().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ee().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ee().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Ee, e, n);
  }
}
Ee.runtime = p;
Ee.typeName = "google.protobuf.EnumValueOptions";
Ee.fields = p.util.newFieldList(() => [
  { no: 1, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 2, name: "features", kind: "message", T: z, opt: !0 },
  { no: 3, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 4, name: "feature_support", kind: "message", T: ie, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
class Me extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Me().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Me().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Me().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Me, e, n);
  }
}
Me.runtime = p;
Me.typeName = "google.protobuf.ServiceOptions";
Me.fields = p.util.newFieldList(() => [
  { no: 34, name: "features", kind: "message", T: z, opt: !0 },
  { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
class re extends E {
  constructor(e) {
    super(), this.uninterpretedOption = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new re().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new re().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new re().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(re, e, n);
  }
}
re.runtime = p;
re.typeName = "google.protobuf.MethodOptions";
re.fields = p.util.newFieldList(() => [
  { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
  { no: 34, name: "idempotency_level", kind: "enum", T: p.getEnumType(kn), opt: !0, default: kn.IDEMPOTENCY_UNKNOWN },
  { no: 35, name: "features", kind: "message", T: z, opt: !0 },
  { no: 999, name: "uninterpreted_option", kind: "message", T: Y, repeated: !0 }
]);
var kn;
(function(t) {
  t[t.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", t[t.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", t[t.IDEMPOTENT = 2] = "IDEMPOTENT";
})(kn || (kn = {}));
p.util.setEnumType(kn, "google.protobuf.MethodOptions.IdempotencyLevel", [
  { no: 0, name: "IDEMPOTENCY_UNKNOWN" },
  { no: 1, name: "NO_SIDE_EFFECTS" },
  { no: 2, name: "IDEMPOTENT" }
]);
class Y extends E {
  constructor(e) {
    super(), this.name = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Y().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Y().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Y().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Y, e, n);
  }
}
Y.runtime = p;
Y.typeName = "google.protobuf.UninterpretedOption";
Y.fields = p.util.newFieldList(() => [
  { no: 2, name: "name", kind: "message", T: Oe, repeated: !0 },
  { no: 3, name: "identifier_value", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "positive_int_value", kind: "scalar", T: 4, opt: !0 },
  { no: 5, name: "negative_int_value", kind: "scalar", T: 3, opt: !0 },
  { no: 6, name: "double_value", kind: "scalar", T: 1, opt: !0 },
  { no: 7, name: "string_value", kind: "scalar", T: 12, opt: !0 },
  { no: 8, name: "aggregate_value", kind: "scalar", T: 9, opt: !0 }
]);
class Oe extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Oe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Oe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Oe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Oe, e, n);
  }
}
Oe.runtime = p;
Oe.typeName = "google.protobuf.UninterpretedOption.NamePart";
Oe.fields = p.util.newFieldList(() => [
  { no: 1, name: "name_part", kind: "scalar", T: 9, req: !0 },
  { no: 2, name: "is_extension", kind: "scalar", T: 8, req: !0 }
]);
class z extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new z().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new z().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new z().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(z, e, n);
  }
}
z.runtime = p;
z.typeName = "google.protobuf.FeatureSet";
z.fields = p.util.newFieldList(() => [
  { no: 1, name: "field_presence", kind: "enum", T: p.getEnumType(zn), opt: !0 },
  { no: 2, name: "enum_type", kind: "enum", T: p.getEnumType($n), opt: !0 },
  { no: 3, name: "repeated_field_encoding", kind: "enum", T: p.getEnumType(Yn), opt: !0 },
  { no: 4, name: "utf8_validation", kind: "enum", T: p.getEnumType(Wn), opt: !0 },
  { no: 5, name: "message_encoding", kind: "enum", T: p.getEnumType(Vn), opt: !0 },
  { no: 6, name: "json_format", kind: "enum", T: p.getEnumType(jn), opt: !0 }
]);
var zn;
(function(t) {
  t[t.FIELD_PRESENCE_UNKNOWN = 0] = "FIELD_PRESENCE_UNKNOWN", t[t.EXPLICIT = 1] = "EXPLICIT", t[t.IMPLICIT = 2] = "IMPLICIT", t[t.LEGACY_REQUIRED = 3] = "LEGACY_REQUIRED";
})(zn || (zn = {}));
p.util.setEnumType(zn, "google.protobuf.FeatureSet.FieldPresence", [
  { no: 0, name: "FIELD_PRESENCE_UNKNOWN" },
  { no: 1, name: "EXPLICIT" },
  { no: 2, name: "IMPLICIT" },
  { no: 3, name: "LEGACY_REQUIRED" }
]);
var $n;
(function(t) {
  t[t.ENUM_TYPE_UNKNOWN = 0] = "ENUM_TYPE_UNKNOWN", t[t.OPEN = 1] = "OPEN", t[t.CLOSED = 2] = "CLOSED";
})($n || ($n = {}));
p.util.setEnumType($n, "google.protobuf.FeatureSet.EnumType", [
  { no: 0, name: "ENUM_TYPE_UNKNOWN" },
  { no: 1, name: "OPEN" },
  { no: 2, name: "CLOSED" }
]);
var Yn;
(function(t) {
  t[t.REPEATED_FIELD_ENCODING_UNKNOWN = 0] = "REPEATED_FIELD_ENCODING_UNKNOWN", t[t.PACKED = 1] = "PACKED", t[t.EXPANDED = 2] = "EXPANDED";
})(Yn || (Yn = {}));
p.util.setEnumType(Yn, "google.protobuf.FeatureSet.RepeatedFieldEncoding", [
  { no: 0, name: "REPEATED_FIELD_ENCODING_UNKNOWN" },
  { no: 1, name: "PACKED" },
  { no: 2, name: "EXPANDED" }
]);
var Wn;
(function(t) {
  t[t.UTF8_VALIDATION_UNKNOWN = 0] = "UTF8_VALIDATION_UNKNOWN", t[t.VERIFY = 2] = "VERIFY", t[t.NONE = 3] = "NONE";
})(Wn || (Wn = {}));
p.util.setEnumType(Wn, "google.protobuf.FeatureSet.Utf8Validation", [
  { no: 0, name: "UTF8_VALIDATION_UNKNOWN" },
  { no: 2, name: "VERIFY" },
  { no: 3, name: "NONE" }
]);
var Vn;
(function(t) {
  t[t.MESSAGE_ENCODING_UNKNOWN = 0] = "MESSAGE_ENCODING_UNKNOWN", t[t.LENGTH_PREFIXED = 1] = "LENGTH_PREFIXED", t[t.DELIMITED = 2] = "DELIMITED";
})(Vn || (Vn = {}));
p.util.setEnumType(Vn, "google.protobuf.FeatureSet.MessageEncoding", [
  { no: 0, name: "MESSAGE_ENCODING_UNKNOWN" },
  { no: 1, name: "LENGTH_PREFIXED" },
  { no: 2, name: "DELIMITED" }
]);
var jn;
(function(t) {
  t[t.JSON_FORMAT_UNKNOWN = 0] = "JSON_FORMAT_UNKNOWN", t[t.ALLOW = 1] = "ALLOW", t[t.LEGACY_BEST_EFFORT = 2] = "LEGACY_BEST_EFFORT";
})(jn || (jn = {}));
p.util.setEnumType(jn, "google.protobuf.FeatureSet.JsonFormat", [
  { no: 0, name: "JSON_FORMAT_UNKNOWN" },
  { no: 1, name: "ALLOW" },
  { no: 2, name: "LEGACY_BEST_EFFORT" }
]);
class Be extends E {
  constructor(e) {
    super(), this.defaults = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Be().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Be().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Be().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Be, e, n);
  }
}
Be.runtime = p;
Be.typeName = "google.protobuf.FeatureSetDefaults";
Be.fields = p.util.newFieldList(() => [
  { no: 1, name: "defaults", kind: "message", T: Ne, repeated: !0 },
  { no: 4, name: "minimum_edition", kind: "enum", T: p.getEnumType(ne), opt: !0 },
  { no: 5, name: "maximum_edition", kind: "enum", T: p.getEnumType(ne), opt: !0 }
]);
class Ne extends E {
  constructor(e) {
    super(), p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ne().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ne().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ne().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Ne, e, n);
  }
}
Ne.runtime = p;
Ne.typeName = "google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault";
Ne.fields = p.util.newFieldList(() => [
  { no: 3, name: "edition", kind: "enum", T: p.getEnumType(ne), opt: !0 },
  { no: 4, name: "overridable_features", kind: "message", T: z, opt: !0 },
  { no: 5, name: "fixed_features", kind: "message", T: z, opt: !0 }
]);
class Ce extends E {
  constructor(e) {
    super(), this.location = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ce().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ce().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ce().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Ce, e, n);
  }
}
Ce.runtime = p;
Ce.typeName = "google.protobuf.SourceCodeInfo";
Ce.fields = p.util.newFieldList(() => [
  { no: 1, name: "location", kind: "message", T: Pe, repeated: !0 }
]);
class Pe extends E {
  constructor(e) {
    super(), this.path = [], this.span = [], this.leadingDetachedComments = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Pe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Pe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Pe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(Pe, e, n);
  }
}
Pe.runtime = p;
Pe.typeName = "google.protobuf.SourceCodeInfo.Location";
Pe.fields = p.util.newFieldList(() => [
  { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
  { no: 2, name: "span", kind: "scalar", T: 5, repeated: !0, packed: !0 },
  { no: 3, name: "leading_comments", kind: "scalar", T: 9, opt: !0 },
  { no: 4, name: "trailing_comments", kind: "scalar", T: 9, opt: !0 },
  { no: 6, name: "leading_detached_comments", kind: "scalar", T: 9, repeated: !0 }
]);
class xe extends E {
  constructor(e) {
    super(), this.annotation = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new xe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new xe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new xe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(xe, e, n);
  }
}
xe.runtime = p;
xe.typeName = "google.protobuf.GeneratedCodeInfo";
xe.fields = p.util.newFieldList(() => [
  { no: 1, name: "annotation", kind: "message", T: De, repeated: !0 }
]);
class De extends E {
  constructor(e) {
    super(), this.path = [], p.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new De().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new De().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new De().fromJsonString(e, n);
  }
  static equals(e, n) {
    return p.util.equals(De, e, n);
  }
}
De.runtime = p;
De.typeName = "google.protobuf.GeneratedCodeInfo.Annotation";
De.fields = p.util.newFieldList(() => [
  { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
  { no: 2, name: "source_file", kind: "scalar", T: 9, opt: !0 },
  { no: 3, name: "begin", kind: "scalar", T: 5, opt: !0 },
  { no: 4, name: "end", kind: "scalar", T: 5, opt: !0 },
  { no: 5, name: "semantic", kind: "enum", T: p.getEnumType(Hn), opt: !0 }
]);
var Hn;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.SET = 1] = "SET", t[t.ALIAS = 2] = "ALIAS";
})(Hn || (Hn = {}));
p.util.setEnumType(Hn, "google.protobuf.GeneratedCodeInfo.Annotation.Semantic", [
  { no: 0, name: "NONE" },
  { no: 1, name: "SET" },
  { no: 2, name: "ALIAS" }
]);
class I extends E {
  constructor(e) {
    super(), this.seconds = $.zero, this.nanos = 0, o.util.initPartial(e, this);
  }
  fromJson(e, n) {
    if (typeof e != "string")
      throw new Error(`cannot decode google.protobuf.Timestamp from JSON: ${o.json.debug(e)}`);
    const a = e.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
    if (!a)
      throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
    const s = Date.parse(a[1] + "-" + a[2] + "-" + a[3] + "T" + a[4] + ":" + a[5] + ":" + a[6] + (a[8] ? a[8] : "Z"));
    if (Number.isNaN(s))
      throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
    if (s < Date.parse("0001-01-01T00:00:00Z") || s > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
    return this.seconds = $.parse(s / 1e3), this.nanos = 0, a[7] && (this.nanos = parseInt("1" + a[7] + "0".repeat(9 - a[7].length)) - 1e9), this;
  }
  toJson(e) {
    const n = Number(this.seconds) * 1e3;
    if (n < Date.parse("0001-01-01T00:00:00Z") || n > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
    if (this.nanos < 0)
      throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
    let a = "Z";
    if (this.nanos > 0) {
      const s = (this.nanos + 1e9).toString().substring(1);
      s.substring(3) === "000000" ? a = "." + s.substring(0, 3) + "Z" : s.substring(6) === "000" ? a = "." + s.substring(0, 6) + "Z" : a = "." + s + "Z";
    }
    return new Date(n).toISOString().replace(".000Z", a);
  }
  toDate() {
    return new Date(Number(this.seconds) * 1e3 + Math.ceil(this.nanos / 1e6));
  }
  static now() {
    return I.fromDate(/* @__PURE__ */ new Date());
  }
  static fromDate(e) {
    const n = e.getTime();
    return new I({
      seconds: $.parse(Math.floor(n / 1e3)),
      nanos: n % 1e3 * 1e6
    });
  }
  static fromBinary(e, n) {
    return new I().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new I().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new I().fromJsonString(e, n);
  }
  static equals(e, n) {
    return o.util.equals(I, e, n);
  }
}
I.runtime = o;
I.typeName = "google.protobuf.Timestamp";
I.fields = o.util.newFieldList(() => [
  {
    no: 1,
    name: "seconds",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "nanos",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
class X extends E {
  constructor(e) {
    super(), this.seconds = $.zero, this.nanos = 0, o.util.initPartial(e, this);
  }
  fromJson(e, n) {
    if (typeof e != "string")
      throw new Error(`cannot decode google.protobuf.Duration from JSON: ${o.json.debug(e)}`);
    const a = e.match(/^(-?[0-9]+)(?:\.([0-9]+))?s/);
    if (a === null)
      throw new Error(`cannot decode google.protobuf.Duration from JSON: ${o.json.debug(e)}`);
    const s = Number(a[1]);
    if (s > 315576e6 || s < -315576e6)
      throw new Error(`cannot decode google.protobuf.Duration from JSON: ${o.json.debug(e)}`);
    if (this.seconds = $.parse(s), typeof a[2] == "string") {
      const i = a[2] + "0".repeat(9 - a[2].length);
      this.nanos = parseInt(i), (s < 0 || Object.is(s, -0)) && (this.nanos = -this.nanos);
    }
    return this;
  }
  toJson(e) {
    if (Number(this.seconds) > 315576e6 || Number(this.seconds) < -315576e6)
      throw new Error("cannot encode google.protobuf.Duration to JSON: value out of range");
    let n = this.seconds.toString();
    if (this.nanos !== 0) {
      let a = Math.abs(this.nanos).toString();
      a = "0".repeat(9 - a.length) + a, a.substring(3) === "000000" ? a = a.substring(0, 3) : a.substring(6) === "000" && (a = a.substring(0, 6)), n += "." + a, this.nanos < 0 && Number(this.seconds) == 0 && (n = "-" + n);
    }
    return n + "s";
  }
  static fromBinary(e, n) {
    return new X().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new X().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new X().fromJsonString(e, n);
  }
  static equals(e, n) {
    return o.util.equals(X, e, n);
  }
}
X.runtime = o;
X.typeName = "google.protobuf.Duration";
X.fields = o.util.newFieldList(() => [
  {
    no: 1,
    name: "seconds",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "nanos",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]);
class W extends E {
  constructor(e) {
    super(), this.typeUrl = "", this.value = new Uint8Array(0), o.util.initPartial(e, this);
  }
  toJson(e) {
    var n;
    if (this.typeUrl === "")
      return {};
    const a = this.typeUrlToName(this.typeUrl), s = (n = e?.typeRegistry) === null || n === void 0 ? void 0 : n.findMessage(a);
    if (!s)
      throw new Error(`cannot encode message google.protobuf.Any to JSON: "${this.typeUrl}" is not in the type registry`);
    let r = s.fromBinary(this.value).toJson(e);
    return (a.startsWith("google.protobuf.") || r === null || Array.isArray(r) || typeof r != "object") && (r = { value: r }), r["@type"] = this.typeUrl, r;
  }
  fromJson(e, n) {
    var a;
    if (e === null || Array.isArray(e) || typeof e != "object")
      throw new Error(`cannot decode message google.protobuf.Any from JSON: expected object but got ${e === null ? "null" : Array.isArray(e) ? "array" : typeof e}`);
    if (Object.keys(e).length == 0)
      return this;
    const s = e["@type"];
    if (typeof s != "string" || s == "")
      throw new Error('cannot decode message google.protobuf.Any from JSON: "@type" is empty');
    const i = this.typeUrlToName(s), r = (a = n?.typeRegistry) === null || a === void 0 ? void 0 : a.findMessage(i);
    if (!r)
      throw new Error(`cannot decode message google.protobuf.Any from JSON: ${s} is not in the type registry`);
    let c;
    if (i.startsWith("google.protobuf.") && Object.prototype.hasOwnProperty.call(e, "value"))
      c = r.fromJson(e.value, n);
    else {
      const d = Object.assign({}, e);
      delete d["@type"], c = r.fromJson(d, n);
    }
    return this.packFrom(c), this;
  }
  packFrom(e) {
    this.value = e.toBinary(), this.typeUrl = this.typeNameToUrl(e.getType().typeName);
  }
  unpackTo(e) {
    return this.is(e.getType()) ? (e.fromBinary(this.value), !0) : !1;
  }
  unpack(e) {
    if (this.typeUrl === "")
      return;
    const n = e.findMessage(this.typeUrlToName(this.typeUrl));
    if (n)
      return n.fromBinary(this.value);
  }
  is(e) {
    if (this.typeUrl === "")
      return !1;
    const n = this.typeUrlToName(this.typeUrl);
    let a = "";
    return typeof e == "string" ? a = e : a = e.typeName, n === a;
  }
  typeNameToUrl(e) {
    return `type.googleapis.com/${e}`;
  }
  typeUrlToName(e) {
    if (!e.length)
      throw new Error(`invalid type url: ${e}`);
    const n = e.lastIndexOf("/"), a = n >= 0 ? e.substring(n + 1) : e;
    if (!a.length)
      throw new Error(`invalid type url: ${e}`);
    return a;
  }
  static pack(e) {
    const n = new W();
    return n.packFrom(e), n;
  }
  static fromBinary(e, n) {
    return new W().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new W().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new W().fromJsonString(e, n);
  }
  static equals(e, n) {
    return o.util.equals(W, e, n);
  }
}
W.runtime = o;
W.typeName = "google.protobuf.Any";
W.fields = o.util.newFieldList(() => [
  {
    no: 1,
    name: "type_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "value",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]);
var yn;
(function(t) {
  t[t.NULL_VALUE = 0] = "NULL_VALUE";
})(yn || (yn = {}));
o.util.setEnumType(yn, "google.protobuf.NullValue", [
  { no: 0, name: "NULL_VALUE" }
]);
class u extends E {
  constructor(e) {
    super(), this.fields = {}, o.util.initPartial(e, this);
  }
  toJson(e) {
    const n = {};
    for (const [a, s] of Object.entries(this.fields))
      n[a] = s.toJson(e);
    return n;
  }
  fromJson(e, n) {
    if (typeof e != "object" || e == null || Array.isArray(e))
      throw new Error("cannot decode google.protobuf.Struct from JSON " + o.json.debug(e));
    for (const [a, s] of Object.entries(e))
      this.fields[a] = K.fromJson(s);
    return this;
  }
  static fromBinary(e, n) {
    return new u().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new u().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new u().fromJsonString(e, n);
  }
  static equals(e, n) {
    return o.util.equals(u, e, n);
  }
}
u.runtime = o;
u.typeName = "google.protobuf.Struct";
u.fields = o.util.newFieldList(() => [
  { no: 1, name: "fields", kind: "map", K: 9, V: { kind: "message", T: K } }
]);
class K extends E {
  constructor(e) {
    super(), this.kind = { case: void 0 }, o.util.initPartial(e, this);
  }
  toJson(e) {
    switch (this.kind.case) {
      case "nullValue":
        return null;
      case "numberValue":
        if (!Number.isFinite(this.kind.value))
          throw new Error("google.protobuf.Value cannot be NaN or Infinity");
        return this.kind.value;
      case "boolValue":
        return this.kind.value;
      case "stringValue":
        return this.kind.value;
      case "structValue":
      case "listValue":
        return this.kind.value.toJson(Object.assign(Object.assign({}, e), { emitDefaultValues: !0 }));
    }
    throw new Error("google.protobuf.Value must have a value");
  }
  fromJson(e, n) {
    switch (typeof e) {
      case "number":
        this.kind = { case: "numberValue", value: e };
        break;
      case "string":
        this.kind = { case: "stringValue", value: e };
        break;
      case "boolean":
        this.kind = { case: "boolValue", value: e };
        break;
      case "object":
        e === null ? this.kind = { case: "nullValue", value: yn.NULL_VALUE } : Array.isArray(e) ? this.kind = { case: "listValue", value: me.fromJson(e) } : this.kind = { case: "structValue", value: u.fromJson(e) };
        break;
      default:
        throw new Error("cannot decode google.protobuf.Value from JSON " + o.json.debug(e));
    }
    return this;
  }
  static fromBinary(e, n) {
    return new K().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new K().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new K().fromJsonString(e, n);
  }
  static equals(e, n) {
    return o.util.equals(K, e, n);
  }
}
K.runtime = o;
K.typeName = "google.protobuf.Value";
K.fields = o.util.newFieldList(() => [
  { no: 1, name: "null_value", kind: "enum", T: o.getEnumType(yn), oneof: "kind" },
  { no: 2, name: "number_value", kind: "scalar", T: 1, oneof: "kind" },
  { no: 3, name: "string_value", kind: "scalar", T: 9, oneof: "kind" },
  { no: 4, name: "bool_value", kind: "scalar", T: 8, oneof: "kind" },
  { no: 5, name: "struct_value", kind: "message", T: u, oneof: "kind" },
  { no: 6, name: "list_value", kind: "message", T: me, oneof: "kind" }
]);
class me extends E {
  constructor(e) {
    super(), this.values = [], o.util.initPartial(e, this);
  }
  toJson(e) {
    return this.values.map((n) => n.toJson());
  }
  fromJson(e, n) {
    if (!Array.isArray(e))
      throw new Error("cannot decode google.protobuf.ListValue from JSON " + o.json.debug(e));
    for (let a of e)
      this.values.push(K.fromJson(a));
    return this;
  }
  static fromBinary(e, n) {
    return new me().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new me().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new me().fromJsonString(e, n);
  }
  static equals(e, n) {
    return o.util.equals(me, e, n);
  }
}
me.runtime = o;
me.typeName = "google.protobuf.ListValue";
me.fields = o.util.newFieldList(() => [
  { no: 1, name: "values", kind: "message", T: K, repeated: !0 }
]);
const Si = /* @__PURE__ */ o.makeEnum(
  "viam.common.v1.KinematicsFileFormat",
  [
    { no: 0, name: "KINEMATICS_FILE_FORMAT_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "KINEMATICS_FILE_FORMAT_SVA", localName: "SVA" },
    { no: 2, name: "KINEMATICS_FILE_FORMAT_URDF", localName: "URDF" }
  ]
), B = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.ResourceName",
  () => [
    {
      no: 1,
      name: "namespace",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "subtype",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "remote_path", kind: "scalar", T: 9, repeated: !0 },
    {
      no: 6,
      name: "local_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ue = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.Pose",
  () => [
    {
      no: 1,
      name: "x",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "y",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "z",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "o_x",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 5,
      name: "o_y",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 6,
      name: "o_z",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 7,
      name: "theta",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), wi = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.Orientation",
  () => [
    {
      no: 1,
      name: "o_x",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "o_y",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "o_z",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "theta",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Qe = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.PoseInFrame",
  () => [
    {
      no: 1,
      name: "reference_frame",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "pose", kind: "message", T: Ue }
  ]
), qe = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.Vector3",
  () => [
    {
      no: 1,
      name: "x",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "y",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "z",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), bi = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.Sphere",
  () => [
    {
      no: 1,
      name: "radius_mm",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), _i = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.Capsule",
  () => [
    {
      no: 1,
      name: "radius_mm",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "length_mm",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Ei = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.RectangularPrism",
  () => [
    { no: 1, name: "dims_mm", kind: "message", T: qe }
  ]
), Ze = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.Geometry",
  () => [
    { no: 1, name: "center", kind: "message", T: Ue },
    { no: 2, name: "sphere", kind: "message", T: bi, oneof: "geometry_type" },
    { no: 3, name: "box", kind: "message", T: Ei, oneof: "geometry_type" },
    { no: 5, name: "capsule", kind: "message", T: _i, oneof: "geometry_type" },
    {
      no: 4,
      name: "label",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Wt = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GeometriesInFrame",
  () => [
    {
      no: 1,
      name: "reference_frame",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "geometries", kind: "message", T: Ze, repeated: !0 }
  ]
), Vt = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.PointCloudObject",
  () => [
    {
      no: 1,
      name: "point_cloud",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    { no: 2, name: "geometries", kind: "message", T: Wt }
  ]
), Je = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GeoPoint",
  () => [
    {
      no: 1,
      name: "latitude",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "longitude",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Kn = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GeoGeometry",
  () => [
    { no: 1, name: "location", kind: "message", T: Je },
    { no: 2, name: "geometries", kind: "message", T: Ze, repeated: !0 }
  ]
), en = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.Transform",
  () => [
    {
      no: 1,
      name: "reference_frame",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "pose_in_observer_frame", kind: "message", T: Qe },
    { no: 3, name: "physical_object", kind: "message", T: Ze, opt: !0 }
  ]
), Mi = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.WorldState",
  () => [
    { no: 1, name: "obstacles", kind: "message", T: Wt, repeated: !0 },
    { no: 3, name: "transforms", kind: "message", T: en, repeated: !0 }
  ]
), ny = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.ActuatorStatus",
  () => [
    {
      no: 1,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), Oi = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.ResponseMetadata",
  () => [
    { no: 1, name: "captured_at", kind: "message", T: I, opt: !0 }
  ]
), U = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.DoCommandRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "command", kind: "message", T: u }
  ]
), L = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.DoCommandResponse",
  () => [
    { no: 1, name: "result", kind: "message", T: u }
  ]
), Ni = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GetKinematicsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Ci = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GetKinematicsResponse",
  () => [
    { no: 1, name: "format", kind: "enum", T: o.getEnumType(Si) },
    {
      no: 2,
      name: "kinematics_data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), j = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GetGeometriesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), H = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GetGeometriesResponse",
  () => [
    { no: 1, name: "geometries", kind: "message", T: Ze, repeated: !0 }
  ]
), We = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GetReadingsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), st = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.GetReadingsResponse",
  () => [
    { no: 1, name: "readings", kind: "map", K: 9, V: { kind: "message", T: K } }
  ]
), ot = /* @__PURE__ */ o.makeMessageType(
  "viam.common.v1.LogEntry",
  () => [
    {
      no: 1,
      name: "host",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "level",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "time", kind: "message", T: I },
    {
      no: 4,
      name: "logger_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "message",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 6, name: "caller", kind: "message", T: u },
    {
      no: 7,
      name: "stack",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 8, name: "fields", kind: "message", T: u, repeated: !0 }
  ]
), ty = o.makeExtension(
  "viam.common.v1.safety_heartbeat_monitored",
  re,
  { no: 84260, kind: "scalar", T: 8, opt: !0 }
), Pi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActuatorStatus: ny,
  Capsule: _i,
  DoCommandRequest: U,
  DoCommandResponse: L,
  GeoGeometry: Kn,
  GeoPoint: Je,
  GeometriesInFrame: Wt,
  Geometry: Ze,
  GetGeometriesRequest: j,
  GetGeometriesResponse: H,
  GetKinematicsRequest: Ni,
  GetKinematicsResponse: Ci,
  GetReadingsRequest: We,
  GetReadingsResponse: st,
  KinematicsFileFormat: Si,
  LogEntry: ot,
  Orientation: wi,
  PointCloudObject: Vt,
  Pose: Ue,
  PoseInFrame: Qe,
  RectangularPrism: Ei,
  ResourceName: B,
  ResponseMetadata: Oi,
  Sphere: bi,
  Transform: en,
  Vector3: qe,
  WorldState: Mi,
  safety_heartbeat_monitored: ty
}, Symbol.toStringTag, { value: "Module" })), Di = /* @__PURE__ */ o.makeEnum(
  "viam.robot.v1.PeerConnectionType",
  [
    { no: 0, name: "PEER_CONNECTION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "PEER_CONNECTION_TYPE_GRPC", localName: "GRPC" },
    { no: 2, name: "PEER_CONNECTION_TYPE_WEBRTC", localName: "WEBRTC" }
  ]
), qi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.FrameSystemConfig",
  () => [
    { no: 1, name: "frame", kind: "message", T: en },
    { no: 2, name: "kinematics", kind: "message", T: u }
  ]
), Ai = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.FrameSystemConfigRequest",
  () => [
    { no: 1, name: "supplemental_transforms", kind: "message", T: en, repeated: !0 }
  ]
), Ui = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.FrameSystemConfigResponse",
  () => [
    { no: 1, name: "frame_system_configs", kind: "message", T: qi, repeated: !0 }
  ]
), jt = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.TransformPoseRequest",
  () => [
    { no: 1, name: "source", kind: "message", T: Qe },
    {
      no: 2,
      name: "destination",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "supplemental_transforms", kind: "message", T: en, repeated: !0 }
  ]
), Gi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.TransformPoseResponse",
  () => [
    { no: 1, name: "pose", kind: "message", T: Qe }
  ]
), Ht = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.TransformPCDRequest",
  () => [
    {
      no: 1,
      name: "point_cloud_pcd",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "source",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "destination",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Li = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.TransformPCDResponse",
  () => [
    {
      no: 1,
      name: "point_cloud_pcd",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), Bi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ResourceNamesRequest",
  []
), xi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ResourceNamesResponse",
  () => [
    { no: 1, name: "resources", kind: "message", T: B, repeated: !0 }
  ]
), Fi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ResourceRPCSubtype",
  () => [
    { no: 1, name: "subtype", kind: "message", T: B },
    {
      no: 2,
      name: "proto_service",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ji = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ResourceRPCSubtypesRequest",
  []
), zi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ResourceRPCSubtypesResponse",
  () => [
    { no: 1, name: "resource_rpc_subtypes", kind: "message", T: Fi, repeated: !0 }
  ]
), $i = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.Operation",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "method",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "arguments", kind: "message", T: u },
    { no: 4, name: "started", kind: "message", T: I },
    { no: 5, name: "session_id", kind: "scalar", T: 9, opt: !0 }
  ]
), Yi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetOperationsRequest",
  []
), Wi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetOperationsResponse",
  () => [
    { no: 1, name: "operations", kind: "message", T: $i, repeated: !0 }
  ]
), Vi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.CancelOperationRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ji = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.CancelOperationResponse",
  []
), Hi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.BlockForOperationRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ki = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.BlockForOperationResponse",
  []
), Xi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.PeerConnectionInfo",
  () => [
    { no: 1, name: "type", kind: "enum", T: o.getEnumType(Di) },
    { no: 2, name: "remote_address", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "local_address", kind: "scalar", T: 9, opt: !0 }
  ]
), Qi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.Session",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "peer_connection_info", kind: "message", T: Xi, opt: !0 }
  ]
), Zi = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetSessionsRequest",
  []
), er = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetSessionsResponse",
  () => [
    { no: 1, name: "sessions", kind: "message", T: Qi, repeated: !0 }
  ]
), Kt = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.DiscoveryQuery",
  () => [
    {
      no: 1,
      name: "subtype",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "model",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), nr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.Discovery",
  () => [
    { no: 1, name: "query", kind: "message", T: Kt },
    { no: 2, name: "results", kind: "message", T: u }
  ]
), tr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.DiscoverComponentsRequest",
  () => [
    { no: 1, name: "queries", kind: "message", T: Kt, repeated: !0 }
  ]
), ar = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.DiscoverComponentsResponse",
  () => [
    { no: 1, name: "discovery", kind: "message", T: nr, repeated: !0 }
  ]
), Xt = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.Status",
  () => [
    { no: 1, name: "name", kind: "message", T: B },
    { no: 2, name: "status", kind: "message", T: u },
    { no: 3, name: "last_reconfigured", kind: "message", T: I }
  ]
), sr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetStatusRequest",
  () => [
    { no: 1, name: "resource_names", kind: "message", T: B, repeated: !0 }
  ]
), or = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetStatusResponse",
  () => [
    { no: 1, name: "status", kind: "message", T: Xt, repeated: !0 }
  ]
), ir = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.StreamStatusRequest",
  () => [
    { no: 1, name: "resource_names", kind: "message", T: B, repeated: !0 },
    { no: 2, name: "every", kind: "message", T: X }
  ]
), rr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.StreamStatusResponse",
  () => [
    { no: 1, name: "status", kind: "message", T: Xt, repeated: !0 }
  ]
), mr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.StopExtraParameters",
  () => [
    { no: 1, name: "name", kind: "message", T: B },
    { no: 2, name: "params", kind: "message", T: u }
  ]
), cr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.StopAllRequest",
  () => [
    { no: 99, name: "extra", kind: "message", T: mr, repeated: !0 }
  ]
), lr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.StopAllResponse",
  []
), Qt = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.StartSessionRequest",
  () => [
    {
      no: 1,
      name: "resume",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), dr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.StartSessionResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "heartbeat_window", kind: "message", T: X }
  ]
), Zt = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.SendSessionHeartbeatRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ur = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.SendSessionHeartbeatResponse",
  []
), pr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.LogRequest",
  () => [
    { no: 1, name: "logs", kind: "message", T: ot, repeated: !0 }
  ]
), gr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.LogResponse",
  []
), Tr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetCloudMetadataRequest",
  []
), ea = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetCloudMetadataResponse",
  () => [
    {
      no: 1,
      name: "robot_part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "primary_org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "machine_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "machine_part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), na = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.RestartModuleRequest",
  () => [
    { no: 1, name: "module_id", kind: "scalar", T: 9, oneof: "id_or_name" },
    { no: 2, name: "module_name", kind: "scalar", T: 9, oneof: "id_or_name" }
  ]
), kr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.RestartModuleResponse",
  []
), yr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ShutdownRequest",
  []
), vr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ShutdownResponse",
  []
), hr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetMachineStatusRequest",
  []
), fr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetMachineStatusResponse",
  () => [
    { no: 1, name: "resources", kind: "message", T: Ir, repeated: !0 },
    { no: 2, name: "config", kind: "message", T: wr },
    { no: 3, name: "state", kind: "enum", T: o.getEnumType(Rr) }
  ]
), Rr = /* @__PURE__ */ o.makeEnum(
  "viam.robot.v1.GetMachineStatusResponse.State",
  [
    { no: 0, name: "STATE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "STATE_INITIALIZING", localName: "INITIALIZING" },
    { no: 2, name: "STATE_RUNNING", localName: "RUNNING" }
  ]
), Ir = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ResourceStatus",
  () => [
    { no: 1, name: "name", kind: "message", T: B },
    { no: 2, name: "state", kind: "enum", T: o.getEnumType(Sr) },
    { no: 3, name: "last_updated", kind: "message", T: I },
    {
      no: 4,
      name: "revision",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "error",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 6, name: "cloud_metadata", kind: "message", T: ea, opt: !0 }
  ]
), Sr = /* @__PURE__ */ o.makeEnum(
  "viam.robot.v1.ResourceStatus.State",
  [
    { no: 0, name: "STATE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "STATE_UNCONFIGURED", localName: "UNCONFIGURED" },
    { no: 2, name: "STATE_CONFIGURING", localName: "CONFIGURING" },
    { no: 3, name: "STATE_READY", localName: "READY" },
    { no: 4, name: "STATE_REMOVING", localName: "REMOVING" },
    { no: 5, name: "STATE_UNHEALTHY", localName: "UNHEALTHY" }
  ]
), wr = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.ConfigStatus",
  () => [
    {
      no: 1,
      name: "revision",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "last_updated", kind: "message", T: I }
  ]
), br = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetVersionRequest",
  []
), _r = /* @__PURE__ */ o.makeMessageType(
  "viam.robot.v1.GetVersionResponse",
  () => [
    {
      no: 1,
      name: "platform",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "api_version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), lf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BlockForOperationRequest: Hi,
  BlockForOperationResponse: Ki,
  CancelOperationRequest: Vi,
  CancelOperationResponse: ji,
  ConfigStatus: wr,
  DiscoverComponentsRequest: tr,
  DiscoverComponentsResponse: ar,
  Discovery: nr,
  DiscoveryQuery: Kt,
  FrameSystemConfig: qi,
  FrameSystemConfigRequest: Ai,
  FrameSystemConfigResponse: Ui,
  GetCloudMetadataRequest: Tr,
  GetCloudMetadataResponse: ea,
  GetMachineStatusRequest: hr,
  GetMachineStatusResponse: fr,
  GetMachineStatusResponse_State: Rr,
  GetOperationsRequest: Yi,
  GetOperationsResponse: Wi,
  GetSessionsRequest: Zi,
  GetSessionsResponse: er,
  GetStatusRequest: sr,
  GetStatusResponse: or,
  GetVersionRequest: br,
  GetVersionResponse: _r,
  LogRequest: pr,
  LogResponse: gr,
  Operation: $i,
  PeerConnectionInfo: Xi,
  PeerConnectionType: Di,
  ResourceNamesRequest: Bi,
  ResourceNamesResponse: xi,
  ResourceRPCSubtype: Fi,
  ResourceRPCSubtypesRequest: Ji,
  ResourceRPCSubtypesResponse: zi,
  ResourceStatus: Ir,
  ResourceStatus_State: Sr,
  RestartModuleRequest: na,
  RestartModuleResponse: kr,
  SendSessionHeartbeatRequest: Zt,
  SendSessionHeartbeatResponse: ur,
  Session: Qi,
  ShutdownRequest: yr,
  ShutdownResponse: vr,
  StartSessionRequest: Qt,
  StartSessionResponse: dr,
  Status: Xt,
  StopAllRequest: cr,
  StopAllResponse: lr,
  StopExtraParameters: mr,
  StreamStatusRequest: ir,
  StreamStatusResponse: rr,
  TransformPCDRequest: Ht,
  TransformPCDResponse: Li,
  TransformPoseRequest: jt,
  TransformPoseResponse: Gi
}, Symbol.toStringTag, { value: "Module" }));
var M;
(function(t) {
  t[t.Canceled = 1] = "Canceled", t[t.Unknown = 2] = "Unknown", t[t.InvalidArgument = 3] = "InvalidArgument", t[t.DeadlineExceeded = 4] = "DeadlineExceeded", t[t.NotFound = 5] = "NotFound", t[t.AlreadyExists = 6] = "AlreadyExists", t[t.PermissionDenied = 7] = "PermissionDenied", t[t.ResourceExhausted = 8] = "ResourceExhausted", t[t.FailedPrecondition = 9] = "FailedPrecondition", t[t.Aborted = 10] = "Aborted", t[t.OutOfRange = 11] = "OutOfRange", t[t.Unimplemented = 12] = "Unimplemented", t[t.Internal = 13] = "Internal", t[t.Unavailable = 14] = "Unavailable", t[t.DataLoss = 15] = "DataLoss", t[t.Unauthenticated = 16] = "Unauthenticated";
})(M || (M = {}));
function Bo(t) {
  const e = M[t];
  return typeof e != "string" ? t.toString() : e[0].toLowerCase() + e.substring(1).replace(/[A-Z]/g, (n) => "_" + n.toLowerCase());
}
class N extends Error {
  /**
   * Create a new ConnectError.
   * If no code is provided, code "unknown" is used.
   * Outgoing details are only relevant for the server side - a service may
   * raise an error with details, and it is up to the protocol implementation
   * to encode and send the details along with error.
   */
  constructor(e, n = M.Unknown, a, s, i) {
    super(ay(e, n)), this.name = "ConnectError", Object.setPrototypeOf(this, new.target.prototype), this.rawMessage = e, this.code = n, this.metadata = new Headers(a ?? {}), this.details = s ?? [], this.cause = i;
  }
  /**
   * Convert any value - typically a caught error into a ConnectError,
   * following these rules:
   * - If the value is already a ConnectError, return it as is.
   * - If the value is an AbortError from the fetch API, return the message
   *   of the AbortError with code Canceled.
   * - For other Errors, return the error message with code Unknown by default.
   * - For other values, return the values String representation as a message,
   *   with the code Unknown by default.
   * The original value will be used for the "cause" property for the new
   * ConnectError.
   */
  static from(e, n = M.Unknown) {
    return e instanceof N ? e : e instanceof Error ? e.name == "AbortError" ? new N(e.message, M.Canceled) : new N(e.message, n, void 0, void 0, e) : new N(String(e), n, void 0, void 0, e);
  }
  static [Symbol.hasInstance](e) {
    return e instanceof Error ? Object.getPrototypeOf(e) === N.prototype ? !0 : e.name === "ConnectError" && "code" in e && typeof e.code == "number" && "metadata" in e && "details" in e && Array.isArray(e.details) && "rawMessage" in e && typeof e.rawMessage == "string" && "cause" in e : !1;
  }
  findDetails(e) {
    const n = "typeName" in e ? {
      findMessage: (s) => s === e.typeName ? e : void 0
    } : e, a = [];
    for (const s of this.details) {
      if ("getType" in s) {
        n.findMessage(s.getType().typeName) && a.push(s);
        continue;
      }
      const i = n.findMessage(s.type);
      if (i)
        try {
          a.push(i.fromBinary(s.value));
        } catch {
        }
    }
    return a;
  }
}
function ay(t, e) {
  return t.length ? `[${Bo(e)}] ${t}` : `[${Bo(e)}]`;
}
function sy(t, e, n) {
  try {
    const a = Yt.dec(t);
    return e ? e.fromBinary(a, n) : a;
  } catch (a) {
    throw N.from(a, M.DataLoss);
  }
}
function oy(t, e) {
  const n = {};
  for (const [a, s] of Object.entries(t.methods)) {
    const i = e(Object.assign(Object.assign({}, s), {
      localName: a,
      service: t
    }));
    i != null && (n[a] = i);
  }
  return n;
}
const xo = 1;
function Fo(t) {
  let e, n = new Uint8Array(0);
  function a(s) {
    const i = new Uint8Array(n.length + s.length);
    i.set(n), i.set(s, n.length), n = i;
  }
  return new ReadableStream({
    start() {
      e = t.getReader();
    },
    async pull(s) {
      let i;
      for (; ; ) {
        if (i === void 0 && n.byteLength >= 5) {
          let d = 0;
          for (let l = 1; l < 5; l++)
            d = (d << 8) + n[l];
          i = { flags: n[0], length: d };
        }
        if (i !== void 0 && n.byteLength >= i.length + 5)
          break;
        const c = await e.read();
        if (c.done)
          break;
        a(c.value);
      }
      if (i === void 0) {
        if (n.byteLength == 0) {
          s.close();
          return;
        }
        s.error(new N("premature end of stream", M.DataLoss));
        return;
      }
      const r = n.subarray(5, 5 + i.length);
      n = n.subarray(5 + i.length), s.enqueue({
        flags: i.flags,
        data: r
      });
    }
  });
}
function Jo(t, e) {
  const n = new Uint8Array(e.length + 5);
  n.set(e, 5);
  const a = new DataView(n.buffer, n.byteOffset, n.byteLength);
  return a.setUint8(0, t), a.setUint32(1, e.length), n;
}
var iy = function(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof __values == "function" ? __values(t) : t[Symbol.iterator](), n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function a(i) {
    n[i] = t[i] && function(r) {
      return new Promise(function(c, d) {
        r = t[i](r), s(c, d, r.done, r.value);
      });
    };
  }
  function s(i, r, c, d) {
    Promise.resolve(d).then(function(l) {
      i({ value: l, done: c });
    }, r);
  }
}, vn = function(t) {
  return this instanceof vn ? (this.v = t, this) : new vn(t);
}, ry = function(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = n.apply(t, e || []), s, i = [];
  return s = {}, c("next"), c("throw"), c("return", r), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function r(f) {
    return function(w) {
      return Promise.resolve(w).then(f, R);
    };
  }
  function c(f, w) {
    a[f] && (s[f] = function(O) {
      return new Promise(function(C, F) {
        i.push([f, O, C, F]) > 1 || d(f, O);
      });
    }, w && (s[f] = w(s[f])));
  }
  function d(f, w) {
    try {
      l(a[f](w));
    } catch (O) {
      S(i[0][3], O);
    }
  }
  function l(f) {
    f.value instanceof vn ? Promise.resolve(f.value.v).then(T, R) : S(i[0][2], f);
  }
  function T(f) {
    d("next", f);
  }
  function R(f) {
    d("throw", f);
  }
  function S(f, w) {
    f(w), i.shift(), i.length && d(i[0][0], i[0][1]);
  }
}, my = function(t) {
  var e, n;
  return e = {}, a("next"), a("throw", function(s) {
    throw s;
  }), a("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function a(s, i) {
    e[s] = t[s] ? function(r) {
      return (n = !n) ? { value: vn(t[s](r)), done: !1 } : i ? i(r) : r;
    } : i;
  }
};
function cy() {
  const t = [], e = [];
  let n, a, s, i = new Promise((d, l) => {
    a = d, s = l;
  }), r = !1;
  function c() {
    for (const d of t.splice(0, t.length))
      d({ done: !0, value: void 0 });
  }
  return {
    close() {
      r = !0, c();
    },
    async write(d) {
      if (r)
        throw n ?? new Error("cannot write, WritableIterable already closed");
      const l = t.shift();
      if (l === void 0)
        e.push(d);
      else if (l({ done: !1, value: d }), t.length > 0)
        return;
      const T = e.length + 1;
      for (let R = 0; R < T; R++)
        await i;
    },
    [Symbol.asyncIterator]() {
      return {
        next() {
          a(), i = new Promise((R, S) => {
            a = R, s = S;
          });
          const d = e.shift();
          if (d !== void 0)
            return Promise.resolve({ done: !1, value: d });
          if (r)
            return Promise.resolve({ done: !0, value: void 0 });
          let l;
          const T = new Promise((R) => l = R);
          return t.push(l), T;
        },
        throw(d) {
          return n = d, r = !0, e.splice(0, e.length), i.catch(() => {
          }), s(n), c(), Promise.resolve({ done: !0, value: void 0 });
        },
        return() {
          return r = !0, e.splice(0, e.length), a(), i = Promise.reject(new Error("cannot write, consumer called return")), i.catch(() => {
          }), c(), Promise.resolve({ done: !0, value: void 0 });
        }
      };
    }
  };
}
function ly(t) {
  return ry(this, arguments, function* () {
    yield vn(yield* my(iy(t)));
  });
}
var Er = function(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof __values == "function" ? __values(t) : t[Symbol.iterator](), n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function a(i) {
    n[i] = t[i] && function(r) {
      return new Promise(function(c, d) {
        r = t[i](r), s(c, d, r.done, r.value);
      });
    };
  }
  function s(i, r, c, d) {
    Promise.resolve(d).then(function(l) {
      i({ value: l, done: c });
    }, r);
  }
}, Ke = function(t) {
  return this instanceof Ke ? (this.v = t, this) : new Ke(t);
}, dy = function(t) {
  var e, n;
  return e = {}, a("next"), a("throw", function(s) {
    throw s;
  }), a("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function a(s, i) {
    e[s] = t[s] ? function(r) {
      return (n = !n) ? { value: Ke(t[s](r)), done: !1 } : i ? i(r) : r;
    } : i;
  }
}, uy = function(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = n.apply(t, e || []), s, i = [];
  return s = {}, c("next"), c("throw"), c("return", r), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function r(f) {
    return function(w) {
      return Promise.resolve(w).then(f, R);
    };
  }
  function c(f, w) {
    a[f] && (s[f] = function(O) {
      return new Promise(function(C, F) {
        i.push([f, O, C, F]) > 1 || d(f, O);
      });
    }, w && (s[f] = w(s[f])));
  }
  function d(f, w) {
    try {
      l(a[f](w));
    } catch (O) {
      S(i[0][3], O);
    }
  }
  function l(f) {
    f.value instanceof Ke ? Promise.resolve(f.value.v).then(T, R) : S(i[0][2], f);
  }
  function T(f) {
    d("next", f);
  }
  function R(f) {
    d("throw", f);
  }
  function S(f, w) {
    f(w), i.shift(), i.length && d(i[0][0], i[0][1]);
  }
};
function ta(t, e) {
  return oy(t, (n) => {
    switch (n.kind) {
      case m.Unary:
        return py(e, t, n);
      case m.ServerStreaming:
        return gy(e, t, n);
      case m.ClientStreaming:
        return Ty(e, t, n);
      case m.BiDiStreaming:
        return ky(e, t, n);
      default:
        return null;
    }
  });
}
function P(t, e) {
  return ta(t, e);
}
function py(t, e, n) {
  return async function(a, s) {
    var i, r;
    const c = await t.unary(e, n, s?.signal, s?.timeoutMs, s?.headers, a, s?.contextValues);
    return (i = s?.onHeader) === null || i === void 0 || i.call(s, c.header), (r = s?.onTrailer) === null || r === void 0 || r.call(s, c.trailer), c.message;
  };
}
function gy(t, e, n) {
  return function(a, s) {
    return Mr(t.stream(e, n, s?.signal, s?.timeoutMs, s?.headers, ly([a]), s?.contextValues), s);
  };
}
function Ty(t, e, n) {
  return async function(a, s) {
    var i, r, c, d, l, T;
    const R = await t.stream(e, n, s?.signal, s?.timeoutMs, s?.headers, a, s?.contextValues);
    (l = s?.onHeader) === null || l === void 0 || l.call(s, R.header);
    let S, f = 0;
    try {
      for (var w = !0, O = Er(R.message), C; C = await O.next(), i = C.done, !i; w = !0)
        d = C.value, w = !1, S = d, f++;
    } catch (F) {
      r = { error: F };
    } finally {
      try {
        !w && !i && (c = O.return) && await c.call(O);
      } finally {
        if (r) throw r.error;
      }
    }
    if (!S)
      throw new N("protocol error: missing response message", M.Unimplemented);
    if (f > 1)
      throw new N("protocol error: received extra messages for client streaming method", M.Unimplemented);
    return (T = s?.onTrailer) === null || T === void 0 || T.call(s, R.trailer), S;
  };
}
function ky(t, e, n) {
  return function(a, s) {
    return Mr(t.stream(e, n, s?.signal, s?.timeoutMs, s?.headers, a, s?.contextValues), s);
  };
}
function Mr(t, e) {
  const n = function() {
    return uy(this, arguments, function* () {
      var a, s;
      const i = yield Ke(t);
      (a = e?.onHeader) === null || a === void 0 || a.call(e, i.header), yield Ke(yield* dy(Er(i.message))), (s = e?.onTrailer) === null || s === void 0 || s.call(e, i.trailer);
    });
  }()[Symbol.asyncIterator]();
  return {
    [Symbol.asyncIterator]: () => ({
      next: () => n.next()
    })
  };
}
function yy(...t) {
  const e = new AbortController(), n = t.filter((s) => s !== void 0).concat(e.signal);
  for (const s of n) {
    if (s.aborted) {
      a.apply(s);
      break;
    }
    s.addEventListener("abort", a);
  }
  function a() {
    e.signal.aborted || e.abort(Or(this));
    for (const s of n)
      s.removeEventListener("abort", a);
  }
  return e;
}
function vy(t) {
  const e = new AbortController(), n = () => {
    e.abort(new N("the operation timed out", M.DeadlineExceeded));
  };
  let a;
  return t !== void 0 && (t <= 0 ? n() : a = setTimeout(n, t)), {
    signal: e.signal,
    cleanup: () => clearTimeout(a)
  };
}
function Or(t) {
  if (!t.aborted)
    return;
  if (t.reason !== void 0)
    return t.reason;
  const e = new Error("This operation was aborted");
  return e.name = "AbortError", e;
}
function Xn() {
  return {
    get(t) {
      return t.id in this ? this[t.id] : t.defaultValue;
    },
    set(t, e) {
      return this[t.id] = e, this;
    },
    delete(t) {
      return delete this[t.id], this;
    }
  };
}
const bt = 128;
function zo(t) {
  const e = new Headers(), n = new TextDecoder().decode(t).split(`\r
`);
  for (const a of n) {
    if (a === "")
      continue;
    const s = a.indexOf(":");
    if (s > 0) {
      const i = a.substring(0, s).trim(), r = a.substring(s + 1).trim();
      e.append(i, r);
    }
  }
  return e;
}
const hy = "Content-Type", fy = "Grpc-Timeout", Xe = "Grpc-Status", Nr = "Grpc-Message", Ry = "Grpc-Status-Details-Bin", Iy = "X-User-Agent", Sy = "X-Grpc-Web", wy = "application/grpc-web+proto", by = "application/grpc-web+json";
let it = class cn extends E {
  constructor(e) {
    super(), this.code = 0, this.message = "", this.details = [], o.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new cn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new cn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new cn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return o.util.equals(cn, e, n);
  }
};
it.runtime = o;
it.typeName = "google.rpc.Status";
it.fields = o.util.newFieldList(() => [
  {
    no: 1,
    name: "code",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 2,
    name: "message",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 3, name: "details", kind: "message", T: W, repeated: !0 }
]);
const _y = "0";
function Cr(t) {
  var e;
  const n = t.get(Ry);
  if (n != null) {
    const s = sy(n, it);
    if (s.code == 0)
      return;
    const i = new N(s.message, s.code, t);
    return i.details = s.details.map((r) => ({
      type: r.typeUrl.substring(r.typeUrl.lastIndexOf("/") + 1),
      value: r.value
    })), i;
  }
  const a = t.get(Xe);
  if (a != null) {
    if (a === _y)
      return;
    const s = parseInt(a, 10);
    return s in M ? new N(decodeURIComponent((e = t.get(Nr)) !== null && e !== void 0 ? e : ""), s, t) : new N(`invalid grpc-status: ${a}`, M.Internal, t);
  }
}
function $o(t, e, n) {
  const a = typeof e == "string" ? e : e.typeName, s = typeof n == "string" ? n : n.name;
  return t.toString().replace(/\/?$/, `/${a}/${s}`);
}
function Pr(t, e) {
  return e instanceof t ? e : new t(e);
}
function Ey(t, e) {
  function n(a) {
    return a.done === !0 ? a : {
      done: a.done,
      value: Pr(t, a.value)
    };
  }
  return {
    [Symbol.asyncIterator]() {
      const a = e[Symbol.asyncIterator](), s = {
        next: () => a.next().then(n)
      };
      return a.throw !== void 0 && (s.throw = (i) => a.throw(i).then(n)), a.return !== void 0 && (s.return = (i) => a.return(i).then(n)), s;
    }
  };
}
function Dr(t, e) {
  var n;
  return (n = e?.concat().reverse().reduce(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    (a, s) => s(a),
    t
  )) !== null && n !== void 0 ? n : t;
}
function My(t) {
  var e;
  const n = Object.assign({}, t);
  return (e = n.ignoreUnknownFields) !== null && e !== void 0 || (n.ignoreUnknownFields = !0), n;
}
function Ot(t, e, n, a) {
  const s = e ? Yo(t.I, a) : Wo(t.I, n);
  return { parse: (e ? Yo(t.O, a) : Wo(t.O, n)).parse, serialize: s.serialize };
}
function Yo(t, e) {
  return {
    parse(n) {
      try {
        return t.fromBinary(n, e);
      } catch (a) {
        const s = a instanceof Error ? a.message : String(a);
        throw new N(`parse binary: ${s}`, M.Internal);
      }
    },
    serialize(n) {
      try {
        return n.toBinary(e);
      } catch (a) {
        const s = a instanceof Error ? a.message : String(a);
        throw new N(`serialize binary: ${s}`, M.Internal);
      }
    }
  };
}
function Wo(t, e) {
  var n, a;
  const s = (n = e?.textEncoder) !== null && n !== void 0 ? n : new TextEncoder(), i = (a = e?.textDecoder) !== null && a !== void 0 ? a : new TextDecoder(), r = My(e);
  return {
    parse(c) {
      try {
        const d = i.decode(c);
        return t.fromJsonString(d, r);
      } catch (d) {
        throw N.from(d, M.InvalidArgument);
      }
    },
    serialize(c) {
      try {
        const d = c.toJsonString(r);
        return s.encode(d);
      } catch (d) {
        throw N.from(d, M.Internal);
      }
    }
  };
}
function qr(t) {
  const e = Dr(t.next, t.interceptors), [n, a, s] = Ur(t), i = Object.assign(Object.assign({}, t.req), { message: Pr(t.req.method.I, t.req.message), signal: n });
  return e(i).then((r) => (s(), r), a);
}
function Ar(t) {
  const e = Dr(t.next, t.interceptors), [n, a, s] = Ur(t), i = Object.assign(Object.assign({}, t.req), { message: Ey(t.req.method.I, t.req.message), signal: n });
  let r = !1;
  return n.addEventListener("abort", function() {
    var c, d;
    const l = t.req.message[Symbol.asyncIterator]();
    r || (c = l.throw) === null || c === void 0 || c.call(l, this.reason).catch(() => {
    }), (d = l.return) === null || d === void 0 || d.call(l).catch(() => {
    });
  }), e(i).then((c) => Object.assign(Object.assign({}, c), { message: {
    [Symbol.asyncIterator]() {
      const d = c.message[Symbol.asyncIterator]();
      return {
        next() {
          return d.next().then((l) => (l.done == !0 && (r = !0, s()), l), a);
        }
        // We deliberately omit throw/return.
      };
    }
  } }), a);
}
function Ur(t) {
  const { signal: e, cleanup: n } = vy(t.timeoutMs), a = yy(t.signal, e);
  return [
    a.signal,
    function(i) {
      const r = N.from(e.aborted ? Or(e) : i);
      return a.abort(r), n(), Promise.reject(r);
    },
    function() {
      n(), a.abort();
    }
  ];
}
var V = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Gr = {}, aa = {}, Qn = V && V.__assign || function() {
  return Qn = Object.assign || function(t) {
    for (var e, n = 1, a = arguments.length; n < a; n++) {
      e = arguments[n];
      for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    }
    return t;
  }, Qn.apply(this, arguments);
};
Object.defineProperty(aa, "__esModule", { value: !0 });
var Oy = {
  delayFirstAttempt: !1,
  jitter: "none",
  maxDelay: 1 / 0,
  numOfAttempts: 10,
  retry: function() {
    return !0;
  },
  startingDelay: 100,
  timeMultiple: 2
};
function Ny(t) {
  var e = Qn(Qn({}, Oy), t);
  return e.numOfAttempts < 1 && (e.numOfAttempts = 1), e;
}
aa.getSanitizedOptions = Ny;
var sa = {}, oa = {}, rt = {}, ia = {}, ra = {};
Object.defineProperty(ra, "__esModule", { value: !0 });
function Cy(t) {
  var e = Math.random() * t;
  return Math.round(e);
}
ra.fullJitter = Cy;
var ma = {};
Object.defineProperty(ma, "__esModule", { value: !0 });
function Py(t) {
  return t;
}
ma.noJitter = Py;
Object.defineProperty(ia, "__esModule", { value: !0 });
var Dy = ra, qy = ma;
function Ay(t) {
  switch (t.jitter) {
    case "full":
      return Dy.fullJitter;
    case "none":
    default:
      return qy.noJitter;
  }
}
ia.JitterFactory = Ay;
Object.defineProperty(rt, "__esModule", { value: !0 });
var Uy = ia, Gy = (
  /** @class */
  function() {
    function t(e) {
      this.options = e, this.attempt = 0;
    }
    return t.prototype.apply = function() {
      var e = this;
      return new Promise(function(n) {
        return setTimeout(n, e.jitteredDelay);
      });
    }, t.prototype.setAttemptNumber = function(e) {
      this.attempt = e;
    }, Object.defineProperty(t.prototype, "jitteredDelay", {
      get: function() {
        var e = Uy.JitterFactory(this.options);
        return e(this.delay);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "delay", {
      get: function() {
        var e = this.options.startingDelay, n = this.options.timeMultiple, a = this.numOfDelayedAttempts, s = e * Math.pow(n, a);
        return Math.min(s, this.options.maxDelay);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "numOfDelayedAttempts", {
      get: function() {
        return this.attempt;
      },
      enumerable: !0,
      configurable: !0
    }), t;
  }()
);
rt.Delay = Gy;
var Ly = V && V.__extends || /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, s) {
      a.__proto__ = s;
    } || function(a, s) {
      for (var i in s) s.hasOwnProperty(i) && (a[i] = s[i]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function a() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (a.prototype = n.prototype, new a());
  };
}(), By = V && V.__awaiter || function(t, e, n, a) {
  function s(i) {
    return i instanceof n ? i : new n(function(r) {
      r(i);
    });
  }
  return new (n || (n = Promise))(function(i, r) {
    function c(T) {
      try {
        l(a.next(T));
      } catch (R) {
        r(R);
      }
    }
    function d(T) {
      try {
        l(a.throw(T));
      } catch (R) {
        r(R);
      }
    }
    function l(T) {
      T.done ? i(T.value) : s(T.value).then(c, d);
    }
    l((a = a.apply(t, e || [])).next());
  });
}, xy = V && V.__generator || function(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, a, s, i, r;
  return r = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (r[Symbol.iterator] = function() {
    return this;
  }), r;
  function c(l) {
    return function(T) {
      return d([l, T]);
    };
  }
  function d(l) {
    if (a) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (a = 1, s && (i = l[0] & 2 ? s.return : l[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, l[1])).done) return i;
      switch (s = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, s = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = l;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(l);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = e.call(t, n);
    } catch (T) {
      l = [6, T], s = 0;
    } finally {
      a = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
};
Object.defineProperty(oa, "__esModule", { value: !0 });
var Fy = rt, Jy = (
  /** @class */
  function(t) {
    Ly(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.apply = function() {
      return By(this, void 0, void 0, function() {
        return xy(this, function(n) {
          return [2, this.isFirstAttempt ? !0 : t.prototype.apply.call(this)];
        });
      });
    }, Object.defineProperty(e.prototype, "isFirstAttempt", {
      get: function() {
        return this.attempt === 0;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "numOfDelayedAttempts", {
      get: function() {
        return this.attempt - 1;
      },
      enumerable: !0,
      configurable: !0
    }), e;
  }(Fy.Delay)
);
oa.SkipFirstDelay = Jy;
var ca = {}, zy = V && V.__extends || /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, s) {
      a.__proto__ = s;
    } || function(a, s) {
      for (var i in s) s.hasOwnProperty(i) && (a[i] = s[i]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function a() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (a.prototype = n.prototype, new a());
  };
}();
Object.defineProperty(ca, "__esModule", { value: !0 });
var $y = rt, Yy = (
  /** @class */
  function(t) {
    zy(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }($y.Delay)
);
ca.AlwaysDelay = Yy;
Object.defineProperty(sa, "__esModule", { value: !0 });
var Wy = oa, Vy = ca;
function jy(t, e) {
  var n = Hy(t);
  return n.setAttemptNumber(e), n;
}
sa.DelayFactory = jy;
function Hy(t) {
  return t.delayFirstAttempt ? new Vy.AlwaysDelay(t) : new Wy.SkipFirstDelay(t);
}
var Nt = V && V.__awaiter || function(t, e, n, a) {
  function s(i) {
    return i instanceof n ? i : new n(function(r) {
      r(i);
    });
  }
  return new (n || (n = Promise))(function(i, r) {
    function c(T) {
      try {
        l(a.next(T));
      } catch (R) {
        r(R);
      }
    }
    function d(T) {
      try {
        l(a.throw(T));
      } catch (R) {
        r(R);
      }
    }
    function l(T) {
      T.done ? i(T.value) : s(T.value).then(c, d);
    }
    l((a = a.apply(t, e || [])).next());
  });
}, Ct = V && V.__generator || function(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, a, s, i, r;
  return r = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (r[Symbol.iterator] = function() {
    return this;
  }), r;
  function c(l) {
    return function(T) {
      return d([l, T]);
    };
  }
  function d(l) {
    if (a) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (a = 1, s && (i = l[0] & 2 ? s.return : l[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, l[1])).done) return i;
      switch (s = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, s = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = l;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(l);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = e.call(t, n);
    } catch (T) {
      l = [6, T], s = 0;
    } finally {
      a = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Gr, "__esModule", { value: !0 });
var Ky = aa, Xy = sa;
function Qy(t, e) {
  return e === void 0 && (e = {}), Nt(this, void 0, void 0, function() {
    var n, a;
    return Ct(this, function(s) {
      switch (s.label) {
        case 0:
          return n = Ky.getSanitizedOptions(e), a = new Zy(t, n), [4, a.execute()];
        case 1:
          return [2, s.sent()];
      }
    });
  });
}
var Pt = Gr.backOff = Qy, Zy = (
  /** @class */
  function() {
    function t(e, n) {
      this.request = e, this.options = n, this.attemptNumber = 0;
    }
    return t.prototype.execute = function() {
      return Nt(this, void 0, void 0, function() {
        var e, n;
        return Ct(this, function(a) {
          switch (a.label) {
            case 0:
              if (this.attemptLimitReached) return [3, 7];
              a.label = 1;
            case 1:
              return a.trys.push([1, 4, , 6]), [4, this.applyDelay()];
            case 2:
              return a.sent(), [4, this.request()];
            case 3:
              return [2, a.sent()];
            case 4:
              return e = a.sent(), this.attemptNumber++, [4, this.options.retry(e, this.attemptNumber)];
            case 5:
              if (n = a.sent(), !n || this.attemptLimitReached)
                throw e;
              return [3, 6];
            case 6:
              return [3, 0];
            case 7:
              throw new Error("Something went wrong.");
          }
        });
      });
    }, Object.defineProperty(t.prototype, "attemptLimitReached", {
      get: function() {
        return this.attemptNumber >= this.options.numOfAttempts;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.applyDelay = function() {
      return Nt(this, void 0, void 0, function() {
        var e;
        return Ct(this, function(n) {
          switch (n.label) {
            case 0:
              return e = Xy.DelayFactory(this.options, this.attemptNumber), [4, e.apply()];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
const Lr = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.v1.Credentials",
  () => [
    {
      no: 1,
      name: "type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "payload",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Dt = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.v1.AuthenticateRequest",
  () => [
    {
      no: 1,
      name: "entity",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "credentials", kind: "message", T: Lr }
  ]
), ev = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.v1.AuthenticateResponse",
  () => [
    {
      no: 1,
      name: "access_token",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), nv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.v1.AuthenticateToRequest",
  () => [
    {
      no: 1,
      name: "entity",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), tv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.v1.AuthenticateToResponse",
  () => [
    {
      no: 1,
      name: "access_token",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), av = {
  typeName: "proto.rpc.v1.AuthService",
  methods: {
    /**
     * Authenticate attempts to authenticate the caller claiming to be
     * the given entity. The resulting response contains an access token
     * with the subject as the entity and the audience/issuer as the
     * provider of this service. This token should be used for all future
     * RPC requests.
     *
     * @generated from rpc proto.rpc.v1.AuthService.Authenticate
     */
    authenticate: {
      name: "Authenticate",
      I: Dt,
      O: ev,
      kind: m.Unary
    }
  }
}, sv = {
  typeName: "proto.rpc.v1.ExternalAuthService",
  methods: {
    /**
     * AuthenticateTo attempts to allow the caller to authenticate to another entity.
     * The resulting response contains an access token with the subject
     * as the calling entity, the audience as the other entity, and the issuer
     * as the provider of this service. This token should be used for all
     * future RPC requests to the other entity on the services it provides.
     * This assumes that the caller is already authenticated to the
     * server implementing this service.
     *
     * @generated from rpc proto.rpc.v1.ExternalAuthService.AuthenticateTo
     */
    authenticateTo: {
      name: "AuthenticateTo",
      I: nv,
      O: tv,
      kind: m.Unary
    }
  }
}, nn = /* @__PURE__ */ o.makeMessageType(
  "google.rpc.Status",
  () => [
    {
      no: 1,
      name: "code",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 2,
      name: "message",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "details", kind: "message", T: W, repeated: !0 }
  ]
), In = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.ICECandidate",
  () => [
    {
      no: 1,
      name: "candidate",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "sdp_mid", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "sdpm_line_index", kind: "scalar", T: 13, opt: !0 },
    { no: 4, name: "username_fragment", kind: "scalar", T: 9, opt: !0 }
  ]
), Br = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.CallRequest",
  () => [
    {
      no: 1,
      name: "sdp",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "disable_trickle",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), ov = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.CallResponseInitStage",
  () => [
    {
      no: 1,
      name: "sdp",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), iv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.CallResponseUpdateStage",
  () => [
    { no: 1, name: "candidate", kind: "message", T: In }
  ]
), rv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.CallResponse",
  () => [
    {
      no: 1,
      name: "uuid",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "init", kind: "message", T: ov, oneof: "stage" },
    { no: 3, name: "update", kind: "message", T: iv, oneof: "stage" }
  ]
), Un = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.CallUpdateRequest",
  () => [
    {
      no: 1,
      name: "uuid",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "candidate", kind: "message", T: In, oneof: "update" },
    { no: 3, name: "done", kind: "scalar", T: 8, oneof: "update" },
    { no: 4, name: "error", kind: "message", T: nn, oneof: "update" }
  ]
), mv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.CallUpdateResponse",
  []
), cv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.ICEServer",
  () => [
    { no: 1, name: "urls", kind: "scalar", T: 9, repeated: !0 },
    {
      no: 2,
      name: "username",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "credential",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Zn = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.WebRTCConfig",
  () => [
    { no: 1, name: "additional_ice_servers", kind: "message", T: cv, repeated: !0 },
    {
      no: 2,
      name: "disable_trickle",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), lv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerRequestInitStage",
  () => [
    {
      no: 1,
      name: "sdp",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "optional_config", kind: "message", T: Zn },
    { no: 3, name: "deadline", kind: "message", T: I, opt: !0 }
  ]
), dv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerRequestUpdateStage",
  () => [
    { no: 1, name: "candidate", kind: "message", T: In }
  ]
), uv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerRequestDoneStage",
  []
), pv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerRequestErrorStage",
  () => [
    { no: 1, name: "status", kind: "message", T: nn }
  ]
), gv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerRequestHeartbeatStage",
  []
), Tv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerRequest",
  () => [
    {
      no: 1,
      name: "uuid",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "init", kind: "message", T: lv, oneof: "stage" },
    { no: 3, name: "update", kind: "message", T: dv, oneof: "stage" },
    { no: 4, name: "done", kind: "message", T: uv, oneof: "stage" },
    { no: 5, name: "error", kind: "message", T: pv, oneof: "stage" },
    { no: 6, name: "heartbeat", kind: "message", T: gv, oneof: "stage" }
  ]
), kv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerResponseInitStage",
  () => [
    {
      no: 1,
      name: "sdp",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), yv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerResponseUpdateStage",
  () => [
    { no: 1, name: "candidate", kind: "message", T: In }
  ]
), vv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerResponseDoneStage",
  []
), hv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerResponseErrorStage",
  () => [
    { no: 1, name: "status", kind: "message", T: nn }
  ]
), fv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.AnswerResponse",
  () => [
    {
      no: 1,
      name: "uuid",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "init", kind: "message", T: kv, oneof: "stage" },
    { no: 3, name: "update", kind: "message", T: yv, oneof: "stage" },
    { no: 4, name: "done", kind: "message", T: vv, oneof: "stage" },
    { no: 5, name: "error", kind: "message", T: hv, oneof: "stage" }
  ]
), Rv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.OptionalWebRTCConfigRequest",
  []
), Iv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.OptionalWebRTCConfigResponse",
  () => [
    { no: 1, name: "config", kind: "message", T: Zn }
  ]
), xr = {
  typeName: "proto.rpc.webrtc.v1.SignalingService",
  methods: {
    /**
     * Call makes an offer to a client that it expects an answer to. The host
     * of the client in question should be identified in the rpc-host metadata
     * field.
     * Note: Based on how this is a server streaming responnse to the caller,
     * we do not have a good way of knowing if the caller has disappeared.
     * Depending on answerer timeouts and concurrency limits, this can result in
     * hangs on the answerer waiting for a connection to establish, which in turn
     * can result in the caller waiting for an answerer to be listening.
     *
     * @generated from rpc proto.rpc.webrtc.v1.SignalingService.Call
     */
    call: {
      name: "Call",
      I: Br,
      O: rv,
      kind: m.ServerStreaming
    },
    /**
     * CallUpdate is used to send additional info in relation to a Call.
     * The host of the client for the call in question should be identified
     * in the rpc-host metadata field.
     * In a world where https://github.com/grpc/grpc-web/issues/24 is fixed,
     * this should be removed in favor of a bidirectional stream on Call.
     *
     * @generated from rpc proto.rpc.webrtc.v1.SignalingService.CallUpdate
     */
    callUpdate: {
      name: "CallUpdate",
      I: Un,
      O: mv,
      kind: m.Unary
    },
    /**
     * Answer sets up an answering service where the caller answers call offers
     * and responds with answers.
     * The host(s) to answer for should be in the rpc-host metadata field.
     *
     * @generated from rpc proto.rpc.webrtc.v1.SignalingService.Answer
     */
    answer: {
      name: "Answer",
      I: fv,
      O: Tv,
      kind: m.BiDiStreaming
    },
    /**
     * OptionalWebRTCConfig returns any WebRTC configuration the caller may want to use.
     * The host to get a config for must be in the rpc-host metadata field.
     *
     * @generated from rpc proto.rpc.webrtc.v1.SignalingService.OptionalWebRTCConfig
     */
    optionalWebRTCConfig: {
      name: "OptionalWebRTCConfig",
      I: Rv,
      O: Iv,
      kind: m.Unary
    }
  }
}, Fr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", qt = (t = "") => {
  const e = t;
  let n = "";
  for (let a = 0, s, i = 0, r = Fr; e.charAt(Math.trunc(i)) || (r = "=", i % 1); n += r.charAt(63 & a >> 8 - i % 1 * 8)) {
    if (s = e.charCodeAt(i += 3 / 4), s > 255)
      throw new Error(
        "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
      );
    a = a << 8 | s;
  }
  return n;
}, Jr = (t = "") => {
  const e = t.replace(/=+$/, "");
  let n = "";
  if (e.length % 4 === 1)
    throw new Error(
      "'atob' failed: The string to be decoded is not correctly encoded."
    );
  for (
    let a = 0, s = 0, i, r = 0;
    i = e.charAt(r++);
    // eslint-disable-line no-cond-assign
    ~i && (s = a % 4 ? s * 64 + i : i, a++ % 4) ? n += String.fromCharCode(255 & s >> (-2 * a & 6)) : 0
  )
    i = Fr.indexOf(i);
  return n;
}, At = (t, e) => {
  const n = {
    sdp: t?.sdp,
    type: t?.type
  };
  if (e)
    for (const [a, s] of Object.entries(e))
      n.sdp = [n.sdp, `a=${a}:${s}\r
`].join("");
  return n;
}, Sv = async (t, e, n) => {
  const a = e ?? {
    iceServers: [
      {
        urls: "stun:global.stun.twilio.com:3478"
      }
    ]
  }, s = new RTCPeerConnection(a);
  let i;
  const r = new Promise((R) => {
    i = R;
  }), c = s.createDataChannel("data", {
    id: 0,
    negotiated: !0,
    ordered: !0
  });
  c.binaryType = "arraybuffer";
  const d = s.createDataChannel("negotiation", {
    id: 1,
    negotiated: !0,
    ordered: !0
  });
  d.binaryType = "arraybuffer";
  let l = !1;
  if (d.addEventListener("open", () => {
    l = !0;
  }), d.addEventListener(
    "message",
    (R) => {
      (async () => {
        const S = new RTCSessionDescription(
          JSON.parse(Jr(R.data))
        );
        if (await s.setRemoteDescription(S), S.type === "offer") {
          await s.setLocalDescription();
          const f = At(
            s.localDescription,
            n
          );
          d.send(qt(JSON.stringify(f)));
        }
      })().catch(console.error);
    }
  ), s.addEventListener("negotiationneeded", () => {
    (async () => {
      if (!l)
        return;
      await s.setLocalDescription();
      const R = At(
        s.localDescription,
        n
      );
      d.send(qt(JSON.stringify(R)));
    })().catch(console.error);
  }), !t)
    return { pc: s, dc: c };
  const T = await s.createOffer({});
  return await s.setLocalDescription(T), s.addEventListener("icecandidate", (R) => {
    R.candidate === null && i({ pc: s, dc: c });
  }), r;
};
function wv() {
  try {
    new Headers();
  } catch {
    throw new Error("connect-web requires the fetch API. Are you running on an old version of Node.js? Node.js is not supported in Connect for Web - please stay tuned for Connect for Node.");
  }
}
function Vo(t, e) {
  const n = Cr(t);
  if (n)
    throw e.forEach((a, s) => {
      n.metadata.append(s, a);
    }), n;
  if (!e.has(Xe) && !t.has(Xe))
    throw new N("protocol error: missing status", M.Internal);
}
function jo(t, e, n, a) {
  const s = new Headers(n ?? {});
  return s.set(hy, t ? wy : by), s.set(Sy, "1"), s.set(Iy, "connect-es/1.6.1"), e !== void 0 && s.set(fy, `${e}m`), s;
}
function bv(t) {
  switch (t) {
    case 400:
      return M.Internal;
    case 401:
      return M.Unauthenticated;
    case 403:
      return M.PermissionDenied;
    case 404:
      return M.Unimplemented;
    case 429:
      return M.Unavailable;
    case 502:
      return M.Unavailable;
    case 503:
      return M.Unavailable;
    case 504:
      return M.Unavailable;
    default:
      return M.Unknown;
  }
}
function Ho(t, e) {
  var n;
  if (t >= 200 && t < 300)
    return {
      foundStatus: e.has(Xe),
      headerError: Cr(e)
    };
  throw new N(decodeURIComponent((n = e.get(Nr)) !== null && n !== void 0 ? n : `HTTP ${t}`), bv(t), e);
}
var $e = function(t) {
  return this instanceof $e ? (this.v = t, this) : new $e(t);
}, _v = function(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = n.apply(t, e || []), s, i = [];
  return s = {}, c("next"), c("throw"), c("return", r), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function r(f) {
    return function(w) {
      return Promise.resolve(w).then(f, R);
    };
  }
  function c(f, w) {
    a[f] && (s[f] = function(O) {
      return new Promise(function(C, F) {
        i.push([f, O, C, F]) > 1 || d(f, O);
      });
    }, w && (s[f] = w(s[f])));
  }
  function d(f, w) {
    try {
      l(a[f](w));
    } catch (O) {
      S(i[0][3], O);
    }
  }
  function l(f) {
    f.value instanceof $e ? Promise.resolve(f.value.v).then(T, R) : S(i[0][2], f);
  }
  function T(f) {
    d("next", f);
  }
  function R(f) {
    d("throw", f);
  }
  function S(f, w) {
    f(w), i.shift(), i.length && d(i[0][0], i[0][1]);
  }
};
function Ev(t) {
  var e;
  wv();
  const n = (e = t.useBinaryFormat) !== null && e !== void 0 ? e : !0;
  return {
    async unary(a, s, i, r, c, d, l) {
      var T;
      const { serialize: R, parse: S } = Ot(s, n, t.jsonOptions, t.binaryOptions);
      return r = r === void 0 ? t.defaultTimeoutMs : r <= 0 ? void 0 : r, await qr({
        interceptors: t.interceptors,
        signal: i,
        timeoutMs: r,
        req: {
          stream: !1,
          service: a,
          method: s,
          url: $o(t.baseUrl, a, s),
          init: {
            method: "POST",
            credentials: (T = t.credentials) !== null && T !== void 0 ? T : "same-origin",
            redirect: "error",
            mode: "cors"
          },
          header: jo(n, r, c),
          contextValues: l ?? Xn(),
          message: d
        },
        next: async (f) => {
          var w;
          const C = await ((w = t.fetch) !== null && w !== void 0 ? w : globalThis.fetch)(f.url, Object.assign(Object.assign({}, f.init), { headers: f.header, signal: f.signal, body: Jo(0, R(f.message)) })), { headerError: F } = Ho(C.status, C.headers);
          if (!C.body)
            throw F !== void 0 ? F : "missing response body";
          const k = Fo(C.body).getReader();
          let v, g;
          for (; ; ) {
            const y = await k.read();
            if (y.done)
              break;
            const { flags: _, data: b } = y.value;
            if ((_ & xo) === xo)
              throw new N("protocol error: received unsupported compressed output", M.Internal);
            if (_ === bt) {
              if (v !== void 0)
                throw "extra trailer";
              v = zo(b);
              continue;
            }
            if (g !== void 0)
              throw new N("extra message", M.Unimplemented);
            g = S(b);
          }
          if (v === void 0)
            throw F !== void 0 ? F : new N("missing trailer", C.headers.has(Xe) ? M.Unimplemented : M.Unknown);
          if (Vo(v, C.headers), g === void 0)
            throw new N("missing message", v.has(Xe) ? M.Unimplemented : M.Unknown);
          return {
            stream: !1,
            service: a,
            method: s,
            header: C.headers,
            message: g,
            trailer: v
          };
        }
      });
    },
    async stream(a, s, i, r, c, d, l) {
      var T;
      const { serialize: R, parse: S } = Ot(s, n, t.jsonOptions, t.binaryOptions);
      function f(O, C, F, k, v) {
        return _v(this, arguments, function* () {
          const y = Fo(O).getReader();
          if (C) {
            if (!(yield $e(y.read())).done)
              throw "extra data for trailers-only";
            return yield $e(void 0);
          }
          let _ = !1;
          for (; ; ) {
            const b = yield $e(y.read());
            if (b.done)
              break;
            const { flags: Z, data: D } = b.value;
            if ((Z & bt) === bt) {
              if (_)
                throw "extra trailer";
              _ = !0;
              const J = zo(D);
              Vo(J, k), J.forEach((ft, Rt) => F.set(Rt, ft));
              continue;
            }
            if (_)
              throw "extra message";
            yield yield $e(S(D));
          }
          if ("throwIfAborted" in v && v.throwIfAborted(), !_)
            throw "missing trailer";
        });
      }
      async function w(O) {
        if (s.kind != m.ServerStreaming)
          throw "The fetch API does not support streaming request bodies";
        const C = await O[Symbol.asyncIterator]().next();
        if (C.done == !0)
          throw "missing request message";
        return Jo(0, R(C.value));
      }
      return r = r === void 0 ? t.defaultTimeoutMs : r <= 0 ? void 0 : r, Ar({
        interceptors: t.interceptors,
        signal: i,
        timeoutMs: r,
        req: {
          stream: !0,
          service: a,
          method: s,
          url: $o(t.baseUrl, a, s),
          init: {
            method: "POST",
            credentials: (T = t.credentials) !== null && T !== void 0 ? T : "same-origin",
            redirect: "error",
            mode: "cors"
          },
          header: jo(n, r, c),
          contextValues: l ?? Xn(),
          message: d
        },
        next: async (O) => {
          var C;
          const k = await ((C = t.fetch) !== null && C !== void 0 ? C : globalThis.fetch)(O.url, Object.assign(Object.assign({}, O.init), { headers: O.header, signal: O.signal, body: await w(O.message) })), { foundStatus: v, headerError: g } = Ho(k.status, k.headers);
          if (g != null)
            throw g;
          if (!k.body)
            throw "missing response body";
          const y = new Headers();
          return Object.assign(Object.assign({}, O), { header: k.headers, trailer: y, message: f(k.body, v, y, k.headers, O.signal) });
        }
      });
    }
  };
}
const et = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.PacketMessage",
  () => [
    {
      no: 1,
      name: "data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "eom",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), la = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.Stream",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), _t = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.Request",
  () => [
    { no: 1, name: "stream", kind: "message", T: la },
    { no: 2, name: "headers", kind: "message", T: zr, oneof: "type" },
    { no: 3, name: "message", kind: "message", T: Ut, oneof: "type" },
    { no: 4, name: "rst_stream", kind: "scalar", T: 8, oneof: "type" }
  ]
), zr = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.RequestHeaders",
  () => [
    {
      no: 1,
      name: "method",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "metadata", kind: "message", T: mt },
    { no: 3, name: "timeout", kind: "message", T: X }
  ]
), Ut = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.RequestMessage",
  () => [
    {
      no: 1,
      name: "has_message",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 2, name: "packet_message", kind: "message", T: et },
    {
      no: 3,
      name: "eos",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), Mv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.Response",
  () => [
    { no: 1, name: "stream", kind: "message", T: la },
    { no: 2, name: "headers", kind: "message", T: Ov, oneof: "type" },
    { no: 3, name: "message", kind: "message", T: Nv, oneof: "type" },
    { no: 4, name: "trailers", kind: "message", T: Cv, oneof: "type" }
  ]
), Ov = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.ResponseHeaders",
  () => [
    { no: 1, name: "metadata", kind: "message", T: mt }
  ]
), Nv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.ResponseMessage",
  () => [
    { no: 1, name: "packet_message", kind: "message", T: et }
  ]
), Cv = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.ResponseTrailers",
  () => [
    { no: 1, name: "status", kind: "message", T: nn },
    { no: 2, name: "metadata", kind: "message", T: mt }
  ]
), $r = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.Strings",
  () => [
    { no: 1, name: "values", kind: "scalar", T: 9, repeated: !0 }
  ]
), mt = /* @__PURE__ */ o.makeMessageType(
  "proto.rpc.webrtc.v1.Metadata",
  () => [
    { no: 1, name: "md", kind: "map", K: 9, V: { kind: "message", T: $r } }
  ]
);
class Ae extends Error {
  name = "ConnectionClosedError";
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Ae.prototype);
  }
  static isError(e) {
    return e instanceof Ae || e instanceof N && e.rawMessage === "closed" ? !0 : typeof e == "string" ? e === "Response closed without headers" : e instanceof Error ? e.message === "Response closed without headers" : !1;
  }
}
class Pv {
  ready;
  peerConn;
  dataChannel;
  pResolve;
  pReject;
  closed = !1;
  closedReason;
  maxDataChannelSize = 65535;
  constructor(e, n) {
    this.peerConn = e, this.dataChannel = n, this.ready = new Promise((a, s) => {
      this.pResolve = a, this.pReject = s;
    }), n.addEventListener("open", () => this.onChannelOpen()), n.addEventListener("close", () => this.onChannelClose()), n.addEventListener("error", (a) => {
      this.onChannelError(a);
    }), e.addEventListener("iceconnectionstatechange", () => {
      const a = e.iceConnectionState;
      (a === "failed" || a === "disconnected" || a === "closed") && this.pReject?.(new Error(`ICE connection failed with state: ${a}`));
    });
  }
  isClosed() {
    return this.closed;
  }
  isClosedReason() {
    return this.closedReason;
  }
  closeWithReason(e) {
    this.closed || (this.closed = !0, this.closedReason = e, this.pReject?.(e), this.peerConn.close());
  }
  onChannelOpen() {
    this.pResolve?.(void 0);
  }
  onChannelClose() {
    this.closeWithReason(new Ae("data channel closed"));
  }
  onChannelError(e) {
    console.error("channel error", e), this.closeWithReason(new Error(JSON.stringify(e)));
  }
  write(e) {
    this.dataChannel.send(e.toBinary());
  }
}
const Ko = 33554432;
class Dv {
  grpcStream;
  onDone;
  closed = !1;
  packetBuf = [];
  packetBufSize = 0;
  constructor(e, n) {
    this.grpcStream = e, this.onDone = n;
  }
  closeWithRecvError() {
    this.closed || (this.closed = !0, this.onDone(this.grpcStream.id));
  }
  processPacketMessage(e) {
    const { data: n } = e;
    if (n.length + this.packetBufSize > Ko) {
      this.packetBuf.length = 0, this.packetBufSize = 0, console.error(
        `message size larger than max ${Ko}; discarding`
      );
      return;
    }
    if (this.packetBuf.push(n), this.packetBufSize += n.length, e.eom) {
      const a = new Uint8Array(this.packetBufSize);
      let s = 0;
      for (const i of this.packetBuf)
        a.set(i, s), s += i.length;
      return this.packetBuf.length = 0, this.packetBufSize = 0, a;
    }
  }
}
const qv = 16373;
class Yr extends Dv {
  channel;
  service;
  method;
  parseMessage;
  requestHeaders;
  headersReceived = !1;
  trailersReceived = !1;
  constructor(e, n, a, s, i, r) {
    super(n, a), this.channel = e, this.service = s, this.method = i;
    const { parse: c } = Ot(
      i,
      !0,
      void 0,
      void 0
    );
    this.parseMessage = c;
    const d = `/${s.typeName}/${i.name}`;
    this.requestHeaders = new zr({
      method: d
    });
    const l = Av(fn(r));
    l && (this.requestHeaders.metadata = l);
  }
  startRequest(e) {
    e && e.addEventListener("abort", () => {
      this.resetStream();
    });
    try {
      this.channel.writeHeaders(this.grpcStream, this.requestHeaders);
    } catch (n) {
      console.error("error writing headers", n), this.closeWithRecvError();
    }
  }
  sendMessage(e) {
    if (e) {
      this.writeMessage(!1, e);
      return;
    }
    this.writeMessage(!1, void 0);
  }
  resetStream() {
    if (!this.closed)
      try {
        this.channel.writeReset(this.grpcStream);
      } catch (e) {
        console.error("error writing reset", e), this.closeWithRecvError();
      }
  }
  writeMessage(e, n) {
    try {
      if (!n || n.length === 0) {
        const s = new et({
          eom: !0
        }), i = new Ut({
          hasMessage: !!n,
          packetMessage: s,
          eos: e
        });
        this.channel.writeMessage(this.grpcStream, i);
        return;
      }
      let a = n;
      for (; a.length > 0; ) {
        const s = Math.min(
          a.length,
          qv
        ), i = new et();
        i.data = a.slice(0, s), a = a.slice(s), a.length === 0 && (i.eom = !0);
        const r = new Ut({
          hasMessage: !!a,
          packetMessage: i,
          eos: e
        });
        this.channel.writeMessage(this.grpcStream, r);
      }
    } catch (a) {
      console.error("error writing message", a), this.closeWithRecvError();
    }
  }
  onResponse(e) {
    switch (e.type.case) {
      case "headers": {
        if (this.headersReceived) {
          console.error(
            `invariant: headers already received for ${this.grpcStream.id}`
          );
          return;
        }
        if (this.trailersReceived) {
          console.error(
            `invariant: headers received after trailers for ${this.grpcStream.id}`
          );
          return;
        }
        this.processHeaders(e.type.value);
        break;
      }
      case "message": {
        if (!this.headersReceived) {
          console.error(
            `invariant: headers not yet received for ${this.grpcStream.id}`
          );
          return;
        }
        if (this.trailersReceived) {
          console.error(
            `invariant: headers received after trailers for ${this.grpcStream.id}`
          );
          return;
        }
        this.processMessage(e.type.value);
        break;
      }
      case "trailers": {
        this.processTrailers(e.type.value);
        break;
      }
      default: {
        console.error("unknown response type", e.type.case);
        break;
      }
    }
  }
  processHeaders(e) {
    this.headersReceived = !0, this.onHeaders(e);
  }
  processMessage(e) {
    if (!e.packetMessage)
      return;
    const n = super.processPacketMessage(e.packetMessage);
    n && this.onMessage(n);
  }
  processTrailers(e) {
    this.trailersReceived = !0;
    const { status: n } = e, a = n ? n.code : 0;
    if (this.onTrailers(e), a === 0) {
      this.closeWithRecvError();
      return;
    }
    this.closeWithRecvError();
  }
}
const Av = (t) => {
  if (!t)
    return;
  const e = new mt({
    md: Object.fromEntries(
      [...t.entries()].map(([n, a]) => [
        n,
        new $r({ values: [a] })
      ])
    )
  });
  return Object.keys(e.md).length > 0 ? e : void 0;
}, Gt = (t) => {
  const e = Object.entries(t?.md ?? {}).flatMap(
    ([n, { values: a }]) => a.map((s) => [n, s])
  );
  return new Headers(e);
};
class Uv extends Yr {
  awaitingHeadersResult;
  gotHeaders = !1;
  // trailers will be written to later
  respStream = cy();
  trailers = new Headers();
  respStreamQueue;
  async run(e, n, a, s) {
    const r = {
      req: {
        stream: !0,
        url: "",
        init: {},
        service: this.service,
        method: this.method,
        header: new Headers(),
        contextValues: s ?? Xn(),
        message: a
      },
      /**
       * Next is what actually kicks off the request. The run call below will
       * ultimately call this for us.
       */
      next: async (c) => {
        const l = await new Promise((T, R) => {
          this.awaitingHeadersResult = {
            success: T,
            failure: R
          }, this.startRequest(), this.sendMessages(c.message).catch((S) => {
            console.error("error sending streaming message", S), this.closeWithRecvError();
          });
        });
        return {
          ...c,
          header: l,
          trailer: this.trailers,
          message: this.respStream
        };
      }
    };
    return e && (r.signal = e), n !== void 0 && (r.timeoutMs = n), Ar(r);
  }
  async sendMessages(e) {
    for await (const n of e)
      this.sendMessage(n.toBinary());
    this.writeMessage(!0, void 0);
  }
  onHeaders(e) {
    this.gotHeaders = !0, this.awaitingHeadersResult?.success(Gt(e.metadata));
  }
  onTrailers(e) {
    if (e.metadata?.md) {
      for (const n in e.metadata.md)
        if (Object.hasOwn(e.metadata.md, n)) {
          const a = e.metadata.md[n];
          for (const s of a?.values ?? [])
            this.trailers.append(n, s);
        }
    }
    if (this.respStream.close(), !e.status || e.status.code === 0) {
      if (this.gotHeaders)
        return;
      this.awaitingHeadersResult?.success(new Headers());
      return;
    }
    this.gotHeaders || this.awaitingHeadersResult?.failure(e.status.message);
  }
  onMessage(e) {
    const n = this.parseMessage(e);
    this.respStreamQueue = this.respStreamQueue ? this.respStreamQueue.then(async () => this.respStream.write(n)) : this.respStream.write(n), this.respStreamQueue.catch((a) => {
      console.error(
        `error pushing received message into stream; failing: ${a}`
      ), this.resetStream();
    });
  }
}
class Gv extends Yr {
  result;
  headers;
  message;
  async run(e, n, a, s) {
    const r = {
      req: {
        stream: !1,
        url: "",
        init: {},
        service: this.service,
        method: this.method,
        header: new Headers(),
        contextValues: s ?? Xn(),
        message: a
      },
      /**
       * Next is what actually kicks off the request. The run call below will
       * ultimately call this for us.
       */
      next: async (c) => new Promise((d, l) => {
        this.result = { success: d, failure: l }, this.startRequest(), this.sendMessage(c.message.toBinary());
      })
    };
    return e && (r.signal = e), n !== void 0 && (r.timeoutMs = n), qr(r);
  }
  onHeaders(e) {
    if (this.headers !== void 0) {
      this.result?.failure(
        new Error("invariant: received headers more than once")
      );
      return;
    }
    this.headers = Gt(e.metadata);
  }
  onTrailers(e) {
    const n = Gt(e.metadata);
    if (!e.status || e.status.code === 0) {
      if (!this.headers) {
        this.result?.failure(
          new Error(
            "invariant: received trailers for successful unary request without headers"
          )
        );
        return;
      }
      if (this.message === void 0) {
        this.result?.failure(
          new Error(
            "invariant: received trailers for successful unary request without message"
          )
        );
        return;
      }
      this.result?.success({
        stream: !1,
        header: this.headers,
        message: this.message,
        trailer: n,
        service: this.service,
        method: this.method
      });
      return;
    }
    this.result?.failure(e.status.message);
  }
  onMessage(e) {
    if (this.message !== void 0) {
      this.result?.failure(
        new Error("invariant: received two response messages for unary request")
      );
      return;
    }
    this.message = this.parseMessage(e);
  }
}
const Lv = 256;
class Bv extends Pv {
  streamIDCounter = 0;
  streams = /* @__PURE__ */ new Map();
  constructor(e, n) {
    super(e, n), n.addEventListener("message", (a) => {
      this.onChannelMessage(a);
    }), e.addEventListener("iceconnectionstatechange", () => {
      const a = e.iceConnectionState;
      (a === "failed" || a === "disconnected" || a === "closed") && this.onConnectionTerminated();
    }), n.addEventListener("close", () => this.onConnectionTerminated());
  }
  onConnectionTerminated() {
    this.closeWithReason(new Ae("data channel closed"));
    for (const e of this.streams.values())
      e.cs.closeWithRecvError();
  }
  onChannelMessage(e) {
    const n = Mv.fromBinary(new Uint8Array(e.data)), { stream: a } = n;
    if (a === void 0) {
      console.error("no stream id; discarding");
      return;
    }
    const { id: s } = a, i = this.streams.get(s.toString());
    if (i === void 0) {
      console.error("no stream for id; discarding", "id", s);
      return;
    }
    i.cs.onResponse(n);
  }
  nextStreamID() {
    const e = this.streamIDCounter;
    return this.streamIDCounter += 1, new la({
      id: BigInt(e)
    });
  }
  newStream(e, n, a, s, i) {
    if (this.isClosed())
      throw new Ae("connection closed");
    let r = this.streams.get(n.id.toString());
    if (r !== void 0)
      throw new Error("invariant: stream should not exist yet");
    if (Object.keys(this.streams).length > Lv)
      throw new Error("stream limit hit");
    const c = new e(
      this,
      n,
      (d) => this.removeStreamByID(d),
      a,
      s,
      i
    );
    return r = { cs: c }, this.streams.set(n.id.toString(), r), c;
  }
  removeStreamByID(e) {
    this.streams.delete(e.toString());
  }
  writeHeaders(e, n) {
    this.write(
      new _t({
        stream: e,
        type: {
          case: "headers",
          value: n
        }
      })
    );
  }
  writeMessage(e, n) {
    this.write(
      new _t({
        stream: e,
        type: {
          case: "message",
          value: n
        }
      })
    );
  }
  writeReset(e) {
    this.write(
      new _t({
        stream: e,
        type: {
          case: "rstStream",
          value: !0
        }
      })
    );
  }
  async unary(e, n, a, s, i, r, c) {
    return this.newStream(
      Gv,
      this.nextStreamID(),
      e,
      n,
      i
    ).run(a, s, r, c);
  }
  async stream(e, n, a, s, i, r, c) {
    return this.newStream(
      Uv,
      this.nextStreamID(),
      e,
      n,
      i
    ).run(a, s, r, c);
  }
}
const Et = "invariant: call uuid unset";
class xv {
  constructor(e, n, a, s, i) {
    this.signalingClient = e, this.callOpts = n, this.pc = a, this.dc = s, this.dialOpts = i, this.clientChannel = new Bv(this.pc, this.dc);
  }
  clientChannel;
  callUuid;
  // only send once since exchange may end or ICE may end
  sentDoneOrErrorOnce = !1;
  exchangeDone = !1;
  iceComplete = !1;
  haveInitResponse = !1;
  awaitingRemoteDescription;
  remoteDescriptionSet;
  // stats
  numCallUpdates = 0;
  maxCallUpdateDuration = 0;
  totalCallUpdateDuration = 0;
  async doExchange() {
    await this.setup();
    const e = At(
      this.pc.localDescription,
      this.dialOpts?.additionalSdpFields
    ), n = qt(JSON.stringify(e)), a = new Br({
      sdp: n
    });
    this.dialOpts && this.dialOpts.disableTrickleICE && (a.disableTrickle = this.dialOpts.disableTrickleICE), this.clientChannel.ready.then(() => {
      this.exchangeDone = !0;
    }).catch(console.error);
    const s = this.signalingClient.call(a, this.callOpts), i = this.processCallResponses(s);
    return await Promise.all([this.clientChannel.ready, i]), this.clientChannel;
  }
  async setup() {
    if (this.remoteDescriptionSet = new Promise((e, n) => {
      this.awaitingRemoteDescription = {
        success: e,
        failure: n
      };
    }), !this.dialOpts?.disableTrickleICE) {
      const e = await this.pc.createOffer({});
      this.pc.addEventListener("iceconnectionstatechange", () => {
        if (this.pc.iceConnectionState !== "completed" || this.numCallUpdates === 0)
          return;
        const n = this.totalCallUpdateDuration / this.numCallUpdates;
        console.groupCollapsed("Caller update statistics"), console.table({
          num_updates: this.numCallUpdates,
          average_duration: `${n}ms`,
          max_duration: `${this.maxCallUpdateDuration}ms`
        }), console.groupEnd();
      }), this.pc.addEventListener(
        "icecandidate",
        (n) => {
          this.onLocalICECandidate(n).catch((a) => {
            console.error(`error processing local ICE candidate ${a}`);
          });
        }
      ), await this.pc.setLocalDescription(e);
    }
  }
  terminate(e) {
    this.clientChannel.closeWithReason(e);
  }
  async processCallResponses(e) {
    try {
      for await (const n of e)
        switch (n.stage.case) {
          case "init": {
            if (!await this.handleInitResponse(
              n.uuid,
              n.stage.value
            ))
              return;
            break;
          }
          case "update": {
            if (!await this.handleUpdateResponse(
              n.uuid,
              n.stage.value
            ))
              return;
            break;
          }
          default: {
            await this.sendError("unknown CallResponse stage");
            return;
          }
        }
    } catch (n) {
      this.handleInitError(n);
    }
  }
  handleInitError(e) {
    if (!(this.exchangeDone || this.pc.iceConnectionState === "connected")) {
      if (e instanceof N && e.code === M.Unimplemented) {
        if (e.message === "Response closed without headers")
          throw new Ae("failed to dial");
        if (this.clientChannel.isClosed())
          throw new Ae("client channel is closed");
        console.error(e.message);
      }
      throw e;
    }
  }
  async handleInitResponse(e, n) {
    if (this.haveInitResponse)
      return await this.sendError("got init stage more than once"), !1;
    this.haveInitResponse = !0, this.callUuid = e;
    const a = new RTCSessionDescription(
      JSON.parse(Jr(n.sdp))
    );
    return this.clientChannel.isClosed() ? (await this.sendError("client channel is closed"), !1) : (await this.pc.setRemoteDescription(a), this.awaitingRemoteDescription?.success(!0), this.dialOpts?.disableTrickleICE ? (this.exchangeDone = !0, await this.sendDone(), !1) : !0);
  }
  async handleUpdateResponse(e, n) {
    if (!this.haveInitResponse)
      return await this.sendError("got update stage before init stage"), !1;
    if (e !== this.callUuid)
      return await this.sendError(`uuid mismatch; have=${e} want=${this.callUuid}`), !1;
    if (n.candidate === void 0)
      return await this.sendError("no candidate"), !1;
    const a = Fv(n.candidate);
    a.candidate !== void 0 && console.debug(`received remote ICE ${a.candidate}`);
    try {
      await this.pc.addIceCandidate(a);
    } catch (s) {
      throw console.log("error adding ice candidate", s), await this.sendError(JSON.stringify(s)), s;
    }
    return !0;
  }
  async onLocalICECandidate(e) {
    if (await this.remoteDescriptionSet, this.exchangeDone || this.pc.iceConnectionState === "connected")
      return;
    if (e.candidate === null) {
      this.iceComplete = !0, await this.sendDone();
      return;
    }
    if (this.callUuid === void 0 || this.callUuid === "")
      throw new Error(Et);
    e.candidate.candidate !== void 0 && console.debug(`gathered local ICE ${e.candidate.candidate}`);
    const n = Jv(e.candidate), a = new Un({
      uuid: this.callUuid,
      update: {
        case: "candidate",
        value: n
      }
    }), s = /* @__PURE__ */ new Date();
    try {
      await this.signalingClient.callUpdate(a, this.callOpts), this.numCallUpdates += 1;
      const r = (/* @__PURE__ */ new Date()).getTime() - s.getTime();
      r > this.maxCallUpdateDuration && (this.maxCallUpdateDuration = r), this.totalCallUpdateDuration += r;
    } catch (i) {
      if (
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        this.exchangeDone || this.iceComplete || // @ts-expect-error tsc is unaware that iceConnectionState can change
        this.pc.iceConnectionState === "connected"
      )
        return;
      console.error(i);
    }
  }
  async sendError(e) {
    if (this.sentDoneOrErrorOnce)
      return;
    if (this.callUuid === void 0 || this.callUuid === "")
      throw new Error(Et);
    this.sentDoneOrErrorOnce = !0;
    const n = new Un({
      uuid: this.callUuid,
      update: {
        case: "error",
        value: new nn({
          code: M.Unknown,
          message: e
        })
      }
    });
    try {
      await this.signalingClient.callUpdate(n, this.callOpts);
    } catch (a) {
      console.error("failed to send call update; continuing", a);
    }
  }
  async sendDone() {
    if (this.sentDoneOrErrorOnce)
      return;
    if (this.callUuid === void 0 || this.callUuid === "")
      throw new Error(Et);
    this.sentDoneOrErrorOnce = !0;
    const e = new Un({
      uuid: this.callUuid,
      update: {
        case: "done",
        value: !0
      }
    });
    try {
      await this.signalingClient.callUpdate(e, this.callOpts);
    } catch (n) {
      console.error(n);
    }
  }
}
const Fv = (t) => {
  const e = {
    candidate: t.candidate
  };
  return t.sdpMid !== void 0 && (e.sdpMid = t.sdpMid), t.sdpmLineIndex !== void 0 && (e.sdpMLineIndex = t.sdpmLineIndex), t.usernameFragment !== void 0 && (e.usernameFragment = t.usernameFragment), e;
}, Jv = (t) => {
  const e = new In();
  return t.candidate !== void 0 && (e.candidate = t.candidate), t.sdpMid !== void 0 && t.sdpMid !== null && (e.sdpMid = t.sdpMid), t.sdpMLineIndex !== void 0 && t.sdpMLineIndex !== null && (e.sdpmLineIndex = t.sdpMLineIndex), t.usernameFragment !== void 0 && t.usernameFragment !== null && (e.usernameFragment = t.usernameFragment), e;
}, hn = async (t, e) => {
  Vr(e);
  const n = globalThis.VIAM?.GRPC_TRANSPORT_FACTORY ?? Ev, a = {
    baseUrl: t
  };
  if (e?.accessToken !== void 0 && e.accessToken !== "" && !(e.externalAuthAddress !== void 0 && e.externalAuthAddress !== "" && e.externalAuthToEntity !== void 0 && e.externalAuthToEntity !== "")) {
    const s = new Headers(e.extraHeaders);
    return s.set("authorization", `Bearer ${e.accessToken}`), new Wr(a, n, s);
  }
  return e === void 0 || e.credentials === void 0 && e.accessToken === void 0 ? n(a) : zv(
    t,
    n,
    e,
    a
  );
}, Lt = /^.*:\/\//u, zv = async (t, e, n, a) => {
  const s = new Headers(n.extraHeaders);
  let i;
  if (n.accessToken === void 0 || n.accessToken === "") {
    const r = new Dt({
      entity: Sn(n.credentials) && n.credentials.authEntity ? n.credentials.authEntity : t.replace(Lt, "")
    });
    n.credentials && (r.credentials = new Lr({
      type: n.credentials.type,
      payload: n.credentials.payload
    }));
    const c = n.externalAuthAddress ?? t, d = e({ baseUrl: c });
    i = (await P(av, d).authenticate(r)).accessToken;
  } else
    i = n.accessToken;
  if (n.externalAuthAddress !== void 0 && n.externalAuthAddress !== "" && n.externalAuthToEntity !== void 0 && n.externalAuthToEntity !== "") {
    const r = new Headers();
    r.set("authorization", `Bearer ${i}`), i = "";
    const c = new Dt({
      entity: n.externalAuthToEntity
    }), d = e({
      baseUrl: n.externalAuthAddress
    });
    i = (await P(
      sv,
      d
    ).authenticateTo(c, {
      headers: r
    })).accessToken;
  }
  return s.set("authorization", `Bearer ${i}`), new Wr(a, e, s);
};
class Wr {
  transport;
  extraHeaders;
  constructor(e, n, a) {
    this.extraHeaders = a, this.transport = n(e);
  }
  async unary(e, n, a, s, i, r, c) {
    const d = fn(i);
    for (const [l, T] of this.extraHeaders)
      d.set(l, T);
    return this.transport.unary(
      e,
      n,
      a,
      s,
      d,
      r,
      c
    );
  }
  async stream(e, n, a, s, i, r, c) {
    const d = fn(i);
    for (const [l, T] of this.extraHeaders)
      d.set(l, T);
    return this.transport.stream(
      e,
      n,
      a,
      s,
      d,
      r,
      c
    );
  }
}
const fn = (t) => {
  const e = new Headers();
  if (t !== void 0)
    if (Array.isArray(t))
      for (const [n, a] of t)
        e.append(n, a);
    else if ("forEach" in t)
      typeof t.forEach == "function" && t.forEach((n, a) => {
        e.append(a, n);
      });
    else
      for (const [n, a] of Object.entries(t))
        e.append(n, a);
  return e;
}, $v = async (t, e, n) => {
  const a = { ...n }, s = await hn(t, a), i = P(
    xr,
    s
  );
  try {
    return (await i.optionalWebRTCConfig({}, e)).config ?? new Zn();
  } catch (r) {
    if (r instanceof N && r.code === M.Unimplemented)
      return new Zn();
    throw r;
  }
}, Yv = async (t, e, n) => {
  const a = t.replace(/\/$/u, "");
  Vr(n);
  const s = {
    headers: {
      "rpc-host": e
    }
  }, i = await Wv(
    a,
    s,
    n
  ), r = Vv(
    a,
    n
  ), { pc: c, dc: d } = await Sv(
    i.disableTrickleICE,
    i.rtcConfig,
    i.additionalSdpFields
  );
  let l = !1, T;
  try {
    T = await hn(a, r);
  } catch (f) {
    throw c.close(), f;
  }
  const R = P(
    xr,
    T
  ), S = new xv(
    R,
    s,
    c,
    d,
    i
  );
  try {
    n?.dialTimeout !== void 0 && setTimeout(() => {
      l || S.terminate(new Error("timed out"));
    }, n.dialTimeout);
    const f = await S.doExchange();
    return n?.externalAuthAddress !== void 0 && n.externalAuthAddress !== "" || n?.credentials?.type, l = !0, {
      transport: f,
      peerConnection: c,
      dataChannel: d
    };
  } catch (f) {
    throw console.error("error dialing", f), f;
  } finally {
    l || c.close();
  }
}, Wv = async (t, e, n) => {
  const a = await $v(
    t,
    e,
    n
  ), s = a.additionalIceServers.map(
    (c) => ({
      urls: c.urls,
      credential: c.credential,
      username: c.username
    })
  ), i = n ?? {};
  let r;
  return i.webrtcOptions === void 0 ? r = {
    disableTrickleICE: a.disableTrickle,
    rtcConfig: {
      iceServers: s
    }
  } : (r = JSON.parse(
    JSON.stringify(i.webrtcOptions)
  ), r.rtcConfig === void 0 ? r.rtcConfig = { iceServers: s } : r.rtcConfig.iceServers = [
    ...r.rtcConfig.iceServers ?? [],
    ...s
  ]), r;
}, Vv = (t, e) => {
  let n = e;
  return e && (n = { ...e }, e.accessToken === void 0 && (Sn(n.credentials) && !n.credentials.authEntity && (n.credentials.authEntity = n.externalAuthAddress !== void 0 && n.externalAuthAddress !== "" ? n.externalAuthAddress.replace(Lt, "") : t.replace(Lt, "")), n.credentials = e.webrtcOptions?.signalingCredentials, n.accessToken = e.webrtcOptions?.signalingAccessToken), n.externalAuthAddress = e.webrtcOptions?.signalingExternalAuthAddress, n.externalAuthToEntity = e.webrtcOptions?.signalingExternalAuthToEntity), n;
}, Vr = (t) => {
  if (t) {
    if (t.accessToken !== void 0 && t.accessToken.length > 0) {
      if (t.credentials)
        throw new Error("cannot set credentials with accessToken");
      if (t.webrtcOptions !== void 0) {
        if (t.webrtcOptions.signalingAccessToken !== void 0)
          throw new Error(
            "cannot set webrtcOptions.signalingAccessToken with accessToken"
          );
        if (t.webrtcOptions.signalingCredentials !== void 0)
          throw new Error(
            "cannot set webrtcOptions.signalingCredentials with accessToken"
          );
      }
    }
    if (t.webrtcOptions?.signalingAccessToken !== void 0 && t.webrtcOptions.signalingAccessToken.length > 0 && t.webrtcOptions.signalingCredentials !== void 0)
      throw new Error(
        "cannot set webrtcOptions.signalingCredentials with webrtcOptions.signalingAccessToken"
      );
  }
}, jv = "v0.1.373", Bt = new Headers({
  "viam-client": `typescript;v0.33.0;${jv}`
}), x = async function(e, n, a, s = {}, i = {}) {
  const r = new U({
    name: n,
    command: a
  });
  s.requestLogger?.(r);
  const d = (await e(r, i)).result?.toJson();
  return d === void 0 ? {} : d;
}, df = (t, e) => {
  const n = e ?? { headers: {} };
  let a = "";
  if (t === void 0) {
    const s = "abcdefghijklmnopqrstuvwxyz";
    for (let i = 0; i < 6; i += 1)
      a += s[Math.floor(Math.random() * 26)];
  } else
    a = t;
  return n.headers.dtname = a, n;
}, uf = (t) => {
  if (t.headers) {
    const { dtname: e, ...n } = t.headers;
    t.headers = n;
  }
}, pf = (t, e, n) => {
  const a = n ?? { headers: {} };
  return a.headers[t] = e, a;
}, gf = (t, e) => {
  const { [e]: n, ...a } = t.headers;
  t.headers = a;
}, Sn = (t) => t !== void 0 && "authEntity" in t, Hv = async (t, e) => e.type === "access-token" ? hn(t, {
  accessToken: e.payload,
  extraHeaders: Bt
}) : hn(t, {
  credentials: e,
  extraHeaders: Bt
}), da = 5e3;
var te = /* @__PURE__ */ ((t) => (t.CONNECTING = "connecting", t.CONNECTED = "connected", t.DISCONNECTING = "disconnecting", t.DISCONNECTED = "disconnected", t))(te || {});
class jr {
  listeners = {};
  on(e, n) {
    const { listeners: a } = this;
    a[e] ??= /* @__PURE__ */ new Set(), a[e]?.add(n);
  }
  once(e, n) {
    const a = (s) => {
      n(s), this.off(e, n);
    };
    this.on(e, a);
  }
  has(e, n) {
    return this.listeners[e]?.has(n);
  }
  off(e, n) {
    this.listeners[e]?.delete(n);
  }
  emit(e, n) {
    for (const a of this.listeners[e] ?? [])
      a(n);
  }
}
const ua = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.GetEndPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Hr = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.GetEndPositionResponse",
  () => [
    { no: 1, name: "pose", kind: "message", T: Ue }
  ]
), tn = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.JointPositions",
  () => [
    { no: 1, name: "values", kind: "scalar", T: 1, repeated: !0 }
  ]
), pa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.GetJointPositionsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Kr = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.GetJointPositionsResponse",
  () => [
    { no: 1, name: "positions", kind: "message", T: tn }
  ]
), ga = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.MoveToPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "to", kind: "message", T: Ue },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Xr = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.MoveToPositionResponse",
  []
), Ta = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.MoveToJointPositionsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "positions", kind: "message", T: tn },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Qr = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.MoveToJointPositionsResponse",
  []
), Zr = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.MoveThroughJointPositionsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "positions", kind: "message", T: tn, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: am, opt: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), em = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.MoveThroughJointPositionsResponse",
  []
), ka = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.StopRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), nm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.StopResponse",
  []
), Kv = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.Status",
  () => [
    { no: 1, name: "end_position", kind: "message", T: Ue },
    { no: 2, name: "joint_positions", kind: "message", T: tn },
    {
      no: 3,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), ya = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.IsMovingRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), tm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.IsMovingResponse",
  () => [
    {
      no: 1,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), am = /* @__PURE__ */ o.makeMessageType(
  "viam.component.arm.v1.MoveOptions",
  () => [
    { no: 1, name: "max_vel_degs_per_sec", kind: "scalar", T: 1, opt: !0 },
    { no: 2, name: "max_acc_degs_per_sec2", kind: "scalar", T: 1, opt: !0 }
  ]
), Xv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetEndPositionRequest: ua,
  GetEndPositionResponse: Hr,
  GetJointPositionsRequest: pa,
  GetJointPositionsResponse: Kr,
  IsMovingRequest: ya,
  IsMovingResponse: tm,
  JointPositions: tn,
  MoveOptions: am,
  MoveThroughJointPositionsRequest: Zr,
  MoveThroughJointPositionsResponse: em,
  MoveToJointPositionsRequest: Ta,
  MoveToJointPositionsResponse: Qr,
  MoveToPositionRequest: ga,
  MoveToPositionResponse: Xr,
  Status: Kv,
  StopRequest: ka,
  StopResponse: nm
}, Symbol.toStringTag, { value: "Module" })), sm = {
  typeName: "viam.component.arm.v1.ArmService",
  methods: {
    /**
     * GetEndPosition gets the current position the end of the robot's arm expressed as X,Y,Z,ox,oy,oz,theta
     *
     * @generated from rpc viam.component.arm.v1.ArmService.GetEndPosition
     */
    getEndPosition: {
      name: "GetEndPosition",
      I: ua,
      O: Hr,
      kind: m.Unary
    },
    /**
     * MoveToPosition moves the mount point of the robot's end effector to the requested position.
     * This will block until done or a new operation cancels this one
     *
     * @generated from rpc viam.component.arm.v1.ArmService.MoveToPosition
     */
    moveToPosition: {
      name: "MoveToPosition",
      I: ga,
      O: Xr,
      kind: m.Unary
    },
    /**
     * GetJointPositions lists the joint positions (in degrees) of every joint on a robot
     *
     * @generated from rpc viam.component.arm.v1.ArmService.GetJointPositions
     */
    getJointPositions: {
      name: "GetJointPositions",
      I: pa,
      O: Kr,
      kind: m.Unary
    },
    /**
     * MoveToJointPositions moves every joint on a robot's arm to specified angles which are expressed in degrees
     * This will block until done or a new operation cancels this one
     *
     * @generated from rpc viam.component.arm.v1.ArmService.MoveToJointPositions
     */
    moveToJointPositions: {
      name: "MoveToJointPositions",
      I: Ta,
      O: Qr,
      kind: m.Unary
    },
    /**
     * MoveThroughJointPositions moves every joint on a robot's arm to the specified JointPositions in the order they are specified,
     * obeying the specified velocity and acceleration limits.
     * This will block until done or a new operation cancels this one
     *
     * @generated from rpc viam.component.arm.v1.ArmService.MoveThroughJointPositions
     */
    moveThroughJointPositions: {
      name: "MoveThroughJointPositions",
      I: Zr,
      O: em,
      kind: m.Unary
    },
    /**
     * Stop stops a robot's arm
     *
     * @generated from rpc viam.component.arm.v1.ArmService.Stop
     */
    stop: {
      name: "Stop",
      I: ka,
      O: nm,
      kind: m.Unary
    },
    /**
     * IsMoving reports if a component is in motion
     *
     * @generated from rpc viam.component.arm.v1.ArmService.IsMoving
     */
    isMoving: {
      name: "IsMoving",
      I: ya,
      O: tm,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.arm.v1.ArmService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetKinematics returns the kinematics file for the component
     *
     * @generated from rpc viam.component.arm.v1.ArmService.GetKinematics
     */
    getKinematics: {
      name: "GetKinematics",
      I: Ni,
      O: Ci,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.arm.v1.ArmService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, va = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.MoveStraightRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "distance_mm",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 3,
      name: "mm_per_sec",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), om = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.MoveStraightResponse",
  []
), ha = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.SpinRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "angle_deg",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "degs_per_sec",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), im = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.SpinResponse",
  []
), fa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.StopRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), rm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.StopResponse",
  []
), Ra = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.SetPowerRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "linear", kind: "message", T: qe },
    { no: 3, name: "angular", kind: "message", T: qe },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), mm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.SetPowerResponse",
  []
), Ia = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.SetVelocityRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "linear", kind: "message", T: qe },
    { no: 3, name: "angular", kind: "message", T: qe },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), cm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.SetVelocityResponse",
  []
), Sa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.IsMovingRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), lm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.IsMovingResponse",
  () => [
    {
      no: 1,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), ct = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), dm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.base.v1.GetPropertiesResponse",
  () => [
    {
      no: 1,
      name: "width_meters",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "turning_radius_meters",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "wheel_circumference_meters",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Qv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetPropertiesRequest: ct,
  GetPropertiesResponse: dm,
  IsMovingRequest: Sa,
  IsMovingResponse: lm,
  MoveStraightRequest: va,
  MoveStraightResponse: om,
  SetPowerRequest: Ra,
  SetPowerResponse: mm,
  SetVelocityRequest: Ia,
  SetVelocityResponse: cm,
  SpinRequest: ha,
  SpinResponse: im,
  StopRequest: fa,
  StopResponse: rm
}, Symbol.toStringTag, { value: "Module" })), um = {
  typeName: "viam.component.base.v1.BaseService",
  methods: {
    /**
     * MoveStraight moves a robot's base in a straight line by a given distance, expressed in millimeters
     * and a given speed, expressed in millimeters per second
     * This method blocks until completed or cancelled
     *
     * @generated from rpc viam.component.base.v1.BaseService.MoveStraight
     */
    moveStraight: {
      name: "MoveStraight",
      I: va,
      O: om,
      kind: m.Unary
    },
    /**
     * Spin spins a robot's base by an given angle, expressed in degrees, and a given
     * angular speed, expressed in degrees per second
     * This method blocks until completed or cancelled
     *
     * @generated from rpc viam.component.base.v1.BaseService.Spin
     */
    spin: {
      name: "Spin",
      I: ha,
      O: im,
      kind: m.Unary
    },
    /**
     * SetPower sets the linear and angular power of a base
     * -1 -> 1 in terms of power for each direction
     *
     * @generated from rpc viam.component.base.v1.BaseService.SetPower
     */
    setPower: {
      name: "SetPower",
      I: Ra,
      O: mm,
      kind: m.Unary
    },
    /**
     * SetVelocity sets the linear and angular velocity of a base
     *
     * @generated from rpc viam.component.base.v1.BaseService.SetVelocity
     */
    setVelocity: {
      name: "SetVelocity",
      I: Ia,
      O: cm,
      kind: m.Unary
    },
    /**
     * Stop stops a robot's base
     *
     * @generated from rpc viam.component.base.v1.BaseService.Stop
     */
    stop: {
      name: "Stop",
      I: fa,
      O: rm,
      kind: m.Unary
    },
    /**
     * IsMoving reports if a component is in motion
     *
     * @generated from rpc viam.component.base.v1.BaseService.IsMoving
     */
    isMoving: {
      name: "IsMoving",
      I: Sa,
      O: lm,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.base.v1.BaseService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.base.v1.BaseService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    },
    /**
     * GetProperties returns the properties of a base in its current configuration
     *
     * @generated from rpc viam.component.base.v1.BaseService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: ct,
      O: dm,
      kind: m.Unary
    }
  }
}, pm = /* @__PURE__ */ o.makeEnum(
  "viam.component.board.v1.PowerMode",
  [
    { no: 0, name: "POWER_MODE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "POWER_MODE_NORMAL", localName: "NORMAL" },
    { no: 2, name: "POWER_MODE_OFFLINE_DEEP", localName: "OFFLINE_DEEP" }
  ]
), Zv = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.Status",
  () => [
    { no: 1, name: "analogs", kind: "map", K: 9, V: {
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    } },
    { no: 2, name: "digital_interrupts", kind: "map", K: 9, V: {
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    } }
  ]
), wa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetGPIORequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "pin",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "high",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), gm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetGPIOResponse",
  []
), ba = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.GetGPIORequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "pin",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Tm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.GetGPIOResponse",
  () => [
    {
      no: 1,
      name: "high",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), _a = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.PWMRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "pin",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), km = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.PWMResponse",
  () => [
    {
      no: 1,
      name: "duty_cycle_pct",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Ea = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetPWMRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "pin",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "duty_cycle_pct",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), ym = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetPWMResponse",
  []
), Ma = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.PWMFrequencyRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "pin",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), vm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.PWMFrequencyResponse",
  () => [
    {
      no: 1,
      name: "frequency_hz",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), Oa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetPWMFrequencyRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "pin",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "frequency_hz",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), hm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetPWMFrequencyResponse",
  []
), Na = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.ReadAnalogReaderRequest",
  () => [
    {
      no: 1,
      name: "board_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "analog_reader_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), fm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.ReadAnalogReaderResponse",
  () => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 2,
      name: "min_range",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    },
    {
      no: 3,
      name: "max_range",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    },
    {
      no: 4,
      name: "step_size",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    }
  ]
), Ca = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.WriteAnalogRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "pin",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "value",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Rm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.WriteAnalogResponse",
  []
), Pa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.GetDigitalInterruptValueRequest",
  () => [
    {
      no: 1,
      name: "board_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "digital_interrupt_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Im = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.GetDigitalInterruptValueResponse",
  () => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]
), Da = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.StreamTicksRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "pin_names", kind: "scalar", T: 9, repeated: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Sm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.StreamTicksResponse",
  () => [
    {
      no: 1,
      name: "pin_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "time",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    },
    {
      no: 3,
      name: "high",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), qa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetPowerModeRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "power_mode", kind: "enum", T: o.getEnumType(pm) },
    { no: 3, name: "duration", kind: "message", T: X, opt: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), wm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.board.v1.SetPowerModeResponse",
  []
), eh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetDigitalInterruptValueRequest: Pa,
  GetDigitalInterruptValueResponse: Im,
  GetGPIORequest: ba,
  GetGPIOResponse: Tm,
  PWMFrequencyRequest: Ma,
  PWMFrequencyResponse: vm,
  PWMRequest: _a,
  PWMResponse: km,
  PowerMode: pm,
  ReadAnalogReaderRequest: Na,
  ReadAnalogReaderResponse: fm,
  SetGPIORequest: wa,
  SetGPIOResponse: gm,
  SetPWMFrequencyRequest: Oa,
  SetPWMFrequencyResponse: hm,
  SetPWMRequest: Ea,
  SetPWMResponse: ym,
  SetPowerModeRequest: qa,
  SetPowerModeResponse: wm,
  Status: Zv,
  StreamTicksRequest: Da,
  StreamTicksResponse: Sm,
  WriteAnalogRequest: Ca,
  WriteAnalogResponse: Rm
}, Symbol.toStringTag, { value: "Module" })), bm = {
  typeName: "viam.component.board.v1.BoardService",
  methods: {
    /**
     * @generated from rpc viam.component.board.v1.BoardService.SetGPIO
     */
    setGPIO: {
      name: "SetGPIO",
      I: wa,
      O: gm,
      kind: m.Unary
    },
    /**
     * GetGPIO gets the high/low state of the given pin of a board of the underlying robot.
     *
     * @generated from rpc viam.component.board.v1.BoardService.GetGPIO
     */
    getGPIO: {
      name: "GetGPIO",
      I: ba,
      O: Tm,
      kind: m.Unary
    },
    /**
     * PWM gets the duty cycle of the given pin of a board of the underlying robot.
     *
     * @generated from rpc viam.component.board.v1.BoardService.PWM
     */
    pWM: {
      name: "PWM",
      I: _a,
      O: km,
      kind: m.Unary
    },
    /**
     * SetPWM sets the given pin of a board of the underlying robot to the given duty cycle.
     *
     * @generated from rpc viam.component.board.v1.BoardService.SetPWM
     */
    setPWM: {
      name: "SetPWM",
      I: Ea,
      O: ym,
      kind: m.Unary
    },
    /**
     * PWMFrequency gets the PWM frequency of the given pin of a board of the underlying robot.
     *
     * @generated from rpc viam.component.board.v1.BoardService.PWMFrequency
     */
    pWMFrequency: {
      name: "PWMFrequency",
      I: Ma,
      O: vm,
      kind: m.Unary
    },
    /**
     * SetPWMFrequency sets the given pin of a board of the underlying robot to the given PWM frequency. 0 will use the board's default PWM frequency.
     *
     * @generated from rpc viam.component.board.v1.BoardService.SetPWMFrequency
     */
    setPWMFrequency: {
      name: "SetPWMFrequency",
      I: Oa,
      O: hm,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.board.v1.BoardService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * ReadAnalogReader reads off the current value of an analog reader of a board of the underlying robot.
     *
     * @generated from rpc viam.component.board.v1.BoardService.ReadAnalogReader
     */
    readAnalogReader: {
      name: "ReadAnalogReader",
      I: Na,
      O: fm,
      kind: m.Unary
    },
    /**
     * WriteAnalog writes the value to the analog writer of the board.
     *
     * @generated from rpc viam.component.board.v1.BoardService.WriteAnalog
     */
    writeAnalog: {
      name: "WriteAnalog",
      I: Ca,
      O: Rm,
      kind: m.Unary
    },
    /**
     * GetDigitalInterruptValue returns the current value of the interrupt which is based on the type of interrupt.
     *
     * @generated from rpc viam.component.board.v1.BoardService.GetDigitalInterruptValue
     */
    getDigitalInterruptValue: {
      name: "GetDigitalInterruptValue",
      I: Pa,
      O: Im,
      kind: m.Unary
    },
    /**
     * StreamTicks starts a stream of ticks for the given digital interrupts.
     *
     * @generated from rpc viam.component.board.v1.BoardService.StreamTicks
     */
    streamTicks: {
      name: "StreamTicks",
      I: Da,
      O: Sm,
      kind: m.ServerStreaming
    },
    /**
     * `SetPowerMode` sets the power consumption mode of the board to the requested setting for the given duration.
     *
     * @generated from rpc viam.component.board.v1.BoardService.SetPowerMode
     */
    setPowerMode: {
      name: "SetPowerMode",
      I: qa,
      O: wm,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration.
     *
     * @generated from rpc viam.component.board.v1.BoardService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, Aa = /* @__PURE__ */ o.makeEnum(
  "viam.component.encoder.v1.PositionType",
  [
    { no: 0, name: "POSITION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "POSITION_TYPE_TICKS_COUNT", localName: "TICKS_COUNT" },
    { no: 2, name: "POSITION_TYPE_ANGLE_DEGREES", localName: "ANGLE_DEGREES" }
  ]
), Ua = /* @__PURE__ */ o.makeMessageType(
  "viam.component.encoder.v1.GetPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "position_type", kind: "enum", T: o.getEnumType(Aa), opt: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), _m = /* @__PURE__ */ o.makeMessageType(
  "viam.component.encoder.v1.GetPositionResponse",
  () => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    },
    { no: 2, name: "position_type", kind: "enum", T: o.getEnumType(Aa) }
  ]
), Ga = /* @__PURE__ */ o.makeMessageType(
  "viam.component.encoder.v1.ResetPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Em = /* @__PURE__ */ o.makeMessageType(
  "viam.component.encoder.v1.ResetPositionResponse",
  []
), La = /* @__PURE__ */ o.makeMessageType(
  "viam.component.encoder.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Mm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.encoder.v1.GetPropertiesResponse",
  () => [
    {
      no: 1,
      name: "ticks_count_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 2,
      name: "angle_degrees_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), nh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetPositionRequest: Ua,
  GetPositionResponse: _m,
  GetPropertiesRequest: La,
  GetPropertiesResponse: Mm,
  PositionType: Aa,
  ResetPositionRequest: Ga,
  ResetPositionResponse: Em
}, Symbol.toStringTag, { value: "Module" })), Om = {
  typeName: "viam.component.encoder.v1.EncoderService",
  methods: {
    /**
     * Returns position of the encoder which can either be ticks since last
     * zeroing for an incremental encoder or degrees for an absolute encoder.
     *
     * @generated from rpc viam.component.encoder.v1.EncoderService.GetPosition
     */
    getPosition: {
      name: "GetPosition",
      I: Ua,
      O: _m,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.encoder.v1.EncoderService.ResetPosition
     */
    resetPosition: {
      name: "ResetPosition",
      I: Ga,
      O: Em,
      kind: m.Unary
    },
    /**
     * Returns a list of all the methods that are
     * supported by a given robot.
     *
     * @generated from rpc viam.component.encoder.v1.EncoderService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: La,
      O: Mm,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.encoder.v1.EncoderService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.encoder.v1.EncoderService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, Ba = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.GetPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Nm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.GetPositionResponse",
  () => [
    { no: 1, name: "positions_mm", kind: "scalar", T: 1, repeated: !0 }
  ]
), xa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.MoveToPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "positions_mm", kind: "scalar", T: 1, repeated: !0 },
    { no: 3, name: "speeds_mm_per_sec", kind: "scalar", T: 1, repeated: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Cm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.MoveToPositionResponse",
  []
), Fa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.HomeRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Pm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.HomeResponse",
  () => [
    {
      no: 1,
      name: "homed",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), Ja = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.GetLengthsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Dm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.GetLengthsResponse",
  () => [
    { no: 1, name: "lengths_mm", kind: "scalar", T: 1, repeated: !0 }
  ]
), za = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.StopRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), qm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.StopResponse",
  []
), th = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.Status",
  () => [
    { no: 1, name: "positions_mm", kind: "scalar", T: 1, repeated: !0 },
    { no: 2, name: "lengths_mm", kind: "scalar", T: 1, repeated: !0 },
    {
      no: 3,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), $a = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.IsMovingRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Am = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gantry.v1.IsMovingResponse",
  () => [
    {
      no: 1,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), Tf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetLengthsRequest: Ja,
  GetLengthsResponse: Dm,
  GetPositionRequest: Ba,
  GetPositionResponse: Nm,
  HomeRequest: Fa,
  HomeResponse: Pm,
  IsMovingRequest: $a,
  IsMovingResponse: Am,
  MoveToPositionRequest: xa,
  MoveToPositionResponse: Cm,
  Status: th,
  StopRequest: za,
  StopResponse: qm
}, Symbol.toStringTag, { value: "Module" })), Um = {
  typeName: "viam.component.gantry.v1.GantryService",
  methods: {
    /**
     * GetPosition gets the current position of a gantry of the underlying robot.
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.GetPosition
     */
    getPosition: {
      name: "GetPosition",
      I: Ba,
      O: Nm,
      kind: m.Unary
    },
    /**
     * MoveToPosition moves a gantry of the underlying robot to the requested position.
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.MoveToPosition
     */
    moveToPosition: {
      name: "MoveToPosition",
      I: xa,
      O: Cm,
      kind: m.Unary
    },
    /**
     * Home runs the homing sequence of a gantry and returns true once it's completed.
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.Home
     */
    home: {
      name: "Home",
      I: Fa,
      O: Pm,
      kind: m.Unary
    },
    /**
     * GetLengths gets the lengths of a gantry of the underlying robot.
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.GetLengths
     */
    getLengths: {
      name: "GetLengths",
      I: Ja,
      O: Dm,
      kind: m.Unary
    },
    /**
     * Stop stops a robot's gantry
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.Stop
     */
    stop: {
      name: "Stop",
      I: za,
      O: qm,
      kind: m.Unary
    },
    /**
     * IsMoving reports if a component is in motion
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.IsMoving
     */
    isMoving: {
      name: "IsMoving",
      I: $a,
      O: Am,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.gantry.v1.GantryService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, Ya = {
  typeName: "viam.component.generic.v1.GenericService",
  methods: {
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.generic.v1.GenericService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.generic.v1.GenericService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, kf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenericService: Ya
}, Symbol.toStringTag, { value: "Module" })), Wa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.OpenRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Gm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.OpenResponse",
  []
), Va = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.GrabRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Lm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.GrabResponse",
  () => [
    {
      no: 1,
      name: "success",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), ja = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.StopRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Bm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.StopResponse",
  []
), Ha = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.IsMovingRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), xm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.gripper.v1.IsMovingResponse",
  () => [
    {
      no: 1,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), yf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GrabRequest: Va,
  GrabResponse: Lm,
  IsMovingRequest: Ha,
  IsMovingResponse: xm,
  OpenRequest: Wa,
  OpenResponse: Gm,
  StopRequest: ja,
  StopResponse: Bm
}, Symbol.toStringTag, { value: "Module" })), Fm = {
  typeName: "viam.component.gripper.v1.GripperService",
  methods: {
    /**
     * Open opens a gripper of the underlying robot.
     *
     * @generated from rpc viam.component.gripper.v1.GripperService.Open
     */
    open: {
      name: "Open",
      I: Wa,
      O: Gm,
      kind: m.Unary
    },
    /**
     * Grab requests a gripper of the underlying robot to grab.
     *
     * @generated from rpc viam.component.gripper.v1.GripperService.Grab
     */
    grab: {
      name: "Grab",
      I: Va,
      O: Lm,
      kind: m.Unary
    },
    /**
     * Stop stops a robot's gripper
     *
     * @generated from rpc viam.component.gripper.v1.GripperService.Stop
     */
    stop: {
      name: "Stop",
      I: ja,
      O: Bm,
      kind: m.Unary
    },
    /**
     * IsMoving reports if a component is in motion
     *
     * @generated from rpc viam.component.gripper.v1.GripperService.IsMoving
     */
    isMoving: {
      name: "IsMoving",
      I: Ha,
      O: xm,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.gripper.v1.GripperService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.gripper.v1.GripperService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, Jm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.GetControlsRequest",
  () => [
    {
      no: 1,
      name: "controller",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), zm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.GetControlsResponse",
  () => [
    { no: 1, name: "controls", kind: "scalar", T: 9, repeated: !0 }
  ]
), Ka = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.GetEventsRequest",
  () => [
    {
      no: 1,
      name: "controller",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), $m = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.GetEventsResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: wn, repeated: !0 }
  ]
), Xa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.TriggerEventRequest",
  () => [
    {
      no: 1,
      name: "controller",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "event", kind: "message", T: wn },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Ym = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.TriggerEventResponse",
  []
), wn = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.Event",
  () => [
    { no: 1, name: "time", kind: "message", T: I },
    {
      no: 2,
      name: "event",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "control",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "value",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Wm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.StreamEventsRequest",
  () => [
    {
      no: 1,
      name: "controller",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "events", kind: "message", T: Vm, repeated: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Vm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.StreamEventsRequest.Events",
  () => [
    {
      no: 1,
      name: "control",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "events", kind: "scalar", T: 9, repeated: !0 },
    { no: 3, name: "cancelled_events", kind: "scalar", T: 9, repeated: !0 }
  ],
  { localName: "StreamEventsRequest_Events" }
), jm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.StreamEventsResponse",
  () => [
    { no: 1, name: "event", kind: "message", T: wn }
  ]
), ah = /* @__PURE__ */ o.makeMessageType(
  "viam.component.inputcontroller.v1.Status",
  () => [
    { no: 1, name: "events", kind: "message", T: wn, repeated: !0 }
  ]
), sh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Event: wn,
  GetControlsRequest: Jm,
  GetControlsResponse: zm,
  GetEventsRequest: Ka,
  GetEventsResponse: $m,
  Status: ah,
  StreamEventsRequest: Wm,
  StreamEventsRequest_Events: Vm,
  StreamEventsResponse: jm,
  TriggerEventRequest: Xa,
  TriggerEventResponse: Ym
}, Symbol.toStringTag, { value: "Module" })), Hm = {
  typeName: "viam.component.inputcontroller.v1.InputControllerService",
  methods: {
    /**
     * GetControls returns a list of GetControls provided by the Controller
     *
     * @generated from rpc viam.component.inputcontroller.v1.InputControllerService.GetControls
     */
    getControls: {
      name: "GetControls",
      I: Jm,
      O: zm,
      kind: m.Unary
    },
    /**
     * GetEvents returns a list of events representing the last event on each control of a give Input Controller
     *
     * @generated from rpc viam.component.inputcontroller.v1.InputControllerService.GetEvents
     */
    getEvents: {
      name: "GetEvents",
      I: Ka,
      O: $m,
      kind: m.Unary
    },
    /**
     * StreamEvents starts a stream of InputControllerEvents for the given controls (buttons/axes) on a robot's input controller
     *
     * @generated from rpc viam.component.inputcontroller.v1.InputControllerService.StreamEvents
     */
    streamEvents: {
      name: "StreamEvents",
      I: Wm,
      O: jm,
      kind: m.ServerStreaming
    },
    /**
     * TriggerEvent, where supported, injects an InputControllerEvent into an input controller to (virtually) generate events
     * like button presses or axis movements
     *
     * @generated from rpc viam.component.inputcontroller.v1.InputControllerService.TriggerEvent
     */
    triggerEvent: {
      name: "TriggerEvent",
      I: Xa,
      O: Ym,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.inputcontroller.v1.InputControllerService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.inputcontroller.v1.InputControllerService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, Qa = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.SetPowerRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "power_pct",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Km = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.SetPowerResponse",
  []
), Za = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GoForRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "rpm",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "revolutions",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Xm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GoForResponse",
  []
), es = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GoToRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "rpm",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "position_revolutions",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Qm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GoToResponse",
  []
), ns = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.SetRPMRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "rpm",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Zm = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.SetRPMResponse",
  []
), ts = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.ResetZeroPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "offset",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), ec = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.ResetZeroPositionResponse",
  []
), as = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GetPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), nc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GetPositionResponse",
  () => [
    {
      no: 1,
      name: "position",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), ss = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.StopRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), tc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.StopResponse",
  []
), os = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.IsPoweredRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), ac = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.IsPoweredResponse",
  () => [
    {
      no: 1,
      name: "is_on",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 2,
      name: "power_pct",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), is = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), sc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.GetPropertiesResponse",
  () => [
    {
      no: 1,
      name: "position_reporting",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), oh = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.Status",
  () => [
    {
      no: 1,
      name: "is_powered",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 3,
      name: "position",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), rs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.IsMovingRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), oc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.motor.v1.IsMovingResponse",
  () => [
    {
      no: 1,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), vf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetPositionRequest: as,
  GetPositionResponse: nc,
  GetPropertiesRequest: is,
  GetPropertiesResponse: sc,
  GoForRequest: Za,
  GoForResponse: Xm,
  GoToRequest: es,
  GoToResponse: Qm,
  IsMovingRequest: rs,
  IsMovingResponse: oc,
  IsPoweredRequest: os,
  IsPoweredResponse: ac,
  ResetZeroPositionRequest: ts,
  ResetZeroPositionResponse: ec,
  SetPowerRequest: Qa,
  SetPowerResponse: Km,
  SetRPMRequest: ns,
  SetRPMResponse: Zm,
  Status: oh,
  StopRequest: ss,
  StopResponse: tc
}, Symbol.toStringTag, { value: "Module" })), ic = {
  typeName: "viam.component.motor.v1.MotorService",
  methods: {
    /**
     * SetPower sets the percentage of the motor's total power that should be employed
     * expressed a value between -1 and 1 where negative values indicate a backwards
     * direction and positive values a forward direction
     *
     * @generated from rpc viam.component.motor.v1.MotorService.SetPower
     */
    setPower: {
      name: "SetPower",
      I: Qa,
      O: Km,
      kind: m.Unary
    },
    /**
     * GoFor instructs the motor to turn at a specified speed, which is expressed in RPM,
     * for a specified number of rotations relative to its starting position
     * This method will return an error if position reporting is not supported
     * If revolutions != 0, this will block until the number of revolutions has been completed or another operation comes in.
     * Deprecated: If revolutions is 0, this will run the motor at rpm indefinitely.
     *
     * @generated from rpc viam.component.motor.v1.MotorService.GoFor
     */
    goFor: {
      name: "GoFor",
      I: Za,
      O: Xm,
      kind: m.Unary
    },
    /**
     * GoTo requests the robot's motor to move to a specific position that
     * is relative to its home position at a specified speed which is expressed in RPM
     * This method will return an error if position reporting is not supported
     *
     * @generated from rpc viam.component.motor.v1.MotorService.GoTo
     */
    goTo: {
      name: "GoTo",
      I: es,
      O: Qm,
      kind: m.Unary
    },
    /**
     * SetRPM instructs the motor to move at the specified RPM indefinitely.
     *
     * @generated from rpc viam.component.motor.v1.MotorService.SetRPM
     */
    setRPM: {
      name: "SetRPM",
      I: ns,
      O: Zm,
      kind: m.Unary
    },
    /**
     * ResetZeroPosition sets the current position of the motor as the new zero position
     * This method will return an error if position reporting is not supported
     *
     * @generated from rpc viam.component.motor.v1.MotorService.ResetZeroPosition
     */
    resetZeroPosition: {
      name: "ResetZeroPosition",
      I: ts,
      O: ec,
      kind: m.Unary
    },
    /**
     * Position reports the position of the robot's motor relative to its zero position
     * This method will return an error if position reporting is not supported
     *
     * @generated from rpc viam.component.motor.v1.MotorService.GetPosition
     */
    getPosition: {
      name: "GetPosition",
      I: as,
      O: nc,
      kind: m.Unary
    },
    /**
     * GetProperties returns a message of booleans indicating which optional features the robot's motor supports
     *
     * @generated from rpc viam.component.motor.v1.MotorService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: is,
      O: sc,
      kind: m.Unary
    },
    /**
     * Stop turns the robot's motor off
     *
     * @generated from rpc viam.component.motor.v1.MotorService.Stop
     */
    stop: {
      name: "Stop",
      I: ss,
      O: tc,
      kind: m.Unary
    },
    /**
     * IsPowered returns true if the robot's motor is on
     *
     * @generated from rpc viam.component.motor.v1.MotorService.IsPowered
     */
    isPowered: {
      name: "IsPowered",
      I: os,
      O: ac,
      kind: m.Unary
    },
    /**
     * IsMoving reports if a component is in motion
     *
     * @generated from rpc viam.component.motor.v1.MotorService.IsMoving
     */
    isMoving: {
      name: "IsMoving",
      I: rs,
      O: oc,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.motor.v1.MotorService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.motor.v1.MotorService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, ms = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetLinearVelocityRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), rc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetLinearVelocityResponse",
  () => [
    { no: 1, name: "linear_velocity", kind: "message", T: qe }
  ]
), cs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetAngularVelocityRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), mc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetAngularVelocityResponse",
  () => [
    { no: 1, name: "angular_velocity", kind: "message", T: qe }
  ]
), ls = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetCompassHeadingRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), cc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetCompassHeadingResponse",
  () => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), ds = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetOrientationRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), lc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetOrientationResponse",
  () => [
    { no: 1, name: "orientation", kind: "message", T: wi }
  ]
), us = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), dc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetPositionResponse",
  () => [
    { no: 1, name: "coordinate", kind: "message", T: Je },
    {
      no: 2,
      name: "altitude_m",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    }
  ]
), ps = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), uc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetPropertiesResponse",
  () => [
    {
      no: 1,
      name: "linear_velocity_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 2,
      name: "angular_velocity_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 3,
      name: "orientation_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 4,
      name: "position_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 5,
      name: "compass_heading_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 6,
      name: "linear_acceleration_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), gs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetAccuracyRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), pc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetAccuracyResponse",
  () => [
    { no: 1, name: "accuracy", kind: "map", K: 9, V: {
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    } },
    { no: 2, name: "position_hdop", kind: "scalar", T: 2, opt: !0 },
    { no: 3, name: "position_vdop", kind: "scalar", T: 2, opt: !0 },
    { no: 4, name: "position_nmea_gga_fix", kind: "scalar", T: 5, opt: !0 },
    { no: 5, name: "compass_degrees_error", kind: "scalar", T: 2, opt: !0 }
  ]
), Ts = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetLinearAccelerationRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), gc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.movementsensor.v1.GetLinearAccelerationResponse",
  () => [
    { no: 1, name: "linear_acceleration", kind: "message", T: qe }
  ]
), ih = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetAccuracyRequest: gs,
  GetAccuracyResponse: pc,
  GetAngularVelocityRequest: cs,
  GetAngularVelocityResponse: mc,
  GetCompassHeadingRequest: ls,
  GetCompassHeadingResponse: cc,
  GetLinearAccelerationRequest: Ts,
  GetLinearAccelerationResponse: gc,
  GetLinearVelocityRequest: ms,
  GetLinearVelocityResponse: rc,
  GetOrientationRequest: ds,
  GetOrientationResponse: lc,
  GetPositionRequest: us,
  GetPositionResponse: dc,
  GetPropertiesRequest: ps,
  GetPropertiesResponse: uc
}, Symbol.toStringTag, { value: "Module" })), Tc = {
  typeName: "viam.component.movementsensor.v1.MovementSensorService",
  methods: {
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetLinearVelocity
     */
    getLinearVelocity: {
      name: "GetLinearVelocity",
      I: ms,
      O: rc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetAngularVelocity
     */
    getAngularVelocity: {
      name: "GetAngularVelocity",
      I: cs,
      O: mc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetCompassHeading
     */
    getCompassHeading: {
      name: "GetCompassHeading",
      I: ls,
      O: cc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetOrientation
     */
    getOrientation: {
      name: "GetOrientation",
      I: ds,
      O: lc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetPosition
     */
    getPosition: {
      name: "GetPosition",
      I: us,
      O: dc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: ps,
      O: uc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetAccuracy
     */
    getAccuracy: {
      name: "GetAccuracy",
      I: gs,
      O: pc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetLinearAcceleration
     */
    getLinearAcceleration: {
      name: "GetLinearAcceleration",
      I: Ts,
      O: gc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    },
    /**
     * GetReadings returns the readings of a sensor of the underlying robot.
     *
     * @generated from rpc viam.component.movementsensor.v1.MovementSensorService.GetReadings
     */
    getReadings: {
      name: "GetReadings",
      I: We,
      O: st,
      kind: m.Unary
    }
  }
}, ks = /* @__PURE__ */ o.makeMessageType(
  "viam.component.powersensor.v1.GetVoltageRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), kc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.powersensor.v1.GetVoltageResponse",
  () => [
    {
      no: 1,
      name: "volts",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "is_ac",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), ys = /* @__PURE__ */ o.makeMessageType(
  "viam.component.powersensor.v1.GetCurrentRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), yc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.powersensor.v1.GetCurrentResponse",
  () => [
    {
      no: 1,
      name: "amperes",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 2,
      name: "is_ac",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), vs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.powersensor.v1.GetPowerRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), vc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.powersensor.v1.GetPowerResponse",
  () => [
    {
      no: 1,
      name: "watts",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), hf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetCurrentRequest: ys,
  GetCurrentResponse: yc,
  GetPowerRequest: vs,
  GetPowerResponse: vc,
  GetVoltageRequest: ks,
  GetVoltageResponse: kc
}, Symbol.toStringTag, { value: "Module" })), hc = {
  typeName: "viam.component.powersensor.v1.PowerSensorService",
  methods: {
    /**
     * GetVoltage returns the voltage reading of a power sensor in volts
     *
     * @generated from rpc viam.component.powersensor.v1.PowerSensorService.GetVoltage
     */
    getVoltage: {
      name: "GetVoltage",
      I: ks,
      O: kc,
      kind: m.Unary
    },
    /**
     * GetCurrent returns the current reading of a power sensor in amperes
     *
     * @generated from rpc viam.component.powersensor.v1.PowerSensorService.GetCurrent
     */
    getCurrent: {
      name: "GetCurrent",
      I: ys,
      O: yc,
      kind: m.Unary
    },
    /**
     * GetPower returns the power reading of a power sensor in watts
     *
     * @generated from rpc viam.component.powersensor.v1.PowerSensorService.GetPower
     */
    getPower: {
      name: "GetPower",
      I: vs,
      O: vc,
      kind: m.Unary
    },
    /**
     * GetReadings returns the readings of a sensor of the underlying robot.
     *
     * @generated from rpc viam.component.powersensor.v1.PowerSensorService.GetReadings
     */
    getReadings: {
      name: "GetReadings",
      I: We,
      O: st,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.powersensor.v1.PowerSensorService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    }
  }
}, hs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.MoveRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "angle_deg",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), fc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.MoveResponse",
  []
), fs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.GetPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Rc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.GetPositionResponse",
  () => [
    {
      no: 1,
      name: "position_deg",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    }
  ]
), Rs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.StopRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Ic = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.StopResponse",
  []
), rh = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.Status",
  () => [
    {
      no: 1,
      name: "position_deg",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    },
    {
      no: 2,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), Is = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.IsMovingRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Sc = /* @__PURE__ */ o.makeMessageType(
  "viam.component.servo.v1.IsMovingResponse",
  () => [
    {
      no: 1,
      name: "is_moving",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), ff = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetPositionRequest: fs,
  GetPositionResponse: Rc,
  IsMovingRequest: Is,
  IsMovingResponse: Sc,
  MoveRequest: hs,
  MoveResponse: fc,
  Status: rh,
  StopRequest: Rs,
  StopResponse: Ic
}, Symbol.toStringTag, { value: "Module" })), wc = {
  typeName: "viam.component.servo.v1.ServoService",
  methods: {
    /**
     * Move requests the servo of the underlying robot to move.
     * This will block until done or a new operation cancels this one
     *
     * @generated from rpc viam.component.servo.v1.ServoService.Move
     */
    move: {
      name: "Move",
      I: hs,
      O: fc,
      kind: m.Unary
    },
    /**
     * GetPosition returns the current set angle (degrees) of the servo of the underlying robot.
     *
     * @generated from rpc viam.component.servo.v1.ServoService.GetPosition
     */
    getPosition: {
      name: "GetPosition",
      I: fs,
      O: Rc,
      kind: m.Unary
    },
    /**
     * Stop stops a robot's servo
     *
     * @generated from rpc viam.component.servo.v1.ServoService.Stop
     */
    stop: {
      name: "Stop",
      I: Rs,
      O: Ic,
      kind: m.Unary
    },
    /**
     * IsMoving reports if a component is in motion
     *
     * @generated from rpc viam.component.servo.v1.ServoService.IsMoving
     */
    isMoving: {
      name: "IsMoving",
      I: Is,
      O: Sc,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.servo.v1.ServoService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.servo.v1.ServoService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, Ss = {
  typeName: "viam.robot.v1.RobotService",
  methods: {
    /**
     * @generated from rpc viam.robot.v1.RobotService.GetOperations
     */
    getOperations: {
      name: "GetOperations",
      I: Yi,
      O: Wi,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.robot.v1.RobotService.GetSessions
     */
    getSessions: {
      name: "GetSessions",
      I: Zi,
      O: er,
      kind: m.Unary
    },
    /**
     * ResourceNames returns the list of all resources.
     *
     * @generated from rpc viam.robot.v1.RobotService.ResourceNames
     */
    resourceNames: {
      name: "ResourceNames",
      I: Bi,
      O: xi,
      kind: m.Unary
    },
    /**
     * ResourceRPCSubtypes returns the list of all resource types.
     *
     * @generated from rpc viam.robot.v1.RobotService.ResourceRPCSubtypes
     */
    resourceRPCSubtypes: {
      name: "ResourceRPCSubtypes",
      I: Ji,
      O: zi,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.robot.v1.RobotService.CancelOperation
     */
    cancelOperation: {
      name: "CancelOperation",
      I: Vi,
      O: ji,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.robot.v1.RobotService.BlockForOperation
     */
    blockForOperation: {
      name: "BlockForOperation",
      I: Hi,
      O: Ki,
      kind: m.Unary
    },
    /**
     * DiscoverComponents returns the list of discovered component configurations.
     *
     * @generated from rpc viam.robot.v1.RobotService.DiscoverComponents
     */
    discoverComponents: {
      name: "DiscoverComponents",
      I: tr,
      O: ar,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.robot.v1.RobotService.FrameSystemConfig
     */
    frameSystemConfig: {
      name: "FrameSystemConfig",
      I: Ai,
      O: Ui,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.robot.v1.RobotService.TransformPose
     */
    transformPose: {
      name: "TransformPose",
      I: jt,
      O: Gi,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.robot.v1.RobotService.TransformPCD
     */
    transformPCD: {
      name: "TransformPCD",
      I: Ht,
      O: Li,
      kind: m.Unary
    },
    /**
     * GetStatus returns the list of all statuses requested. An empty request signifies all resources.
     *
     * @generated from rpc viam.robot.v1.RobotService.GetStatus
     * @deprecated
     */
    getStatus: {
      name: "GetStatus",
      I: sr,
      O: or,
      kind: m.Unary
    },
    /**
     * StreamStatus periodically sends the status of all statuses requested. An empty request signifies all resources.
     *
     * @generated from rpc viam.robot.v1.RobotService.StreamStatus
     * @deprecated
     */
    streamStatus: {
      name: "StreamStatus",
      I: ir,
      O: rr,
      kind: m.ServerStreaming
    },
    /**
     * StopAll will stop all current and outstanding operations for the robot and stops all actuators and movement
     *
     * @generated from rpc viam.robot.v1.RobotService.StopAll
     */
    stopAll: {
      name: "StopAll",
      I: cr,
      O: lr,
      kind: m.Unary
    },
    /**
     * StartSession creates a new session that expects at least one heartbeat within the returned window.
     * If the window lapses, any resources that have safety heart monitored methods, where this session was
     * the last caller on the resource, will be stopped.
     *
     * @generated from rpc viam.robot.v1.RobotService.StartSession
     */
    startSession: {
      name: "StartSession",
      I: Qt,
      O: dr,
      kind: m.Unary
    },
    /**
     * SendSessionHeartbeat sends a heartbeat to the given session. If the session has expired, a
     * SESSION_EXPIRED error will be returned.
     *
     * @generated from rpc viam.robot.v1.RobotService.SendSessionHeartbeat
     */
    sendSessionHeartbeat: {
      name: "SendSessionHeartbeat",
      I: Zt,
      O: ur,
      kind: m.Unary
    },
    /**
     * Log sends logs to be logged by this robot. Currently used for module logging.
     *
     * @generated from rpc viam.robot.v1.RobotService.Log
     */
    log: {
      name: "Log",
      I: pr,
      O: gr,
      kind: m.Unary
    },
    /**
     * GetCloudMetadata returns app-related information about the robot.
     *
     * @generated from rpc viam.robot.v1.RobotService.GetCloudMetadata
     */
    getCloudMetadata: {
      name: "GetCloudMetadata",
      I: Tr,
      O: ea,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.robot.v1.RobotService.RestartModule
     */
    restartModule: {
      name: "RestartModule",
      I: na,
      O: kr,
      kind: m.Unary
    },
    /**
     * Shutdown shuts down the robot.
     *
     * @generated from rpc viam.robot.v1.RobotService.Shutdown
     */
    shutdown: {
      name: "Shutdown",
      I: yr,
      O: vr,
      kind: m.Unary
    },
    /**
     * GetMachineStatus returns the current status of the robot.
     *
     * @generated from rpc viam.robot.v1.RobotService.GetMachineStatus
     */
    getMachineStatus: {
      name: "GetMachineStatus",
      I: hr,
      O: fr,
      kind: m.Unary
    },
    /**
     * GetVersion returns version information about the robot.
     *
     * @generated from rpc viam.robot.v1.RobotService.GetVersion
     */
    getVersion: {
      name: "GetVersion",
      I: br,
      O: _r,
      kind: m.Unary
    }
  }
}, bc = /* @__PURE__ */ o.makeEnum(
  "viam.service.motion.v1.PlanState",
  [
    { no: 0, name: "PLAN_STATE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "PLAN_STATE_IN_PROGRESS", localName: "IN_PROGRESS" },
    { no: 2, name: "PLAN_STATE_STOPPED", localName: "STOPPED" },
    { no: 3, name: "PLAN_STATE_SUCCEEDED", localName: "SUCCEEDED" },
    { no: 4, name: "PLAN_STATE_FAILED", localName: "FAILED" }
  ]
), ws = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.MoveRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "destination", kind: "message", T: Qe },
    { no: 3, name: "component_name", kind: "message", T: B },
    { no: 4, name: "world_state", kind: "message", T: Mi, opt: !0 },
    { no: 5, name: "constraints", kind: "message", T: qc, opt: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), _c = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.MoveResponse",
  () => [
    {
      no: 1,
      name: "success",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), bs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.MoveOnMapRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "destination", kind: "message", T: Ue },
    { no: 3, name: "component_name", kind: "message", T: B },
    { no: 4, name: "slam_service_name", kind: "message", T: B },
    { no: 5, name: "motion_configuration", kind: "message", T: _s, opt: !0 },
    { no: 6, name: "obstacles", kind: "message", T: Ze, repeated: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Ec = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.MoveOnMapResponse",
  () => [
    {
      no: 1,
      name: "execution_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Mc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.ObstacleDetector",
  () => [
    { no: 1, name: "vision_service", kind: "message", T: B },
    { no: 2, name: "camera", kind: "message", T: B }
  ]
), _s = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.MotionConfiguration",
  () => [
    { no: 1, name: "obstacle_detectors", kind: "message", T: Mc, repeated: !0 },
    { no: 2, name: "position_polling_frequency_hz", kind: "scalar", T: 1, opt: !0 },
    { no: 3, name: "obstacle_polling_frequency_hz", kind: "scalar", T: 1, opt: !0 },
    { no: 4, name: "plan_deviation_m", kind: "scalar", T: 1, opt: !0 },
    { no: 5, name: "linear_m_per_sec", kind: "scalar", T: 1, opt: !0 },
    { no: 6, name: "angular_degs_per_sec", kind: "scalar", T: 1, opt: !0 }
  ]
), Es = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.MoveOnGlobeRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "destination", kind: "message", T: Je },
    { no: 3, name: "heading", kind: "scalar", T: 1, opt: !0 },
    { no: 4, name: "component_name", kind: "message", T: B },
    { no: 5, name: "movement_sensor_name", kind: "message", T: B },
    { no: 6, name: "obstacles", kind: "message", T: Kn, repeated: !0 },
    { no: 7, name: "motion_configuration", kind: "message", T: _s, opt: !0 },
    { no: 8, name: "bounding_regions", kind: "message", T: Kn, repeated: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Oc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.MoveOnGlobeResponse",
  () => [
    {
      no: 1,
      name: "execution_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ms = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.GetPoseRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "component_name", kind: "message", T: B },
    {
      no: 3,
      name: "destination_frame",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "supplemental_transforms", kind: "message", T: en, repeated: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Nc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.GetPoseResponse",
  () => [
    { no: 1, name: "pose", kind: "message", T: Qe }
  ]
), Os = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.StopPlanRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "component_name", kind: "message", T: B },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Cc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.StopPlanResponse",
  []
), Ns = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.ListPlanStatusesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "only_active_plans",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Pc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.ListPlanStatusesResponse",
  () => [
    { no: 1, name: "plan_statuses_with_ids", kind: "message", T: Bc, repeated: !0 }
  ]
), Cs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.GetPlanRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "component_name", kind: "message", T: B },
    {
      no: 3,
      name: "last_plan_only",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 4, name: "execution_id", kind: "scalar", T: 9, opt: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Dc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.GetPlanResponse",
  () => [
    { no: 1, name: "current_plan_with_status", kind: "message", T: xt },
    { no: 2, name: "replan_history", kind: "message", T: xt, repeated: !0 }
  ]
), qc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.Constraints",
  () => [
    { no: 1, name: "linear_constraint", kind: "message", T: Ac, repeated: !0 },
    { no: 2, name: "orientation_constraint", kind: "message", T: Uc, repeated: !0 },
    { no: 3, name: "collision_specification", kind: "message", T: Gc, repeated: !0 }
  ]
), Ac = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.LinearConstraint",
  () => [
    { no: 1, name: "line_tolerance_mm", kind: "scalar", T: 2, opt: !0 },
    { no: 2, name: "orientation_tolerance_degs", kind: "scalar", T: 2, opt: !0 }
  ]
), Uc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.OrientationConstraint",
  () => [
    { no: 1, name: "orientation_tolerance_degs", kind: "scalar", T: 2, opt: !0 }
  ]
), Gc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.CollisionSpecification",
  () => [
    { no: 1, name: "allows", kind: "message", T: Lc, repeated: !0 }
  ]
), Lc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.CollisionSpecification.AllowedFrameCollisions",
  () => [
    {
      no: 1,
      name: "frame1",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "frame2",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ],
  { localName: "CollisionSpecification_AllowedFrameCollisions" }
), xt = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.PlanWithStatus",
  () => [
    { no: 1, name: "plan", kind: "message", T: xc },
    { no: 2, name: "status", kind: "message", T: nt },
    { no: 3, name: "status_history", kind: "message", T: nt, repeated: !0 }
  ]
), Bc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.PlanStatusWithID",
  () => [
    {
      no: 1,
      name: "plan_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "component_name", kind: "message", T: B },
    {
      no: 3,
      name: "execution_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "status", kind: "message", T: nt }
  ]
), nt = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.PlanStatus",
  () => [
    { no: 1, name: "state", kind: "enum", T: o.getEnumType(bc) },
    { no: 2, name: "timestamp", kind: "message", T: I },
    { no: 3, name: "reason", kind: "scalar", T: 9, opt: !0 }
  ]
), xc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.Plan",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "component_name", kind: "message", T: B },
    {
      no: 3,
      name: "execution_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "steps", kind: "message", T: Fc, repeated: !0 }
  ]
), Fc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.PlanStep",
  () => [
    { no: 1, name: "step", kind: "map", K: 9, V: { kind: "message", T: Jc } }
  ]
), Jc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.motion.v1.ComponentState",
  () => [
    { no: 1, name: "pose", kind: "message", T: Ue }
  ]
), mh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CollisionSpecification: Gc,
  CollisionSpecification_AllowedFrameCollisions: Lc,
  ComponentState: Jc,
  Constraints: qc,
  GetPlanRequest: Cs,
  GetPlanResponse: Dc,
  GetPoseRequest: Ms,
  GetPoseResponse: Nc,
  LinearConstraint: Ac,
  ListPlanStatusesRequest: Ns,
  ListPlanStatusesResponse: Pc,
  MotionConfiguration: _s,
  MoveOnGlobeRequest: Es,
  MoveOnGlobeResponse: Oc,
  MoveOnMapRequest: bs,
  MoveOnMapResponse: Ec,
  MoveRequest: ws,
  MoveResponse: _c,
  ObstacleDetector: Mc,
  OrientationConstraint: Uc,
  Plan: xc,
  PlanState: bc,
  PlanStatus: nt,
  PlanStatusWithID: Bc,
  PlanStep: Fc,
  PlanWithStatus: xt,
  StopPlanRequest: Os,
  StopPlanResponse: Cc
}, Symbol.toStringTag, { value: "Module" })), zc = {
  typeName: "viam.service.motion.v1.MotionService",
  methods: {
    /**
     * @generated from rpc viam.service.motion.v1.MotionService.Move
     */
    move: {
      name: "Move",
      I: ws,
      O: _c,
      kind: m.Unary
    },
    /**
     * Generate a plan and move a component to a specific pose
     * with respect to the SLAM map's origin.
     * May replan to avoid obstacles
     *
     * @generated from rpc viam.service.motion.v1.MotionService.MoveOnMap
     */
    moveOnMap: {
      name: "MoveOnMap",
      I: bs,
      O: Ec,
      kind: m.Unary
    },
    /**
     * Generate and begin executing an execution to move a component
     * to a specific GPS coordinate.
     * May replan to avoid obstacles & account for location drift.
     * Creates a new plan upon replanning.
     *
     * @generated from rpc viam.service.motion.v1.MotionService.MoveOnGlobe
     */
    moveOnGlobe: {
      name: "MoveOnGlobe",
      I: Es,
      O: Oc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.motion.v1.MotionService.GetPose
     */
    getPose: {
      name: "GetPose",
      I: Ms,
      O: Nc,
      kind: m.Unary
    },
    /**
     * Stops a Plan
     *
     * @generated from rpc viam.service.motion.v1.MotionService.StopPlan
     */
    stopPlan: {
      name: "StopPlan",
      I: Os,
      O: Cc,
      kind: m.Unary
    },
    /**
     * Returns the status of plans created by requests to move components
     * that are executing OR are part of an execution which changed it state
     * within the a 24HR TTL OR until the robot reinitializes.
     * This currently only returns plans for MoveOnGlobe and MoveOnMap.
     *
     * @generated from rpc viam.service.motion.v1.MotionService.ListPlanStatuses
     */
    listPlanStatuses: {
      name: "ListPlanStatuses",
      I: Ns,
      O: Pc,
      kind: m.Unary
    },
    /**
     * Returns the plan(s) & state history of the most recent execution to move a
     * component. Returns a result if the last execution is still executing OR
     * changed state within the last 24 hours AND the robot has not reinitialized.
     * Plans are never mutated.
     * Replans always create new plans.
     * Replans share the execution_id of the previously executing plan.
     * This currently only returns plans for MoveOnGlobe and MoveOnMap.
     *
     * @generated from rpc viam.service.motion.v1.MotionService.GetPlan
     */
    getPlan: {
      name: "GetPlan",
      I: Cs,
      O: Dc,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.service.motion.v1.MotionService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    }
  }
}, $c = /* @__PURE__ */ o.makeEnum(
  "viam.service.navigation.v1.MapType",
  [
    { no: 0, name: "MAP_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "MAP_TYPE_NONE", localName: "NONE" },
    { no: 2, name: "MAP_TYPE_GPS", localName: "GPS" }
  ]
), Ps = /* @__PURE__ */ o.makeEnum(
  "viam.service.navigation.v1.Mode",
  [
    { no: 0, name: "MODE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "MODE_MANUAL", localName: "MANUAL" },
    { no: 2, name: "MODE_WAYPOINT", localName: "WAYPOINT" },
    { no: 3, name: "MODE_EXPLORE", localName: "EXPLORE" }
  ]
), Ds = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetModeRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Yc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetModeResponse",
  () => [
    { no: 1, name: "mode", kind: "enum", T: o.getEnumType(Ps) }
  ]
), qs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.SetModeRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "mode", kind: "enum", T: o.getEnumType(Ps) },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Wc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.SetModeResponse",
  []
), Vc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.Waypoint",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "location", kind: "message", T: Je }
  ]
), As = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetLocationRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), jc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetLocationResponse",
  () => [
    { no: 1, name: "location", kind: "message", T: Je },
    {
      no: 2,
      name: "compass_heading",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Us = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetWaypointsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Hc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetWaypointsResponse",
  () => [
    { no: 1, name: "waypoints", kind: "message", T: Vc, repeated: !0 }
  ]
), Gs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.AddWaypointRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "location", kind: "message", T: Je },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Kc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.AddWaypointResponse",
  []
), Ls = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.RemoveWaypointRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Xc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.RemoveWaypointResponse",
  []
), Bs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetObstaclesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Qc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetObstaclesResponse",
  () => [
    { no: 1, name: "obstacles", kind: "message", T: Kn, repeated: !0 }
  ]
), Zc = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.Path",
  () => [
    {
      no: 1,
      name: "destination_waypoint_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "geopoints", kind: "message", T: Je, repeated: !0 }
  ]
), xs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetPathsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), el = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetPathsResponse",
  () => [
    { no: 1, name: "paths", kind: "message", T: Zc, repeated: !0 }
  ]
), Fs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), nl = /* @__PURE__ */ o.makeMessageType(
  "viam.service.navigation.v1.GetPropertiesResponse",
  () => [
    { no: 1, name: "map_type", kind: "enum", T: o.getEnumType($c) }
  ]
), ch = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddWaypointRequest: Gs,
  AddWaypointResponse: Kc,
  GetLocationRequest: As,
  GetLocationResponse: jc,
  GetModeRequest: Ds,
  GetModeResponse: Yc,
  GetObstaclesRequest: Bs,
  GetObstaclesResponse: Qc,
  GetPathsRequest: xs,
  GetPathsResponse: el,
  GetPropertiesRequest: Fs,
  GetPropertiesResponse: nl,
  GetWaypointsRequest: Us,
  GetWaypointsResponse: Hc,
  MapType: $c,
  Mode: Ps,
  Path: Zc,
  RemoveWaypointRequest: Ls,
  RemoveWaypointResponse: Xc,
  SetModeRequest: qs,
  SetModeResponse: Wc,
  Waypoint: Vc
}, Symbol.toStringTag, { value: "Module" })), tl = {
  typeName: "viam.service.navigation.v1.NavigationService",
  methods: {
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.GetMode
     */
    getMode: {
      name: "GetMode",
      I: Ds,
      O: Yc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.SetMode
     */
    setMode: {
      name: "SetMode",
      I: qs,
      O: Wc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.GetLocation
     */
    getLocation: {
      name: "GetLocation",
      I: As,
      O: jc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.GetWaypoints
     */
    getWaypoints: {
      name: "GetWaypoints",
      I: Us,
      O: Hc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.AddWaypoint
     */
    addWaypoint: {
      name: "AddWaypoint",
      I: Gs,
      O: Kc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.RemoveWaypoint
     */
    removeWaypoint: {
      name: "RemoveWaypoint",
      I: Ls,
      O: Xc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.GetObstacles
     */
    getObstacles: {
      name: "GetObstacles",
      I: Bs,
      O: Qc,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.navigation.v1.NavigationService.GetPaths
     */
    getPaths: {
      name: "GetPaths",
      I: xs,
      O: el,
      kind: m.Unary
    },
    /**
     * GetProperties returns properties of the current navigation service, including the
     * map_type being operated on.
     *
     * @generated from rpc viam.service.navigation.v1.NavigationService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: Fs,
      O: nl,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.service.navigation.v1.NavigationService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    }
  }
}, al = /* @__PURE__ */ o.makeEnum(
  "viam.service.slam.v1.MappingMode",
  [
    { no: 0, name: "MAPPING_MODE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "MAPPING_MODE_CREATE_NEW_MAP", localName: "CREATE_NEW_MAP" },
    { no: 2, name: "MAPPING_MODE_LOCALIZE_ONLY", localName: "LOCALIZE_ONLY" },
    { no: 3, name: "MAPPING_MODE_UPDATE_EXISTING_MAP", localName: "UPDATE_EXISTING_MAP" }
  ]
), sl = /* @__PURE__ */ o.makeEnum(
  "viam.service.slam.v1.SensorType",
  [
    { no: 0, name: "SENSOR_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "SENSOR_TYPE_CAMERA", localName: "CAMERA" },
    { no: 2, name: "SENSOR_TYPE_MOVEMENT_SENSOR", localName: "MOVEMENT_SENSOR" }
  ]
), Js = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetPositionRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ol = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetPositionResponse",
  () => [
    { no: 1, name: "pose", kind: "message", T: Ue }
  ]
), zs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetPointCloudMapRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "return_edited_map", kind: "scalar", T: 8, opt: !0 }
  ]
), il = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetPointCloudMapResponse",
  () => [
    {
      no: 1,
      name: "point_cloud_pcd_chunk",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), $s = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetInternalStateRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), rl = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetInternalStateResponse",
  () => [
    {
      no: 1,
      name: "internal_state_chunk",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), Ys = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ml = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.GetPropertiesResponse",
  () => [
    {
      no: 1,
      name: "cloud_slam",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 2, name: "mapping_mode", kind: "enum", T: o.getEnumType(al) },
    { no: 3, name: "internal_state_file_type", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "sensor_info", kind: "message", T: cl, repeated: !0 }
  ]
), cl = /* @__PURE__ */ o.makeMessageType(
  "viam.service.slam.v1.SensorInfo",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "type", kind: "enum", T: o.getEnumType(sl) }
  ]
), lh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetInternalStateRequest: $s,
  GetInternalStateResponse: rl,
  GetPointCloudMapRequest: zs,
  GetPointCloudMapResponse: il,
  GetPositionRequest: Js,
  GetPositionResponse: ol,
  GetPropertiesRequest: Ys,
  GetPropertiesResponse: ml,
  MappingMode: al,
  SensorInfo: cl,
  SensorType: sl
}, Symbol.toStringTag, { value: "Module" })), ll = {
  typeName: "viam.service.slam.v1.SLAMService",
  methods: {
    /**
     * GetPosition returns the current estimated position of the robot with
     * respect to a returned component reference.
     *
     * @generated from rpc viam.service.slam.v1.SLAMService.GetPosition
     */
    getPosition: {
      name: "GetPosition",
      I: Js,
      O: ol,
      kind: m.Unary
    },
    /**
     * GetPointCloudMap returns the latest pointcloud map available where XY is the ground
     * plane and positive Z is up, following the Right Hand Rule.
     *
     * @generated from rpc viam.service.slam.v1.SLAMService.GetPointCloudMap
     */
    getPointCloudMap: {
      name: "GetPointCloudMap",
      I: zs,
      O: il,
      kind: m.ServerStreaming
    },
    /**
     * GetInternalState returns the internal map as defined by the specified slam
     * algorithm required to continue mapping/localizing.
     * This endpoint is not intended for end users.
     *
     * @generated from rpc viam.service.slam.v1.SLAMService.GetInternalState
     */
    getInternalState: {
      name: "GetInternalState",
      I: $s,
      O: rl,
      kind: m.ServerStreaming
    },
    /**
     * GetProperties returns properties of the current slam service including mapping_mode
     * and cloud_slam, where mapping_mode is the type of mapping/localizing being performed
     * and cloud_slam is a boolean representing if this SLAM service is being run in the cloud.
     *
     * @generated from rpc viam.service.slam.v1.SLAMService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: Ys,
      O: ml,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands.
     *
     * @generated from rpc viam.service.slam.v1.SLAMService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    }
  }
}, dl = /* @__PURE__ */ o.makeEnum(
  "viam.component.camera.v1.Format",
  [
    { no: 0, name: "FORMAT_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "FORMAT_RAW_RGBA", localName: "RAW_RGBA" },
    { no: 2, name: "FORMAT_RAW_DEPTH", localName: "RAW_DEPTH" },
    { no: 3, name: "FORMAT_JPEG", localName: "JPEG" },
    { no: 4, name: "FORMAT_PNG", localName: "PNG" }
  ]
), Ws = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetImageRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), ul = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetImageResponse",
  () => [
    {
      no: 1,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "image",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), pl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetImagesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), gl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetImagesResponse",
  () => [
    { no: 1, name: "images", kind: "message", T: Vs, repeated: !0 },
    { no: 84260, name: "response_metadata", kind: "message", T: Oi }
  ]
), Vs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.Image",
  () => [
    {
      no: 1,
      name: "source_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "format", kind: "enum", T: o.getEnumType(dl) },
    {
      no: 3,
      name: "image",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), js = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.RenderFrameRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Hs = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetPointCloudRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Tl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetPointCloudResponse",
  () => [
    {
      no: 1,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "point_cloud",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), kl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), yl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.GetPropertiesResponse",
  () => [
    {
      no: 1,
      name: "supports_pcd",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 2, name: "intrinsic_parameters", kind: "message", T: fl },
    { no: 3, name: "distortion_parameters", kind: "message", T: Rl },
    { no: 4, name: "mime_types", kind: "scalar", T: 9, repeated: !0 },
    { no: 5, name: "frame_rate", kind: "scalar", T: 2, opt: !0 }
  ]
), dh = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.Webcams",
  () => [
    { no: 1, name: "webcams", kind: "message", T: vl, repeated: !0 }
  ]
), vl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.Webcam",
  () => [
    {
      no: 1,
      name: "label",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "status",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "properties", kind: "message", T: hl, repeated: !0 },
    {
      no: 4,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), hl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.Property",
  () => [
    {
      no: 1,
      name: "width_px",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 2,
      name: "height_px",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "frame_format",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "frame_rate",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    }
  ]
), fl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.IntrinsicParameters",
  () => [
    {
      no: 1,
      name: "width_px",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    },
    {
      no: 2,
      name: "height_px",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    },
    {
      no: 3,
      name: "focal_x_px",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "focal_y_px",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 5,
      name: "center_x_px",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 6,
      name: "center_y_px",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Rl = /* @__PURE__ */ o.makeMessageType(
  "viam.component.camera.v1.DistortionParameters",
  () => [
    {
      no: 1,
      name: "model",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "parameters", kind: "scalar", T: 1, repeated: !0 }
  ]
), Rf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DistortionParameters: Rl,
  Format: dl,
  GetImageRequest: Ws,
  GetImageResponse: ul,
  GetImagesRequest: pl,
  GetImagesResponse: gl,
  GetPointCloudRequest: Hs,
  GetPointCloudResponse: Tl,
  GetPropertiesRequest: kl,
  GetPropertiesResponse: yl,
  Image: Vs,
  IntrinsicParameters: fl,
  Property: hl,
  RenderFrameRequest: js,
  Webcam: vl,
  Webcams: dh
}, Symbol.toStringTag, { value: "Module" })), Ks = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetDetectionsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "image",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "width",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "height",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 5,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Il = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetDetectionsResponse",
  () => [
    { no: 1, name: "detections", kind: "message", T: lt, repeated: !0 }
  ]
), Xs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetDetectionsFromCameraRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "camera_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Sl = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetDetectionsFromCameraResponse",
  () => [
    { no: 1, name: "detections", kind: "message", T: lt, repeated: !0 }
  ]
), lt = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.Detection",
  () => [
    { no: 1, name: "x_min", kind: "scalar", T: 3, opt: !0 },
    { no: 2, name: "y_min", kind: "scalar", T: 3, opt: !0 },
    { no: 3, name: "x_max", kind: "scalar", T: 3, opt: !0 },
    { no: 4, name: "y_max", kind: "scalar", T: 3, opt: !0 },
    {
      no: 5,
      name: "confidence",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 6,
      name: "class_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Qs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetClassificationsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "image",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "width",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 4,
      name: "height",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 5,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "n",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), wl = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetClassificationsResponse",
  () => [
    { no: 1, name: "classifications", kind: "message", T: dt, repeated: !0 }
  ]
), Zs = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetClassificationsFromCameraRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "camera_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "n",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), bl = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetClassificationsFromCameraResponse",
  () => [
    { no: 1, name: "classifications", kind: "message", T: dt, repeated: !0 }
  ]
), dt = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.Classification",
  () => [
    {
      no: 1,
      name: "class_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "confidence",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), eo = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetObjectPointCloudsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "camera_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), _l = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetObjectPointCloudsResponse",
  () => [
    {
      no: 1,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "objects", kind: "message", T: Vt, repeated: !0 }
  ]
), no = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetPropertiesRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), to = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.CaptureAllFromCameraRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "camera_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "return_image",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 4,
      name: "return_classifications",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 5,
      name: "return_detections",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 6,
      name: "return_object_point_clouds",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), El = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.CaptureAllFromCameraResponse",
  () => [
    { no: 1, name: "image", kind: "message", T: Vs },
    { no: 2, name: "detections", kind: "message", T: lt, repeated: !0 },
    { no: 3, name: "classifications", kind: "message", T: dt, repeated: !0 },
    { no: 4, name: "objects", kind: "message", T: Vt, repeated: !0 },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), Ml = /* @__PURE__ */ o.makeMessageType(
  "viam.service.vision.v1.GetPropertiesResponse",
  () => [
    {
      no: 1,
      name: "classifications_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 2,
      name: "detections_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 3,
      name: "object_point_clouds_supported",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), uh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CaptureAllFromCameraRequest: to,
  CaptureAllFromCameraResponse: El,
  Classification: dt,
  Detection: lt,
  GetClassificationsFromCameraRequest: Zs,
  GetClassificationsFromCameraResponse: bl,
  GetClassificationsRequest: Qs,
  GetClassificationsResponse: wl,
  GetDetectionsFromCameraRequest: Xs,
  GetDetectionsFromCameraResponse: Sl,
  GetDetectionsRequest: Ks,
  GetDetectionsResponse: Il,
  GetObjectPointCloudsRequest: eo,
  GetObjectPointCloudsResponse: _l,
  GetPropertiesRequest: no,
  GetPropertiesResponse: Ml
}, Symbol.toStringTag, { value: "Module" })), Ol = {
  typeName: "viam.service.vision.v1.VisionService",
  methods: {
    /**
     * GetDetectionsFromCamera will return a list of detections in the next image given a camera and a detector
     *
     * @generated from rpc viam.service.vision.v1.VisionService.GetDetectionsFromCamera
     */
    getDetectionsFromCamera: {
      name: "GetDetectionsFromCamera",
      I: Xs,
      O: Sl,
      kind: m.Unary
    },
    /**
     * GetDetections will return a list of detections in the next image given the image bytes and a detector
     *
     * @generated from rpc viam.service.vision.v1.VisionService.GetDetections
     */
    getDetections: {
      name: "GetDetections",
      I: Ks,
      O: Il,
      kind: m.Unary
    },
    /**
     * GetClassificationsFromCamera will return a list of classifications in the next image given a camera and a classifier
     *
     * @generated from rpc viam.service.vision.v1.VisionService.GetClassificationsFromCamera
     */
    getClassificationsFromCamera: {
      name: "GetClassificationsFromCamera",
      I: Zs,
      O: bl,
      kind: m.Unary
    },
    /**
     * GetClassifications will return a list of classifications in the next image given the image bytes and a classifier
     *
     * @generated from rpc viam.service.vision.v1.VisionService.GetClassifications
     */
    getClassifications: {
      name: "GetClassifications",
      I: Qs,
      O: wl,
      kind: m.Unary
    },
    /**
     * GetObjectPointClouds returns all the found objects in a pointcloud from a camera of the underlying robot,
     * as well as the 3-vector center of each of the found objects.
     * A specific MIME type can be requested but may not necessarily be the same one returned.
     *
     * @generated from rpc viam.service.vision.v1.VisionService.GetObjectPointClouds
     */
    getObjectPointClouds: {
      name: "GetObjectPointClouds",
      I: eo,
      O: _l,
      kind: m.Unary
    },
    /**
     * GetProperties will return the properties as booleans given the name of the vision service
     *
     * @generated from rpc viam.service.vision.v1.VisionService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: no,
      O: Ml,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.service.vision.v1.VisionService.CaptureAllFromCamera
     */
    captureAllFromCamera: {
      name: "CaptureAllFromCamera",
      I: to,
      O: El,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.service.vision.v1.VisionService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    }
  }
}, ph = new Blob(
  [
    `self.onmessage = function(e) {
    setTimeout(() => self.postMessage(""), e.data);
  };`
  ],
  { type: "text/javascript" }
);
class gh {
  constructor(e, n, a = 1e4) {
    this.deferredTransport = e, this.onDisconnect = n, this.heartbeatIntervalMs = a;
  }
  connecting;
  get client() {
    const e = this.deferredTransport();
    return P(Ss, e);
  }
  heartbeat() {
    let e;
    const n = async () => {
      try {
        await this.client.getOperations({});
      } catch {
        this.onDisconnect();
        return;
      }
      e ? e.postMessage(this.heartbeatIntervalMs) : setTimeout(() => {
        n().catch(console.error);
      }, this.heartbeatIntervalMs);
    };
    if (globalThis.Worker !== void 0) {
      const a = window.URL.createObjectURL(ph);
      e = new Worker(a), URL.revokeObjectURL(a), e.addEventListener("message", () => {
        n().catch(console.error);
      });
    }
    n().catch(console.error);
  }
  async start() {
    this.connecting && await this.connecting, this.connecting = new Promise((e, n) => {
      (async () => {
        await this.client.getOperations({});
      })().then(e).catch(n).finally(() => {
        this.connecting = void 0;
      });
    });
    try {
      await this.connecting;
    } finally {
      this.connecting = void 0;
    }
    this.heartbeat();
  }
}
class Th {
  constructor(e, n) {
    this.deferredTransport = e, this.sessionManager = n;
  }
  async getSessionMetadata() {
    try {
      return await this.sessionManager.getSessionMetadata();
    } catch (e) {
      throw e instanceof N && e.code === M.InvalidArgument && e.message === "SESSION_EXPIRED" && this.sessionManager.reset(), e;
    }
  }
  async unary(e, n, a, s, i, r, c) {
    const d = await this.getSessionMetadata(), l = fn(i);
    for (const [T, R] of d)
      l.set(T, R);
    return this.deferredTransport().unary(
      e,
      n,
      a,
      s,
      l,
      r,
      c
    );
  }
  async stream(e, n, a, s, i, r, c) {
    const d = await this.getSessionMetadata(), l = fn(i);
    for (const [T, R] of d)
      l.set(T, R);
    return this.deferredTransport().stream(
      e,
      n,
      a,
      s,
      l,
      r,
      c
    );
  }
}
const kh = new Blob(
  [
    `self.onmessage = function(e) {
  setTimeout(() => self.postMessage(""), e.data);
};`
  ],
  { type: "text/javascript" }
);
class yh {
  constructor(e) {
    this.deferredTransport = e, this.transport = new Th(this.deferredTransport, this);
  }
  transport;
  currentSessionID = "";
  sessionsSupported;
  heartbeatIntervalMs;
  starting;
  get client() {
    const e = this.deferredTransport();
    return ta(Ss, e);
  }
  get sessionID() {
    return this.currentSessionID;
  }
  getSessionMetadataInner() {
    const e = new Headers();
    return this.sessionsSupported && this.currentSessionID !== "" && e.set("viam-sid", this.currentSessionID), e;
  }
  reset() {
    this.starting || (this.sessionsSupported = void 0);
  }
  // Note: maybe support non-worker for foreground presence.
  backgroundHeartbeat = !0;
  async heartbeat() {
    if (!this.sessionsSupported || this.currentSessionID === "")
      return;
    for (; this.starting; )
      await this.starting;
    let e;
    const n = async () => {
      const a = new Zt({
        id: this.currentSessionID
      });
      try {
        await this.client.sendSessionHeartbeat(a);
      } catch (s) {
        if (s instanceof N && s.code === M.Unimplemented) {
          console.error("sessions unsupported; will not try again"), this.sessionsSupported = !1;
          return;
        }
        if (s instanceof Ae || s instanceof N && s.rawMessage === "closed") {
          this.reset();
          return;
        }
      }
      e ? e.postMessage(this.heartbeatIntervalMs) : setTimeout(() => {
        n().catch(console.error);
      }, this.heartbeatIntervalMs);
    };
    if (this.backgroundHeartbeat && globalThis.Worker !== void 0) {
      const a = window.URL.createObjectURL(kh);
      e = new Worker(a), URL.revokeObjectURL(a), e.addEventListener("message", () => {
        n().catch(console.error);
      });
    }
    n().catch(console.error);
  }
  async getSessionMetadata() {
    for (; this.starting; )
      await this.starting;
    return this.sessionsSupported !== void 0 ? this.getSessionMetadataInner() : (this.starting = new Promise((e, n) => {
      (async () => {
        const a = new Qt();
        this.currentSessionID !== "" && (a.resume = this.currentSessionID);
        let s;
        try {
          s = await this.client.startSession(a);
        } catch (r) {
          if (r instanceof N && r.code === M.Unimplemented) {
            console.error("sessions unsupported; will not try again"), this.sessionsSupported = !1;
            return;
          }
          throw r;
        }
        const { heartbeatWindow: i } = s;
        if (!i)
          throw new Error(
            "expected heartbeat window in response to start session"
          );
        this.sessionsSupported = !0, this.currentSessionID = s.id, this.heartbeatIntervalMs = (Number(i.seconds) * 1e3 + i.nanos / 1e6) / 5, e(), this.heartbeat().catch(console.error);
      })().then(e).catch(n).finally(() => {
        this.starting = void 0;
      });
    }), await this.starting, this.getSessionMetadataInner());
  }
}
class q extends jr {
  serviceHost;
  webrtcOptions;
  directOptions;
  sessionOptions;
  gRPCConnectionManager;
  sessionManager;
  peerConn;
  transport;
  connecting;
  connectResolve;
  savedCreds;
  closed;
  robotServiceClient;
  armServiceClient;
  baseServiceClient;
  boardServiceClient;
  encoderServiceClient;
  gantryServiceClient;
  genericServiceClient;
  gripperServiceClient;
  movementSensorServiceClient;
  powerSensorServiceClient;
  inputControllerServiceClient;
  motorServiceClient;
  navigationServiceClient;
  motionServiceClient;
  visionServiceClient;
  servoServiceClient;
  slamServiceClient;
  constructor(e, n, a, s) {
    super(), this.serviceHost = e, this.webrtcOptions = n, this.directOptions = s, this.sessionOptions = a, this.gRPCConnectionManager = new gh(
      () => {
        if (!this.transport)
          throw new Error(q.notConnectedYetStr);
        return this.transport;
      },
      () => {
        this.onDisconnect();
      }
    ), this.sessionManager = new yh(() => {
      if (!this.transport)
        throw new Error(q.notConnectedYetStr);
      return this.transport;
    });
    for (const i of Object.values(te))
      this.on(i, () => {
        this.emit("connectionstatechange", { eventType: i });
      });
    this.closed = !1;
  }
  onDisconnect(e) {
    if (this.emit(te.DISCONNECTED, e ?? {}), this.noReconnect !== void 0 && this.noReconnect || this.closed)
      return;
    console.debug("Connection closed, will try to reconnect");
    const n = {
      retry: (a, s) => (console.debug(
        `Failed to connect, attempt ${s} with backoff`,
        a
      ), !0)
    };
    this.reconnectMaxWait !== void 0 && (n.maxDelay = this.reconnectMaxWait), this.reconnectMaxAttempts !== void 0 && (n.numOfAttempts = this.reconnectMaxAttempts), Pt(async () => this.connect(), n).then(() => {
      console.debug("Reconnected successfully!");
    }).catch(() => {
      console.debug(`Reached max attempts: ${this.reconnectMaxAttempts}`);
    });
  }
  get noReconnect() {
    return this.webrtcOptions?.noReconnect ?? this.directOptions?.noReconnect;
  }
  get reconnectMaxAttempts() {
    return this.webrtcOptions?.reconnectMaxAttempts ?? this.directOptions?.reconnectMaxAttempts;
  }
  get reconnectMaxWait() {
    return this.webrtcOptions?.reconnectMaxWait ?? this.directOptions?.reconnectMaxWait;
  }
  get sessionId() {
    return this.sessionManager.sessionID;
  }
  static notConnectedYetStr = "not connected yet";
  get robotService() {
    if (!this.robotServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.robotServiceClient;
  }
  get armService() {
    if (!this.armServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.armServiceClient;
  }
  get baseService() {
    if (!this.baseServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.baseServiceClient;
  }
  get boardService() {
    if (!this.boardServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.boardServiceClient;
  }
  get encoderService() {
    if (!this.encoderServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.encoderServiceClient;
  }
  get gantryService() {
    if (!this.gantryServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.gantryServiceClient;
  }
  get genericService() {
    if (!this.genericServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.genericServiceClient;
  }
  get gripperService() {
    if (!this.gripperServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.gripperServiceClient;
  }
  get movementSensorService() {
    if (!this.movementSensorServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.movementSensorServiceClient;
  }
  get powerSensorService() {
    if (!this.powerSensorServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.powerSensorServiceClient;
  }
  get inputControllerService() {
    if (!this.inputControllerServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.inputControllerServiceClient;
  }
  get motorService() {
    if (!this.motorServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.motorServiceClient;
  }
  get navigationService() {
    if (!this.navigationServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.navigationServiceClient;
  }
  get motionService() {
    if (!this.motionServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.motionServiceClient;
  }
  get visionService() {
    if (!this.visionServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.visionServiceClient;
  }
  get servoService() {
    if (!this.servoServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.servoServiceClient;
  }
  get slamService() {
    if (!this.slamServiceClient)
      throw new Error(q.notConnectedYetStr);
    return this.slamServiceClient;
  }
  createServiceClient(e) {
    const n = this.sessionOptions?.disabled ? this.transport : this.sessionManager.transport;
    if (!n)
      throw new Error(q.notConnectedYetStr);
    return P(e, n);
  }
  get peerConnection() {
    return this.peerConn;
  }
  async disconnect() {
    for (this.emit(te.DISCONNECTING, {}); this.connecting; )
      await this.connecting;
    this.peerConn && (this.peerConn.close(), this.peerConn = void 0), this.sessionManager.reset(), this.closed = !0, this.emit(te.DISCONNECTED, {});
  }
  isConnected() {
    return this.peerConn?.iceConnectionState === "connected";
  }
  // TODO(RSDK-7672): refactor due to cognitive complexity
  // eslint-disable-next-line sonarjs/cognitive-complexity
  async connect({
    creds: e = this.savedCreds,
    priority: n,
    dialTimeout: a
  } = {}) {
    if (this.emit(te.CONNECTING, {}), this.closed = !1, this.connecting) {
      for (; this.connecting !== void 0; )
        await this.connecting;
      return;
    }
    this.connecting = new Promise((s) => {
      this.connectResolve = s;
    }), this.peerConn && (this.peerConn.close(), this.peerConn = void 0), this.sessionManager.reset();
    try {
      const s = {
        webrtcOptions: {
          disableTrickleICE: !1,
          rtcConfig: this.webrtcOptions?.rtcConfig
        },
        dialTimeout: a ?? da,
        extraHeaders: Bt
      };
      if (e && (Sn(e) ? s.credentials = e : s.accessToken = e.payload), n !== void 0 && s.webrtcOptions && (s.webrtcOptions.additionalSdpFields = { "x-priority": n }), this.savedCreds = e, this.webrtcOptions?.enabled) {
        s.webrtcOptions && (s.webrtcOptions.signalingCredentials = s.credentials);
        const r = await Yv(
          this.webrtcOptions.signalingAddress || this.serviceHost,
          this.webrtcOptions.host,
          s
        );
        this.peerConn = r.peerConnection, this.peerConn.addEventListener("iceconnectionstatechange", () => {
          this.peerConn?.iceConnectionState === "connected" ? this.emit(te.CONNECTED, {}) : this.peerConn?.iceConnectionState === "closed" && this.onDisconnect();
        }), r.dataChannel.addEventListener("close", (c) => {
          this.onDisconnect(c);
        }), this.transport = r.transport, r.peerConnection.addEventListener("track", (c) => {
          const [d] = c.streams;
          if (!d)
            throw this.emit("track", c), new Error("expected event stream to exist");
          const l = d.id.replaceAll("+", ":");
          Object.defineProperty(d, "id", {
            value: l
          }), this.emit("track", c);
        });
      } else
        this.transport = await hn(this.serviceHost, s), await this.gRPCConnectionManager.start();
      const i = this.sessionOptions?.disabled ? this.transport : this.sessionManager.transport;
      this.robotServiceClient = P(
        Ss,
        i
      ), this.armServiceClient = P(sm, i), this.baseServiceClient = P(
        um,
        i
      ), this.boardServiceClient = P(
        bm,
        i
      ), this.encoderServiceClient = P(
        Om,
        i
      ), this.gantryServiceClient = P(
        Um,
        i
      ), this.genericServiceClient = P(
        Ya,
        i
      ), this.gripperServiceClient = P(
        Fm,
        i
      ), this.movementSensorServiceClient = P(
        Tc,
        i
      ), this.powerSensorServiceClient = P(
        hc,
        i
      ), this.inputControllerServiceClient = P(
        Hm,
        i
      ), this.motorServiceClient = P(
        ic,
        i
      ), this.navigationServiceClient = P(
        tl,
        i
      ), this.motionServiceClient = P(
        zc,
        i
      ), this.visionServiceClient = P(
        Ol,
        i
      ), this.servoServiceClient = P(
        wc,
        i
      ), this.slamServiceClient = P(
        ll,
        i
      ), this.emit(te.CONNECTED, {});
    } catch (s) {
      throw this.emit(te.DISCONNECTED, {}), s;
    } finally {
      this.connectResolve?.(), this.connectResolve = void 0, this.connecting = void 0;
    }
  }
  // SESSIONS
  async getSessions() {
    return (await this.robotService.getSessions({})).sessions;
  }
  // OPERATIONS
  async getOperations() {
    return (await this.robotService.getOperations({})).operations;
  }
  async cancelOperation(e) {
    await this.robotService.cancelOperation({ id: e });
  }
  async blockForOperation(e) {
    await this.robotService.blockForOperation({ id: e });
  }
  async stopAll() {
    await this.robotService.stopAll({});
  }
  // FRAME SYSTEM
  async frameSystemConfig(e) {
    return (await this.robotService.frameSystemConfig({
      supplementalTransforms: e
    })).frameSystemConfigs;
  }
  async transformPose(e, n, a) {
    const s = new jt({
      source: e,
      destination: n,
      supplementalTransforms: a
    }), r = (await this.robotService.transformPose(s)).pose;
    if (!r)
      throw new Error("no pose");
    return r;
  }
  async transformPCD(e, n, a) {
    const s = new Ht({
      pointCloudPcd: e,
      source: n,
      destination: a
    });
    return (await this.robotService.transformPCD(s)).pointCloudPcd;
  }
  // DISCOVERY
  async discoverComponents(e) {
    return (await this.robotService.discoverComponents({
      queries: e
    })).discovery;
  }
  // GET CLOUD METADATA
  async getCloudMetadata() {
    return this.robotService.getCloudMetadata({});
  }
  // RESOURCES
  async resourceNames() {
    return (await this.robotService.resourceNames({})).resources;
  }
  async resourceRPCSubtypes() {
    return (await this.robotService.resourceRPCSubtypes({})).resourceRpcSubtypes;
  }
  // MODULES
  async restartModule(e, n) {
    const a = new na();
    e !== void 0 && (a.idOrName.case = "moduleId", a.idOrName.value = e), n !== void 0 && (a.idOrName.case = "moduleName", a.idOrName.value = n), await this.robotService.restartModule(a);
  }
}
const Xo = (t) => !!(t > 0 && Number.isInteger(t)), vh = (t) => t.includes("local"), Qo = async (t) => {
  if (console.debug("dialing via gRPC..."), !vh(t.host))
    throw new Error(
      `cannot dial "${t.host}" directly, please use a local url instead.`
    );
  const e = {
    noReconnect: t.noReconnect,
    reconnectMaxWait: t.reconnectMaxWait,
    reconnectMaxAttempts: t.reconnectMaxAttempts
  };
  let n;
  t.disableSessions && (n = { disabled: !0 });
  const a = new q(t.host, void 0, n, e);
  return await a.connect({
    creds: t.credentials,
    dialTimeout: t.dialTimeout ?? da
  }), console.debug("connected via gRPC"), a;
}, Zo = async (t) => {
  console.debug("dialing via WebRTC...");
  const e = t.serviceHost ?? t.host, { signalingAddress: n } = t, s = { iceServers: t.iceServers ?? [] }, i = {
    enabled: !0,
    host: t.host,
    signalingAddress: n,
    rtcConfig: s,
    noReconnect: t.noReconnect,
    reconnectMaxWait: t.reconnectMaxWait,
    reconnectMaxAttempts: t.reconnectMaxAttempts
  };
  let r;
  t.disableSessions && (r = { disabled: !0 });
  const c = new q(e, i, r);
  return await c.connect({
    priority: t.priority,
    dialTimeout: t.dialTimeout ?? da,
    creds: t.credentials
  }), console.debug("connected via WebRTC"), c;
}, hh = (t) => {
  const e = t;
  return typeof e.signalingAddress != "string" ? !1 : !e.iceServers || Array.isArray(e.iceServers);
}, fh = async (t) => {
  Rh(t);
  const e = {
    retry: (n, a) => (console.debug(
      `Failed to connect, attempt ${a} with backoff`,
      n
    ), !t.reconnectAbortSignal?.abort)
  };
  if (t.reconnectMaxWait !== void 0 && (e.maxDelay = t.reconnectMaxWait), t.reconnectMaxAttempts !== void 0 && (e.numOfAttempts = t.reconnectMaxAttempts), hh(t) && !t.reconnectAbortSignal?.abort)
    try {
      return t.noReconnect ? await Zo(t) : await Pt(async () => Zo(t), e);
    } catch {
      console.debug("Failed to connect via WebRTC");
    }
  if (!t.reconnectAbortSignal?.abort)
    try {
      return t.noReconnect ? await Qo(t) : await Pt(async () => Qo(t), e);
    } catch {
      console.debug("Failed to connect via gRPC");
    }
  throw new Error("Failed to connect to robot");
}, Rh = (t) => {
  if (t.credentials && Sn(t.credentials))
    try {
      t.credentials.authEntity = new URL(t.credentials.authEntity).host;
    } catch (e) {
      if (!(e instanceof TypeError))
        throw e;
    }
  if (t.reconnectMaxAttempts !== void 0 && !Xo(t.reconnectMaxAttempts))
    throw new Error(
      `Value of max reconnect attempts (${t.reconnectMaxAttempts}) should be a positive integer`
    );
  if (t.reconnectMaxWait !== void 0 && !Xo(t.reconnectMaxWait))
    throw new Error(
      `Value of max reconnect wait (${t.reconnectMaxWait}) should be a positive integer`
    );
}, bn = /* @__PURE__ */ o.makeEnum(
  "viam.app.mltraining.v1.ModelType",
  [
    { no: 0, name: "MODEL_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "MODEL_TYPE_SINGLE_LABEL_CLASSIFICATION", localName: "SINGLE_LABEL_CLASSIFICATION" },
    { no: 2, name: "MODEL_TYPE_MULTI_LABEL_CLASSIFICATION", localName: "MULTI_LABEL_CLASSIFICATION" },
    { no: 3, name: "MODEL_TYPE_OBJECT_DETECTION", localName: "OBJECT_DETECTION" }
  ]
), ut = /* @__PURE__ */ o.makeEnum(
  "viam.app.mltraining.v1.ModelFramework",
  [
    { no: 0, name: "MODEL_FRAMEWORK_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "MODEL_FRAMEWORK_TFLITE", localName: "TFLITE" },
    { no: 2, name: "MODEL_FRAMEWORK_TENSORFLOW", localName: "TENSORFLOW" },
    { no: 3, name: "MODEL_FRAMEWORK_PYTORCH", localName: "PYTORCH" },
    { no: 4, name: "MODEL_FRAMEWORK_ONNX", localName: "ONNX" }
  ]
), ao = /* @__PURE__ */ o.makeEnum(
  "viam.app.mltraining.v1.TrainingStatus",
  [
    { no: 0, name: "TRAINING_STATUS_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "TRAINING_STATUS_PENDING", localName: "PENDING" },
    { no: 2, name: "TRAINING_STATUS_IN_PROGRESS", localName: "IN_PROGRESS" },
    { no: 3, name: "TRAINING_STATUS_COMPLETED", localName: "COMPLETED" },
    { no: 4, name: "TRAINING_STATUS_FAILED", localName: "FAILED" },
    { no: 5, name: "TRAINING_STATUS_CANCELED", localName: "CANCELED" },
    { no: 6, name: "TRAINING_STATUS_CANCELING", localName: "CANCELING" }
  ]
), Nl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.SubmitTrainingJobRequest",
  () => [
    {
      no: 7,
      name: "dataset_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "model_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "model_version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "model_type", kind: "enum", T: o.getEnumType(bn) },
    { no: 6, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), Cl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.SubmitTrainingJobResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Pl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.SubmitCustomTrainingJobRequest",
  () => [
    {
      no: 1,
      name: "dataset_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "registry_item_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "registry_item_version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "model_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "model_version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 7, name: "arguments", kind: "map", K: 9, V: {
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    } }
  ]
), Dl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.SubmitCustomTrainingJobResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ql = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.GetTrainingJobRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Al = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.GetTrainingJobResponse",
  () => [
    { no: 1, name: "metadata", kind: "message", T: so }
  ]
), Ul = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.ListTrainingJobsRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "status", kind: "enum", T: o.getEnumType(ao) }
  ]
), Gl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.ListTrainingJobsResponse",
  () => [
    { no: 1, name: "jobs", kind: "message", T: so, repeated: !0 }
  ]
), so = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.TrainingJobMetadata",
  () => [
    {
      no: 7,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 11,
      name: "dataset_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 12,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 13,
      name: "model_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 14,
      name: "model_version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 15, name: "model_type", kind: "enum", T: o.getEnumType(bn) },
    { no: 17, name: "model_framework", kind: "enum", T: o.getEnumType(ut) },
    {
      no: 18,
      name: "is_custom_job",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 19,
      name: "registry_item_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 20,
      name: "registry_item_version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "status", kind: "enum", T: o.getEnumType(ao) },
    { no: 8, name: "error_status", kind: "message", T: nn },
    { no: 3, name: "created_on", kind: "message", T: I },
    { no: 4, name: "last_modified", kind: "message", T: I },
    { no: 9, name: "training_started", kind: "message", T: I },
    { no: 10, name: "training_ended", kind: "message", T: I },
    {
      no: 5,
      name: "synced_model_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 16, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), Ll = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.CancelTrainingJobRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Bl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.CancelTrainingJobResponse",
  []
), xl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.DeleteCompletedTrainingJobRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Fl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.DeleteCompletedTrainingJobResponse",
  []
), Jl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.TrainingJobLogEntry",
  () => [
    {
      no: 1,
      name: "level",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "time", kind: "message", T: I },
    {
      no: 3,
      name: "message",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), zl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.GetTrainingJobLogsRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "page_token", kind: "scalar", T: 9, opt: !0 }
  ]
), $l = /* @__PURE__ */ o.makeMessageType(
  "viam.app.mltraining.v1.GetTrainingJobLogsResponse",
  () => [
    { no: 1, name: "logs", kind: "message", T: Jl, repeated: !0 },
    {
      no: 2,
      name: "next_page_token",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), If = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CancelTrainingJobRequest: Ll,
  CancelTrainingJobResponse: Bl,
  DeleteCompletedTrainingJobRequest: xl,
  DeleteCompletedTrainingJobResponse: Fl,
  GetTrainingJobLogsRequest: zl,
  GetTrainingJobLogsResponse: $l,
  GetTrainingJobRequest: ql,
  GetTrainingJobResponse: Al,
  ListTrainingJobsRequest: Ul,
  ListTrainingJobsResponse: Gl,
  ModelFramework: ut,
  ModelType: bn,
  SubmitCustomTrainingJobRequest: Pl,
  SubmitCustomTrainingJobResponse: Dl,
  SubmitTrainingJobRequest: Nl,
  SubmitTrainingJobResponse: Cl,
  TrainingJobLogEntry: Jl,
  TrainingJobMetadata: so,
  TrainingStatus: ao
}, Symbol.toStringTag, { value: "Module" })), pt = /* @__PURE__ */ o.makeEnum(
  "viam.app.packages.v1.PackageType",
  [
    { no: 0, name: "PACKAGE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "PACKAGE_TYPE_ARCHIVE", localName: "ARCHIVE" },
    { no: 2, name: "PACKAGE_TYPE_ML_MODEL", localName: "ML_MODEL" },
    { no: 3, name: "PACKAGE_TYPE_MODULE", localName: "MODULE" },
    { no: 4, name: "PACKAGE_TYPE_SLAM_MAP", localName: "SLAM_MAP" },
    { no: 5, name: "PACKAGE_TYPE_ML_TRAINING", localName: "ML_TRAINING" }
  ]
), Yl = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.AuthenticationType",
  [
    { no: 0, name: "AUTHENTICATION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "AUTHENTICATION_TYPE_WEB_OAUTH", localName: "WEB_OAUTH" },
    { no: 2, name: "AUTHENTICATION_TYPE_API_KEY", localName: "API_KEY" },
    { no: 3, name: "AUTHENTICATION_TYPE_ROBOT_PART_SECRET", localName: "ROBOT_PART_SECRET" },
    { no: 4, name: "AUTHENTICATION_TYPE_LOCATION_SECRET", localName: "LOCATION_SECRET" }
  ]
), _n = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.FragmentVisibility",
  [
    { no: 0, name: "FRAGMENT_VISIBILITY_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "FRAGMENT_VISIBILITY_PRIVATE", localName: "PRIVATE" },
    { no: 2, name: "FRAGMENT_VISIBILITY_PUBLIC", localName: "PUBLIC" },
    { no: 3, name: "FRAGMENT_VISIBILITY_PUBLIC_UNLISTED", localName: "PUBLIC_UNLISTED" }
  ]
), Wl = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.FragmentErrorType",
  [
    { no: 0, name: "FRAGMENT_ERROR_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "FRAGMENT_ERROR_TYPE_NO_ACCESS", localName: "NO_ACCESS" },
    { no: 2, name: "FRAGMENT_ERROR_TYPE_NESTING_LIMIT_EXCEEDED", localName: "NESTING_LIMIT_EXCEEDED" },
    { no: 3, name: "FRAGMENT_ERROR_TYPE_CHILD_ID_INVALID", localName: "CHILD_ID_INVALID" },
    { no: 4, name: "FRAGMENT_ERROR_TYPE_CYCLE_DETECTED", localName: "CYCLE_DETECTED" }
  ]
), Vl = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.RegistryItemStatus",
  [
    { no: 0, name: "REGISTRY_ITEM_STATUS_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "REGISTRY_ITEM_STATUS_PUBLISHED", localName: "PUBLISHED" },
    { no: 2, name: "REGISTRY_ITEM_STATUS_IN_DEVELOPMENT", localName: "IN_DEVELOPMENT" }
  ]
), an = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.Visibility",
  [
    { no: 0, name: "VISIBILITY_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "VISIBILITY_PRIVATE", localName: "PRIVATE" },
    { no: 2, name: "VISIBILITY_PUBLIC", localName: "PUBLIC" },
    { no: 3, name: "VISIBILITY_PUBLIC_UNLISTED", localName: "PUBLIC_UNLISTED" }
  ]
), jl = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.ClientAuthentication",
  [
    { no: 0, name: "CLIENT_AUTHENTICATION_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "CLIENT_AUTHENTICATION_REQUIRED", localName: "REQUIRED" },
    { no: 2, name: "CLIENT_AUTHENTICATION_NOT_REQUIRED", localName: "NOT_REQUIRED" },
    { no: 3, name: "CLIENT_AUTHENTICATION_NOT_REQUIRED_WHEN_USING_PKCE", localName: "NOT_REQUIRED_WHEN_USING_PKCE" }
  ]
), Hl = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.PKCE",
  [
    { no: 0, name: "PKCE_UNSPECIFIED" },
    { no: 1, name: "PKCE_REQUIRED" },
    { no: 2, name: "PKCE_NOT_REQUIRED" },
    { no: 3, name: "PKCE_NOT_REQUIRED_WHEN_USING_CLIENT_AUTHENTICATION" }
  ]
), Kl = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.URLValidation",
  [
    { no: 0, name: "URL_VALIDATION_UNSPECIFIED" },
    { no: 1, name: "URL_VALIDATION_EXACT_MATCH" },
    { no: 2, name: "URL_VALIDATION_ALLOW_WILDCARDS" }
  ]
), Xl = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.EnabledGrant",
  [
    { no: 0, name: "ENABLED_GRANT_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "ENABLED_GRANT_AUTHORIZATION_CODE", localName: "AUTHORIZATION_CODE" },
    { no: 2, name: "ENABLED_GRANT_IMPLICIT", localName: "IMPLICIT" },
    { no: 3, name: "ENABLED_GRANT_PASSWORD", localName: "PASSWORD" },
    { no: 4, name: "ENABLED_GRANT_REFRESH_TOKEN", localName: "REFRESH_TOKEN" },
    { no: 5, name: "ENABLED_GRANT_DEVICE_CODE", localName: "DEVICE_CODE" }
  ]
), gt = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Robot",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "location",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "last_access", kind: "message", T: I },
    { no: 5, name: "created_on", kind: "message", T: I }
  ]
), sn = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RobotPart",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 10,
      name: "dns_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "secret",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "robot",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 12,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "robot_config", kind: "message", T: u },
    { no: 6, name: "last_access", kind: "message", T: I },
    { no: 7, name: "user_supplied_info", kind: "message", T: u },
    {
      no: 8,
      name: "main_part",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 9,
      name: "fqdn",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 11,
      name: "local_fqdn",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 13, name: "created_on", kind: "message", T: I },
    { no: 14, name: "secrets", kind: "message", T: io, repeated: !0 },
    { no: 15, name: "last_updated", kind: "message", T: I }
  ]
), Ql = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RobotPartHistoryEntry",
  () => [
    {
      no: 1,
      name: "part",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "robot",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "when", kind: "message", T: I },
    { no: 4, name: "old", kind: "message", T: sn },
    { no: 5, name: "edited_by", kind: "message", T: oo }
  ]
), oo = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.AuthenticatorInfo",
  () => [
    { no: 1, name: "type", kind: "enum", T: o.getEnumType(Yl) },
    {
      no: 2,
      name: "value",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "is_deactivated",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), Zl = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOrganizationsRequest",
  []
), En = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Organization",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "created_on", kind: "message", T: I },
    {
      no: 4,
      name: "public_namespace",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "default_region",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 6, name: "cid", kind: "scalar", T: 9, opt: !0 }
  ]
), ed = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationMember",
  () => [
    {
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "emails", kind: "scalar", T: 9, repeated: !0 },
    { no: 3, name: "date_added", kind: "message", T: I },
    { no: 4, name: "last_login", kind: "message", T: I, opt: !0 }
  ]
), nd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOrganizationsResponse",
  () => [
    { no: 1, name: "organizations", kind: "message", T: En, repeated: !0 }
  ]
), Mn = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationInvite",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "created_on", kind: "message", T: I },
    { no: 4, name: "authorizations", kind: "message", T: Q, repeated: !0 }
  ]
), td = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateOrganizationRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ad = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateOrganizationResponse",
  () => [
    { no: 1, name: "organization", kind: "message", T: En }
  ]
), sd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrganizationRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), od = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrganizationResponse",
  () => [
    { no: 1, name: "organization", kind: "message", T: En }
  ]
), id = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrganizationNamespaceAvailabilityRequest",
  () => [
    {
      no: 1,
      name: "public_namespace",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), rd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrganizationNamespaceAvailabilityResponse",
  () => [
    {
      no: 1,
      name: "available",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), md = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateOrganizationRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "public_namespace", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "region", kind: "scalar", T: 9, opt: !0 },
    { no: 5, name: "cid", kind: "scalar", T: 9, opt: !0 }
  ]
), cd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateOrganizationResponse",
  () => [
    { no: 1, name: "organization", kind: "message", T: En }
  ]
), ld = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOrganizationRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), dd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOrganizationResponse",
  []
), ud = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOrganizationMembersRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), pd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOrganizationMembersResponse",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "members", kind: "message", T: ed, repeated: !0 },
    { no: 3, name: "invites", kind: "message", T: Mn, repeated: !0 }
  ]
), gd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateOrganizationInviteRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "authorizations", kind: "message", T: Q, repeated: !0 },
    { no: 4, name: "send_email_invite", kind: "scalar", T: 8, opt: !0 }
  ]
), Td = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateOrganizationInviteResponse",
  () => [
    { no: 1, name: "invite", kind: "message", T: Mn }
  ]
), kd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateOrganizationInviteAuthorizationsRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "add_authorizations", kind: "message", T: Q, repeated: !0 },
    { no: 4, name: "remove_authorizations", kind: "message", T: Q, repeated: !0 }
  ]
), yd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateOrganizationInviteAuthorizationsResponse",
  () => [
    { no: 1, name: "invite", kind: "message", T: Mn }
  ]
), vd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOrganizationInviteRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), hd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOrganizationInviteResponse",
  []
), fd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ResendOrganizationInviteRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Rd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ResendOrganizationInviteResponse",
  () => [
    { no: 1, name: "invite", kind: "message", T: Mn }
  ]
), Id = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOrganizationMemberRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "user_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Sd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOrganizationMemberResponse",
  []
), Tt = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.BillingAddress",
  () => [
    {
      no: 1,
      name: "address_line_1",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "address_line_2", kind: "scalar", T: 9, opt: !0 },
    {
      no: 3,
      name: "city",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "state",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "zipcode",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), wd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.EnableBillingServiceRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "billing_address", kind: "message", T: Tt }
  ]
), bd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.EnableBillingServiceResponse",
  []
), _d = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateBillingServiceRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "billing_address", kind: "message", T: Tt }
  ]
), Ed = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateBillingServiceResponse",
  []
), Md = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetBillingServiceConfigRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Od = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetBillingServiceConfigResponse",
  () => [
    { no: 1, name: "billing_address", kind: "message", T: Tt },
    {
      no: 2,
      name: "support_email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "logo_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "billing_dashboard_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Nd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DisableBillingServiceRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Cd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DisableBillingServiceResponse",
  []
), Pd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationSetSupportEmailRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Dd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationSetSupportEmailResponse",
  []
), qd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationGetSupportEmailRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ad = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationGetSupportEmailResponse",
  () => [
    {
      no: 1,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ud = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationIdentity",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Gd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.LocationOrganization",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "primary",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), kt = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.LocationAuth",
  () => [
    {
      no: 1,
      name: "secret",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "secrets", kind: "message", T: io, repeated: !0 }
  ]
), Ld = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.StorageConfig",
  () => [
    {
      no: 1,
      name: "region",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), On = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Location",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "parent_location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "auth", kind: "message", T: kt },
    { no: 6, name: "organizations", kind: "message", T: Gd, repeated: !0 },
    { no: 3, name: "created_on", kind: "message", T: I },
    {
      no: 7,
      name: "robot_count",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 8, name: "config", kind: "message", T: Ld }
  ]
), io = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.SharedSecret",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "secret",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "created_on", kind: "message", T: I },
    { no: 4, name: "state", kind: "enum", T: o.getEnumType(ro) }
  ]
), ro = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.SharedSecret.State",
  [
    { no: 0, name: "STATE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "STATE_ENABLED", localName: "ENABLED" },
    { no: 2, name: "STATE_DISABLED", localName: "DISABLED" }
  ]
), Bd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateLocationRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "parent_location_id", kind: "scalar", T: 9, opt: !0 }
  ]
), xd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateLocationResponse",
  () => [
    { no: 1, name: "location", kind: "message", T: On }
  ]
), Fd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetLocationRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Jd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetLocationResponse",
  () => [
    { no: 1, name: "location", kind: "message", T: On }
  ]
), zd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateLocationRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "parent_location_id", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "region", kind: "scalar", T: 9, opt: !0 }
  ]
), $d = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateLocationResponse",
  () => [
    { no: 1, name: "location", kind: "message", T: On }
  ]
), Yd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteLocationRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Wd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteLocationResponse",
  []
), Vd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrganizationsWithAccessToLocationRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), jd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrganizationsWithAccessToLocationResponse",
  () => [
    { no: 1, name: "organization_identities", kind: "message", T: Ud, repeated: !0 }
  ]
), Hd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListLocationsRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Kd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ShareLocationRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Xd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ShareLocationResponse",
  []
), Qd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UnshareLocationRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Zd = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UnshareLocationResponse",
  []
), eu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListLocationsResponse",
  () => [
    { no: 1, name: "locations", kind: "message", T: On, repeated: !0 }
  ]
), nu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateLocationSecretRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), tu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateLocationSecretResponse",
  () => [
    { no: 1, name: "auth", kind: "message", T: kt }
  ]
), au = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteLocationSecretRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "secret_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), su = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteLocationSecretResponse",
  []
), ou = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.LocationAuthRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), iu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.LocationAuthResponse",
  () => [
    { no: 1, name: "auth", kind: "message", T: kt }
  ]
), ru = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), mu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRoverRentalRobotsRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), cu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RoverRentalRobot",
  () => [
    {
      no: 1,
      name: "robot_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "robot_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "robot_main_part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), lu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRoverRentalRobotsResponse",
  () => [
    { no: 1, name: "robots", kind: "message", T: cu, repeated: !0 }
  ]
), du = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotResponse",
  () => [
    { no: 1, name: "robot", kind: "message", T: gt }
  ]
), uu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartsRequest",
  () => [
    {
      no: 1,
      name: "robot_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), pu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartsResponse",
  () => [
    { no: 1, name: "parts", kind: "message", T: sn, repeated: !0 }
  ]
), gu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Tu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartResponse",
  () => [
    { no: 1, name: "part", kind: "message", T: sn },
    {
      no: 2,
      name: "config_json",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ku = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartLogsRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "errors_only",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 3, name: "filter", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "page_token", kind: "scalar", T: 9, opt: !0 },
    { no: 5, name: "levels", kind: "scalar", T: 9, repeated: !0 },
    { no: 6, name: "start", kind: "message", T: I, opt: !0 },
    { no: 7, name: "end", kind: "message", T: I, opt: !0 },
    { no: 8, name: "limit", kind: "scalar", T: 3, opt: !0 },
    { no: 9, name: "source", kind: "scalar", T: 9, opt: !0 }
  ]
), yu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartLogsResponse",
  () => [
    { no: 1, name: "logs", kind: "message", T: ot, repeated: !0 },
    {
      no: 2,
      name: "next_page_token",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), vu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.TailRobotPartLogsRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "errors_only",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 3, name: "filter", kind: "scalar", T: 9, opt: !0 }
  ]
), hu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.TailRobotPartLogsResponse",
  () => [
    { no: 1, name: "logs", kind: "message", T: ot, repeated: !0 }
  ]
), fu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartHistoryRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ru = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotPartHistoryResponse",
  () => [
    { no: 1, name: "history", kind: "message", T: Ql, repeated: !0 }
  ]
), Iu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateRobotPartRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "robot_config", kind: "message", T: u }
  ]
), Su = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateRobotPartResponse",
  () => [
    { no: 1, name: "part", kind: "message", T: sn }
  ]
), wu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.NewRobotPartRequest",
  () => [
    {
      no: 1,
      name: "robot_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "part_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), bu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.NewRobotPartResponse",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), _u = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRobotPartRequest",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Eu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotAPIKeysRequest",
  () => [
    {
      no: 1,
      name: "robot_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Mu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.APIKey",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "key",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "created_on", kind: "message", T: I }
  ]
), Ou = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRobotAPIKeysResponse",
  () => [
    { no: 1, name: "api_keys", kind: "message", T: go, repeated: !0 }
  ]
), Nu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRobotPartResponse",
  []
), Ve = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Fragment",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "fragment", kind: "message", T: u },
    {
      no: 4,
      name: "organization_owner",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "public",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 6, name: "created_on", kind: "message", T: I },
    {
      no: 7,
      name: "organization_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 9,
      name: "robot_part_count",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 10,
      name: "organization_count",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 11,
      name: "only_used_by_owner",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 12, name: "visibility", kind: "enum", T: o.getEnumType(_n) },
    { no: 13, name: "last_updated", kind: "message", T: I }
  ]
), Cu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.FragmentHistoryEntry",
  () => [
    {
      no: 1,
      name: "fragment",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "edited_on", kind: "message", T: I },
    { no: 3, name: "old", kind: "message", T: Ve },
    { no: 4, name: "edited_by", kind: "message", T: oo }
  ]
), Pu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.FragmentError",
  () => [
    { no: 1, name: "error_type", kind: "enum", T: o.getEnumType(Wl) },
    {
      no: 2,
      name: "fragment_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "detail",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), mo = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.FragmentUsage",
  () => [
    {
      no: 1,
      name: "fragment_id",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 2,
      name: "organizations",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 3,
      name: "machines",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "machines_in_current_org",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]
), Du = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ResolvedFragment",
  () => [
    {
      no: 1,
      name: "fragment_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "resolved_config", kind: "message", T: u },
    { no: 3, name: "error", kind: "message", T: Pu }
  ]
), qu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListFragmentsRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "show_public",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 3, name: "fragment_visibility", kind: "enum", T: o.getEnumType(_n), repeated: !0 }
  ]
), Au = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListFragmentsResponse",
  () => [
    { no: 1, name: "fragments", kind: "message", T: Ve, repeated: !0 },
    { no: 2, name: "fragment_usages", kind: "message", T: mo, repeated: !0 }
  ]
), Uu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetFragmentRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "current_organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Gu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetFragmentResponse",
  () => [
    { no: 1, name: "fragment", kind: "message", T: Ve },
    { no: 2, name: "fragment_usage", kind: "message", T: mo }
  ]
), Lu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateFragmentRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "config", kind: "message", T: u },
    {
      no: 3,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "visibility", kind: "enum", T: o.getEnumType(_n), opt: !0 }
  ]
), Bu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateFragmentResponse",
  () => [
    { no: 1, name: "fragment", kind: "message", T: Ve }
  ]
), xu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateFragmentRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "config", kind: "message", T: u },
    { no: 4, name: "public", kind: "scalar", T: 8, opt: !0 },
    { no: 5, name: "visibility", kind: "enum", T: o.getEnumType(_n), opt: !0 }
  ]
), Fu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateFragmentResponse",
  () => [
    { no: 1, name: "fragment", kind: "message", T: Ve }
  ]
), Ju = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteFragmentRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), zu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteFragmentResponse",
  []
), $u = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetFragmentHistoryRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "page_token", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "page_limit", kind: "scalar", T: 3, opt: !0 }
  ]
), Yu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetFragmentHistoryResponse",
  () => [
    { no: 1, name: "history", kind: "message", T: Cu, repeated: !0 },
    {
      no: 2,
      name: "next_page_token",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Wu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListRobotsRequest",
  () => [
    {
      no: 1,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Vu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListMachineFragmentsRequest",
  () => [
    {
      no: 1,
      name: "machine_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "additional_fragment_ids", kind: "scalar", T: 9, repeated: !0 }
  ]
), ju = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListMachineFragmentsResponse",
  () => [
    { no: 1, name: "fragments", kind: "message", T: Ve, repeated: !0 },
    { no: 2, name: "resolved_fragments", kind: "message", T: Du, repeated: !0 }
  ]
), Hu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListRobotsResponse",
  () => [
    { no: 1, name: "robots", kind: "message", T: gt, repeated: !0 }
  ]
), Ku = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.NewRobotRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "location",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Xu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.NewRobotResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Qu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateRobotRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "location",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Zu = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateRobotResponse",
  () => [
    { no: 1, name: "robot", kind: "message", T: gt }
  ]
), ep = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRobotRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), np = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRobotResponse",
  []
), tp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.MarkPartAsMainRequest",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ap = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.MarkPartAsMainResponse",
  []
), sp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.MarkPartForRestartRequest",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), op = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.MarkPartForRestartResponse",
  []
), ip = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateRobotPartSecretRequest",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), rp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateRobotPartSecretResponse",
  () => [
    { no: 1, name: "part", kind: "message", T: sn }
  ]
), mp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRobotPartSecretRequest",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "secret_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), cp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRobotPartSecretResponse",
  []
), Q = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Authorization",
  () => [
    {
      no: 1,
      name: "authorization_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "authorization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "resource_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "resource_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "identity_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "identity_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), lp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.AddRoleRequest",
  () => [
    { no: 1, name: "authorization", kind: "message", T: Q }
  ]
), dp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.AddRoleResponse",
  []
), up = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RemoveRoleRequest",
  () => [
    { no: 1, name: "authorization", kind: "message", T: Q }
  ]
), pp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RemoveRoleResponse",
  []
), gp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ChangeRoleRequest",
  () => [
    { no: 1, name: "old_authorization", kind: "message", T: Q },
    { no: 2, name: "new_authorization", kind: "message", T: Q }
  ]
), Tp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ChangeRoleResponse",
  []
), kp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListAuthorizationsRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "resource_ids", kind: "scalar", T: 9, repeated: !0 }
  ]
), yp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListAuthorizationsResponse",
  () => [
    { no: 1, name: "authorizations", kind: "message", T: Q, repeated: !0 }
  ]
), vp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CheckPermissionsRequest",
  () => [
    { no: 1, name: "permissions", kind: "message", T: co, repeated: !0 }
  ]
), co = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.AuthorizedPermissions",
  () => [
    {
      no: 1,
      name: "resource_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "resource_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "permissions", kind: "scalar", T: 9, repeated: !0 }
  ]
), hp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CheckPermissionsResponse",
  () => [
    { no: 1, name: "authorized_permissions", kind: "message", T: co, repeated: !0 }
  ]
), fp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ModuleVersion",
  () => [
    {
      no: 1,
      name: "version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "files", kind: "message", T: po, repeated: !0 },
    { no: 3, name: "models", kind: "message", T: on, repeated: !0 },
    {
      no: 4,
      name: "entrypoint",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "first_run", kind: "scalar", T: 9, opt: !0 }
  ]
), Rp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ModuleMetadata",
  () => [
    { no: 1, name: "models", kind: "message", T: on, repeated: !0 },
    { no: 2, name: "versions", kind: "message", T: fp, repeated: !0 },
    {
      no: 3,
      name: "entrypoint",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "first_run", kind: "scalar", T: 9, opt: !0 }
  ]
), Ip = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.MLModelMetadata",
  () => [
    { no: 1, name: "versions", kind: "scalar", T: 9, repeated: !0 },
    { no: 2, name: "model_type", kind: "enum", T: o.getEnumType(bn) },
    { no: 3, name: "model_framework", kind: "enum", T: o.getEnumType(ut) }
  ]
), Sp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.MLTrainingVersion",
  () => [
    {
      no: 1,
      name: "version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "created_on", kind: "message", T: I }
  ]
), wp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.MLTrainingMetadata",
  () => [
    { no: 5, name: "versions", kind: "message", T: Sp, repeated: !0 },
    { no: 2, name: "model_type", kind: "enum", T: o.getEnumType(bn) },
    { no: 3, name: "model_framework", kind: "enum", T: o.getEnumType(ut) },
    {
      no: 4,
      name: "draft",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), lo = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RegistryItem",
  () => [
    {
      no: 1,
      name: "item_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "public_namespace",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "type", kind: "enum", T: o.getEnumType(pt) },
    { no: 6, name: "visibility", kind: "enum", T: o.getEnumType(an) },
    {
      no: 7,
      name: "url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 8,
      name: "description",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 9,
      name: "total_robot_usage",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 13,
      name: "total_external_robot_usage",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 10,
      name: "total_organization_usage",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 14,
      name: "total_external_organization_usage",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    { no: 11, name: "module_metadata", kind: "message", T: Rp, oneof: "metadata" },
    { no: 12, name: "ml_model_metadata", kind: "message", T: Ip, oneof: "metadata" },
    { no: 18, name: "ml_training_metadata", kind: "message", T: wp, oneof: "metadata" },
    { no: 15, name: "created_at", kind: "message", T: I },
    { no: 16, name: "updated_at", kind: "message", T: I }
  ]
), bp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRegistryItemRequest",
  () => [
    {
      no: 1,
      name: "item_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), _p = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetRegistryItemResponse",
  () => [
    { no: 1, name: "item", kind: "message", T: lo }
  ]
), Ep = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateRegistryItemRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "type", kind: "enum", T: o.getEnumType(pt) }
  ]
), Mp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateRegistryItemResponse",
  []
), Op = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateRegistryItemRequest",
  () => [
    {
      no: 1,
      name: "item_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "type", kind: "enum", T: o.getEnumType(pt) },
    {
      no: 3,
      name: "description",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "visibility", kind: "enum", T: o.getEnumType(an) },
    { no: 5, name: "url", kind: "scalar", T: 9, opt: !0 }
  ]
), Np = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateRegistryItemResponse",
  []
), Cp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListRegistryItemsRequest",
  () => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "types", kind: "enum", T: o.getEnumType(pt), repeated: !0 },
    { no: 3, name: "visibilities", kind: "enum", T: o.getEnumType(an), repeated: !0 },
    { no: 4, name: "platforms", kind: "scalar", T: 9, repeated: !0 },
    { no: 5, name: "statuses", kind: "enum", T: o.getEnumType(Vl), repeated: !0 },
    { no: 6, name: "search_term", kind: "scalar", T: 9, opt: !0 },
    { no: 7, name: "page_token", kind: "scalar", T: 9, opt: !0 },
    { no: 8, name: "public_namespaces", kind: "scalar", T: 9, repeated: !0 }
  ]
), Pp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListRegistryItemsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: lo, repeated: !0 }
  ]
), Dp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRegistryItemRequest",
  () => [
    {
      no: 1,
      name: "item_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), qp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteRegistryItemResponse",
  []
), Ap = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.TransferRegistryItemRequest",
  () => [
    {
      no: 1,
      name: "item_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "new_public_namespace",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Up = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.TransferRegistryItemResponse",
  []
), Gp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateModuleRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Lp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateModuleResponse",
  () => [
    {
      no: 1,
      name: "module_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Bp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateModuleRequest",
  () => [
    {
      no: 1,
      name: "module_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "visibility", kind: "enum", T: o.getEnumType(an) },
    {
      no: 3,
      name: "url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "description",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "models", kind: "message", T: on, repeated: !0 },
    {
      no: 6,
      name: "entrypoint",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 7, name: "first_run", kind: "scalar", T: 9, opt: !0 }
  ]
), xp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateModuleResponse",
  () => [
    {
      no: 1,
      name: "url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), on = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Model",
  () => [
    {
      no: 1,
      name: "api",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "model",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Fp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ModuleFileInfo",
  () => [
    {
      no: 1,
      name: "module_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "platform",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "platform_tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), Jp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UploadModuleFileRequest",
  () => [
    { no: 1, name: "module_file_info", kind: "message", T: Fp, oneof: "module_file" },
    { no: 2, name: "file", kind: "scalar", T: 12, oneof: "module_file" }
  ]
), zp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UploadModuleFileResponse",
  () => [
    {
      no: 1,
      name: "url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), $p = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetModuleRequest",
  () => [
    {
      no: 1,
      name: "module_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Yp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetModuleResponse",
  () => [
    { no: 1, name: "module", kind: "message", T: uo }
  ]
), uo = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Module",
  () => [
    {
      no: 1,
      name: "module_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "visibility", kind: "enum", T: o.getEnumType(an) },
    { no: 4, name: "versions", kind: "message", T: Wp, repeated: !0 },
    {
      no: 5,
      name: "url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "description",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 7, name: "models", kind: "message", T: on, repeated: !0 },
    {
      no: 8,
      name: "total_robot_usage",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 9,
      name: "total_organization_usage",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 10,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 11,
      name: "entrypoint",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 12,
      name: "public_namespace",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 13, name: "first_run", kind: "scalar", T: 9, opt: !0 }
  ]
), Wp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.VersionHistory",
  () => [
    {
      no: 1,
      name: "version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "files", kind: "message", T: po, repeated: !0 },
    { no: 3, name: "models", kind: "message", T: on, repeated: !0 },
    {
      no: 4,
      name: "entrypoint",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "first_run", kind: "scalar", T: 9, opt: !0 }
  ]
), po = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.Uploads",
  () => [
    {
      no: 1,
      name: "platform",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "uploaded_at", kind: "message", T: I }
  ]
), Vp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListModulesRequest",
  () => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9, opt: !0 }
  ]
), jp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListModulesResponse",
  () => [
    { no: 1, name: "modules", kind: "message", T: uo, repeated: !0 }
  ]
), Hp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetUserIDByEmailRequest",
  () => [
    {
      no: 1,
      name: "email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Kp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetUserIDByEmailResponse",
  () => [
    {
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Xp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOrganizationsByUserRequest",
  () => [
    {
      no: 1,
      name: "user_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Qp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrgDetails",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "org_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Zp = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOrganizationsByUserResponse",
  () => [
    { no: 1, name: "orgs", kind: "message", T: Qp, repeated: !0 }
  ]
), eg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateKeyRequest",
  () => [
    { no: 1, name: "authorizations", kind: "message", T: Q, repeated: !0 },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ng = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateKeyResponse",
  () => [
    {
      no: 1,
      name: "key",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), tg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteKeyRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ag = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteKeyResponse",
  []
), sg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RenameKeyRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), og = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RenameKeyResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ig = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.AuthorizationDetails",
  () => [
    {
      no: 1,
      name: "authorization_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "authorization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "resource_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "resource_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), go = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.APIKeyWithAuthorizations",
  () => [
    { no: 1, name: "api_key", kind: "message", T: Mu },
    { no: 2, name: "authorizations", kind: "message", T: ig, repeated: !0 }
  ]
), rg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListKeysRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), mg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListKeysResponse",
  () => [
    { no: 1, name: "api_keys", kind: "message", T: go, repeated: !0 }
  ]
), cg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RotateKeyRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), lg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.RotateKeyResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "key",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), dg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateKeyFromExistingKeyAuthorizationsRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ug = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateKeyFromExistingKeyAuthorizationsResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "key",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), pg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationSetLogoRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "logo",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), gg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationSetLogoResponse",
  []
), Tg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationGetLogoRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), kg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OrganizationGetLogoResponse",
  () => [
    {
      no: 1,
      name: "url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), yg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.EnableAuthServiceRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), vg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.EnableAuthServiceResponse",
  []
), hg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DisableAuthServiceRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), fg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DisableAuthServiceResponse",
  []
), Rg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateOAuthAppRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "client_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "oauth_config", kind: "message", T: yt }
  ]
), Ig = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.CreateOAuthAppResponse",
  () => [
    {
      no: 1,
      name: "client_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "client_secret",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Sg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ReadOAuthAppRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "client_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), wg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ReadOAuthAppResponse",
  () => [
    {
      no: 1,
      name: "client_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "client_secret",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "oauth_config", kind: "message", T: yt }
  ]
), bg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateOAuthAppRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "client_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "client_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "oauth_config", kind: "message", T: yt }
  ]
), _g = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UpdateOAuthAppResponse",
  []
), Eg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOAuthAppRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "client_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Mg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.DeleteOAuthAppResponse",
  []
), Og = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOAuthAppsRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ng = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ListOAuthAppsResponse",
  () => [
    { no: 1, name: "client_ids", kind: "scalar", T: 9, repeated: !0 }
  ]
), yt = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.OAuthConfig",
  () => [
    { no: 1, name: "client_authentication", kind: "enum", T: o.getEnumType(jl) },
    { no: 2, name: "pkce", kind: "enum", T: o.getEnumType(Hl) },
    { no: 3, name: "url_validation", kind: "enum", T: o.getEnumType(Kl) },
    { no: 4, name: "origin_uris", kind: "scalar", T: 9, repeated: !0 },
    { no: 5, name: "redirect_uris", kind: "scalar", T: 9, repeated: !0 },
    {
      no: 6,
      name: "logout_uri",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 7, name: "enabled_grants", kind: "enum", T: o.getEnumType(Xl), repeated: !0 }
  ]
), Sf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  APIKey: Mu,
  APIKeyWithAuthorizations: go,
  AddRoleRequest: lp,
  AddRoleResponse: dp,
  AuthenticationType: Yl,
  AuthenticatorInfo: oo,
  Authorization: Q,
  AuthorizationDetails: ig,
  AuthorizedPermissions: co,
  BillingAddress: Tt,
  ChangeRoleRequest: gp,
  ChangeRoleResponse: Tp,
  CheckPermissionsRequest: vp,
  CheckPermissionsResponse: hp,
  ClientAuthentication: jl,
  CreateFragmentRequest: Lu,
  CreateFragmentResponse: Bu,
  CreateKeyFromExistingKeyAuthorizationsRequest: dg,
  CreateKeyFromExistingKeyAuthorizationsResponse: ug,
  CreateKeyRequest: eg,
  CreateKeyResponse: ng,
  CreateLocationRequest: Bd,
  CreateLocationResponse: xd,
  CreateLocationSecretRequest: nu,
  CreateLocationSecretResponse: tu,
  CreateModuleRequest: Gp,
  CreateModuleResponse: Lp,
  CreateOAuthAppRequest: Rg,
  CreateOAuthAppResponse: Ig,
  CreateOrganizationInviteRequest: gd,
  CreateOrganizationInviteResponse: Td,
  CreateOrganizationRequest: td,
  CreateOrganizationResponse: ad,
  CreateRegistryItemRequest: Ep,
  CreateRegistryItemResponse: Mp,
  CreateRobotPartSecretRequest: ip,
  CreateRobotPartSecretResponse: rp,
  DeleteFragmentRequest: Ju,
  DeleteFragmentResponse: zu,
  DeleteKeyRequest: tg,
  DeleteKeyResponse: ag,
  DeleteLocationRequest: Yd,
  DeleteLocationResponse: Wd,
  DeleteLocationSecretRequest: au,
  DeleteLocationSecretResponse: su,
  DeleteOAuthAppRequest: Eg,
  DeleteOAuthAppResponse: Mg,
  DeleteOrganizationInviteRequest: vd,
  DeleteOrganizationInviteResponse: hd,
  DeleteOrganizationMemberRequest: Id,
  DeleteOrganizationMemberResponse: Sd,
  DeleteOrganizationRequest: ld,
  DeleteOrganizationResponse: dd,
  DeleteRegistryItemRequest: Dp,
  DeleteRegistryItemResponse: qp,
  DeleteRobotPartRequest: _u,
  DeleteRobotPartResponse: Nu,
  DeleteRobotPartSecretRequest: mp,
  DeleteRobotPartSecretResponse: cp,
  DeleteRobotRequest: ep,
  DeleteRobotResponse: np,
  DisableAuthServiceRequest: hg,
  DisableAuthServiceResponse: fg,
  DisableBillingServiceRequest: Nd,
  DisableBillingServiceResponse: Cd,
  EnableAuthServiceRequest: yg,
  EnableAuthServiceResponse: vg,
  EnableBillingServiceRequest: wd,
  EnableBillingServiceResponse: bd,
  EnabledGrant: Xl,
  Fragment: Ve,
  FragmentError: Pu,
  FragmentErrorType: Wl,
  FragmentHistoryEntry: Cu,
  FragmentUsage: mo,
  FragmentVisibility: _n,
  GetBillingServiceConfigRequest: Md,
  GetBillingServiceConfigResponse: Od,
  GetFragmentHistoryRequest: $u,
  GetFragmentHistoryResponse: Yu,
  GetFragmentRequest: Uu,
  GetFragmentResponse: Gu,
  GetLocationRequest: Fd,
  GetLocationResponse: Jd,
  GetModuleRequest: $p,
  GetModuleResponse: Yp,
  GetOrganizationNamespaceAvailabilityRequest: id,
  GetOrganizationNamespaceAvailabilityResponse: rd,
  GetOrganizationRequest: sd,
  GetOrganizationResponse: od,
  GetOrganizationsWithAccessToLocationRequest: Vd,
  GetOrganizationsWithAccessToLocationResponse: jd,
  GetRegistryItemRequest: bp,
  GetRegistryItemResponse: _p,
  GetRobotAPIKeysRequest: Eu,
  GetRobotAPIKeysResponse: Ou,
  GetRobotPartHistoryRequest: fu,
  GetRobotPartHistoryResponse: Ru,
  GetRobotPartLogsRequest: ku,
  GetRobotPartLogsResponse: yu,
  GetRobotPartRequest: gu,
  GetRobotPartResponse: Tu,
  GetRobotPartsRequest: uu,
  GetRobotPartsResponse: pu,
  GetRobotRequest: ru,
  GetRobotResponse: du,
  GetRoverRentalRobotsRequest: mu,
  GetRoverRentalRobotsResponse: lu,
  GetUserIDByEmailRequest: Hp,
  GetUserIDByEmailResponse: Kp,
  ListAuthorizationsRequest: kp,
  ListAuthorizationsResponse: yp,
  ListFragmentsRequest: qu,
  ListFragmentsResponse: Au,
  ListKeysRequest: rg,
  ListKeysResponse: mg,
  ListLocationsRequest: Hd,
  ListLocationsResponse: eu,
  ListMachineFragmentsRequest: Vu,
  ListMachineFragmentsResponse: ju,
  ListModulesRequest: Vp,
  ListModulesResponse: jp,
  ListOAuthAppsRequest: Og,
  ListOAuthAppsResponse: Ng,
  ListOrganizationMembersRequest: ud,
  ListOrganizationMembersResponse: pd,
  ListOrganizationsByUserRequest: Xp,
  ListOrganizationsByUserResponse: Zp,
  ListOrganizationsRequest: Zl,
  ListOrganizationsResponse: nd,
  ListRegistryItemsRequest: Cp,
  ListRegistryItemsResponse: Pp,
  ListRobotsRequest: Wu,
  ListRobotsResponse: Hu,
  Location: On,
  LocationAuth: kt,
  LocationAuthRequest: ou,
  LocationAuthResponse: iu,
  LocationOrganization: Gd,
  MLModelMetadata: Ip,
  MLTrainingMetadata: wp,
  MLTrainingVersion: Sp,
  MarkPartAsMainRequest: tp,
  MarkPartAsMainResponse: ap,
  MarkPartForRestartRequest: sp,
  MarkPartForRestartResponse: op,
  Model: on,
  Module: uo,
  ModuleFileInfo: Fp,
  ModuleMetadata: Rp,
  ModuleVersion: fp,
  NewRobotPartRequest: wu,
  NewRobotPartResponse: bu,
  NewRobotRequest: Ku,
  NewRobotResponse: Xu,
  OAuthConfig: yt,
  OrgDetails: Qp,
  Organization: En,
  OrganizationGetLogoRequest: Tg,
  OrganizationGetLogoResponse: kg,
  OrganizationGetSupportEmailRequest: qd,
  OrganizationGetSupportEmailResponse: Ad,
  OrganizationIdentity: Ud,
  OrganizationInvite: Mn,
  OrganizationMember: ed,
  OrganizationSetLogoRequest: pg,
  OrganizationSetLogoResponse: gg,
  OrganizationSetSupportEmailRequest: Pd,
  OrganizationSetSupportEmailResponse: Dd,
  PKCE: Hl,
  ReadOAuthAppRequest: Sg,
  ReadOAuthAppResponse: wg,
  RegistryItem: lo,
  RegistryItemStatus: Vl,
  RemoveRoleRequest: up,
  RemoveRoleResponse: pp,
  RenameKeyRequest: sg,
  RenameKeyResponse: og,
  ResendOrganizationInviteRequest: fd,
  ResendOrganizationInviteResponse: Rd,
  ResolvedFragment: Du,
  Robot: gt,
  RobotPart: sn,
  RobotPartHistoryEntry: Ql,
  RotateKeyRequest: cg,
  RotateKeyResponse: lg,
  RoverRentalRobot: cu,
  ShareLocationRequest: Kd,
  ShareLocationResponse: Xd,
  SharedSecret: io,
  SharedSecret_State: ro,
  StorageConfig: Ld,
  TailRobotPartLogsRequest: vu,
  TailRobotPartLogsResponse: hu,
  TransferRegistryItemRequest: Ap,
  TransferRegistryItemResponse: Up,
  URLValidation: Kl,
  UnshareLocationRequest: Qd,
  UnshareLocationResponse: Zd,
  UpdateBillingServiceRequest: _d,
  UpdateBillingServiceResponse: Ed,
  UpdateFragmentRequest: xu,
  UpdateFragmentResponse: Fu,
  UpdateLocationRequest: zd,
  UpdateLocationResponse: $d,
  UpdateModuleRequest: Bp,
  UpdateModuleResponse: xp,
  UpdateOAuthAppRequest: bg,
  UpdateOAuthAppResponse: _g,
  UpdateOrganizationInviteAuthorizationsRequest: kd,
  UpdateOrganizationInviteAuthorizationsResponse: yd,
  UpdateOrganizationRequest: md,
  UpdateOrganizationResponse: cd,
  UpdateRegistryItemRequest: Op,
  UpdateRegistryItemResponse: Np,
  UpdateRobotPartRequest: Iu,
  UpdateRobotPartResponse: Su,
  UpdateRobotRequest: Qu,
  UpdateRobotResponse: Zu,
  UploadModuleFileRequest: Jp,
  UploadModuleFileResponse: zp,
  Uploads: po,
  VersionHistory: Wp,
  Visibility: an
}, Symbol.toStringTag, { value: "Module" })), Ih = {
  typeName: "viam.app.v1.AppService",
  methods: {
    /**
     * Get the id of the user with the email
     *
     * @generated from rpc viam.app.v1.AppService.GetUserIDByEmail
     */
    getUserIDByEmail: {
      name: "GetUserIDByEmail",
      I: Hp,
      O: Kp,
      kind: m.Unary
    },
    /**
     * Create a new organization
     *
     * @generated from rpc viam.app.v1.AppService.CreateOrganization
     */
    createOrganization: {
      name: "CreateOrganization",
      I: td,
      O: ad,
      kind: m.Unary
    },
    /**
     * List organizations
     *
     * @generated from rpc viam.app.v1.AppService.ListOrganizations
     */
    listOrganizations: {
      name: "ListOrganizations",
      I: Zl,
      O: nd,
      kind: m.Unary
    },
    /**
     * Get all organizations that have access to a location.
     *
     * @generated from rpc viam.app.v1.AppService.GetOrganizationsWithAccessToLocation
     */
    getOrganizationsWithAccessToLocation: {
      name: "GetOrganizationsWithAccessToLocation",
      I: Vd,
      O: jd,
      kind: m.Unary
    },
    /**
     * List the organizations a user belongs to
     *
     * @generated from rpc viam.app.v1.AppService.ListOrganizationsByUser
     */
    listOrganizationsByUser: {
      name: "ListOrganizationsByUser",
      I: Xp,
      O: Zp,
      kind: m.Unary
    },
    /**
     * Get an organization
     *
     * @generated from rpc viam.app.v1.AppService.GetOrganization
     */
    getOrganization: {
      name: "GetOrganization",
      I: sd,
      O: od,
      kind: m.Unary
    },
    /**
     * Checks for namespace availablity throughout all orgs.
     *
     * @generated from rpc viam.app.v1.AppService.GetOrganizationNamespaceAvailability
     */
    getOrganizationNamespaceAvailability: {
      name: "GetOrganizationNamespaceAvailability",
      I: id,
      O: rd,
      kind: m.Unary
    },
    /**
     * Update an organization
     *
     * @generated from rpc viam.app.v1.AppService.UpdateOrganization
     */
    updateOrganization: {
      name: "UpdateOrganization",
      I: md,
      O: cd,
      kind: m.Unary
    },
    /**
     * Delete an organization
     *
     * @generated from rpc viam.app.v1.AppService.DeleteOrganization
     */
    deleteOrganization: {
      name: "DeleteOrganization",
      I: ld,
      O: dd,
      kind: m.Unary
    },
    /**
     * List all members of an organization and all invited members to the organization.
     *
     * @generated from rpc viam.app.v1.AppService.ListOrganizationMembers
     */
    listOrganizationMembers: {
      name: "ListOrganizationMembers",
      I: ud,
      O: pd,
      kind: m.Unary
    },
    /**
     * Create an organization invite to an organization
     *
     * @generated from rpc viam.app.v1.AppService.CreateOrganizationInvite
     */
    createOrganizationInvite: {
      name: "CreateOrganizationInvite",
      I: gd,
      O: Td,
      kind: m.Unary
    },
    /**
     * Update the authorizations attached to an organization invite
     *
     * @generated from rpc viam.app.v1.AppService.UpdateOrganizationInviteAuthorizations
     */
    updateOrganizationInviteAuthorizations: {
      name: "UpdateOrganizationInviteAuthorizations",
      I: kd,
      O: yd,
      kind: m.Unary
    },
    /**
     * Delete an organization member from an organization
     *
     * @generated from rpc viam.app.v1.AppService.DeleteOrganizationMember
     */
    deleteOrganizationMember: {
      name: "DeleteOrganizationMember",
      I: Id,
      O: Sd,
      kind: m.Unary
    },
    /**
     * Delete an organization invite
     *
     * @generated from rpc viam.app.v1.AppService.DeleteOrganizationInvite
     */
    deleteOrganizationInvite: {
      name: "DeleteOrganizationInvite",
      I: vd,
      O: hd,
      kind: m.Unary
    },
    /**
     * Resend an organization invite
     *
     * @generated from rpc viam.app.v1.AppService.ResendOrganizationInvite
     */
    resendOrganizationInvite: {
      name: "ResendOrganizationInvite",
      I: fd,
      O: Rd,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.EnableBillingService
     */
    enableBillingService: {
      name: "EnableBillingService",
      I: wd,
      O: bd,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.DisableBillingService
     */
    disableBillingService: {
      name: "DisableBillingService",
      I: Nd,
      O: Cd,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.UpdateBillingService
     */
    updateBillingService: {
      name: "UpdateBillingService",
      I: _d,
      O: Ed,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.GetBillingServiceConfig
     */
    getBillingServiceConfig: {
      name: "GetBillingServiceConfig",
      I: Md,
      O: Od,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.OrganizationSetSupportEmail
     */
    organizationSetSupportEmail: {
      name: "OrganizationSetSupportEmail",
      I: Pd,
      O: Dd,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.OrganizationGetSupportEmail
     */
    organizationGetSupportEmail: {
      name: "OrganizationGetSupportEmail",
      I: qd,
      O: Ad,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.OrganizationSetLogo
     */
    organizationSetLogo: {
      name: "OrganizationSetLogo",
      I: pg,
      O: gg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.OrganizationGetLogo
     */
    organizationGetLogo: {
      name: "OrganizationGetLogo",
      I: Tg,
      O: kg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.EnableAuthService
     */
    enableAuthService: {
      name: "EnableAuthService",
      I: yg,
      O: vg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.DisableAuthService
     */
    disableAuthService: {
      name: "DisableAuthService",
      I: hg,
      O: fg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.CreateOAuthApp
     */
    createOAuthApp: {
      name: "CreateOAuthApp",
      I: Rg,
      O: Ig,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.ReadOAuthApp
     */
    readOAuthApp: {
      name: "ReadOAuthApp",
      I: Sg,
      O: wg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.UpdateOAuthApp
     */
    updateOAuthApp: {
      name: "UpdateOAuthApp",
      I: bg,
      O: _g,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.DeleteOAuthApp
     */
    deleteOAuthApp: {
      name: "DeleteOAuthApp",
      I: Eg,
      O: Mg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.ListOAuthApps
     */
    listOAuthApps: {
      name: "ListOAuthApps",
      I: Og,
      O: Ng,
      kind: m.Unary
    },
    /**
     * Create a location
     *
     * @generated from rpc viam.app.v1.AppService.CreateLocation
     */
    createLocation: {
      name: "CreateLocation",
      I: Bd,
      O: xd,
      kind: m.Unary
    },
    /**
     * Get a location
     *
     * @generated from rpc viam.app.v1.AppService.GetLocation
     */
    getLocation: {
      name: "GetLocation",
      I: Fd,
      O: Jd,
      kind: m.Unary
    },
    /**
     * Update a location
     *
     * @generated from rpc viam.app.v1.AppService.UpdateLocation
     */
    updateLocation: {
      name: "UpdateLocation",
      I: zd,
      O: $d,
      kind: m.Unary
    },
    /**
     * Delete a location
     *
     * @generated from rpc viam.app.v1.AppService.DeleteLocation
     */
    deleteLocation: {
      name: "DeleteLocation",
      I: Yd,
      O: Wd,
      kind: m.Unary
    },
    /**
     * Get a list of locations
     *
     * @generated from rpc viam.app.v1.AppService.ListLocations
     */
    listLocations: {
      name: "ListLocations",
      I: Hd,
      O: eu,
      kind: m.Unary
    },
    /**
     * Share a location with an organization
     *
     * @generated from rpc viam.app.v1.AppService.ShareLocation
     */
    shareLocation: {
      name: "ShareLocation",
      I: Kd,
      O: Xd,
      kind: m.Unary
    },
    /**
     * Stop sharing a location with an organization
     *
     * @generated from rpc viam.app.v1.AppService.UnshareLocation
     */
    unshareLocation: {
      name: "UnshareLocation",
      I: Qd,
      O: Zd,
      kind: m.Unary
    },
    /**
     * Get a location's authorization secrets
     *
     * @generated from rpc viam.app.v1.AppService.LocationAuth
     */
    locationAuth: {
      name: "LocationAuth",
      I: ou,
      O: iu,
      kind: m.Unary
    },
    /**
     * Create a new generated Secret in the Location.
     *  - Succeeds if there are no more than 2 active secrets after creation.
     *
     * @generated from rpc viam.app.v1.AppService.CreateLocationSecret
     */
    createLocationSecret: {
      name: "CreateLocationSecret",
      I: nu,
      O: tu,
      kind: m.Unary
    },
    /**
     * Delete a Secret from the Location.
     *
     * @generated from rpc viam.app.v1.AppService.DeleteLocationSecret
     */
    deleteLocationSecret: {
      name: "DeleteLocationSecret",
      I: au,
      O: su,
      kind: m.Unary
    },
    /**
     * Get a specific robot by ID
     *
     * @generated from rpc viam.app.v1.AppService.GetRobot
     */
    getRobot: {
      name: "GetRobot",
      I: ru,
      O: du,
      kind: m.Unary
    },
    /**
     * Get Rover Rental Location Robots
     *
     * @generated from rpc viam.app.v1.AppService.GetRoverRentalRobots
     */
    getRoverRentalRobots: {
      name: "GetRoverRentalRobots",
      I: mu,
      O: lu,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.GetRobotParts
     */
    getRobotParts: {
      name: "GetRobotParts",
      I: uu,
      O: pu,
      kind: m.Unary
    },
    /**
     * Get a specific robot part by ID
     *
     * @generated from rpc viam.app.v1.AppService.GetRobotPart
     */
    getRobotPart: {
      name: "GetRobotPart",
      I: gu,
      O: Tu,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.GetRobotPartLogs
     */
    getRobotPartLogs: {
      name: "GetRobotPartLogs",
      I: ku,
      O: yu,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.TailRobotPartLogs
     */
    tailRobotPartLogs: {
      name: "TailRobotPartLogs",
      I: vu,
      O: hu,
      kind: m.ServerStreaming
    },
    /**
     * Get a specific robot part histy by ID
     *
     * @generated from rpc viam.app.v1.AppService.GetRobotPartHistory
     */
    getRobotPartHistory: {
      name: "GetRobotPartHistory",
      I: fu,
      O: Ru,
      kind: m.Unary
    },
    /**
     * Update a robot
     *
     * @generated from rpc viam.app.v1.AppService.UpdateRobotPart
     */
    updateRobotPart: {
      name: "UpdateRobotPart",
      I: Iu,
      O: Su,
      kind: m.Unary
    },
    /**
     * Create a new robot part
     *
     * @generated from rpc viam.app.v1.AppService.NewRobotPart
     */
    newRobotPart: {
      name: "NewRobotPart",
      I: wu,
      O: bu,
      kind: m.Unary
    },
    /**
     * Delete a robot part
     *
     * @generated from rpc viam.app.v1.AppService.DeleteRobotPart
     */
    deleteRobotPart: {
      name: "DeleteRobotPart",
      I: _u,
      O: Nu,
      kind: m.Unary
    },
    /**
     * Gets the Robot API Keys for the robot
     *
     * @generated from rpc viam.app.v1.AppService.GetRobotAPIKeys
     */
    getRobotAPIKeys: {
      name: "GetRobotAPIKeys",
      I: Eu,
      O: Ou,
      kind: m.Unary
    },
    /**
     * Marks the given part as the main part, and all the others as not
     *
     * @generated from rpc viam.app.v1.AppService.MarkPartAsMain
     */
    markPartAsMain: {
      name: "MarkPartAsMain",
      I: tp,
      O: ap,
      kind: m.Unary
    },
    /**
     * Marks part for restart. Once the robot part checks-in with the app the flag
     * is reset on the robot part. Calling this multiple times before a robot part
     * checks-in has no affect.
     * Note: This API may be removed in the near future.
     * TODO(APP-388): Remove
     *
     * @generated from rpc viam.app.v1.AppService.MarkPartForRestart
     */
    markPartForRestart: {
      name: "MarkPartForRestart",
      I: sp,
      O: op,
      kind: m.Unary
    },
    /**
     * Create a new generated Secret in the Robot Part.
     *  - Succeeds if there are no more than 2 active secrets after creation.
     *
     * @generated from rpc viam.app.v1.AppService.CreateRobotPartSecret
     */
    createRobotPartSecret: {
      name: "CreateRobotPartSecret",
      I: ip,
      O: rp,
      kind: m.Unary
    },
    /**
     * Delete a Secret from the RobotPart.
     *
     * @generated from rpc viam.app.v1.AppService.DeleteRobotPartSecret
     */
    deleteRobotPartSecret: {
      name: "DeleteRobotPartSecret",
      I: mp,
      O: cp,
      kind: m.Unary
    },
    /**
     * Get a list of robots
     *
     * @generated from rpc viam.app.v1.AppService.ListRobots
     */
    listRobots: {
      name: "ListRobots",
      I: Wu,
      O: Hu,
      kind: m.Unary
    },
    /**
     * NewRobot creates a new robot
     *
     * @generated from rpc viam.app.v1.AppService.NewRobot
     */
    newRobot: {
      name: "NewRobot",
      I: Ku,
      O: Xu,
      kind: m.Unary
    },
    /**
     * UpdateRobot updates a robot
     *
     * @generated from rpc viam.app.v1.AppService.UpdateRobot
     */
    updateRobot: {
      name: "UpdateRobot",
      I: Qu,
      O: Zu,
      kind: m.Unary
    },
    /**
     * DeleteRobot deletes a robot
     *
     * @generated from rpc viam.app.v1.AppService.DeleteRobot
     */
    deleteRobot: {
      name: "DeleteRobot",
      I: ep,
      O: np,
      kind: m.Unary
    },
    /**
     * Gets a list of fragments
     *
     * @generated from rpc viam.app.v1.AppService.ListFragments
     */
    listFragments: {
      name: "ListFragments",
      I: qu,
      O: Au,
      kind: m.Unary
    },
    /**
     * Gets a single fragment
     *
     * @generated from rpc viam.app.v1.AppService.GetFragment
     */
    getFragment: {
      name: "GetFragment",
      I: Uu,
      O: Gu,
      kind: m.Unary
    },
    /**
     * Creates a fragment
     *
     * @generated from rpc viam.app.v1.AppService.CreateFragment
     */
    createFragment: {
      name: "CreateFragment",
      I: Lu,
      O: Bu,
      kind: m.Unary
    },
    /**
     * Updates a fragment
     *
     * @generated from rpc viam.app.v1.AppService.UpdateFragment
     */
    updateFragment: {
      name: "UpdateFragment",
      I: xu,
      O: Fu,
      kind: m.Unary
    },
    /**
     * Deletes a fragment
     *
     * @generated from rpc viam.app.v1.AppService.DeleteFragment
     */
    deleteFragment: {
      name: "DeleteFragment",
      I: Ju,
      O: zu,
      kind: m.Unary
    },
    /**
     * Gets top level and nested fragments for a machine, as well as any other specified fragment ids
     *
     * @generated from rpc viam.app.v1.AppService.ListMachineFragments
     */
    listMachineFragments: {
      name: "ListMachineFragments",
      I: Vu,
      O: ju,
      kind: m.Unary
    },
    /**
     * Gets fragment history
     *
     * @generated from rpc viam.app.v1.AppService.GetFragmentHistory
     */
    getFragmentHistory: {
      name: "GetFragmentHistory",
      I: $u,
      O: Yu,
      kind: m.Unary
    },
    /**
     * Creates an IdentityAuthorization
     *
     * @generated from rpc viam.app.v1.AppService.AddRole
     */
    addRole: {
      name: "AddRole",
      I: lp,
      O: dp,
      kind: m.Unary
    },
    /**
     * Deletes an IdentityAuthorization
     *
     * @generated from rpc viam.app.v1.AppService.RemoveRole
     */
    removeRole: {
      name: "RemoveRole",
      I: up,
      O: pp,
      kind: m.Unary
    },
    /**
     * Changes an IdentityAuthorization to a new IdentityAuthorization
     *
     * @generated from rpc viam.app.v1.AppService.ChangeRole
     */
    changeRole: {
      name: "ChangeRole",
      I: gp,
      O: Tp,
      kind: m.Unary
    },
    /**
     * Returns all authorization roles for a given resource
     *
     * @generated from rpc viam.app.v1.AppService.ListAuthorizations
     */
    listAuthorizations: {
      name: "ListAuthorizations",
      I: kp,
      O: yp,
      kind: m.Unary
    },
    /**
     * Validates a permission for the current user
     *
     * @generated from rpc viam.app.v1.AppService.CheckPermissions
     */
    checkPermissions: {
      name: "CheckPermissions",
      I: vp,
      O: hp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.GetRegistryItem
     */
    getRegistryItem: {
      name: "GetRegistryItem",
      I: bp,
      O: _p,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.CreateRegistryItem
     */
    createRegistryItem: {
      name: "CreateRegistryItem",
      I: Ep,
      O: Mp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.UpdateRegistryItem
     */
    updateRegistryItem: {
      name: "UpdateRegistryItem",
      I: Op,
      O: Np,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.ListRegistryItems
     */
    listRegistryItems: {
      name: "ListRegistryItems",
      I: Cp,
      O: Pp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.DeleteRegistryItem
     */
    deleteRegistryItem: {
      name: "DeleteRegistryItem",
      I: Dp,
      O: qp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.TransferRegistryItem
     */
    transferRegistryItem: {
      name: "TransferRegistryItem",
      I: Ap,
      O: Up,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.CreateModule
     */
    createModule: {
      name: "CreateModule",
      I: Gp,
      O: Lp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.UpdateModule
     */
    updateModule: {
      name: "UpdateModule",
      I: Bp,
      O: xp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.UploadModuleFile
     */
    uploadModuleFile: {
      name: "UploadModuleFile",
      I: Jp,
      O: zp,
      kind: m.ClientStreaming
    },
    /**
     * @generated from rpc viam.app.v1.AppService.GetModule
     */
    getModule: {
      name: "GetModule",
      I: $p,
      O: Yp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.ListModules
     */
    listModules: {
      name: "ListModules",
      I: Vp,
      O: jp,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.CreateKey
     */
    createKey: {
      name: "CreateKey",
      I: eg,
      O: ng,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.DeleteKey
     */
    deleteKey: {
      name: "DeleteKey",
      I: tg,
      O: ag,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.ListKeys
     */
    listKeys: {
      name: "ListKeys",
      I: rg,
      O: mg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.RenameKey
     */
    renameKey: {
      name: "RenameKey",
      I: sg,
      O: og,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.RotateKey
     */
    rotateKey: {
      name: "RotateKey",
      I: cg,
      O: lg,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.app.v1.AppService.CreateKeyFromExistingKeyAuthorizations
     */
    createKeyFromExistingKeyAuthorizations: {
      name: "CreateKeyFromExistingKeyAuthorizations",
      I: dg,
      O: ug,
      kind: m.Unary
    }
  }
}, ei = (t, e, n, a, s, i) => new Q({
  authorizationType: "role",
  identityId: e,
  identityType: s,
  authorizationId: `${a}_${n}`,
  resourceType: a,
  organizationId: t,
  resourceId: i
});
class Sh {
  client;
  constructor(e) {
    this.client = ta(Ih, e);
  }
  /**
   * Obain a user's ID from their email address.
   *
   * @param email The email address of the user
   * @returns The user's ID
   */
  async getUserIDByEmail(e) {
    return (await this.client.getUserIDByEmail({ email: e })).userId;
  }
  /**
   * Create a new organization.
   *
   * @param name The name of the new organization
   * @returns The new organization
   */
  async createOrganization(e) {
    return (await this.client.createOrganization({ name: e })).organization;
  }
  /**
   * List all organizations.
   *
   * @returns The organization list
   */
  async listOrganizations() {
    return (await this.client.listOrganizations({})).organizations;
  }
  /**
   * List all organizations with access to a particular location.
   *
   * @param locationId The ID of the location to query
   * @returns The list of locations with access to the requested location
   */
  async getOrganizationsWithAccessToLocation(e) {
    return (await this.client.getOrganizationsWithAccessToLocation({
      locationId: e
    })).organizationIdentities;
  }
  /**
   * List all organizations associated with a user.
   *
   * @param userId The ID of the user to query
   * @returns The list of locations the requested user has access to
   */
  async listOrganizationsByUser(e) {
    return (await this.client.listOrganizationsByUser({ userId: e })).orgs;
  }
  /**
   * Get details about an organization.
   *
   * @param organizationId The ID of the organization
   * @returns Details about the organization, if it exists
   */
  async getOrganization(e) {
    return (await this.client.getOrganization({ organizationId: e })).organization;
  }
  /**
   * Find out if an organization namespace is available.
   *
   * @param namespace The namespace to query for availability
   * @returns A boolean indicating whether or not the namespace is available
   */
  async getOrganizationNamespaceAvailability(e) {
    return (await this.client.getOrganizationNamespaceAvailability({
      publicNamespace: e
    })).available;
  }
  /**
   * Updates organization details.
   *
   * @param organizationId The id of the organization to update
   * @param name Optional name to update the organization with
   * @param publicNamespace Optional namespace to update the organization with
   * @param region Optional region to update the organization with
   * @param cid Optional CRM ID to update the organization with
   * @returns The updated organization details
   */
  async updateOrganization(e, n, a, s, i) {
    return (await this.client.updateOrganization({
      organizationId: e,
      name: n,
      publicNamespace: a,
      region: s,
      cid: i
    })).organization;
  }
  /**
   * Deletes an organization.
   *
   * @param organizationId The id of the organization to delete
   */
  async deleteOrganization(e) {
    await this.client.deleteOrganization({ organizationId: e });
  }
  /**
   * Lists organization memebers and outstanding invites.
   *
   * @param organizationId The id of the organization to query
   * @returns An object containing organization members, pending invites, and
   *   org ID
   */
  async listOrganizationMembers(e) {
    return this.client.listOrganizationMembers({ organizationId: e });
  }
  /**
   * Creates a new invitation to join an organization.
   *
   * @param organizationId The id of the organization to create the invite for
   * @param email The email address of the user to generate an invite for
   * @param authorizations The authorizations to associate with the new invite
   * @param sendEmailInvite Bool of whether to send an email invite (true) or
   *   automatically add a user. Defaults to true
   * @returns The organization invite
   */
  async createOrganizationInvite(e, n, a, s = !0) {
    return (await this.client.createOrganizationInvite({
      organizationId: e,
      email: n,
      authorizations: a,
      sendEmailInvite: s
    })).invite;
  }
  /**
   * Updates authorizations for an existing org invite.
   *
   * @param organizationId The id of the organization
   * @param email The email address associated with the invite
   * @param addAuthsList List of authorizations to add to the invite
   * @param removeAuthsList List of authorizations to remove from the invite
   * @returns The organization invite
   */
  async updateOrganizationInviteAuthorizations(e, n, a, s) {
    return (await this.client.updateOrganizationInviteAuthorizations({
      organizationId: e,
      email: n,
      addAuthorizations: a,
      removeAuthorizations: s
    })).invite;
  }
  /**
   * Removes a member from an organization.
   *
   * @param organizationId The ID of the organization
   * @param userId The ID of the user
   */
  async deleteOrganizationMember(e, n) {
    await this.client.deleteOrganizationMember({ organizationId: e, userId: n });
  }
  /**
   * Deletes a pending organization invite.
   *
   * @param organizationId The ID of the organization
   * @param email The email associated with the invite to delete
   */
  async deleteOrganizationInvite(e, n) {
    await this.client.deleteOrganizationInvite({ organizationId: e, email: n });
  }
  /**
   * Resends a pending organization invite.
   *
   * @param organizationId The ID of the organization
   * @param email The email associated with the invite to resend
   * @returns The invite
   */
  async resendOrganizationInvite(e, n) {
    return (await this.client.resendOrganizationInvite({
      organizationId: e,
      email: n
    })).invite;
  }
  /**
   * Creates a new location.
   *
   * @param organizationId The ID of the organization to create the location
   *   under
   * @param name The name of the location to create
   * @param parentLocationId Optional name of a parent location to create the
   *   new location under
   * @returns The location object
   */
  async createLocation(e, n, a) {
    return (await this.client.createLocation({
      organizationId: e,
      name: n,
      parentLocationId: a
    })).location;
  }
  /**
   * Looks up a location.
   *
   * @param locId The ID of the location to query.
   * @returns The location object
   */
  async getLocation(e) {
    return (await this.client.getLocation({
      locationId: e
    })).location;
  }
  /**
   * Updates location details.
   *
   * @param locId The ID of the location to update
   * @param name Optional string to update the location's name to
   * @param parentLocId Optional string to update the location's parent location
   *   to
   * @param region Optional string to update the location's region to
   * @returns The location object
   */
  async updateLocation(e, n, a, s) {
    return (await this.client.updateLocation({
      locationId: e,
      name: n,
      parentLocationId: a,
      region: s
    })).location;
  }
  /**
   * Deletes a location
   *
   * @param locId The ID of the location to delete
   */
  async deleteLocation(e) {
    await this.client.deleteLocation({ locationId: e });
  }
  /**
   * Lists all locations under an organization.
   *
   * @param organizationId The ID of the organization to query
   * @returns A list of locations under the organization
   */
  async listLocations(e) {
    return (await this.client.listLocations({ organizationId: e })).locations;
  }
  /**
   * Shares a location with another organization
   *
   * @param organizationId The ID of the organization to share with
   * @param locId The ID of the location to share
   */
  async shareLocation(e, n) {
    await this.client.shareLocation({ organizationId: e, locationId: n });
  }
  /**
   * Unshares a location with an organization
   *
   * @param organizationId The ID of the organization to unshare with
   * @param locId The ID of the location to unshare
   */
  async unshareLocation(e, n) {
    await this.client.unshareLocation({ organizationId: e, locationId: n });
  }
  /**
   * Get a location's `LocationAuth` (location secret(s)).
   *
   * @param locId The ID of the location to retrieve `LocationAuth` from.
   * @returns The `LocationAuth` for the requested location.
   */
  async locationAuth(e) {
    return (await this.client.locationAuth({ locationId: e })).auth;
  }
  /**
   * Create a location secret (`LocationAuth`).
   *
   * @param locId The ID of the location to create a `LocationAuth` for
   * @returns The newly created `LocationAuth`
   */
  async createLocationSecret(e) {
    return (await this.client.createLocationSecret({ locationId: e })).auth;
  }
  /**
   * Deletes a location secret (`LocationAuth`).
   *
   * @param locId The ID of the location to delete the `LocationAuth` from
   * @param secretId The ID of the location secret to delete
   */
  async deleteLocationSecret(e, n) {
    await this.client.deleteLocationSecret({ locationId: e, secretId: n });
  }
  /**
   * Queries a robot by its ID.
   *
   * @param id The ID of the robot
   * @returns The `Robot` object
   */
  async getRobot(e) {
    return (await this.client.getRobot({ id: e })).robot;
  }
  /**
   * Returns a list of rover rental robots for an organization.
   *
   * @param orgId The ID of the organization to query
   * @returns The list of `RoverRentalRobot` objects
   */
  async getRoverRentalRobots(e) {
    return (await this.client.getRoverRentalRobots({ orgId: e })).robots;
  }
  /**
   * Returns a list of parts for a given robot
   *
   * @param robotId The ID of the robot to query
   * @returns The list of `RobotPart` objects associated with the robot
   */
  async getRobotParts(e) {
    return (await this.client.getRobotParts({ robotId: e })).parts;
  }
  /**
   * Queries a specific robot part by ID.
   *
   * @param id The ID of the requested robot part
   * @returns The robot part and a its json config
   */
  async getRobotPart(e) {
    return this.client.getRobotPart({ id: e });
  }
  /**
   * Get a page of log entries for a specific robot part. Logs are sorted by
   * descending time (newest first).
   *
   * @param id The ID of the requested robot part
   * @param filter Optional string to filter logs on
   * @param levels Optional array of log levels to return. Defaults to returning
   *   all log levels
   * @param pageToken Optional string indicating which page of logs to query.
   *   Defaults to the most recent
   * @returns The robot requested logs and the page token for the next page of
   *   logs
   */
  async getRobotPartLogs(e, n, a, s = "") {
    return this.client.getRobotPartLogs({
      id: e,
      filter: n,
      levels: a,
      pageToken: s
    });
  }
  /**
   * Get a stream of log entries for a specific robot part. Logs are sorted by
   * descending time (newest first).
   *
   * @param id The ID of the requested robot part
   * @param queue A queue to put the log entries into
   * @param filter Optional string to filter logs on
   * @param errorsOnly Optional bool to indicate whether or not only error-level
   *   logs should be returned. Defaults to true
   */
  async tailRobotPartLogs(e, n, a, s = !0) {
    const i = this.client.tailRobotPartLogs({
      id: e,
      errorsOnly: s,
      filter: a
    });
    for await (const r of i)
      for (const c of r.logs)
        n.push(c);
  }
  /**
   * Get a list containing the history of a robot part.
   *
   * @param id The ID of the requested robot part
   * @returns The list of the robot part's history
   */
  async getRobotPartHistory(e) {
    return (await this.client.getRobotPartHistory({ id: e })).history;
  }
  /**
   * Updates a robot part based on its ID.
   *
   * @param id The ID of the requested robot part
   * @param name The new name of the robot part
   * @param robotConfig The new config for the robot part
   * @returns The updated robot part
   */
  async updateRobotPart(e, n, a) {
    return (await this.client.updateRobotPart({ id: e, name: n, robotConfig: a })).part;
  }
  /**
   * Creates a new robot part.
   *
   * @param robotId The ID of the robot to create a part for
   * @param partName The name for the new robot part
   * @returns The ID of the newly-created robot part
   */
  async newRobotPart(e, n) {
    return (await this.client.newRobotPart({ robotId: e, partName: n })).partId;
  }
  /**
   * Deletes a robot part.
   *
   * @param partId The ID of the part to delete
   */
  async deleteRobotPart(e) {
    await this.client.deleteRobotPart({ partId: e });
  }
  /**
   * Gets a list of a robot's API keys.
   *
   * @param robotId The ID of the robot to get API keys for
   * @returns A list of the robot's API keys
   */
  async getRobotAPIKeys(e) {
    return (await this.client.getRobotAPIKeys({ robotId: e })).apiKeys;
  }
  /**
   * Marks a robot part as the main part.
   *
   * @param partId The ID of the part to mark as main
   */
  async markPartAsMain(e) {
    await this.client.markPartAsMain({ partId: e });
  }
  /**
   * Marks a robot part for restart.
   *
   * @param partId The ID of the part to mark for restart
   */
  async markPartForRestart(e) {
    await this.client.markPartForRestart({ partId: e });
  }
  /**
   * Creates a new secret for a robot part.
   *
   * @param partId The ID of the part to create a secret for
   * @returns The robot part object
   */
  async createRobotPartSecret(e) {
    return (await this.client.createRobotPartSecret({ partId: e })).part;
  }
  /**
   * Deletes a robot secret from a robot part.
   *
   * @param partId The ID of the part to delete a secret from
   * @param secretId The ID of the secret to delete
   */
  async deleteRobotPartSecret(e, n) {
    await this.client.deleteRobotPartSecret({ partId: e, secretId: n });
  }
  /**
   * Lists all robots in a location.
   *
   * @param locId The ID of the location to list robots for
   * @returns The list of robot objects
   */
  async listRobots(e) {
    return (await this.client.listRobots({ locationId: e })).robots;
  }
  /**
   * Creates a new robot.
   *
   * @param locId The ID of the location to create the robot in
   * @param name The name of the new robot
   * @returns The new robot's ID
   */
  async newRobot(e, n) {
    return (await this.client.newRobot({ name: n, location: e })).id;
  }
  /**
   * Updates an existing robot's name and/or location.
   *
   * @param robotId The ID of the robot to update
   * @param locId The ID of the location to move the robot to
   * @param name The name to update the robot to
   * @returns The newly-modified robot object
   */
  async updateRobot(e, n, a) {
    return (await this.client.updateRobot({
      id: e,
      location: n,
      name: a
    })).robot;
  }
  /**
   * Deletes a robot.
   *
   * @param id The ID of the robot to delete
   */
  async deleteRobot(e) {
    await this.client.deleteRobot({ id: e });
  }
  /**
   * Lists all fragments within an organization.
   *
   * @param organizationId The ID of the organization to list fragments for
   * @param publicOnly Optional, deprecated boolean. Use fragmentVisibilities
   *   instead. If true then only public fragments will be listed. Defaults to
   *   true
   * @param fragmentVisibilities Optional list of fragment visibilities to
   *   include in returned list. An empty fragmentVisibilities list defaults to
   *   normal publicOnly behavior (discludes unlisted public fragments)
   *   Otherwise, fragment visibilities should contain one of the three
   *   visibilities and takes precendence over the publicOnly field
   * @returns The list of fragment objects
   */
  async listFragments(e, n = !0, a = []) {
    return (await this.client.listFragments({
      organizationId: e,
      showPublic: n,
      fragmentVisibility: a
    })).fragments;
  }
  /**
   * Looks up a fragment by ID.
   *
   * @param id The ID of the fragment to look up
   * @returns The requested fragment
   */
  async getFragment(e) {
    return (await this.client.getFragment({ id: e })).fragment;
  }
  /**
   * Creates a new fragment.
   *
   * @param organizationId The ID of the organization to create the fragment
   *   under
   * @param name The name of the new fragment
   * @param config The new fragment's config
   * @returns The newly created fragment
   */
  async createFragment(e, n, a) {
    return (await this.client.createFragment({
      organizationId: e,
      name: n,
      config: a
    })).fragment;
  }
  /**
   * Updates an existing fragment.
   *
   * @param id The ID of the fragment to update
   * @param name The name to update the fragment to
   * @param config The config to update the fragment to
   * @param makePublic Optional, deprecated boolean specifying whether the
   *   fragment should be public or not. If not passed, the visibility will be
   *   unchanged. Fragments are private by default when created
   * @param visibility Optional FragmentVisibility specifying the updated
   *   fragment visibility. If not passed, the visibility will be unchanged. If
   *   visibility is not set and makePublic is set, makePublic takes effect. If
   *   makePublic and visibility are set, they must not be conflicting. If
   *   neither is set, the fragment visibility will remain unchanged.
   * @returns The updated fragment
   */
  async updateFragment(e, n, a, s, i) {
    return (await this.client.updateFragment({
      id: e,
      name: n,
      config: a,
      public: s,
      visibility: i
    })).fragment;
  }
  /**
   * Deletes a fragment.
   *
   * @param id The ID of the fragment to delete
   */
  async deleteFragment(e) {
    await this.client.deleteFragment({ id: e });
  }
  /**
   * @param machineId The machine ID used to filter fragments defined in a
   *   machine's parts. Also returns any fragments nested within the fragments
   *   defined in parts.
   * @param additionalFragmentIds Additional fragment IDs to append to the
   *   response. Useful when needing to view fragments that will be
   *   provisionally added to the machine alongside existing fragments.
   * @returns The list of top level and nested fragments for a machine, as well
   *   as additionally specified fragment IDs.
   */
  async listMachineFragments(e, n) {
    return (await this.client.listMachineFragments({
      machineId: e,
      additionalFragmentIds: n
    })).fragments;
  }
  /**
   * Add a role under an organization.
   *
   * @param organizationId The ID of the organization to create the role under
   * @param entityId The ID of the entity the role belongs to (e.g., a user ID)
   * @param role The role to add ("owner" or "operator")
   * @param resourceType The type of resource to create the role for ("robot",
   *   "location", or "organization")
   * @param resourceId The ID of the resource the role is being created for
   */
  async addRole(e, n, a, s, i) {
    await this.client.addRole({
      authorization: ei(
        e,
        n,
        a,
        s,
        "",
        i
      )
    });
  }
  /**
   * Removes a role from an organization.
   *
   * @param organizationId The ID of the organization to remove the role from
   * @param entityId The ID of the entity the role belongs to (e.g., a user ID)
   * @param role The role to remove ("owner" or "operator")
   * @param resourceType The type of resource to remove the role from ("robot",
   *   "location", or "organization")
   * @param resourceId The ID of the resource the role is being removes from
   */
  async removeRole(e, n, a, s, i) {
    await this.client.removeRole({
      authorization: ei(
        e,
        n,
        a,
        s,
        "",
        i
      )
    });
  }
  /**
   * Changes an existing role.
   *
   * @param oldAuth The existing authorization
   * @param newAuth The new authorization
   */
  async changeRole(e, n) {
    await this.client.changeRole({ oldAuthorization: e, newAuthorization: n });
  }
  /**
   * List all authorizations for an organization.
   *
   * @param organizationId The ID of the organization to list authorizations for
   * @param resourceIds Optional list of IDs of resources to list authorizations
   *   for. If not provided, all resources will be included
   * @returns The list of authorizations
   */
  async listAuthorizations(e, n) {
    return (await this.client.listAuthorizations({
      organizationId: e,
      resourceIds: n
    })).authorizations;
  }
  /**
   * Checks whether requested permissions exist.
   *
   * @param permissions A list of permissions to check
   * @returns A filtered list of the authorized permissions
   */
  async checkPermissions(e) {
    return (await this.client.checkPermissions({ permissions: e })).authorizedPermissions;
  }
  /**
   * Get an item from the registry.
   *
   * @param itemId The ID of the item to get
   * @returns The requested item
   */
  async getRegistryItem(e) {
    return (await this.client.getRegistryItem({ itemId: e })).item;
  }
  /**
   * Create a new registry item.
   *
   * @param organizationId The ID of the organization to create the registry
   *   item under
   * @param name The name of the registry item
   * @param type The type of the item in the registry.
   */
  async createRegistryItem(e, n, a) {
    await this.client.createRegistryItem({
      organizationId: e,
      name: n,
      type: a
    });
  }
  /**
   * Update an existing registry item.
   *
   * @param itemId The ID of the registry item to update
   * @param type The PackageType to update the item to
   * @param description A description of the item
   * @param visibility A visibility value to update to
   */
  async updateRegistryItem(e, n, a, s) {
    await this.client.updateRegistryItem({
      itemId: e,
      type: n,
      description: a,
      visibility: s
    });
  }
  /**
   * List all registry items for an organization.
   *
   * @param organizationId The ID of the organization to query registry items
   *   for
   * @param types A list of types to query. If empty, will not filter on type
   * @param visibilities A list of visibilities to query for. If empty, will not
   *   filter on visibility
   * @param platforms A list of platforms to query for. If empty, will not
   *   filter on platform
   * @param statuses A list of statuses to query for. If empty, will not filter
   *   on status
   * @param searchTerm Optional search term to filter on
   * @param pageToken Optional page token for results. If not provided, will
   *   return all results
   * @returns The list of registry items
   */
  async listRegistryItems(e, n, a, s, i, r, c) {
    const d = {
      organizationId: e,
      types: n,
      visibilities: a,
      platforms: s,
      statuses: i,
      searchTerm: r,
      pageToken: c
    };
    return (await this.client.listRegistryItems(d)).items;
  }
  /**
   * Deletes a registry item.
   *
   * @param itemId The ID of the item to delete
   */
  async deleteRegistryItem(e) {
    await this.client.deleteRegistryItem({
      itemId: e
    });
  }
  /**
   * Creates a new module.
   *
   * @param organizationId The ID of the organization to create the module under
   * @param name The name of the module
   * @returns The module ID and a URL to its detail page
   */
  async createModule(e, n) {
    return this.client.createModule({
      organizationId: e,
      name: n
    });
  }
  /**
   * Updates an existing module.
   *
   * @param moduleId The ID of the module to update
   * @param visibility The visibility to set for the module
   * @param url The url to reference for documentation, code, etc.
   * @param description A short description of the module
   * @param models A list of models available in the module
   * @param entrypoint The executable to run to start the module program
   * @returns The module URL
   */
  async updateModule(e, n, a, s, i, r) {
    return (await this.client.updateModule({
      moduleId: e,
      visibility: n,
      url: a,
      description: s,
      models: i,
      entrypoint: r
    })).url;
  }
  /**
   * Looks up a particular module.
   *
   * @param moduleId The ID of the module
   * @returns The requested module
   */
  async getModule(e) {
    return (await this.client.getModule({ moduleId: e })).module;
  }
  /**
   * Lists all modules for an organization.
   *
   * @param organizationId The ID of the organization to query
   * @returns The organization's modules
   */
  async listModules(e) {
    return (await this.client.listModules({ organizationId: e })).modules;
  }
  /**
   * Creates a new API key.
   *
   * @param authorizations The list of authorizations to provide for the API key
   * @param name An optional name for the key. If none is passed, defaults to
   *   present timestamp
   * @returns The new key and ID
   */
  async createKey(e, n) {
    return this.client.createKey({ name: n, authorizations: e });
  }
  /**
   * Deletes an existing API key.
   *
   * @param id The ID of the key to delete
   */
  async deleteKey(e) {
    return this.client.deleteKey({ id: e });
  }
  /**
   * List all API keys for an organization.
   *
   * @param orgId The ID of the organization to query
   * @returns The list of API keys
   */
  async listKeys(e) {
    return (await this.client.listKeys({ orgId: e })).apiKeys;
  }
  /**
   * Rotates an existing API key.
   *
   * @param id The ID of the key to rotate
   * @returns The updated key and ID
   */
  async rotateKey(e) {
    return this.client.rotateKey({ id: e });
  }
  /**
   * Creates a new key with an existing key's authorizations
   *
   * @param id The ID of the key to duplicate
   * @returns The new key and ID
   */
  async createKeyFromExistingKeyAuthorizations(e) {
    return this.client.createKeyFromExistingKeyAuthorizations({ id: e });
  }
}
const Cg = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.PaymentMethodType",
  [
    { no: 0, name: "PAYMENT_METHOD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "PAYMENT_METHOD_TYPE_CARD", localName: "CARD" }
  ]
), Pg = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.UsageCostType",
  [
    { no: 0, name: "USAGE_COST_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "USAGE_COST_TYPE_DATA_UPLOAD", localName: "DATA_UPLOAD" },
    { no: 2, name: "USAGE_COST_TYPE_DATA_EGRESS", localName: "DATA_EGRESS" },
    { no: 3, name: "USAGE_COST_TYPE_REMOTE_CONTROL", localName: "REMOTE_CONTROL" },
    { no: 4, name: "USAGE_COST_TYPE_STANDARD_COMPUTE", localName: "STANDARD_COMPUTE" },
    { no: 5, name: "USAGE_COST_TYPE_CLOUD_STORAGE", localName: "CLOUD_STORAGE" },
    { no: 6, name: "USAGE_COST_TYPE_BINARY_DATA_CLOUD_STORAGE", localName: "BINARY_DATA_CLOUD_STORAGE" },
    { no: 7, name: "USAGE_COST_TYPE_OTHER_CLOUD_STORAGE", localName: "OTHER_CLOUD_STORAGE" },
    { no: 8, name: "USAGE_COST_TYPE_PER_MACHINE", localName: "PER_MACHINE" },
    { no: 9, name: "USAGE_COST_TYPE_TRIGGER_NOTIFICATION", localName: "TRIGGER_NOTIFICATION" }
  ]
), Dg = /* @__PURE__ */ o.makeEnum(
  "viam.app.v1.SourceType",
  [
    { no: 0, name: "SOURCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "SOURCE_TYPE_ORG", localName: "ORG" },
    { no: 2, name: "SOURCE_TYPE_FRAGMENT", localName: "FRAGMENT" }
  ]
), qg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.InvoiceSummary",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "invoice_date", kind: "message", T: I },
    {
      no: 3,
      name: "invoice_amount",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "status",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "due_date", kind: "message", T: I },
    { no: 6, name: "paid_date", kind: "message", T: I }
  ]
), Ag = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.PaymentMethodCard",
  () => [
    {
      no: 1,
      name: "brand",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "last_four_digits",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ug = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetCurrentMonthUsageRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Gg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.UsageCost",
  () => [
    { no: 1, name: "resource_type", kind: "enum", T: o.getEnumType(Pg) },
    {
      no: 2,
      name: "cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Lg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ResourceUsageCostsBySource",
  () => [
    { no: 1, name: "source_type", kind: "enum", T: o.getEnumType(Dg) },
    { no: 2, name: "resource_usage_costs", kind: "message", T: Bg },
    {
      no: 3,
      name: "tier_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Bg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.ResourceUsageCosts",
  () => [
    { no: 1, name: "usage_costs", kind: "message", T: Gg, repeated: !0 },
    {
      no: 2,
      name: "discount",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "total_with_discount",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "total_without_discount",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), xg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetCurrentMonthUsageResponse",
  () => [
    { no: 1, name: "start_date", kind: "message", T: I },
    { no: 2, name: "end_date", kind: "message", T: I },
    { no: 14, name: "resource_usage_costs_by_source", kind: "message", T: Lg, repeated: !0 },
    {
      no: 15,
      name: "subtotal",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 3,
      name: "cloud_storage_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "data_upload_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 5,
      name: "data_egres_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 6,
      name: "remote_control_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 7,
      name: "standard_compute_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 8,
      name: "discount_amount",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 9,
      name: "total_usage_with_discount",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 10,
      name: "total_usage_without_discount",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 11,
      name: "per_machine_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 12,
      name: "binary_data_cloud_storage_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 13,
      name: "other_cloud_storage_usage_cost",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), Fg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrgBillingInformationRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Jg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetOrgBillingInformationResponse",
  () => [
    { no: 1, name: "type", kind: "enum", T: o.getEnumType(Cg) },
    {
      no: 2,
      name: "billing_email",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "method", kind: "message", T: Ag, opt: !0 },
    { no: 4, name: "billing_tier", kind: "scalar", T: 9, opt: !0 }
  ]
), zg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetInvoicesSummaryRequest",
  () => [
    {
      no: 1,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), $g = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetInvoicesSummaryResponse",
  () => [
    {
      no: 1,
      name: "outstanding_balance",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 2, name: "invoices", kind: "message", T: qg, repeated: !0 }
  ]
), Yg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetInvoicePdfRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Wg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.GetInvoicePdfResponse",
  () => [
    {
      no: 1,
      name: "chunk",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), Vg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.SendPaymentRequiredEmailRequest",
  () => [
    {
      no: 1,
      name: "customer_org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "billing_owner_org_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), jg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.v1.SendPaymentRequiredEmailResponse",
  []
), wf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GetCurrentMonthUsageRequest: Ug,
  GetCurrentMonthUsageResponse: xg,
  GetInvoicePdfRequest: Yg,
  GetInvoicePdfResponse: Wg,
  GetInvoicesSummaryRequest: zg,
  GetInvoicesSummaryResponse: $g,
  GetOrgBillingInformationRequest: Fg,
  GetOrgBillingInformationResponse: Jg,
  InvoiceSummary: qg,
  PaymentMethodCard: Ag,
  PaymentMethodType: Cg,
  ResourceUsageCosts: Bg,
  ResourceUsageCostsBySource: Lg,
  SendPaymentRequiredEmailRequest: Vg,
  SendPaymentRequiredEmailResponse: jg,
  SourceType: Dg,
  UsageCost: Gg,
  UsageCostType: Pg
}, Symbol.toStringTag, { value: "Module" })), wh = {
  typeName: "viam.app.v1.BillingService",
  methods: {
    /**
     * Detailed breakdown of current month's costs
     *
     * @generated from rpc viam.app.v1.BillingService.GetCurrentMonthUsage
     */
    getCurrentMonthUsage: {
      name: "GetCurrentMonthUsage",
      I: Ug,
      O: xg,
      kind: m.Unary
    },
    /**
     * Org-level information (like billing email and payment details)
     *
     * @generated from rpc viam.app.v1.BillingService.GetOrgBillingInformation
     */
    getOrgBillingInformation: {
      name: "GetOrgBillingInformation",
      I: Fg,
      O: Jg,
      kind: m.Unary
    },
    /**
     * Total outstanding balance and previous invoices
     *
     * @generated from rpc viam.app.v1.BillingService.GetInvoicesSummary
     */
    getInvoicesSummary: {
      name: "GetInvoicesSummary",
      I: zg,
      O: $g,
      kind: m.Unary
    },
    /**
     * Download a PDF invoice
     *
     * @generated from rpc viam.app.v1.BillingService.GetInvoicePdf
     */
    getInvoicePdf: {
      name: "GetInvoicePdf",
      I: Yg,
      O: Wg,
      kind: m.ServerStreaming
    },
    /**
     * Send an email with a prompt to the user's org's billing page.
     *
     * @generated from rpc viam.app.v1.BillingService.SendPaymentRequiredEmail
     */
    sendPaymentRequiredEmail: {
      name: "SendPaymentRequiredEmail",
      I: Vg,
      O: jg,
      kind: m.Unary
    }
  }
};
class bh {
  client;
  constructor(e) {
    this.client = P(wh, e);
  }
  async getCurrentMonthUsage(e) {
    const n = await this.client.getCurrentMonthUsage({
      orgId: e
    });
    return n.start = n.startDate?.toDate(), n.end = n.endDate?.toDate(), n;
  }
  async getOrgBillingInformation(e) {
    return this.client.getOrgBillingInformation({
      orgId: e
    });
  }
  async getInvoicesSummary(e) {
    return this.client.getInvoicesSummary({
      orgId: e
    });
  }
  async getInvoicePdf(e, n) {
    const a = this.client.getInvoicePdf({
      id: e,
      orgId: n
    }), s = [];
    for await (const i of a)
      s.push(i.chunk);
    return _h(s);
  }
}
const _h = (t) => {
  const e = t.reduce((s, i) => s + i.length, 0), n = new Uint8Array(e);
  let a = 0;
  for (const s of t)
    n.set(s, a), a += s.length;
  return n;
};
var Hg = {}, Kg = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), function(e) {
    var n = (
      /** @class */
      function() {
        function k(v) {
          this._id = new Uint8Array(v);
        }
        return k.prototype.buffer = function() {
          return this._id;
        }, k;
      }()
    );
    e.UUID = n;
    var a = (
      /** @class */
      function() {
        function k(v) {
          this._id = new Uint8Array(v);
        }
        return k.prototype.buffer = function() {
          return this._id;
        }, k;
      }()
    );
    e.ObjectId = a;
    var s = (
      /** @class */
      function() {
        function k(v) {
          this._time = typeof v != "string" ? new Uint8Array(v || f(Date.now())) : f(+new Date(v));
        }
        return k.prototype.buffer = function() {
          return this._time;
        }, k.prototype.fromString = function(v) {
          this._time = f(+new Date(v));
        }, k.prototype.toNumber = function() {
          return w(this._time);
        }, k.prototype.toDate = function() {
          return new Date(w(this._time));
        }, k;
      }()
    );
    e.UTC = s;
    function i(k) {
      var v = 5;
      for (var g in k)
        v += r(g, k[g]);
      return v;
    }
    function r(k, v) {
      var g = 1;
      if (k && (g += F(k) + 1), v == null)
        return g;
      switch (v.constructor) {
        case String:
          return g + 4 + F(v) + 1;
        case Number:
          return Math.floor(v) === v && v <= 2147483647 && v >= -2147483647 ? g + 4 : g + 8;
        case Boolean:
          return g + 1;
        case Array:
        case Object:
          return g + i(v);
        case Int8Array:
        case Uint8Array:
          return g + 5 + v.byteLength;
        case Date:
        case s:
          return g + 8;
        case n:
          return g + 5 + 16;
        case a:
          return g + 12;
        default:
          return 0;
      }
    }
    function c(k) {
      var v = new Uint8Array(i(k));
      return d(k, v), v;
    }
    e.serialize = c;
    function d(k, v, g) {
      if (g === void 0 && (g = 0), g += T(v.length, v, g), k.constructor === Array)
        for (var y = 0, _ = k.length; y < _; y++)
          g = R(y.toString(), k[y], v, g);
      else
        for (var b in k)
          g = R(b, k[b], v, g);
      return v[g++] = 0, g;
    }
    function l(k, v, g) {
      var y = O(k), _ = y.length;
      return v.set(y, g), v[g + _++] = 0, _;
    }
    function T(k, v, g) {
      return v[g++] = k & 255, v[g++] = k >>> 8 & 255, v[g++] = k >>> 16 & 255, v[g++] = k >>> 24 & 255, 4;
    }
    function R(k, v, g, y) {
      if (v == null)
        return g[y++] = 10, y += l(k, g, y), y;
      switch (v.constructor) {
        case String:
          g[y++] = 2, y += l(k, g, y);
          var _ = l(v, g, y + 4);
          return y += T(_, g, y), y + _;
        case Number:
          if (Math.floor(v) === v)
            v <= 2147483647 && v >= -2147483647 ? (g[y++] = 16, y += l(k, g, y), y += T(v, g, y)) : (g[y++] = 18, y += l(k, g, y), g.set(f(v), y), y += 8);
          else {
            g[y++] = 1, y += l(k, g, y);
            var b = new Float64Array([v]), Z = new Uint8Array(b.buffer);
            g.set(Z, y), y += 8;
          }
          return y;
        case Boolean:
          return g[y++] = 8, y += l(k, g, y), g[y++] = v ? 1 : 0, y;
        case Array:
        case Object:
          g[y++] = v.constructor === Array ? 4 : 3, y += l(k, g, y);
          var D = d(v, g, y);
          return T(D - y, g, y), D;
        case Int8Array:
        case Uint8Array:
          return g[y++] = 5, y += l(k, g, y), y += T(v.byteLength, g, y), g[y++] = 0, g.set(v, y), y += v.byteLength, y;
        case Date:
          return g[y++] = 9, y += l(k, g, y), g.set(f(v.getTime()), y), y += 8, y;
        case s:
          return g[y++] = 9, y += l(k, g, y), g.set(v.buffer(), y), y += 8, y;
        case n:
          return g[y++] = 5, y += l(k, g, y), y += T(16, g, y), g[y++] = 4, g.set(v.buffer(), y), y += 16, y;
        case a:
          return g[y++] = 7, y += l(k, g, y), g.set(v.buffer(), y), y += 12, y;
        case RegExp:
          return g[y++] = 11, y += l(k, g, y), y += l(v.source, g, y), v.global && (g[y++] = 115), v.ignoreCase && (g[y++] = 105), v.multiline && (g[y++] = 109), g[y++] = 0, y;
        default:
          return y;
      }
    }
    function S(k, v, g, y) {
      if (v === void 0 && (v = !1), g === void 0 && (g = 0), y === void 0 && (y = !1), !(k.length < 5)) {
        var _ = k[g++] | k[g++] << 8 | k[g++] << 16 | k[g++] << 24;
        if (!(_ < 5 || _ > k.length) && k[k.length - 1] === 0) {
          for (var b = y ? [] : {}; ; ) {
            var Z = k[g++];
            if (Z === 0)
              break;
            for (var D = g; k[D] !== 0 && D < k.length; D++)
              ;
            if (D >= k.length - 1)
              return;
            var J = C(k.subarray(g, D));
            switch (y && (J = parseInt(J)), g = ++D, Z) {
              case 1:
                b[J] = new Float64Array(k.slice(g, g += 8).buffer)[0];
                break;
              case 2:
                _ = k[g++] | k[g++] << 8 | k[g++] << 16 | k[g++] << 24, b[J] = C(k.subarray(g, g += _ - 1)), g++;
                break;
              case 3:
                _ = k[g] | k[g + 1] << 8 | k[g + 2] << 16 | k[g + 3] << 24, b[J] = S(k, v, g, !1), g += _;
                break;
              case 4:
                _ = k[g] | k[g + 1] << 8 | k[g + 2] << 16 | k[g + 3] << 24, b[J] = S(k, v, g, !0), g += _;
                break;
              case 5:
                if (_ = k[g++] | k[g++] << 8 | k[g++] << 16 | k[g++] << 24, k[g++] === 4) {
                  if (_ !== 16)
                    return;
                  b[J] = new n(k.subarray(g, g += _));
                } else
                  b[J] = k.slice(g, g += _);
                break;
              case 6:
                b[J] = null;
                break;
              case 7:
                b[J] = new a(k.subarray(g, g += 12));
                break;
              case 8:
                b[J] = k[g++] === 1;
                break;
              case 9:
                b[J] = v ? new s(k.subarray(g, g += 8)) : new Date(w(k.subarray(g, g += 8)));
                break;
              case 10:
                b[J] = null;
                break;
              case 11:
                for (D = g; D < k.length && k[D++] !== 0; )
                  ;
                if (D >= k.length)
                  return;
                var ft = C(k.subarray(g, D));
                for (g = D; D < k.length && k[D++] !== 0; )
                  ;
                if (D >= k.length)
                  return;
                var Rt = C(k.subarray(g, D));
                g = D, b[J] = new RegExp(ft, Rt);
                break;
              case 16:
                b[J] = k[g++] | k[g++] << 8 | k[g++] << 16 | k[g++] << 24;
                break;
              case 18:
                b[J] = w(k.subarray(g, g += 8));
                break;
              default:
                return;
            }
          }
          return b;
        }
      }
    }
    e.deserialize = S;
    function f(k) {
      var v = new Uint8Array(8);
      if (Math.floor(k) === k) {
        var g = 4294967296, y = k % g | 0, _ = k / g | 0;
        k < 0 && (y = ~(-k % g) | 0, _ = ~(-k / g) | 0, y = y + 1 & 4294967295, y || _++);
        var b = 0;
        v[b++] = y & 255, v[b++] = y >>> 8 & 255, v[b++] = y >>> 16 & 255, v[b++] = y >>> 24 & 255, v[b++] = _ & 255, v[b++] = _ >>> 8 & 255, v[b++] = _ >>> 16 & 255, v[b] = _ >>> 24 & 255;
      } else {
        var Z = new Float64Array([k]), D = new Uint8Array(Z.buffer);
        v.set(D);
      }
      return v;
    }
    function w(k, v) {
      v === void 0 && (v = 0);
      var g = 4294967296, y = k[v++] | k[v++] << 8 | k[v++] << 16 | k[v++] << 24, _ = k[v++] | k[v++] << 8 | k[v++] << 16 | k[v] << 24;
      return _ * g + (y >= 0 ? y : g + y);
    }
    function O(k) {
      k = k.replace(/\r\n/g, `
`);
      for (var v = [], g = 0, y = 0, _ = k.length; y < _; y++) {
        var b = k.charCodeAt(y);
        b < 128 ? v[g++] = b : b < 2048 ? (v[g++] = b >>> 6 | 192, v[g++] = b & 63 | 128) : (v[g++] = b >>> 12 | 224, v[g++] = b >>> 6 & 63 | 128, v[g++] = b & 63 | 128);
      }
      return new Uint8Array(v);
    }
    function C(k) {
      for (var v = "", g = k.length, y = 0, _, b, Z; y < g; )
        _ = k[y], _ < 128 ? (v += String.fromCharCode(_), y++) : _ > 191 && _ < 224 ? (b = k[y + 1], v += String.fromCharCode((_ & 31) << 6 | b & 63), y += 2) : (b = k[y + 1], Z = k[y + 2], v += String.fromCharCode((_ & 15) << 12 | (b & 63) << 6 | Z & 63), y += 3);
      return v;
    }
    function F(k) {
      return encodeURI(k).split(/%..|./).length - 1;
    }
  }(t.BSON || (t.BSON = {}));
})(Kg);
Object.defineProperty(Hg, "__esModule", { value: !0 });
var Eh = Kg, ni = Hg.BSON = Eh.BSON;
const Xg = /* @__PURE__ */ o.makeEnum(
  "viam.app.data.v1.Order",
  [
    { no: 0, name: "ORDER_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "ORDER_DESCENDING", localName: "DESCENDING" },
    { no: 2, name: "ORDER_ASCENDING", localName: "ASCENDING" }
  ]
), Qg = /* @__PURE__ */ o.makeEnum(
  "viam.app.data.v1.TagsFilterType",
  [
    { no: 0, name: "TAGS_FILTER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "TAGS_FILTER_TYPE_MATCH_BY_OR", localName: "MATCH_BY_OR" },
    { no: 2, name: "TAGS_FILTER_TYPE_TAGGED", localName: "TAGGED" },
    { no: 3, name: "TAGS_FILTER_TYPE_UNTAGGED", localName: "UNTAGGED" }
  ]
), To = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.DataRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: ze },
    {
      no: 2,
      name: "limit",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    },
    {
      no: 3,
      name: "last",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "sort_order", kind: "enum", T: o.getEnumType(Xg) }
  ]
), ze = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.Filter",
  () => [
    {
      no: 1,
      name: "component_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "component_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "method",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "robot_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "robot_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 8,
      name: "part_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 9,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 10, name: "location_ids", kind: "scalar", T: 9, repeated: !0 },
    { no: 11, name: "organization_ids", kind: "scalar", T: 9, repeated: !0 },
    { no: 12, name: "mime_type", kind: "scalar", T: 9, repeated: !0 },
    { no: 13, name: "interval", kind: "message", T: ht },
    { no: 14, name: "tags_filter", kind: "message", T: ko },
    { no: 15, name: "bbox_labels", kind: "scalar", T: 9, repeated: !0 },
    {
      no: 16,
      name: "dataset_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ko = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TagsFilter",
  () => [
    { no: 1, name: "type", kind: "enum", T: o.getEnumType(Qg) },
    { no: 2, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), vt = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.CaptureMetadata",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "robot_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "robot_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "part_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "component_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 9,
      name: "component_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 10,
      name: "method_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 11, name: "method_parameters", kind: "map", K: 9, V: { kind: "message", T: W } },
    { no: 12, name: "tags", kind: "scalar", T: 9, repeated: !0 },
    {
      no: 13,
      name: "mime_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ht = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.CaptureInterval",
  () => [
    { no: 1, name: "start", kind: "message", T: I },
    { no: 2, name: "end", kind: "message", T: I }
  ]
), Zg = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TabularDataByFilterRequest",
  () => [
    { no: 1, name: "data_request", kind: "message", T: To },
    {
      no: 2,
      name: "count_only",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 3,
      name: "include_internal_data",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), eT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TabularDataByFilterResponse",
  () => [
    { no: 1, name: "metadata", kind: "message", T: vt, repeated: !0 },
    { no: 2, name: "data", kind: "message", T: nT, repeated: !0 },
    {
      no: 3,
      name: "count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    },
    {
      no: 4,
      name: "last",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "total_size_bytes",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), nT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TabularData",
  () => [
    { no: 1, name: "data", kind: "message", T: u },
    {
      no: 2,
      name: "metadata_index",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    },
    { no: 3, name: "time_requested", kind: "message", T: I },
    { no: 4, name: "time_received", kind: "message", T: I }
  ]
), tT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TabularDataBySQLRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "sql_query",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), aT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TabularDataBySQLResponse",
  () => [
    { no: 2, name: "raw_data", kind: "scalar", T: 12, repeated: !0 }
  ]
), sT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TabularDataByMQLRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "mql_binary", kind: "scalar", T: 12, repeated: !0 }
  ]
), oT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TabularDataByMQLResponse",
  () => [
    { no: 2, name: "raw_data", kind: "scalar", T: 12, repeated: !0 }
  ]
), iT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.ExportTabularDataRequest",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "resource_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "resource_subtype",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "method_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "interval", kind: "message", T: ht }
  ]
), rT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.ExportTabularDataResponse",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "resource_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "resource_subtype",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "method_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "time_captured", kind: "message", T: I },
    {
      no: 6,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 8,
      name: "robot_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 9,
      name: "robot_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 10,
      name: "part_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 11, name: "method_parameters", kind: "message", T: u },
    { no: 12, name: "tags", kind: "scalar", T: 9, repeated: !0 },
    { no: 13, name: "payload", kind: "message", T: u }
  ]
), mT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.GetLatestTabularDataRequest",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "resource_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "method_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "resource_subtype",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), cT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.GetLatestTabularDataResponse",
  () => [
    { no: 1, name: "time_captured", kind: "message", T: I },
    { no: 2, name: "time_synced", kind: "message", T: I },
    { no: 3, name: "payload", kind: "message", T: u }
  ]
), yo = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BinaryData",
  () => [
    {
      no: 1,
      name: "binary",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    { no: 2, name: "metadata", kind: "message", T: kT }
  ]
), lT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BinaryDataByFilterRequest",
  () => [
    { no: 1, name: "data_request", kind: "message", T: To },
    {
      no: 2,
      name: "include_binary",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 3,
      name: "count_only",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 4,
      name: "include_internal_data",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), dT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BinaryDataByFilterResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: yo, repeated: !0 },
    {
      no: 2,
      name: "count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    },
    {
      no: 3,
      name: "last",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "total_size_bytes",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), ce = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BinaryID",
  () => [
    {
      no: 1,
      name: "file_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "location_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), uT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BinaryDataByIDsRequest",
  () => [
    {
      no: 2,
      name: "include_binary",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 3, name: "binary_ids", kind: "message", T: ce, repeated: !0 }
  ]
), pT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BinaryDataByIDsResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: yo, repeated: !0 },
    {
      no: 2,
      name: "count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), gT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BoundingBox",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "label",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "x_min_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "y_min_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 5,
      name: "x_max_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 6,
      name: "y_max_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    { no: 7, name: "confidence", kind: "scalar", T: 1, opt: !0 }
  ]
), TT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.Classification",
  () => [
    {
      no: 1,
      name: "label",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "confidence", kind: "scalar", T: 1, opt: !0 }
  ]
), vo = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.Annotations",
  () => [
    { no: 1, name: "bboxes", kind: "message", T: gT, repeated: !0 },
    { no: 2, name: "classifications", kind: "message", T: TT, repeated: !0 }
  ]
), kT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BinaryMetadata",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "capture_metadata", kind: "message", T: vt },
    { no: 3, name: "time_requested", kind: "message", T: I },
    { no: 4, name: "time_received", kind: "message", T: I },
    {
      no: 5,
      name: "file_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "file_ext",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "uri",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 8, name: "annotations", kind: "message", T: vo },
    { no: 9, name: "dataset_ids", kind: "scalar", T: 9, repeated: !0 }
  ]
), yT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.DeleteTabularDataRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "delete_older_than_days",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    }
  ]
), vT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.DeleteTabularDataResponse",
  () => [
    {
      no: 1,
      name: "deleted_count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), hT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.DeleteBinaryDataByFilterRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: ze },
    {
      no: 2,
      name: "include_internal_data",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), fT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.DeleteBinaryDataByFilterResponse",
  () => [
    {
      no: 1,
      name: "deleted_count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), RT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.DeleteBinaryDataByIDsRequest",
  () => [
    { no: 2, name: "binary_ids", kind: "message", T: ce, repeated: !0 }
  ]
), IT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.DeleteBinaryDataByIDsResponse",
  () => [
    {
      no: 1,
      name: "deleted_count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), ST = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddTagsToBinaryDataByIDsRequest",
  () => [
    { no: 3, name: "binary_ids", kind: "message", T: ce, repeated: !0 },
    { no: 2, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), wT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddTagsToBinaryDataByIDsResponse",
  []
), bT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddTagsToBinaryDataByFilterRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: ze },
    { no: 2, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), _T = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddTagsToBinaryDataByFilterResponse",
  []
), ET = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveTagsFromBinaryDataByIDsRequest",
  () => [
    { no: 3, name: "binary_ids", kind: "message", T: ce, repeated: !0 },
    { no: 2, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), MT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveTagsFromBinaryDataByIDsResponse",
  () => [
    {
      no: 1,
      name: "deleted_count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), OT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveTagsFromBinaryDataByFilterRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: ze },
    { no: 2, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), NT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveTagsFromBinaryDataByFilterResponse",
  () => [
    {
      no: 1,
      name: "deleted_count",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]
), CT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TagsByFilterRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: ze }
  ]
), PT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.TagsByFilterResponse",
  () => [
    { no: 1, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), DT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddBoundingBoxToImageByIDRequest",
  () => [
    { no: 7, name: "binary_id", kind: "message", T: ce },
    {
      no: 2,
      name: "label",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "x_min_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 4,
      name: "y_min_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 5,
      name: "x_max_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    },
    {
      no: 6,
      name: "y_max_normalized",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]
), qT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddBoundingBoxToImageByIDResponse",
  () => [
    {
      no: 1,
      name: "bbox_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), AT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveBoundingBoxFromImageByIDRequest",
  () => [
    { no: 3, name: "binary_id", kind: "message", T: ce },
    {
      no: 2,
      name: "bbox_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), UT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveBoundingBoxFromImageByIDResponse",
  []
), GT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.UpdateBoundingBoxRequest",
  () => [
    { no: 1, name: "binary_id", kind: "message", T: ce },
    {
      no: 2,
      name: "bbox_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "label", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "x_min_normalized", kind: "scalar", T: 1, opt: !0 },
    { no: 5, name: "y_min_normalized", kind: "scalar", T: 1, opt: !0 },
    { no: 6, name: "x_max_normalized", kind: "scalar", T: 1, opt: !0 },
    { no: 7, name: "y_max_normalized", kind: "scalar", T: 1, opt: !0 }
  ]
), LT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.UpdateBoundingBoxResponse",
  []
), BT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BoundingBoxLabelsByFilterRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: ze }
  ]
), xT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.BoundingBoxLabelsByFilterResponse",
  () => [
    { no: 1, name: "labels", kind: "scalar", T: 9, repeated: !0 }
  ]
), FT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.ConfigureDatabaseUserRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "password",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), JT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.ConfigureDatabaseUserResponse",
  []
), zT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.GetDatabaseConnectionRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), $T = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.GetDatabaseConnectionResponse",
  () => [
    {
      no: 1,
      name: "hostname",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "mongodb_uri",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "has_database_user",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]
), YT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddBinaryDataToDatasetByIDsRequest",
  () => [
    { no: 1, name: "binary_ids", kind: "message", T: ce, repeated: !0 },
    {
      no: 2,
      name: "dataset_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), WT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.AddBinaryDataToDatasetByIDsResponse",
  []
), VT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsRequest",
  () => [
    { no: 1, name: "binary_ids", kind: "message", T: ce, repeated: !0 },
    {
      no: 2,
      name: "dataset_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), jT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsResponse",
  []
), bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddBinaryDataToDatasetByIDsRequest: YT,
  AddBinaryDataToDatasetByIDsResponse: WT,
  AddBoundingBoxToImageByIDRequest: DT,
  AddBoundingBoxToImageByIDResponse: qT,
  AddTagsToBinaryDataByFilterRequest: bT,
  AddTagsToBinaryDataByFilterResponse: _T,
  AddTagsToBinaryDataByIDsRequest: ST,
  AddTagsToBinaryDataByIDsResponse: wT,
  Annotations: vo,
  BinaryData: yo,
  BinaryDataByFilterRequest: lT,
  BinaryDataByFilterResponse: dT,
  BinaryDataByIDsRequest: uT,
  BinaryDataByIDsResponse: pT,
  BinaryID: ce,
  BinaryMetadata: kT,
  BoundingBox: gT,
  BoundingBoxLabelsByFilterRequest: BT,
  BoundingBoxLabelsByFilterResponse: xT,
  CaptureInterval: ht,
  CaptureMetadata: vt,
  Classification: TT,
  ConfigureDatabaseUserRequest: FT,
  ConfigureDatabaseUserResponse: JT,
  DataRequest: To,
  DeleteBinaryDataByFilterRequest: hT,
  DeleteBinaryDataByFilterResponse: fT,
  DeleteBinaryDataByIDsRequest: RT,
  DeleteBinaryDataByIDsResponse: IT,
  DeleteTabularDataRequest: yT,
  DeleteTabularDataResponse: vT,
  ExportTabularDataRequest: iT,
  ExportTabularDataResponse: rT,
  Filter: ze,
  GetDatabaseConnectionRequest: zT,
  GetDatabaseConnectionResponse: $T,
  GetLatestTabularDataRequest: mT,
  GetLatestTabularDataResponse: cT,
  Order: Xg,
  RemoveBinaryDataFromDatasetByIDsRequest: VT,
  RemoveBinaryDataFromDatasetByIDsResponse: jT,
  RemoveBoundingBoxFromImageByIDRequest: AT,
  RemoveBoundingBoxFromImageByIDResponse: UT,
  RemoveTagsFromBinaryDataByFilterRequest: OT,
  RemoveTagsFromBinaryDataByFilterResponse: NT,
  RemoveTagsFromBinaryDataByIDsRequest: ET,
  RemoveTagsFromBinaryDataByIDsResponse: MT,
  TabularData: nT,
  TabularDataByFilterRequest: Zg,
  TabularDataByFilterResponse: eT,
  TabularDataByMQLRequest: sT,
  TabularDataByMQLResponse: oT,
  TabularDataBySQLRequest: tT,
  TabularDataBySQLResponse: aT,
  TagsByFilterRequest: CT,
  TagsByFilterResponse: PT,
  TagsFilter: ko,
  TagsFilterType: Qg,
  UpdateBoundingBoxRequest: GT,
  UpdateBoundingBoxResponse: LT
}, Symbol.toStringTag, { value: "Module" })), Mh = {
  typeName: "viam.app.data.v1.DataService",
  methods: {
    /**
     * TabularDataByFilter queries tabular data and metadata based on given filters.
     *
     * @generated from rpc viam.app.data.v1.DataService.TabularDataByFilter
     * @deprecated
     */
    tabularDataByFilter: {
      name: "TabularDataByFilter",
      I: Zg,
      O: eT,
      kind: m.Unary
    },
    /**
     * TabularDataBySQL queries tabular data with a SQL query.
     *
     * @generated from rpc viam.app.data.v1.DataService.TabularDataBySQL
     */
    tabularDataBySQL: {
      name: "TabularDataBySQL",
      I: tT,
      O: aT,
      kind: m.Unary
    },
    /**
     * TabularDataByMQL queries tabular data with an MQL (MongoDB Query Language) query.
     *
     * @generated from rpc viam.app.data.v1.DataService.TabularDataByMQL
     */
    tabularDataByMQL: {
      name: "TabularDataByMQL",
      I: sT,
      O: oT,
      kind: m.Unary
    },
    /**
     * ExportTabularData queries tabular data from the specified data source.
     *
     * @generated from rpc viam.app.data.v1.DataService.ExportTabularData
     */
    exportTabularData: {
      name: "ExportTabularData",
      I: iT,
      O: rT,
      kind: m.ServerStreaming
    },
    /**
     * GetLatestTabularData gets the most recent tabular data captured from the specified data source.
     *
     * @generated from rpc viam.app.data.v1.DataService.GetLatestTabularData
     */
    getLatestTabularData: {
      name: "GetLatestTabularData",
      I: mT,
      O: cT,
      kind: m.Unary
    },
    /**
     * BinaryDataByFilter queries binary data and metadata based on given filters.
     *
     * @generated from rpc viam.app.data.v1.DataService.BinaryDataByFilter
     */
    binaryDataByFilter: {
      name: "BinaryDataByFilter",
      I: lT,
      O: dT,
      kind: m.Unary
    },
    /**
     * BinaryDataByIDs queries binary data and metadata based on given IDs.
     *
     * @generated from rpc viam.app.data.v1.DataService.BinaryDataByIDs
     */
    binaryDataByIDs: {
      name: "BinaryDataByIDs",
      I: uT,
      O: pT,
      kind: m.Unary
    },
    /**
     * DeleteTabularData deletes tabular data older than a number of days, based on the given organization ID.
     *
     * @generated from rpc viam.app.data.v1.DataService.DeleteTabularData
     */
    deleteTabularData: {
      name: "DeleteTabularData",
      I: yT,
      O: vT,
      kind: m.Unary
    },
    /**
     * DeleteBinaryDataByFilter deletes binary data based on given filters.
     *
     * @generated from rpc viam.app.data.v1.DataService.DeleteBinaryDataByFilter
     */
    deleteBinaryDataByFilter: {
      name: "DeleteBinaryDataByFilter",
      I: hT,
      O: fT,
      kind: m.Unary
    },
    /**
     * DeleteBinaryDataByIDs deletes binary data based on given IDs.
     *
     * @generated from rpc viam.app.data.v1.DataService.DeleteBinaryDataByIDs
     */
    deleteBinaryDataByIDs: {
      name: "DeleteBinaryDataByIDs",
      I: RT,
      O: IT,
      kind: m.Unary
    },
    /**
     * AddTagsToBinaryDataByIDs adds string tags, unless the tags are already present, to binary data based on given IDs.
     *
     * @generated from rpc viam.app.data.v1.DataService.AddTagsToBinaryDataByIDs
     */
    addTagsToBinaryDataByIDs: {
      name: "AddTagsToBinaryDataByIDs",
      I: ST,
      O: wT,
      kind: m.Unary
    },
    /**
     * AddTagsToBinaryDataByFilter adds string tags, unless the tags are already present, to binary data based on the given filter.
     *
     * @generated from rpc viam.app.data.v1.DataService.AddTagsToBinaryDataByFilter
     */
    addTagsToBinaryDataByFilter: {
      name: "AddTagsToBinaryDataByFilter",
      I: bT,
      O: _T,
      kind: m.Unary
    },
    /**
     * RemoveTagsToBinaryDataByIDs removes string tags from binary data based on given IDs.
     *
     * @generated from rpc viam.app.data.v1.DataService.RemoveTagsFromBinaryDataByIDs
     */
    removeTagsFromBinaryDataByIDs: {
      name: "RemoveTagsFromBinaryDataByIDs",
      I: ET,
      O: MT,
      kind: m.Unary
    },
    /**
     * RemoveTagsToBinaryDataByFilter removes string tags from binary data based on the given filter.
     *
     * @generated from rpc viam.app.data.v1.DataService.RemoveTagsFromBinaryDataByFilter
     */
    removeTagsFromBinaryDataByFilter: {
      name: "RemoveTagsFromBinaryDataByFilter",
      I: OT,
      O: NT,
      kind: m.Unary
    },
    /**
     * TagsByFilter gets all unique tags from data based on given filter.
     *
     * @generated from rpc viam.app.data.v1.DataService.TagsByFilter
     */
    tagsByFilter: {
      name: "TagsByFilter",
      I: CT,
      O: PT,
      kind: m.Unary
    },
    /**
     * AddBoundingBoxToImageByID adds a bounding box to an image with the given ID.
     *
     * @generated from rpc viam.app.data.v1.DataService.AddBoundingBoxToImageByID
     */
    addBoundingBoxToImageByID: {
      name: "AddBoundingBoxToImageByID",
      I: DT,
      O: qT,
      kind: m.Unary
    },
    /**
     * RemoveBoundingBoxFromImageByID removes a bounding box from an image with the given ID.
     *
     * @generated from rpc viam.app.data.v1.DataService.RemoveBoundingBoxFromImageByID
     */
    removeBoundingBoxFromImageByID: {
      name: "RemoveBoundingBoxFromImageByID",
      I: AT,
      O: UT,
      kind: m.Unary
    },
    /**
     * BoundingBoxLabelsByFilter gets all string labels for bounding boxes from data based on given filter.
     *
     * @generated from rpc viam.app.data.v1.DataService.BoundingBoxLabelsByFilter
     */
    boundingBoxLabelsByFilter: {
      name: "BoundingBoxLabelsByFilter",
      I: BT,
      O: xT,
      kind: m.Unary
    },
    /**
     * UpdateBoundingBox updates the bounding box associated with a given binary ID and bounding box ID.
     *
     * @generated from rpc viam.app.data.v1.DataService.UpdateBoundingBox
     */
    updateBoundingBox: {
      name: "UpdateBoundingBox",
      I: GT,
      O: LT,
      kind: m.Unary
    },
    /**
     * GetDatabaseConnection gets a connection to access a MongoDB Atlas Data Federation instance. It
     * returns the hostname of the federated database.
     *
     * @generated from rpc viam.app.data.v1.DataService.GetDatabaseConnection
     */
    getDatabaseConnection: {
      name: "GetDatabaseConnection",
      I: zT,
      O: $T,
      kind: m.Unary
    },
    /**
     * ConfigureDatabaseUser configures a database user for the Viam organization's MongoDB Atlas Data
     * Federation instance. It can also be used to reset the password of the existing database user.
     *
     * @generated from rpc viam.app.data.v1.DataService.ConfigureDatabaseUser
     */
    configureDatabaseUser: {
      name: "ConfigureDatabaseUser",
      I: FT,
      O: JT,
      kind: m.Unary
    },
    /**
     * AddBinaryDataToDatasetByIDs adds the binary data with the given binary IDs to the dataset.
     *
     * @generated from rpc viam.app.data.v1.DataService.AddBinaryDataToDatasetByIDs
     */
    addBinaryDataToDatasetByIDs: {
      name: "AddBinaryDataToDatasetByIDs",
      I: YT,
      O: WT,
      kind: m.Unary
    },
    /**
     * RemoveBinaryDataFromDatasetByIDs removes the binary data with the given binary IDs from the dataset.
     *
     * @generated from rpc viam.app.data.v1.DataService.RemoveBinaryDataFromDatasetByIDs
     */
    removeBinaryDataFromDatasetByIDs: {
      name: "RemoveBinaryDataFromDatasetByIDs",
      I: VT,
      O: jT,
      kind: m.Unary
    }
  }
}, HT = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.Dataset",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "time_created", kind: "message", T: I }
  ]
), Oh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.CreateDatasetRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Nh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.CreateDatasetResponse",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ch = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.DeleteDatasetRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Ph = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.DeleteDatasetResponse",
  []
), Dh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.RenameDatasetRequest",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), qh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.RenameDatasetResponse",
  []
), Ah = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.ListDatasetsByOrganizationIDRequest",
  () => [
    {
      no: 1,
      name: "organization_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Uh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.ListDatasetsByOrganizationIDResponse",
  () => [
    { no: 1, name: "datasets", kind: "message", T: HT, repeated: !0 }
  ]
), Gh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.ListDatasetsByIDsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9, repeated: !0 }
  ]
), Lh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.dataset.v1.ListDatasetsByIDsResponse",
  () => [
    { no: 1, name: "datasets", kind: "message", T: HT, repeated: !0 }
  ]
), Bh = {
  typeName: "viam.app.dataset.v1.DatasetService",
  methods: {
    /**
     * CreateDataset makes a new dataset.
     *
     * @generated from rpc viam.app.dataset.v1.DatasetService.CreateDataset
     */
    createDataset: {
      name: "CreateDataset",
      I: Oh,
      O: Nh,
      kind: m.Unary
    },
    /**
     * DeleteDatasets deletes an existing dataset.
     *
     * @generated from rpc viam.app.dataset.v1.DatasetService.DeleteDataset
     */
    deleteDataset: {
      name: "DeleteDataset",
      I: Ch,
      O: Ph,
      kind: m.Unary
    },
    /**
     * RenameDataset modifies the name of an existing dataset.
     *
     * @generated from rpc viam.app.dataset.v1.DatasetService.RenameDataset
     */
    renameDataset: {
      name: "RenameDataset",
      I: Dh,
      O: qh,
      kind: m.Unary
    },
    /**
     * ListDatasetsByOrganizationID lists all of the datasets for an organization.
     *
     * @generated from rpc viam.app.dataset.v1.DatasetService.ListDatasetsByOrganizationID
     */
    listDatasetsByOrganizationID: {
      name: "ListDatasetsByOrganizationID",
      I: Ah,
      O: Uh,
      kind: m.Unary
    },
    /**
     * ListDatasetsByIDs lists all of the datasets specified by the given dataset IDs.
     *
     * @generated from rpc viam.app.dataset.v1.DatasetService.ListDatasetsByIDs
     */
    listDatasetsByIDs: {
      name: "ListDatasetsByIDs",
      I: Gh,
      O: Lh,
      kind: m.Unary
    }
  }
}, xh = /* @__PURE__ */ o.makeEnum(
  "viam.app.datasync.v1.MimeType",
  [
    { no: 0, name: "MIME_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "MIME_TYPE_IMAGE_JPEG", localName: "IMAGE_JPEG" },
    { no: 2, name: "MIME_TYPE_IMAGE_PNG", localName: "IMAGE_PNG" },
    { no: 3, name: "MIME_TYPE_APPLICATION_PCD", localName: "APPLICATION_PCD" }
  ]
), Ft = /* @__PURE__ */ o.makeEnum(
  "viam.app.datasync.v1.DataType",
  [
    { no: 0, name: "DATA_TYPE_UNSPECIFIED", localName: "UNSPECIFIED" },
    { no: 1, name: "DATA_TYPE_BINARY_SENSOR", localName: "BINARY_SENSOR" },
    { no: 2, name: "DATA_TYPE_TABULAR_SENSOR", localName: "TABULAR_SENSOR" },
    { no: 3, name: "DATA_TYPE_FILE", localName: "FILE" }
  ]
), Jt = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.DataCaptureUploadRequest",
  () => [
    { no: 1, name: "metadata", kind: "message", T: Rn },
    { no: 2, name: "sensor_contents", kind: "message", T: zt, repeated: !0 }
  ]
), Fh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.DataCaptureUploadResponse",
  () => [
    {
      no: 1,
      name: "file_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), Jh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.FileUploadRequest",
  () => [
    { no: 1, name: "metadata", kind: "message", T: Rn, oneof: "upload_packet" },
    { no: 2, name: "file_contents", kind: "message", T: Wh, oneof: "upload_packet" }
  ]
), zh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.FileUploadResponse",
  () => [
    {
      no: 1,
      name: "file_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), $h = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.StreamingDataCaptureUploadRequest",
  () => [
    { no: 1, name: "metadata", kind: "message", T: Vh, oneof: "upload_packet" },
    { no: 2, name: "data", kind: "scalar", T: 12, oneof: "upload_packet" }
  ]
), Yh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.StreamingDataCaptureUploadResponse",
  () => [
    {
      no: 1,
      name: "file_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ho = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.SensorMetadata",
  () => [
    { no: 1, name: "time_requested", kind: "message", T: I },
    { no: 2, name: "time_received", kind: "message", T: I },
    { no: 3, name: "mime_type", kind: "enum", T: o.getEnumType(xh) },
    { no: 4, name: "annotations", kind: "message", T: vo }
  ]
), zt = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.SensorData",
  () => [
    { no: 1, name: "metadata", kind: "message", T: ho },
    { no: 2, name: "struct", kind: "message", T: u, oneof: "data" },
    { no: 3, name: "binary", kind: "scalar", T: 12, oneof: "data" }
  ]
), Wh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.FileData",
  () => [
    {
      no: 1,
      name: "data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]
), Rn = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.UploadMetadata",
  () => [
    {
      no: 1,
      name: "part_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "component_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "component_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "method_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 6, name: "type", kind: "enum", T: o.getEnumType(Ft) },
    {
      no: 7,
      name: "file_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 8, name: "method_parameters", kind: "map", K: 9, V: { kind: "message", T: W } },
    {
      no: 9,
      name: "file_extension",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 10, name: "tags", kind: "scalar", T: 9, repeated: !0 }
  ]
), Vh = /* @__PURE__ */ o.makeMessageType(
  "viam.app.datasync.v1.DataCaptureUploadMetadata",
  () => [
    { no: 1, name: "upload_metadata", kind: "message", T: Rn },
    { no: 2, name: "sensor_metadata", kind: "message", T: ho }
  ]
), jh = {
  typeName: "viam.app.datasync.v1.DataSyncService",
  methods: {
    /**
     * DataCaptureUpload uploads the contents and metadata for tabular data.
     *
     * @generated from rpc viam.app.datasync.v1.DataSyncService.DataCaptureUpload
     */
    dataCaptureUpload: {
      name: "DataCaptureUpload",
      I: Jt,
      O: Fh,
      kind: m.Unary
    },
    /**
     * FileUpload uploads the contents and metadata for binary (image + file) data,
     * where the first packet must be the UploadMetadata.
     *
     * @generated from rpc viam.app.datasync.v1.DataSyncService.FileUpload
     */
    fileUpload: {
      name: "FileUpload",
      I: Jh,
      O: zh,
      kind: m.ClientStreaming
    },
    /**
     * StreamingDataCaptureUpload uploads the streaming contents and metadata for streaming binary (image + file) data,
     * where the first packet must be the UploadMetadata.
     *
     * @generated from rpc viam.app.datasync.v1.DataSyncService.StreamingDataCaptureUpload
     */
    streamingDataCaptureUpload: {
      name: "StreamingDataCaptureUpload",
      I: $h,
      O: Yh,
      kind: m.ClientStreaming
    }
  }
};
class Hh {
  dataClient;
  datasetClient;
  dataSyncClient;
  constructor(e) {
    this.dataClient = P(Mh, e), this.datasetClient = P(Bh, e), this.dataSyncClient = P(jh, e);
  }
  /**
   * Obtain unified tabular data and metadata, queried with SQL.
   *
   * @param organizationId The ID of the organization that owns the data
   * @param query The SQL query to run
   * @returns An array of data objects
   */
  async tabularDataBySQL(e, n) {
    return (await this.dataClient.tabularDataBySQL({
      organizationId: e,
      sqlQuery: n
    })).rawData.map((s) => ni.deserialize(s));
  }
  /**
   * Obtain unified tabular data and metadata, queried with MQL.
   *
   * @param organizationId The ID of the organization that owns the data
   * @param query The MQL query to run as a list of BSON documents
   * @returns An array of data objects
   */
  async tabularDataByMQL(e, n) {
    return (await this.dataClient.tabularDataByMQL({
      organizationId: e,
      mqlBinary: n
    })).rawData.map((s) => ni.deserialize(s));
  }
  /**
   * Filter and get a page of tabular data. The returned metadata might be empty
   * if the metadata index of the data is out of the bounds of the returned
   * metadata list. The data will be paginated into pages of `limit` items, and
   * the pagination ID will be included in the returned tuple.
   *
   * @param filter Optional `pb.Filter` specifying tabular data to retrieve. No
   *   `filter` implies all tabular data.
   * @param limit The maximum number of entries to include in a page. Defaults
   *   to 50 if unspecfied
   * @param sortOrder The desired sort order of the data
   * @param last Optional string indicating the ID of the last-returned data. If
   *   provided, the server will return the next data entries after the `last`
   *   ID.
   * @param countOnly Whether to return only the total count of entries
   * @param includeInternalData Whether to retun internal data. Internal data is
   *   used for Viam-specific data ingestion, like cloud SLAM. Defaults to
   *   `false`.
   * @returns An array of data objects, the count (number of entries), and the
   *   last-returned page ID.
   */
  async tabularDataByFilter(e, n, a, s = "", i = !1, r = !1) {
    const d = {
      dataRequest: {
        filter: e,
        limit: n === void 0 ? void 0 : BigInt(n),
        sortOrder: a,
        last: s
      },
      countOnly: i,
      includeInternalData: r
    }, l = await this.dataClient.tabularDataByFilter(d), T = l.metadata.length, R = [];
    return R.push(
      ...l.data.map((S) => {
        const f = S.metadataIndex, w = T !== 0 && f >= T ? new vt() : l.metadata[f];
        return {
          data: S.data?.toJson(),
          metadata: w,
          timeRequested: S.timeRequested?.toDate(),
          timeReceived: S.timeRequested?.toDate()
        };
      })
    ), {
      data: R,
      count: l.count,
      last: l.last
    };
  }
  /**
   * Filter and get a page of binary data. The returned metadata might be empty
   * if the metadata index of the data is out of the bounds of the returned
   * metadata list. The data will be paginated into pages of `limit` items, and
   * the pagination ID will be included in the returned tuple.
   *
   * @param filter Optional `pb.Filter` specifying binary data to retrieve. No
   *   `filter` implies all binary data.
   * @param limit The maximum number of entries to include in a page. Defaults
   *   to 50 if unspecfied
   * @param sortOrder The desired sort order of the data
   * @param last Optional string indicating the ID of the last-returned data. If
   *   provided, the server will return the next data entries after the `last`
   *   ID.
   * @param includeBinary Whether to include binary file data with each
   *   retrieved file
   * @param countOnly Whether to return only the total count of entries
   * @param includeInternalData Whether to retun internal data. Internal data is
   *   used for Viam-specific data ingestion, like cloud SLAM. Defaults to
   *   `false`.
   * @returns An array of data objects, the count (number of entries), and the
   *   last-returned page ID.
   */
  async binaryDataByFilter(e, n, a, s = "", i = !0, r = !1, c = !1) {
    const l = {
      dataRequest: {
        filter: e,
        limit: n === void 0 ? void 0 : BigInt(n),
        sortOrder: a,
        last: s
      },
      includeBinary: i,
      countOnly: r,
      includeInternalData: c
    }, T = await this.dataClient.binaryDataByFilter(l);
    return {
      data: T.data,
      count: T.count,
      last: T.last
    };
  }
  /**
   * Get binary data using the BinaryID.
   *
   * @param ids The IDs of the requested binary data
   * @returns An array of data objects
   */
  async binaryDataByIds(e) {
    return (await this.dataClient.binaryDataByIDs({
      binaryIds: e,
      includeBinary: !0
    })).data;
  }
  /**
   * Delete tabular data older than a specified number of days.
   *
   * @param organizationId The ID of organization to delete data from
   * @param deleteOlderThanDays Delete data that was captured more than this
   *   many days ago. For example if `deleteOlderThanDays` is 10, this deletes
   *   any data that was captured more than 10 days ago. If it is 0, all
   *   existing data is deleted.
   * @returns The number of items deleted
   */
  async deleteTabularData(e, n) {
    return (await this.dataClient.deleteTabularData({
      organizationId: e,
      deleteOlderThanDays: n
    })).deletedCount;
  }
  /**
   * Filter and delete binary data.
   *
   * @param filter Optional `pb.Filter` specifying binary data to delete. No
   *   `filter` implies all binary data.
   * @param includeInternalData Whether or not to delete internal data. Default
   *   is true
   * @returns The number of items deleted
   */
  async deleteBinaryDataByFilter(e, n = !0) {
    return (await this.dataClient.deleteBinaryDataByFilter({
      filter: e,
      includeInternalData: n
    })).deletedCount;
  }
  /**
   * Delete binary data, specified by ID.
   *
   * @param ids The IDs of the data to be deleted. Must be non-empty.
   * @returns The number of items deleted
   */
  async deleteBinaryDataByIds(e) {
    return (await this.dataClient.deleteBinaryDataByIDs({
      binaryIds: e
    })).deletedCount;
  }
  /**
   * Add tags to binary data, specified by ID.
   *
   * @param tags The list of tags to add to specified binary data. Must be
   *   non-empty.
   * @param ids The IDs of the data to be tagged. Must be non-empty.
   */
  async addTagsToBinaryDataByIds(e, n) {
    await this.dataClient.addTagsToBinaryDataByIDs({
      tags: e,
      binaryIds: n
    });
  }
  /**
   * Add tags to binary data, specified by filter.
   *
   * @param tags The tags to add to the data
   * @param filter Optional `pb.Filter` specifying binary data to add tags to.
   *   No `filter` implies all binary data.
   */
  async addTagsToBinaryDataByFilter(e, n) {
    await this.dataClient.addTagsToBinaryDataByFilter({
      tags: e,
      filter: n
    });
  }
  /**
   * Remove tags from binary data, specified by ID.
   *
   * @param tags List of tags to remove from specified binary data. Must be
   *   non-empty.
   * @param ids The IDs of the data to be edited. Must be non-empty.
   * @returns The number of items deleted
   */
  async removeTagsFromBinaryDataByIds(e, n) {
    return (await this.dataClient.removeTagsFromBinaryDataByIDs({
      tags: e,
      binaryIds: n
    })).deletedCount;
  }
  /**
   * Remove tags from binary data, specified by filter.
   *
   * @param tags List of tags to remove from specified binary data. Must be
   *   non-empty.
   * @param filter Optional `pb.Filter` specifying binary data to add tags to.
   *   No `filter` implies all binary data.
   * @returns The number of items deleted
   */
  async removeTagsFromBinaryDataByFilter(e, n) {
    return (await this.dataClient.removeTagsFromBinaryDataByFilter({
      tags: e,
      filter: n
    })).deletedCount;
  }
  /**
   * Get a list of tags using a filter.
   *
   * @param filter Optional `pb.Filter` specifying what data to get tags from.
   *   No `filter` implies all data.
   * @returns The list of tags
   */
  async tagsByFilter(e) {
    return (await this.dataClient.tagsByFilter({ filter: e })).tags;
  }
  /**
   * Add bounding box to an image.
   *
   * @param binaryId The ID of the image to add the bounding box to
   * @param label A label for the bounding box
   * @param xMinNormalized The min X value of the bounding box normalized from 0
   *   to 1
   * @param yMinNormalized The min Y value of the bounding box normalized from 0
   *   to 1
   * @param xMaxNormalized The max X value of the bounding box normalized from 0
   *   to 1
   * @param yMaxNormalized The max Y value of the bounding box normalized from 0
   *   to 1
   * @returns The bounding box ID
   */
  async addBoundingBoxToImageById(e, n, a, s, i, r) {
    return (await this.dataClient.addBoundingBoxToImageByID({
      binaryId: e,
      label: n,
      xMinNormalized: a,
      yMinNormalized: s,
      xMaxNormalized: i,
      yMaxNormalized: r
    })).bboxId;
  }
  /**
   * Remove a bounding box from an image.
   *
   * @param binId The ID of the image to remove the bounding box from
   * @param bboxId The ID of the bounding box to remove
   */
  async removeBoundingBoxFromImageById(e, n) {
    await this.dataClient.removeBoundingBoxFromImageByID({
      binaryId: e,
      bboxId: n
    });
  }
  /**
   * Get a list of bounding box labels using a Filter.
   *
   * @param filter Optional `pb.Filter` specifying what data to get tags from.
   *   No `filter` implies all labels.
   * @returns The list of bounding box labels
   */
  async boundingBoxLabelsByFilter(e) {
    return (await this.dataClient.boundingBoxLabelsByFilter({
      filter: e
    })).labels;
  }
  /**
   * Configure a database user for the Viam organization's MongoDB Atlas Data
   * Federation instance. It can also be used to reset the password of the
   * existing database user.
   *
   * @param organizationId The ID of the organization
   * @param password The password of the user
   */
  async configureDatabaseUser(e, n) {
    await this.dataClient.configureDatabaseUser({ organizationId: e, password: n });
  }
  /**
   * Get a connection to access a MongoDB Atlas Data federation instance.
   *
   * @param organizationId Organization to retrieve connection for
   * @returns Hostname of the federated database
   */
  async getDatabaseConnection(e) {
    return (await this.dataClient.getDatabaseConnection({
      organizationId: e
    })).hostname;
  }
  /**
   * Add BinaryData to the provided dataset.
   *
   * @param ids The IDs of binary data to add to dataset
   * @param datasetId The ID of the dataset to be added to
   */
  async addBinaryDataToDatasetByIds(e, n) {
    await this.dataClient.addBinaryDataToDatasetByIDs({
      binaryIds: e,
      datasetId: n
    });
  }
  /**
   * Remove BinaryData from the provided dataset.
   *
   * @param ids The IDs of the binary data to remove from dataset
   * @param datasetId The ID of the dataset to be removed from
   */
  async removeBinaryDataFromDatasetByIds(e, n) {
    await this.dataClient.removeBinaryDataFromDatasetByIDs({
      binaryIds: e,
      datasetId: n
    });
  }
  /**
   * Create a new dataset.
   *
   * @param name The name of the new dataset
   * @param organizationId The ID of the organization the dataset is being
   *   created in
   * @returns The ID of the dataset
   */
  async createDataset(e, n) {
    return (await this.datasetClient.createDataset({
      name: e,
      organizationId: n
    })).id;
  }
  /**
   * Delete a dataset.
   *
   * @param id The ID of the dataset.
   */
  async deleteDataset(e) {
    await this.datasetClient.deleteDataset({ id: e });
  }
  /**
   * Rename a dataset.
   *
   * @param id The ID of the dataset
   * @param name The new name of the dataset
   */
  async renameDataset(e, n) {
    await this.datasetClient.renameDataset({ id: e, name: n });
  }
  /**
   * List all of the datasets for an organization.
   *
   * @param organizationId The ID of the organization
   * @returns The list of datasets in the organization
   */
  async listDatasetsByOrganizationID(e) {
    return (await this.datasetClient.listDatasetsByOrganizationID({
      organizationId: e
    })).datasets.map((a) => ({
      created: a.timeCreated?.toDate(),
      ...a
    }));
  }
  /**
   * List all of the datasets specified by the given dataset IDs.
   *
   * @param ids The list of IDs of the datasets
   * @returns The list of datasets
   */
  async listDatasetsByIds(e) {
    return (await this.datasetClient.listDatasetsByIDs({
      ids: e
    })).datasets.map((a) => ({
      created: a.timeCreated?.toDate(),
      ...a
    }));
  }
  /**
   * Uploads the content and metadata for tabular data.
   *
   * Upload tabular data collected on a robot through a specific component
   * (e.g., a motor) along with the relevant metadata to app.viam.com. Tabular
   * data can be found under the "Sensors" subtab of the Data tab on
   * app.viam.com.
   *
   * @param tabularData The list of data to be uploaded, represented tabularly
   *   as an array.
   * @param partId The part ID of the component used to capture the data
   * @param componentType The type of the component used to capture the data
   *   (e.g., "movementSensor")
   * @param componentName The name of the component used to capture the data
   * @param methodName The name of the method used to capture the data.
   * @param tags The list of tags to allow for tag-based filtering when
   *   retrieving data
   * @param dataRequestTimes Array of Date tuples, each containing two `Date`
   *   objects denoting the times this data was requested[0] by the robot and
   *   received[1] from the appropriate sensor. Passing a list of tabular data
   *   and Timestamps with length n > 1 will result in n datapoints being
   *   uploaded, all tied to the same metadata.
   * @returns The file ID of the uploaded data
   */
  async tabularDataCaptureUpload(e, n, a, s, i, r, c) {
    if (r.length !== e.length)
      throw new Error("dataRequestTimes and data lengths must be equal.");
    const d = new Rn({
      partId: n,
      componentType: a,
      componentName: s,
      methodName: i,
      type: Ft.TABULAR_SENSOR,
      tags: c
    }), l = [];
    for (const [S, f] of e.entries()) {
      const w = new ho(), O = r[S];
      O && (w.timeRequested = I.fromDate(O[0]), w.timeReceived = I.fromDate(O[1])), l.push(
        new zt({
          metadata: w,
          data: {
            case: "struct",
            value: u.fromJson(f)
          }
        })
      );
    }
    const T = new Jt({
      metadata: d,
      sensorContents: l
    });
    return (await this.dataSyncClient.dataCaptureUpload(T)).fileId;
  }
  /**
   * Uploads the content and metadata for binary data.
   *
   * Upload binary data collected on a robot through a specific component (e.g.,
   * a motor) along with the relevant metadata to app.viam.com. binary data can
   * be found under the "Sensors" subtab of the Data tab on app.viam.com.
   *
   * @param binaryData The data to be uploaded, represented in bytes
   * @param partId The part ID of the component used to capture the data
   * @param componentType The type of the component used to capture the data
   *   (e.g., "movementSensor")
   * @param componentName The name of the component used to capture the data
   * @param methodName The name of the method used to capture the data.
   * @param fileExtension The file extension of binary data including the
   *   period, e.g. .jpg, .png, .pcd. The backend will route the binary to its
   *   corresponding mime type based on this extension. Files with a .jpeg,
   *   .jpg, or .png extension will be saved to the images tab.
   * @param tags The list of tags to allow for tag-based filtering when
   *   retrieving data
   * @param dataRequestTimes Tuple containing `Date` objects denoting the times
   *   this data was requested[0] by the robot and received[1] from the
   *   appropriate sensor.
   * @returns The file ID of the uploaded data
   */
  async binaryDataCaptureUpload(e, n, a, s, i, r, c, d) {
    const l = new Rn({
      partId: n,
      componentType: a,
      componentName: s,
      methodName: i,
      type: Ft.BINARY_SENSOR,
      tags: d,
      fileExtension: r
    }), T = new zt({
      metadata: {
        timeRequested: I.fromDate(c[0]),
        timeReceived: I.fromDate(c[1])
      },
      data: {
        case: "binary",
        value: e
      }
    }), R = new Jt({
      metadata: l,
      sensorContents: [T]
    });
    return (await this.dataSyncClient.dataCaptureUpload(R)).fileId;
  }
  // eslint-disable-next-line class-methods-use-this
  createFilter(e) {
    const n = new ze(e);
    if (e.startTime ?? e.endTime) {
      const s = new ht();
      e.startTime && (s.start = I.fromDate(e.startTime)), e.endTime && (s.end = I.fromDate(e.endTime)), n.interval = s;
    }
    const a = new ko();
    return e.tags && (a.tags = e.tags, n.tagsFilter = a), n;
  }
  /**
   * Gets the most recent tabular data captured from the specified data source,
   * as long as it was synced within the last year.
   *
   * @param partId The ID of the part that owns the data
   * @param resourceName The name of the requested resource that captured the
   *   data
   * @param resourceSubtype The subtype of the requested resource that captured
   *   the data
   * @param methodName The data capture method name
   * @returns A tuple containing [timeCaptured, timeSynced, payload] or null if
   *   no data has been synced for the specified resource OR the most recently
   *   captured data was over a year ago
   */
  async getLatestTabularData(e, n, a, s) {
    const i = await this.dataClient.getLatestTabularData({
      partId: e,
      resourceName: n,
      resourceSubtype: a,
      methodName: s
    });
    return !i.payload || !i.timeCaptured || !i.timeSynced ? null : [
      i.timeCaptured.toDate(),
      i.timeSynced.toDate(),
      i.payload.toJson()
    ];
  }
}
const Kh = {
  typeName: "viam.app.mltraining.v1.MLTrainingService",
  methods: {
    /**
     * SubmitTrainingJob submits a training job request.
     *
     * @generated from rpc viam.app.mltraining.v1.MLTrainingService.SubmitTrainingJob
     */
    submitTrainingJob: {
      name: "SubmitTrainingJob",
      I: Nl,
      O: Cl,
      kind: m.Unary
    },
    /**
     * SubmitCustomTrainingJob submits a custom training job request.
     *
     * @generated from rpc viam.app.mltraining.v1.MLTrainingService.SubmitCustomTrainingJob
     */
    submitCustomTrainingJob: {
      name: "SubmitCustomTrainingJob",
      I: Pl,
      O: Dl,
      kind: m.Unary
    },
    /**
     * GetTrainingJob retrieves a training job by its ID.
     *
     * @generated from rpc viam.app.mltraining.v1.MLTrainingService.GetTrainingJob
     */
    getTrainingJob: {
      name: "GetTrainingJob",
      I: ql,
      O: Al,
      kind: m.Unary
    },
    /**
     * ListTrainingJobs lists training jobs for a given organization ID and training status.
     *
     * @generated from rpc viam.app.mltraining.v1.MLTrainingService.ListTrainingJobs
     */
    listTrainingJobs: {
      name: "ListTrainingJobs",
      I: Ul,
      O: Gl,
      kind: m.Unary
    },
    /**
     * CancelTrainingJob cancels a training job that has not yet completed.
     *
     * @generated from rpc viam.app.mltraining.v1.MLTrainingService.CancelTrainingJob
     */
    cancelTrainingJob: {
      name: "CancelTrainingJob",
      I: Ll,
      O: Bl,
      kind: m.Unary
    },
    /**
     * DeleteCompletedTrainingJob removes a completed training job from the database, whether the job succeeded or failed.
     *
     * @generated from rpc viam.app.mltraining.v1.MLTrainingService.DeleteCompletedTrainingJob
     */
    deleteCompletedTrainingJob: {
      name: "DeleteCompletedTrainingJob",
      I: xl,
      O: Fl,
      kind: m.Unary
    },
    /**
     * GetTrainingJobLogs gets the logs for a given custom training job.
     *
     * @generated from rpc viam.app.mltraining.v1.MLTrainingService.GetTrainingJobLogs
     */
    getTrainingJobLogs: {
      name: "GetTrainingJobLogs",
      I: zl,
      O: $l,
      kind: m.Unary
    }
  }
};
class Xh {
  client;
  constructor(e) {
    this.client = P(Kh, e);
  }
  async submitTrainingJob(e, n, a, s, i, r) {
    return (await this.client.submitTrainingJob({
      organizationId: e,
      datasetId: n,
      modelName: a,
      modelVersion: s,
      modelType: i,
      tags: r
    })).id;
  }
  async submitCustomTrainingJob(e, n, a, s, i, r) {
    return (await this.client.submitCustomTrainingJob({
      organizationId: e,
      datasetId: n,
      registryItemId: a,
      registryItemVersion: s,
      modelName: i,
      modelVersion: r
    })).id;
  }
  async getTrainingJob(e) {
    return (await this.client.getTrainingJob({ id: e })).metadata;
  }
  async listTrainingJobs(e, n) {
    return (await this.client.listTrainingJobs({ organizationId: e, status: n })).jobs;
  }
  async cancelTrainingJob(e) {
    return await this.client.cancelTrainingJob({ id: e }), null;
  }
  async deleteCompletedTrainingJob(e) {
    return await this.client.deleteCompletedTrainingJob({ id: e }), null;
  }
}
const KT = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.GetSmartMachineStatusRequest",
  []
), XT = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.GetSmartMachineStatusResponse",
  () => [
    { no: 1, name: "provisioning_info", kind: "message", T: sk },
    {
      no: 2,
      name: "has_smart_machine_credentials",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 3,
      name: "is_online",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 4, name: "latest_connection_attempt", kind: "message", T: fo },
    { no: 5, name: "errors", kind: "scalar", T: 9, repeated: !0 }
  ]
), QT = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.SetNetworkCredentialsRequest",
  () => [
    {
      no: 1,
      name: "type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "ssid",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "psk",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ZT = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.SetNetworkCredentialsResponse",
  []
), ek = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.SetSmartMachineCredentialsRequest",
  () => [
    { no: 1, name: "cloud", kind: "message", T: ok }
  ]
), nk = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.SetSmartMachineCredentialsResponse",
  []
), tk = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.GetNetworkListRequest",
  []
), ak = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.GetNetworkListResponse",
  () => [
    { no: 1, name: "networks", kind: "message", T: fo, repeated: !0 }
  ]
), sk = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.ProvisioningInfo",
  () => [
    {
      no: 1,
      name: "fragment_id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "model",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "manufacturer",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), fo = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.NetworkInfo",
  () => [
    {
      no: 1,
      name: "type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "ssid",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "security",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "signal",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 5,
      name: "connected",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 6,
      name: "last_error",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ok = /* @__PURE__ */ o.makeMessageType(
  "viam.provisioning.v1.CloudConfig",
  () => [
    {
      no: 1,
      name: "id",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "secret",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "app_address",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), _f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CloudConfig: ok,
  GetNetworkListRequest: tk,
  GetNetworkListResponse: ak,
  GetSmartMachineStatusRequest: KT,
  GetSmartMachineStatusResponse: XT,
  NetworkInfo: fo,
  ProvisioningInfo: sk,
  SetNetworkCredentialsRequest: QT,
  SetNetworkCredentialsResponse: ZT,
  SetSmartMachineCredentialsRequest: ek,
  SetSmartMachineCredentialsResponse: nk
}, Symbol.toStringTag, { value: "Module" })), Qh = {
  typeName: "viam.provisioning.v1.ProvisioningService",
  methods: {
    /**
     * GetSmartMachineStatus is for retrieving the status of the smart machine including networking.
     *
     * @generated from rpc viam.provisioning.v1.ProvisioningService.GetSmartMachineStatus
     */
    getSmartMachineStatus: {
      name: "GetSmartMachineStatus",
      I: KT,
      O: XT,
      kind: m.Unary
    },
    /**
     * SetNetworkCredentials is to set the wifi credentials.
     *
     * @generated from rpc viam.provisioning.v1.ProvisioningService.SetNetworkCredentials
     */
    setNetworkCredentials: {
      name: "SetNetworkCredentials",
      I: QT,
      O: ZT,
      kind: m.Unary
    },
    /**
     * SetSmartMachineCredentials is to set the smart machine credentials.
     *
     * @generated from rpc viam.provisioning.v1.ProvisioningService.SetSmartMachineCredentials
     */
    setSmartMachineCredentials: {
      name: "SetSmartMachineCredentials",
      I: ek,
      O: nk,
      kind: m.Unary
    },
    /**
     * GetNetworkList is to retrieve the list of networks that are visible to the smart machine.
     *
     * @generated from rpc viam.provisioning.v1.ProvisioningService.GetNetworkList
     */
    getNetworkList: {
      name: "GetNetworkList",
      I: tk,
      O: ak,
      kind: m.Unary
    }
  }
};
class Zh {
  client;
  constructor(e) {
    this.client = P(Qh, e);
  }
  /**
   * Get the status of the Smart Machine.
   *
   * @returns The Smart Machine status
   */
  async getSmartMachineStatus() {
    return this.client.getSmartMachineStatus({});
  }
  /**
   * Set the network credentials of the Smart Machine, so it can connect to the
   * internet.
   *
   * @param type - The type of network
   * @param ssid - The SSID of the network
   * @param psk - The network's passkey
   */
  async setNetworkCredentials(e, n, a) {
    await this.client.setNetworkCredentials({
      type: e,
      ssid: n,
      psk: a
    });
  }
  /**
   * Set the Viam credentials of the smart machine credentials, so it connect to
   * the Cloud.
   *
   * @param cloud - The configuration of the Cloud
   */
  async setSmartMachineCredentials(e) {
    await this.client.setSmartMachineCredentials({ cloud: e });
  }
  /**
   * Get the networks that are visible to the Smart Machine.
   *
   * @returns A list of networks
   */
  async getNetworkList() {
    return (await this.client.getNetworkList({})).networks;
  }
}
const Ef = async ({
  serviceHost: t = "https://app.viam.com",
  credentials: e
}) => {
  const n = await Hv(t, e);
  return new ef(n, e);
};
class ef {
  transport;
  credentials;
  dataClient;
  appClient;
  mlTrainingClient;
  provisioningClient;
  billingClient;
  constructor(e, n) {
    this.transport = e, this.credentials = n, this.dataClient = new Hh(this.transport), this.appClient = new Sh(this.transport), this.mlTrainingClient = new Xh(this.transport), this.provisioningClient = new Zh(this.transport), this.billingClient = new bh(this.transport);
  }
  async connectToMachine({
    host: e = void 0,
    id: n = void 0
  }) {
    if (e === void 0 && n === void 0)
      throw new Error("Either a machine address or ID must be provided");
    let a = e, s;
    if (n !== void 0 && e === void 0) {
      const c = (await this.appClient.getRobotParts(n)).find((d) => d.mainPart);
      if (!c)
        throw new Error(
          `Could not find a main part for the machine with UUID: ${n}`
        );
      a = c.fqdn, s = c.locationId;
    }
    if (a === void 0 || a === "")
      throw new Error(
        "Host was not provided and could not be obtained from the machine ID"
      );
    let i = this.credentials;
    if (!Sn(i)) {
      if (s === void 0) {
        const c = a.split(".viam.")[0]?.split(".");
        c !== void 0 && (s = c.at(-1));
      }
      s !== void 0 && (i = {
        type: "robot-location-secret",
        payload: (await this.appClient.getLocation(s))?.auth?.secrets.find(
          // eslint-disable-next-line camelcase
          (d) => d.state === ro.ENABLED
        )?.secret,
        authEntity: a
      });
    }
    return fh({
      host: a,
      credentials: i,
      signalingAddress: "https://app.viam.com:443",
      reconnectMaxAttempts: 1
    });
  }
}
const { JointPositions: Mf } = Xv;
class Of {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(sm), this.name = n, this.options = a;
  }
  async getEndPosition(e = {}, n = this.callOptions) {
    const a = new ua({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const i = (await this.client.getEndPosition(a, n)).pose;
    if (!i)
      throw new Error("no pose");
    return i;
  }
  async moveToPosition(e, n = {}, a = this.callOptions) {
    const s = new ga({
      name: this.name,
      to: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.moveToPosition(s, a);
  }
  async moveToJointPositions(e, n = {}, a = this.callOptions) {
    const s = new tn({
      values: e
    }), i = new Ta({
      name: this.name,
      positions: s,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(i), await this.client.moveToJointPositions(i, a);
  }
  async getJointPositions(e = {}, n = this.callOptions) {
    const a = new pa({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const i = (await this.client.getJointPositions(a, n)).positions;
    if (!i)
      throw new Error("no pose");
    return i;
  }
  async stop(e = {}, n = this.callOptions) {
    const a = new ka({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.stop(a, n);
  }
  async isMoving(e = this.callOptions) {
    const n = new ya({
      name: this.name
    });
    return this.options.requestLogger?.(n), (await this.client.isMoving(n, e)).isMoving;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const { GetPropertiesResponse: Nf } = Qv;
class Cf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(um), this.name = n, this.options = a;
  }
  async moveStraight(e, n, a = {}, s = this.callOptions) {
    const i = new va({
      name: this.name,
      mmPerSec: n,
      distanceMm: e ? BigInt(e) : void 0,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.moveStraight(i, s);
  }
  async spin(e, n, a = {}, s = this.callOptions) {
    const i = new ha({
      name: this.name,
      angleDeg: e,
      degsPerSec: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.spin(i, s);
  }
  async setPower(e, n, a = {}, s = this.callOptions) {
    const i = new Ra({
      name: this.name,
      linear: e,
      angular: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.setPower(i, s);
  }
  async setVelocity(e, n, a = {}, s = this.callOptions) {
    const i = new Ia({
      name: this.name,
      linear: e,
      angular: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.setVelocity(i, s);
  }
  async stop(e = {}, n = this.callOptions) {
    const a = new fa({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.stop(a, n);
  }
  async isMoving(e = this.callOptions) {
    const n = new Sa({
      name: this.name
    });
    return this.options.requestLogger?.(n), (await this.client.isMoving(n, e)).isMoving;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
  async getProperties(e = {}, n = this.callOptions) {
    const a = new ct({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), this.client.getProperties(a, n);
  }
}
const { ReadAnalogReaderResponse: Pf, PowerMode: Df } = eh;
class qf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(bm), this.name = n, this.options = a;
  }
  async setGPIO(e, n, a = {}, s = this.callOptions) {
    const i = new wa({
      name: this.name,
      pin: e,
      high: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.setGPIO(i, s);
  }
  async getGPIO(e, n = {}, a = this.callOptions) {
    const s = new ba({
      name: this.name,
      pin: e,
      extra: u.fromJson(n)
    });
    return this.options.requestLogger?.(s), (await this.client.getGPIO(s, a)).high;
  }
  async getPWM(e, n = {}, a = this.callOptions) {
    const s = new _a({
      name: this.name,
      pin: e,
      extra: u.fromJson(n)
    });
    return this.options.requestLogger?.(s), (await this.client.pWM(s, a)).dutyCyclePct;
  }
  async setPWM(e, n, a = {}, s = this.callOptions) {
    const i = new Ea({
      name: this.name,
      pin: e,
      dutyCyclePct: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.setPWM(i, s);
  }
  async getPWMFrequency(e, n = {}, a = this.callOptions) {
    const s = new Ma({
      name: this.name,
      pin: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s);
    const i = await this.client.pWMFrequency(s, a);
    return Number(i.frequencyHz);
  }
  async setPWMFrequency(e, n, a = {}, s = this.callOptions) {
    const i = new Oa({
      name: this.name,
      pin: e,
      frequencyHz: n ? BigInt(n) : void 0,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.setPWMFrequency(i, s);
  }
  async readAnalogReader(e, n = {}, a = this.callOptions) {
    const s = new Na({
      boardName: this.name,
      analogReaderName: e,
      extra: u.fromJson(n)
    });
    return this.options.requestLogger?.(s), this.client.readAnalogReader(s, a);
  }
  async writeAnalog(e, n, a = {}, s = this.callOptions) {
    const i = new Ca({
      name: this.name,
      pin: e,
      value: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.writeAnalog(i, s);
  }
  async getDigitalInterruptValue(e, n = {}, a = this.callOptions) {
    const s = new Pa({
      boardName: this.name,
      digitalInterruptName: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s);
    const i = await this.client.getDigitalInterruptValue(
      s,
      a
    );
    return Number(i.value);
  }
  async streamTicks(e, n, a = {}, s = this.callOptions) {
    const i = new Da({
      name: this.name,
      pinNames: e,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i);
    const r = this.client.streamTicks(i, s);
    for await (const c of r)
      n.push({
        pinName: c.pinName,
        high: c.high,
        time: c.time ? Number(c.time) : 0
      });
  }
  async setPowerMode(e, n, a = {}, s = this.callOptions) {
    const i = new qa({
      name: this.name,
      powerMode: e,
      duration: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.setPowerMode(i, s);
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const nf = /* @__PURE__ */ o.makeMessageType(
  "google.api.HttpBody",
  () => [
    {
      no: 1,
      name: "content_type",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    { no: 3, name: "extensions", kind: "message", T: W, repeated: !0 }
  ]
), tf = {
  typeName: "viam.component.camera.v1.CameraService",
  methods: {
    /**
     * GetImage returns a frame from a camera of the underlying robot. A specific MIME type
     * can be requested but may not necessarily be the same one returned.
     *
     * @generated from rpc viam.component.camera.v1.CameraService.GetImage
     */
    getImage: {
      name: "GetImage",
      I: Ws,
      O: ul,
      kind: m.Unary
    },
    /**
     * @generated from rpc viam.component.camera.v1.CameraService.GetImages
     */
    getImages: {
      name: "GetImages",
      I: pl,
      O: gl,
      kind: m.Unary
    },
    /**
     * RenderFrame renders a frame from a camera of the underlying robot to an HTTP response. A specific MIME type
     * can be requested but may not necessarily be the same one returned.
     *
     * @generated from rpc viam.component.camera.v1.CameraService.RenderFrame
     */
    renderFrame: {
      name: "RenderFrame",
      I: js,
      O: nf,
      kind: m.Unary
    },
    /**
     * GetPointCloud returns a point cloud from a camera of the underlying robot. A specific MIME type
     * can be requested but may not necessarily be the same one returned.
     *
     * @generated from rpc viam.component.camera.v1.CameraService.GetPointCloud
     */
    getPointCloud: {
      name: "GetPointCloud",
      I: Hs,
      O: Tl,
      kind: m.Unary
    },
    /**
     * GetProperties returns the camera intrinsic parameters and camera distortion parameters from a camera of the underlying robot, if available.
     *
     * @generated from rpc viam.component.camera.v1.CameraService.GetProperties
     */
    getProperties: {
      name: "GetProperties",
      I: kl,
      O: yl,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.camera.v1.CameraService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.camera.v1.CameraService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, af = "pointcloud/pcd";
class Af {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(tf), this.name = n, this.options = a;
  }
  async getImage(e = "", n = this.callOptions) {
    const a = new Ws({
      name: this.name,
      mimeType: e
    });
    return this.options.requestLogger?.(a), (await this.client.getImage(a, n)).image;
  }
  async renderFrame(e = "", n = this.callOptions) {
    const a = new js({
      name: this.name,
      mimeType: e
    });
    this.options.requestLogger?.(a);
    const s = await this.client.renderFrame(a, n);
    return new Blob([s.data], { type: e });
  }
  async getPointCloud(e = this.callOptions) {
    const n = new Hs({
      name: this.name,
      mimeType: af
    });
    return this.options.requestLogger?.(n), (await this.client.getPointCloud(n, e)).pointCloud;
  }
  async getProperties(e = this.callOptions) {
    const n = new ct({
      name: this.name
    });
    return this.options.requestLogger?.(n), this.client.getProperties(n, e);
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const {
  GetPropertiesResponse: Uf,
  PositionType: sf
} = nh;
class Gf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(Om), this.name = n, this.options = a;
  }
  async resetPosition(e = {}, n = this.callOptions) {
    const a = new Ga({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.resetPosition(a, n);
  }
  async getProperties(e = {}, n = this.callOptions) {
    const a = new La({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), this.client.getProperties(a, n);
  }
  async getPosition(e = sf.UNSPECIFIED, n = {}, a = this.callOptions) {
    const s = new Ua({
      name: this.name,
      positionType: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s);
    const i = await this.client.getPosition(s, a);
    return [i.value, i.positionType];
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
class Lf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(Um), this.name = n, this.options = a;
  }
  async getPosition(e = {}, n = this.callOptions) {
    const a = new Ba({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getPosition(a, n)).positionsMm;
  }
  async moveToPosition(e, n, a = {}, s = this.callOptions) {
    const i = new xa({
      name: this.name,
      positionsMm: e,
      speedsMmPerSec: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.moveToPosition(i, s);
  }
  async home(e = {}, n = this.callOptions) {
    const a = new Fa({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.home(a, n)).homed;
  }
  async getLengths(e = {}, n = this.callOptions) {
    const a = new Ja({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getLengths(a, n)).lengthsMm;
  }
  async stop(e = {}, n = this.callOptions) {
    const a = new za({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.stop(a, n);
  }
  async isMoving(e = this.callOptions) {
    const n = new $a({
      name: this.name
    });
    return this.options.requestLogger?.(n), (await this.client.isMoving(n, e)).isMoving;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
class Bf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(ic), this.name = n, this.options = a;
  }
  async setPower(e, n = {}, a = this.callOptions) {
    const s = new Qa({
      name: this.name,
      powerPct: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.setPower(s, a);
  }
  async goFor(e, n, a = {}, s = this.callOptions) {
    const i = new Za({
      name: this.name,
      rpm: e,
      revolutions: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.goFor(i, s);
  }
  async goTo(e, n, a = {}, s = this.callOptions) {
    const i = new es({
      name: this.name,
      rpm: e,
      positionRevolutions: n,
      extra: u.fromJson(a)
    });
    this.options.requestLogger?.(i), await this.client.goTo(i, s);
  }
  async setRPM(e, n = {}, a = this.callOptions) {
    const s = new ns({
      name: this.name,
      rpm: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.setRPM(s, a);
  }
  async resetZeroPosition(e, n = {}, a = this.callOptions) {
    const s = new ts({
      name: this.name,
      offset: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.resetZeroPosition(s, a);
  }
  async stop(e = {}, n = this.callOptions) {
    const a = new ss({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.stop(a, n);
  }
  async getProperties(e = {}, n = this.callOptions) {
    const a = new is({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), {
      positionReporting: (await this.client.getProperties(a, n)).positionReporting
    };
  }
  async getPosition(e = {}, n = this.callOptions) {
    const a = new as({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getPosition(a, n)).position;
  }
  async isPowered(e = {}, n = this.callOptions) {
    const a = new os({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.isPowered(a, n);
    return [s.isOn, s.powerPct];
  }
  async isMoving(e = this.callOptions) {
    const n = new rs({
      name: this.name
    });
    return this.options.requestLogger?.(n), (await this.client.isMoving(n, e)).isMoving;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
class xf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(Tc), this.name = n, this.options = a;
  }
  async getLinearVelocity(e = {}, n = this.callOptions) {
    const a = new ms({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const i = (await this.client.getLinearVelocity(a, n)).linearVelocity;
    if (!i)
      throw new Error("no linear velocity");
    return i;
  }
  async getAngularVelocity(e = {}, n = this.callOptions) {
    const a = new cs({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const i = (await this.client.getAngularVelocity(a, n)).angularVelocity;
    if (!i)
      throw new Error("no angular velocity");
    return i;
  }
  async getCompassHeading(e = {}, n = this.callOptions) {
    const a = new ls({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getCompassHeading(a, n)).value;
  }
  async getOrientation(e = {}, n = this.callOptions) {
    const a = new ds({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const i = (await this.client.getOrientation(a, n)).orientation;
    if (!i)
      throw new Error("no orientation");
    return i;
  }
  async getPosition(e = {}, n = this.callOptions) {
    const a = new us({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), this.client.getPosition(a, n);
  }
  async getProperties(e = {}, n = this.callOptions) {
    const a = new ps({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), this.client.getProperties(a, n);
  }
  async getAccuracy(e = {}, n = this.callOptions) {
    const a = new gs({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), this.client.getAccuracy(a, n);
  }
  async getLinearAcceleration(e = {}, n = this.callOptions) {
    const a = new Ts({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const i = (await this.client.getLinearAcceleration(
      a,
      n
    )).linearAcceleration;
    if (!i)
      throw new Error("no linear acceleration");
    return i;
  }
  async getReadings(e = {}, n = this.callOptions) {
    const a = new We({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.getReadings(a, n), i = {};
    for (const r of Object.keys(s.readings)) {
      const c = s.readings[r];
      c && (i[r] = c.toJson());
    }
    return i;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const {
  GetAccuracyResponse: Ff,
  GetPositionResponse: Jf,
  GetPropertiesResponse: zf
} = ih;
class $f {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(hc), this.name = n, this.options = a;
  }
  async getVoltage(e = {}, n = this.callOptions) {
    const a = new ks({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.getVoltage(a, n);
    return [s.volts, s.isAc];
  }
  async getCurrent(e = {}, n = this.callOptions) {
    const a = new ys({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.getCurrent(a, n);
    return [s.amperes, s.isAc];
  }
  async getPower(e = {}, n = this.callOptions) {
    const a = new vs({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getPower(a, n)).watts;
  }
  async getReadings(e = {}, n = this.callOptions) {
    const a = new We({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.getReadings(a, n), i = {};
    for (const r of Object.keys(s.readings)) {
      const c = s.readings[r];
      c && (i[r] = c.toJson());
    }
    return i;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const ik = {
  typeName: "viam.component.sensor.v1.SensorService",
  methods: {
    /**
     * GetReadings returns the readings of a sensor of the underlying robot.
     *
     * @generated from rpc viam.component.sensor.v1.SensorService.GetReadings
     */
    getReadings: {
      name: "GetReadings",
      I: We,
      O: st,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.component.sensor.v1.SensorService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    },
    /**
     * GetGeometries returns the geometries of the component in their current configuration
     *
     * @generated from rpc viam.component.sensor.v1.SensorService.GetGeometries
     */
    getGeometries: {
      name: "GetGeometries",
      I: j,
      O: H,
      kind: m.Unary
    }
  }
}, Yf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SensorService: ik
}, Symbol.toStringTag, { value: "Module" }));
class Wf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(ik), this.name = n, this.options = a;
  }
  async getReadings(e = {}, n = this.callOptions) {
    const a = new We({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.getReadings(a, n), i = {};
    for (const r of Object.keys(s.readings)) {
      const c = s.readings[r];
      c && (i[r] = c.toJson());
    }
    return i;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const rk = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.ListStreamsRequest",
  []
), mk = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.ListStreamsResponse",
  () => [
    { no: 1, name: "names", kind: "scalar", T: 9, repeated: !0 }
  ]
), Ro = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.AddStreamRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), ck = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.AddStreamResponse",
  []
), Io = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.RemoveStreamRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), lk = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.RemoveStreamResponse",
  []
), So = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.Resolution",
  () => [
    {
      no: 1,
      name: "width",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 2,
      name: "height",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]
), wo = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.GetStreamOptionsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]
), dk = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.GetStreamOptionsResponse",
  () => [
    { no: 1, name: "resolutions", kind: "message", T: So, repeated: !0 }
  ]
), tt = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.SetStreamOptionsRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "resolution", kind: "message", T: So }
  ]
), uk = /* @__PURE__ */ o.makeMessageType(
  "proto.stream.v1.SetStreamOptionsResponse",
  []
), Vf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddStreamRequest: Ro,
  AddStreamResponse: ck,
  GetStreamOptionsRequest: wo,
  GetStreamOptionsResponse: dk,
  ListStreamsRequest: rk,
  ListStreamsResponse: mk,
  RemoveStreamRequest: Io,
  RemoveStreamResponse: lk,
  Resolution: So,
  SetStreamOptionsRequest: tt,
  SetStreamOptionsResponse: uk
}, Symbol.toStringTag, { value: "Module" })), of = {
  typeName: "proto.stream.v1.StreamService",
  methods: {
    /**
     * ListStreams returns all streams registered.
     *
     * @generated from rpc proto.stream.v1.StreamService.ListStreams
     */
    listStreams: {
      name: "ListStreams",
      I: rk,
      O: mk,
      kind: m.Unary
    },
    /**
     * AddStream requests a particular stream be added.
     *
     * @generated from rpc proto.stream.v1.StreamService.AddStream
     */
    addStream: {
      name: "AddStream",
      I: Ro,
      O: ck,
      kind: m.Unary
    },
    /**
     * GetStreamOptions returns the options for a particular stream.
     *
     * @generated from rpc proto.stream.v1.StreamService.GetStreamOptions
     */
    getStreamOptions: {
      name: "GetStreamOptions",
      I: wo,
      O: dk,
      kind: m.Unary
    },
    /**
     * SetStreamOptions sets the options for a particular stream.
     *
     * @generated from rpc proto.stream.v1.StreamService.SetStreamOptions
     */
    setStreamOptions: {
      name: "SetStreamOptions",
      I: tt,
      O: uk,
      kind: m.Unary
    },
    /**
     * RemoveStream requests a particular stream be removed. If the calling client
     * is the last to be receiving the stream, it will attempt to be stopped to
     * conserve resources.
     *
     * @generated from rpc proto.stream.v1.StreamService.RemoveStream
     */
    removeStream: {
      name: "RemoveStream",
      I: Io,
      O: lk,
      kind: m.Unary
    }
  }
}, mn = (t) => t.replaceAll(":", "+");
class jf extends jr {
  client;
  options;
  streams;
  constructor(e, n = {}) {
    super(), this.client = e.createServiceClient(of), this.options = n, this.streams = /* @__PURE__ */ new Set(), e.on("track", (a) => {
      this.emit("track", a);
    }), e.on(te.CONNECTED, () => {
      for (const a of this.streams.values())
        this.add(a);
    });
  }
  async add(e) {
    const n = new Ro({
      name: mn(e)
    });
    this.options.requestLogger?.(n);
    try {
      await this.client.addStream(n), this.streams.add(e);
    } catch {
      n.name = e, this.options.requestLogger?.(n), await this.client.addStream(n), this.streams.add(e);
    }
  }
  async remove(e) {
    const n = new Io({
      name: mn(e)
    });
    this.options.requestLogger?.(n);
    try {
      await this.client.removeStream(n), this.streams.delete(e);
    } catch {
      n.name = e, this.options.requestLogger?.(n), await this.client.removeStream(n), this.streams.delete(e);
    }
  }
  /**
   * Get the available livestream resolutions for a camera component. If the
   * stream client cannot find any available resolutions, an empty list will be
   * returned.
   *
   * @param resourceName - The name of a camera component.
   * @returns A list of available resolutions for livestreaming.
   */
  async getOptions(e) {
    const n = async (i) => {
      const r = new wo({ name: i });
      this.options.requestLogger?.(r);
      try {
        return (await this.client.getStreamOptions(r)).resolutions;
      } catch {
        return [];
      }
    }, a = mn(e);
    let s = await n(a);
    return s.length > 0 || (s = await n(e)), s;
  }
  /**
   * Set the livestream options for a camera component. This will change the
   * resolution of the stream to the specified width and height.
   *
   * @param name - The name of a camera component.
   * @param width - The width of the resolution.
   * @param height - The height of the resolution.
   */
  async setOptions(e, n, a) {
    const s = new tt({
      name: mn(e),
      resolution: {
        width: n,
        height: a
      }
    });
    this.options.requestLogger?.(s);
    try {
      await this.client.setStreamOptions(s);
    } catch {
      s.name = e, this.options.requestLogger?.(s), await this.client.setStreamOptions(s);
    }
  }
  /**
   * Reset the livestream options for a camera component. This will reset the
   * resolution to the default component attributes.
   *
   * @param name - The name of a camera component.
   */
  async resetOptions(e) {
    const n = new tt({
      name: mn(e)
    });
    this.options.requestLogger?.(n);
    try {
      await this.client.setStreamOptions(n);
    } catch {
      n.name = e, this.options.requestLogger?.(n), await this.client.setStreamOptions(n);
    }
  }
  STREAM_TIMEOUT = 5e3;
  /**
   * Get a stream by name from a StreamClient. Will time out if stream is not
   * received within 5 seconds.
   *
   * @param name - The name of a camera component.
   */
  getStream = async (e) => {
    const n = new Promise((a, s) => {
      const i = (r) => {
        const [c] = r.streams;
        c ? c.id === e && (this.off("track", i), a(c)) : (this.off("track", i), s(new Error("Received track event with no streams")));
      };
      this.on("track", i), setTimeout(() => {
        this.off("track", i), s(
          new Error(`Did not receive a stream after ${this.STREAM_TIMEOUT} ms`)
        );
      }, this.STREAM_TIMEOUT);
    });
    return await this.add(e), n;
  };
}
let Hf = class {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(Ya), this.name = n, this.options = a;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
};
class Xf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(Fm), this.name = n, this.options = a;
  }
  async open(e = {}, n = this.callOptions) {
    const a = new Wa({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.open(a, n);
  }
  async grab(e = {}, n = this.callOptions) {
    const a = new Va({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.grab(a, n);
  }
  async stop(e = {}, n = this.callOptions) {
    const a = new ja({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.stop(a, n);
  }
  async isMoving(e = this.callOptions) {
    const n = new Ha({
      name: this.name
    });
    return this.options.requestLogger?.(n), (await this.client.isMoving(n, e)).isMoving;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
class Qf {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(Hm), this.name = n, this.options = a;
  }
  async getEvents(e = {}, n = this.callOptions) {
    const a = new Ka({
      controller: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getEvents(a, n)).events;
  }
  async triggerEvent(e, n = {}, a = this.callOptions) {
    const s = new Xa({
      controller: this.name,
      event: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.triggerEvent(s, a);
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const { Event: Zf } = sh, {
  CollisionSpecification: eR,
  Constraints: nR,
  GetPlanResponse: tR,
  LinearConstraint: aR,
  ListPlanStatusesResponse: sR,
  MotionConfiguration: oR,
  ObstacleDetector: iR,
  OrientationConstraint: rR,
  PlanState: mR
} = mh;
class cR {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(zc), this.name = n, this.options = a;
  }
  async move(e, n, a, s, i = {}, r = this.callOptions) {
    const c = new ws({
      name: this.name,
      destination: e,
      componentName: n,
      worldState: a,
      constraints: s,
      extra: u.fromJson(i)
    });
    return this.options.requestLogger?.(c), (await this.client.move(c, r)).success;
  }
  async moveOnMap(e, n, a, s, i, r = {}, c = this.callOptions) {
    const d = new bs({
      name: this.name,
      destination: e,
      componentName: n,
      slamServiceName: a,
      motionConfiguration: s,
      obstacles: i,
      extra: u.fromJson(r)
    });
    return this.options.requestLogger?.(d), (await this.client.moveOnMap(d, c)).executionId;
  }
  async moveOnGlobe(e, n, a, s, i, r, c, d = {}, l = this.callOptions) {
    const T = new Es({
      name: this.name,
      destination: e,
      componentName: n,
      movementSensorName: a,
      heading: s,
      obstacles: i,
      boundingRegions: c,
      motionConfiguration: r,
      extra: u.fromJson(d)
    });
    return this.options.requestLogger?.(T), (await this.client.moveOnGlobe(T, l)).executionId;
  }
  async stopPlan(e, n = {}, a = this.callOptions) {
    const s = new Os({
      name: this.name,
      componentName: e,
      extra: u.fromJson(n)
    });
    return this.options.requestLogger?.(s), await this.client.stopPlan(s, a), null;
  }
  async getPlan(e, n, a, s = {}, i = this.callOptions) {
    const r = new Cs({
      name: this.name,
      componentName: e,
      lastPlanOnly: n,
      executionId: a,
      extra: u.fromJson(s)
    });
    return this.options.requestLogger?.(r), this.client.getPlan(r, i);
  }
  async listPlanStatuses(e, n = {}, a = this.callOptions) {
    const s = new Ns({
      name: this.name,
      onlyActivePlans: e,
      extra: u.fromJson(n)
    });
    return this.options.requestLogger?.(s), this.client.listPlanStatuses(s, a);
  }
  async getPose(e, n, a, s = {}, i = this.callOptions) {
    const r = new Ms({
      name: this.name,
      componentName: e,
      destinationFrame: n,
      supplementalTransforms: a,
      extra: u.fromJson(s)
    });
    this.options.requestLogger?.(r);
    const d = (await this.client.getPose(r, i)).pose;
    if (!d)
      throw new Error("no pose");
    return d;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const pk = /* @__PURE__ */ o.makeMessageType(
  "viam.service.datamanager.v1.SyncRequest",
  () => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 99, name: "extra", kind: "message", T: u }
  ]
), rf = /* @__PURE__ */ o.makeMessageType(
  "viam.service.datamanager.v1.SyncResponse",
  []
), mf = {
  typeName: "viam.service.datamanager.v1.DataManagerService",
  methods: {
    /**
     * Sync performs a sync of the non-synced files for the specified service name,
     *
     * @generated from rpc viam.service.datamanager.v1.DataManagerService.Sync
     */
    sync: {
      name: "Sync",
      I: pk,
      O: rf,
      kind: m.Unary
    },
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.service.datamanager.v1.DataManagerService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    }
  }
};
class lR {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(mf), this.name = n, this.options = a;
  }
  async sync(e = {}, n = this.callOptions) {
    const a = new pk({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.sync(a, n);
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const {
  Capsule: dR,
  GeoGeometry: uR,
  GeoPoint: pR,
  GeometriesInFrame: gR,
  Geometry: TR,
  Orientation: kR,
  Pose: yR,
  PoseInFrame: vR,
  RectangularPrism: hR,
  ResourceName: fR,
  Sphere: RR,
  Transform: IR,
  Vector3: SR,
  WorldState: wR
} = Pi, cf = (t) => {
  const { latitude: e, longitude: n } = t;
  return !(typeof e != "number" || typeof n != "number" || Number.isNaN(e) || Number.isNaN(n));
};
class bR {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(tl), this.name = n, this.options = a;
  }
  async getMode(e = {}, n = this.callOptions) {
    const a = new Ds({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getMode(a, n)).mode;
  }
  async setMode(e, n = {}, a = this.callOptions) {
    const s = new qs({
      name: this.name,
      mode: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.setMode(s, a);
  }
  async getLocation(e = {}, n = this.callOptions) {
    const a = new As({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.getLocation(a, n);
    if (!s.location)
      throw new Error("no location");
    if (!cf(s.location))
      throw new Error("invalid location");
    return s;
  }
  async getWayPoints(e = {}, n = this.callOptions) {
    const a = new Us({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getWaypoints(a, n)).waypoints;
  }
  async addWayPoint(e, n = {}, a = this.callOptions) {
    const s = new Gs({
      name: this.name,
      location: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.addWaypoint(s, a);
  }
  async removeWayPoint(e, n = {}, a = this.callOptions) {
    const s = new Ls({
      name: this.name,
      id: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.removeWaypoint(s, a);
  }
  async getObstacles(e = {}, n = this.callOptions) {
    const a = new Bs({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getObstacles(a, n)).obstacles;
  }
  async getPaths(e = {}, n = this.callOptions) {
    const a = new xs({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getPaths(a, n)).paths;
  }
  async getProperties(e = this.callOptions) {
    const n = new Fs({
      name: this.name
    });
    return this.options.requestLogger?.(n), this.client.getProperties(n, e);
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const {
  GetLocationResponse: _R,
  GetPropertiesResponse: ER,
  Mode: MR,
  Path: OR,
  Waypoint: NR
} = ch;
class CR {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(wc), this.name = n, this.options = a;
  }
  async move(e, n = {}, a = this.callOptions) {
    const s = new hs({
      name: this.name,
      angleDeg: e,
      extra: u.fromJson(n)
    });
    this.options.requestLogger?.(s), await this.client.move(s, a);
  }
  async getPosition(e = {}, n = this.callOptions) {
    const a = new fs({
      name: this.name,
      extra: u.fromJson(e)
    });
    return this.options.requestLogger?.(a), (await this.client.getPosition(a, n)).positionDeg;
  }
  async stop(e = {}, n = this.callOptions) {
    const a = new Rs({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a), await this.client.stop(a, n);
  }
  async isMoving(e = this.callOptions) {
    const n = new Is({
      name: this.name
    });
    return this.options.requestLogger?.(n), (await this.client.isMoving(n, e)).isMoving;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
class PR {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(ll), this.name = n, this.options = a;
  }
  async getPosition(e = this.callOptions) {
    const n = new Js({
      name: this.name
    });
    return this.options.requestLogger?.(n), this.client.getPosition(n, e);
  }
  getPointCloudMap = async (e, n = this.callOptions) => {
    const a = new zs({
      name: this.name,
      returnEditedMap: e
    });
    this.options.requestLogger?.(a);
    const s = [], i = this.client.getPointCloudMap(a, n);
    for await (const r of i)
      s.push(r.pointCloudPcdChunk);
    return ti(s);
  };
  getInternalState = async (e = this.callOptions) => {
    const n = new $s({
      name: this.name
    });
    this.options.requestLogger?.(n);
    const a = [], s = this.client.getInternalState(n, e);
    for await (const i of s)
      a.push(i.internalStateChunk);
    return ti(a);
  };
  async getProperties(e = this.callOptions) {
    const n = new Ys({
      name: this.name
    });
    return this.options.requestLogger?.(n), this.client.getProperties(n, e);
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const ti = (t) => {
  const e = t.reduce((s, i) => s + i.length, 0), n = new Uint8Array(e);
  let a = 0;
  for (const s of t)
    n.set(s, a), a += s.length;
  return n;
}, {
  GetPositionResponse: DR,
  GetPropertiesResponse: qR
} = lh;
class AR {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(Ol), this.name = n, this.options = a;
  }
  async getDetectionsFromCamera(e, n = {}, a = this.callOptions) {
    const s = new Xs({
      name: this.name,
      cameraName: e,
      extra: u.fromJson(n)
    });
    return this.options.requestLogger?.(s), (await this.client.getDetectionsFromCamera(
      s,
      a
    )).detections;
  }
  async getDetections(e, n, a, s, i = {}, r = this.callOptions) {
    const c = new Ks({
      name: this.name,
      image: e,
      width: n ? BigInt(n) : void 0,
      height: a ? BigInt(a) : void 0,
      mimeType: s,
      extra: u.fromJson(i)
    });
    return this.options.requestLogger?.(c), (await this.client.getDetections(c, r)).detections;
  }
  async getClassificationsFromCamera(e, n, a = {}, s = this.callOptions) {
    const i = new Zs({
      name: this.name,
      cameraName: e,
      n,
      // eslint-disable-line id-length
      extra: u.fromJson(a)
    });
    return this.options.requestLogger?.(i), (await this.client.getClassificationsFromCamera(
      i,
      s
    )).classifications;
  }
  async getClassifications(e, n, a, s, i, r = {}, c = this.callOptions) {
    const d = new Qs({
      name: this.name,
      image: e,
      width: n,
      height: a,
      mimeType: s,
      n: i,
      // eslint-disable-line id-length
      extra: u.fromJson(r)
    });
    return this.options.requestLogger?.(d), (await this.client.getClassifications(d, c)).classifications;
  }
  async getObjectPointClouds(e, n = {}, a = this.callOptions) {
    const s = new eo({
      name: this.name,
      cameraName: e,
      extra: u.fromJson(n)
    });
    return this.options.requestLogger?.(s), (await this.client.getObjectPointClouds(s, a)).objects;
  }
  async getProperties(e = {}, n = this.callOptions) {
    const a = new no({
      name: this.name,
      extra: u.fromJson(e)
    });
    this.options.requestLogger?.(a);
    const s = await this.client.getProperties(a, n);
    return {
      classificationsSupported: s.classificationsSupported,
      detectionsSupported: s.detectionsSupported,
      objectPointCloudsSupported: s.objectPointCloudsSupported
    };
  }
  async captureAllFromCamera(e, {
    returnImage: n,
    returnClassifications: a,
    returnDetections: s,
    returnObjectPointClouds: i
  }, r = {}, c = this.callOptions) {
    const d = new to({
      name: this.name,
      cameraName: e,
      returnImage: n,
      returnClassifications: a,
      returnDetections: s,
      returnObjectPointClouds: i,
      extra: u.fromJson(r)
    });
    this.options.requestLogger?.(d);
    const l = await this.client.captureAllFromCamera(
      d,
      c
    );
    return {
      image: l.image,
      classifications: l.classifications,
      detections: l.detections,
      objectPointClouds: l.objects
    };
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const { Classification: UR, Detection: GR } = uh, { PointCloudObject: LR } = Pi, gk = {
  typeName: "viam.service.generic.v1.GenericService",
  methods: {
    /**
     * DoCommand sends/receives arbitrary commands
     *
     * @generated from rpc viam.service.generic.v1.GenericService.DoCommand
     */
    doCommand: {
      name: "DoCommand",
      I: U,
      O: L,
      kind: m.Unary
    }
  }
}, BR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GenericService: gk
}, Symbol.toStringTag, { value: "Module" }));
class xR {
  client;
  name;
  options;
  callOptions = { headers: {} };
  constructor(e, n, a = {}) {
    this.client = e.createServiceClient(gk), this.name = n, this.options = a;
  }
  async doCommand(e, n = this.callOptions) {
    return x(
      this.client.doCommand,
      this.name,
      e,
      this.options,
      n
    );
  }
}
const FR = "0.33.0";
export {
  Pf as AnalogValue,
  Of as ArmClient,
  Mf as ArmJointPositions,
  Cf as BaseClient,
  Nf as BaseProperties,
  qf as BoardClient,
  Af as CameraClient,
  dR as Capsule,
  UR as Classification,
  q as Client,
  ok as CloudConfig,
  M as Code,
  eR as CollisionSpecification,
  N as ConnectError,
  Ae as ConnectionClosedError,
  nR as Constraints,
  lR as DataManagerClient,
  GR as Detection,
  X as Duration,
  Gf as EncoderClient,
  sf as EncoderPositionType,
  Uf as EncoderProperties,
  Lf as GantryClient,
  Hf as GenericComponentClient,
  xR as GenericServiceClient,
  uR as GeoGeometry,
  pR as GeoPoint,
  gR as GeometriesInFrame,
  TR as Geometry,
  Xf as GripperClient,
  Qf as InputControllerClient,
  Zf as InputControllerEvent,
  aR as LinearConstraint,
  sR as ListPlanStatusesResponse,
  te as MachineConnectionEvent,
  bn as ModelType,
  cR as MotionClient,
  oR as MotionConfiguration,
  Bf as MotorClient,
  Ff as MovementSensorAccuracy,
  xf as MovementSensorClient,
  Jf as MovementSensorPosition,
  zf as MovementSensorProperties,
  bR as NavigationClient,
  _R as NavigationPosition,
  ER as NavigationProperties,
  iR as ObstacleDetector,
  kR as Orientation,
  rR as OrientationConstraint,
  OR as Path,
  LR as PointCloudObject,
  yR as Pose,
  vR as PoseInFrame,
  Df as PowerMode,
  $f as PowerSensorClient,
  hR as RectangularPrism,
  fR as ResourceName,
  q as RobotClient,
  Wf as SensorClient,
  CR as ServoClient,
  PR as SlamClient,
  DR as SlamPosition,
  qR as SlamProperties,
  RR as Sphere,
  jf as StreamClient,
  u as Struct,
  I as Timestamp,
  ao as TrainingStatus,
  IR as Transform,
  SR as Vector3,
  AR as VisionClient,
  NR as Waypoint,
  wR as WorldState,
  pf as addMetadata,
  Sf as appApi,
  Xv as armApi,
  Qv as baseApi,
  wf as billingApi,
  eh as boardApi,
  Rf as cameraApi,
  Pi as commonApi,
  fh as createRobotClient,
  Ef as createViamClient,
  bf as dataApi,
  gf as deleteMetadata,
  uf as disableDebugLogging,
  x as doCommandFromClient,
  df as enableDebugLogging,
  nh as encoderApi,
  Tf as gantryApi,
  kf as genericComponentApi,
  BR as genericServiceApi,
  yf as gripperApi,
  sh as inputControllerApi,
  cf as isValidGeoPoint,
  If as mlTrainingApi,
  mh as motionApi,
  vf as motorApi,
  ih as movementSensorApi,
  ch as navigationApi,
  hf as powerSensorApi,
  _f as provisioningApi,
  lf as robotApi,
  Yf as sensorApi,
  ff as servoApi,
  lh as slamApi,
  Vf as streamApi,
  FR as version,
  uh as visionApi
};
